/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var Ac = function(t, A) {
  return Ac = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, r) {
    e.__proto__ = r;
  } || function(e, r) {
    for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
  }, Ac(t, A);
};
function ur(t, A) {
  if (typeof A != "function" && A !== null)
    throw new TypeError("Class extends value " + String(A) + " is not a constructor or null");
  Ac(t, A);
  function e() {
    this.constructor = t;
  }
  t.prototype = A === null ? Object.create(A) : (e.prototype = A.prototype, new e());
}
var ec = function() {
  return ec = Object.assign || function(A) {
    for (var e, r = 1, n = arguments.length; r < n; r++) {
      e = arguments[r];
      for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && (A[i] = e[i]);
    }
    return A;
  }, ec.apply(this, arguments);
};
function mt(t, A, e, r) {
  function n(i) {
    return i instanceof e ? i : new e(function(s) {
      s(i);
    });
  }
  return new (e || (e = Promise))(function(i, s) {
    function u(g) {
      try {
        h(r.next(g));
      } catch (p) {
        s(p);
      }
    }
    function c(g) {
      try {
        h(r.throw(g));
      } catch (p) {
        s(p);
      }
    }
    function h(g) {
      g.done ? i(g.value) : n(g.value).then(u, c);
    }
    h((r = r.apply(t, [])).next());
  });
}
function Bt(t, A) {
  var e = { label: 0, sent: function() {
    if (i[0] & 1) throw i[1];
    return i[1];
  }, trys: [], ops: [] }, r, n, i, s;
  return s = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function u(h) {
    return function(g) {
      return c([h, g]);
    };
  }
  function c(h) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; e; ) try {
      if (r = 1, n && (i = h[0] & 2 ? n.return : h[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, h[1])).done) return i;
      switch (n = 0, i && (h = [h[0] & 2, i.value]), h[0]) {
        case 0:
        case 1:
          i = h;
          break;
        case 4:
          return e.label++, { value: h[1], done: !1 };
        case 5:
          e.label++, n = h[1], h = [0];
          continue;
        case 7:
          h = e.ops.pop(), e.trys.pop();
          continue;
        default:
          if (i = e.trys, !(i = i.length > 0 && i[i.length - 1]) && (h[0] === 6 || h[0] === 2)) {
            e = 0;
            continue;
          }
          if (h[0] === 3 && (!i || h[1] > i[0] && h[1] < i[3])) {
            e.label = h[1];
            break;
          }
          if (h[0] === 6 && e.label < i[1]) {
            e.label = i[1], i = h;
            break;
          }
          if (i && e.label < i[2]) {
            e.label = i[2], e.ops.push(h);
            break;
          }
          i[2] && e.ops.pop(), e.trys.pop();
          continue;
      }
      h = A.call(t, e);
    } catch (g) {
      h = [6, g], n = 0;
    } finally {
      r = i = 0;
    }
    if (h[0] & 5) throw h[1];
    return { value: h[0] ? h[1] : void 0, done: !0 };
  }
}
function Is(t, A, e) {
  if (arguments.length === 2) for (var r = 0, n = A.length, i; r < n; r++)
    (i || !(r in A)) && (i || (i = Array.prototype.slice.call(A, 0, r)), i[r] = A[r]);
  return t.concat(i || A);
}
var jr = (
  /** @class */
  function() {
    function t(A, e, r, n) {
      this.left = A, this.top = e, this.width = r, this.height = n;
    }
    return t.prototype.add = function(A, e, r, n) {
      return new t(this.left + A, this.top + e, this.width + r, this.height + n);
    }, t.fromClientRect = function(A, e) {
      return new t(e.left + A.windowBounds.left, e.top + A.windowBounds.top, e.width, e.height);
    }, t.fromDOMRectList = function(A, e) {
      var r = Array.from(e).find(function(n) {
        return n.width !== 0;
      });
      return r ? new t(r.left + A.windowBounds.left, r.top + A.windowBounds.top, r.width, r.height) : t.EMPTY;
    }, t.EMPTY = new t(0, 0, 0, 0), t;
  }()
), Fo = function(t, A) {
  return jr.fromClientRect(t, A.getBoundingClientRect());
}, VB = function(t) {
  var A = t.body, e = t.documentElement;
  if (!A || !e)
    throw new Error("Unable to get document size");
  var r = Math.max(Math.max(A.scrollWidth, e.scrollWidth), Math.max(A.offsetWidth, e.offsetWidth), Math.max(A.clientWidth, e.clientWidth)), n = Math.max(Math.max(A.scrollHeight, e.scrollHeight), Math.max(A.offsetHeight, e.offsetHeight), Math.max(A.clientHeight, e.clientHeight));
  return new jr(0, 0, r, n);
}, Uo = function(t) {
  for (var A = [], e = 0, r = t.length; e < r; ) {
    var n = t.charCodeAt(e++);
    if (n >= 55296 && n <= 56319 && e < r) {
      var i = t.charCodeAt(e++);
      (i & 64512) === 56320 ? A.push(((n & 1023) << 10) + (i & 1023) + 65536) : (A.push(n), e--);
    } else
      A.push(n);
  }
  return A;
}, Me = function() {
  for (var t = [], A = 0; A < arguments.length; A++)
    t[A] = arguments[A];
  if (String.fromCodePoint)
    return String.fromCodePoint.apply(String, t);
  var e = t.length;
  if (!e)
    return "";
  for (var r = [], n = -1, i = ""; ++n < e; ) {
    var s = t[n];
    s <= 65535 ? r.push(s) : (s -= 65536, r.push((s >> 10) + 55296, s % 1024 + 56320)), (n + 1 === e || r.length > 16384) && (i += String.fromCharCode.apply(String, r), r.length = 0);
  }
  return i;
}, pl = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", qB = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var xs = 0; xs < pl.length; xs++)
  qB[pl.charCodeAt(xs)] = xs;
var wl = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", ma = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var Hs = 0; Hs < wl.length; Hs++)
  ma[wl.charCodeAt(Hs)] = Hs;
var WB = function(t) {
  var A = t.length * 0.75, e = t.length, r, n = 0, i, s, u, c;
  t[t.length - 1] === "=" && (A--, t[t.length - 2] === "=" && A--);
  var h = typeof ArrayBuffer < "u" && typeof Uint8Array < "u" && typeof Uint8Array.prototype.slice < "u" ? new ArrayBuffer(A) : new Array(A), g = Array.isArray(h) ? h : new Uint8Array(h);
  for (r = 0; r < e; r += 4)
    i = ma[t.charCodeAt(r)], s = ma[t.charCodeAt(r + 1)], u = ma[t.charCodeAt(r + 2)], c = ma[t.charCodeAt(r + 3)], g[n++] = i << 2 | s >> 4, g[n++] = (s & 15) << 4 | u >> 2, g[n++] = (u & 3) << 6 | c & 63;
  return h;
}, XB = function(t) {
  for (var A = t.length, e = [], r = 0; r < A; r += 2)
    e.push(t[r + 1] << 8 | t[r]);
  return e;
}, JB = function(t) {
  for (var A = t.length, e = [], r = 0; r < A; r += 4)
    e.push(t[r + 3] << 24 | t[r + 2] << 16 | t[r + 1] << 8 | t[r]);
  return e;
}, Pn = 5, _c = 11, Uu = 2, zB = _c - Pn, Of = 65536 >> Pn, YB = 1 << Pn, yu = YB - 1, ZB = 1024 >> Pn, $B = Of + ZB, A0 = $B, e0 = 32, t0 = A0 + e0, r0 = 65536 >> _c, n0 = 1 << zB, i0 = n0 - 1, vl = function(t, A, e) {
  return t.slice ? t.slice(A, e) : new Uint16Array(Array.prototype.slice.call(t, A, e));
}, a0 = function(t, A, e) {
  return t.slice ? t.slice(A, e) : new Uint32Array(Array.prototype.slice.call(t, A, e));
}, s0 = function(t, A) {
  var e = WB(t), r = Array.isArray(e) ? JB(e) : new Uint32Array(e), n = Array.isArray(e) ? XB(e) : new Uint16Array(e), i = 24, s = vl(n, i / 2, r[4] / 2), u = r[5] === 2 ? vl(n, (i + r[4]) / 2) : a0(r, Math.ceil((i + r[4]) / 4));
  return new o0(r[0], r[1], r[2], r[3], s, u);
}, o0 = (
  /** @class */
  function() {
    function t(A, e, r, n, i, s) {
      this.initialValue = A, this.errorValue = e, this.highStart = r, this.highValueIndex = n, this.index = i, this.data = s;
    }
    return t.prototype.get = function(A) {
      var e;
      if (A >= 0) {
        if (A < 55296 || A > 56319 && A <= 65535)
          return e = this.index[A >> Pn], e = (e << Uu) + (A & yu), this.data[e];
        if (A <= 65535)
          return e = this.index[Of + (A - 55296 >> Pn)], e = (e << Uu) + (A & yu), this.data[e];
        if (A < this.highStart)
          return e = t0 - r0 + (A >> _c), e = this.index[e], e += A >> Pn & i0, e = this.index[e], e = (e << Uu) + (A & yu), this.data[e];
        if (A <= 1114111)
          return this.data[this.highValueIndex];
      }
      return this.errorValue;
    }, t;
  }()
), ml = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", u0 = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var Ss = 0; Ss < ml.length; Ss++)
  u0[ml.charCodeAt(Ss)] = Ss;
var c0 = "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", Cl = 50, l0 = 1, Pf = 2, Mf = 3, f0 = 4, h0 = 5, Ql = 7, Kf = 8, Fl = 9, ln = 10, tc = 11, Ul = 12, rc = 13, B0 = 14, Ca = 15, nc = 16, Ns = 17, Ba = 18, g0 = 19, yl = 20, ic = 21, ga = 22, bu = 23, pi = 24, _t = 25, Qa = 26, Fa = 27, wi = 28, d0 = 29, Dn = 30, p0 = 31, _s = 32, Ds = 33, ac = 34, sc = 35, oc = 36, Na = 37, uc = 38, to = 39, ro = 40, Lu = 41, kf = 42, w0 = 43, v0 = [9001, 65288], Rf = "!", ie = "×", Ts = "÷", cc = s0(c0), Kr = [Dn, oc], lc = [l0, Pf, Mf, h0], Gf = [ln, Kf], bl = [Fa, Qa], m0 = lc.concat(Gf), Ll = [uc, to, ro, ac, sc], C0 = [Ca, rc], Q0 = function(t, A) {
  A === void 0 && (A = "strict");
  var e = [], r = [], n = [];
  return t.forEach(function(i, s) {
    var u = cc.get(i);
    if (u > Cl ? (n.push(!0), u -= Cl) : n.push(!1), ["normal", "auto", "loose"].indexOf(A) !== -1 && [8208, 8211, 12316, 12448].indexOf(i) !== -1)
      return r.push(s), e.push(nc);
    if (u === f0 || u === tc) {
      if (s === 0)
        return r.push(s), e.push(Dn);
      var c = e[s - 1];
      return m0.indexOf(c) === -1 ? (r.push(r[s - 1]), e.push(c)) : (r.push(s), e.push(Dn));
    }
    if (r.push(s), u === p0)
      return e.push(A === "strict" ? ic : Na);
    if (u === kf || u === d0)
      return e.push(Dn);
    if (u === w0)
      return i >= 131072 && i <= 196605 || i >= 196608 && i <= 262141 ? e.push(Na) : e.push(Dn);
    e.push(u);
  }), [r, e, n];
}, Eu = function(t, A, e, r) {
  var n = r[e];
  if (Array.isArray(t) ? t.indexOf(n) !== -1 : t === n)
    for (var i = e; i <= r.length; ) {
      i++;
      var s = r[i];
      if (s === A)
        return !0;
      if (s !== ln)
        break;
    }
  if (n === ln)
    for (var i = e; i > 0; ) {
      i--;
      var u = r[i];
      if (Array.isArray(t) ? t.indexOf(u) !== -1 : t === u)
        for (var c = e; c <= r.length; ) {
          c++;
          var s = r[c];
          if (s === A)
            return !0;
          if (s !== ln)
            break;
        }
      if (u !== ln)
        break;
    }
  return !1;
}, El = function(t, A) {
  for (var e = t; e >= 0; ) {
    var r = A[e];
    if (r === ln)
      e--;
    else
      return r;
  }
  return 0;
}, F0 = function(t, A, e, r, n) {
  if (e[r] === 0)
    return ie;
  var i = r - 1;
  if (Array.isArray(n) && n[i] === !0)
    return ie;
  var s = i - 1, u = i + 1, c = A[i], h = s >= 0 ? A[s] : 0, g = A[u];
  if (c === Pf && g === Mf)
    return ie;
  if (lc.indexOf(c) !== -1)
    return Rf;
  if (lc.indexOf(g) !== -1 || Gf.indexOf(g) !== -1)
    return ie;
  if (El(i, A) === Kf)
    return Ts;
  if (cc.get(t[i]) === tc || (c === _s || c === Ds) && cc.get(t[u]) === tc || c === Ql || g === Ql || c === Fl || [ln, rc, Ca].indexOf(c) === -1 && g === Fl || [Ns, Ba, g0, pi, wi].indexOf(g) !== -1 || El(i, A) === ga || Eu(bu, ga, i, A) || Eu([Ns, Ba], ic, i, A) || Eu(Ul, Ul, i, A))
    return ie;
  if (c === ln)
    return Ts;
  if (c === bu || g === bu)
    return ie;
  if (g === nc || c === nc)
    return Ts;
  if ([rc, Ca, ic].indexOf(g) !== -1 || c === B0 || h === oc && C0.indexOf(c) !== -1 || c === wi && g === oc || g === yl || Kr.indexOf(g) !== -1 && c === _t || Kr.indexOf(c) !== -1 && g === _t || c === Fa && [Na, _s, Ds].indexOf(g) !== -1 || [Na, _s, Ds].indexOf(c) !== -1 && g === Qa || Kr.indexOf(c) !== -1 && bl.indexOf(g) !== -1 || bl.indexOf(c) !== -1 && Kr.indexOf(g) !== -1 || // (PR | PO) × ( OP | HY )? NU
  [Fa, Qa].indexOf(c) !== -1 && (g === _t || [ga, Ca].indexOf(g) !== -1 && A[u + 1] === _t) || // ( OP | HY ) × NU
  [ga, Ca].indexOf(c) !== -1 && g === _t || // NU ×	(NU | SY | IS)
  c === _t && [_t, wi, pi].indexOf(g) !== -1)
    return ie;
  if ([_t, wi, pi, Ns, Ba].indexOf(g) !== -1)
    for (var p = i; p >= 0; ) {
      var w = A[p];
      if (w === _t)
        return ie;
      if ([wi, pi].indexOf(w) !== -1)
        p--;
      else
        break;
    }
  if ([Fa, Qa].indexOf(g) !== -1)
    for (var p = [Ns, Ba].indexOf(c) !== -1 ? s : i; p >= 0; ) {
      var w = A[p];
      if (w === _t)
        return ie;
      if ([wi, pi].indexOf(w) !== -1)
        p--;
      else
        break;
    }
  if (uc === c && [uc, to, ac, sc].indexOf(g) !== -1 || [to, ac].indexOf(c) !== -1 && [to, ro].indexOf(g) !== -1 || [ro, sc].indexOf(c) !== -1 && g === ro || Ll.indexOf(c) !== -1 && [yl, Qa].indexOf(g) !== -1 || Ll.indexOf(g) !== -1 && c === Fa || Kr.indexOf(c) !== -1 && Kr.indexOf(g) !== -1 || c === pi && Kr.indexOf(g) !== -1 || Kr.concat(_t).indexOf(c) !== -1 && g === ga && v0.indexOf(t[u]) === -1 || Kr.concat(_t).indexOf(g) !== -1 && c === Ba)
    return ie;
  if (c === Lu && g === Lu) {
    for (var B = e[i], L = 1; B > 0 && (B--, A[B] === Lu); )
      L++;
    if (L % 2 !== 0)
      return ie;
  }
  return c === _s && g === Ds ? ie : Ts;
}, U0 = function(t, A) {
  A || (A = { lineBreak: "normal", wordBreak: "normal" });
  var e = Q0(t, A.lineBreak), r = e[0], n = e[1], i = e[2];
  (A.wordBreak === "break-all" || A.wordBreak === "break-word") && (n = n.map(function(u) {
    return [_t, Dn, kf].indexOf(u) !== -1 ? Na : u;
  }));
  var s = A.wordBreak === "keep-all" ? i.map(function(u, c) {
    return u && t[c] >= 19968 && t[c] <= 40959;
  }) : void 0;
  return [r, n, s];
}, y0 = (
  /** @class */
  function() {
    function t(A, e, r, n) {
      this.codePoints = A, this.required = e === Rf, this.start = r, this.end = n;
    }
    return t.prototype.slice = function() {
      return Me.apply(void 0, this.codePoints.slice(this.start, this.end));
    }, t;
  }()
), b0 = function(t, A) {
  var e = Uo(t), r = U0(e, A), n = r[0], i = r[1], s = r[2], u = e.length, c = 0, h = 0;
  return {
    next: function() {
      if (h >= u)
        return { done: !0, value: null };
      for (var g = ie; h < u && (g = F0(e, i, n, ++h, s)) === ie; )
        ;
      if (g !== ie || h === u) {
        var p = new y0(e, g, c, h);
        return c = h, { value: p, done: !1 };
      }
      return { done: !0, value: null };
    }
  };
}, L0 = 1, E0 = 2, Oa = 4, Il = 8, co = 10, xl = 47, La = 92, I0 = 9, x0 = 32, Os = 34, da = 61, H0 = 35, S0 = 36, N0 = 37, Ps = 39, Ms = 40, pa = 41, _0 = 95, Lt = 45, D0 = 33, T0 = 60, O0 = 62, P0 = 64, M0 = 91, K0 = 93, k0 = 61, R0 = 123, Ks = 63, G0 = 125, Hl = 124, j0 = 126, V0 = 128, Sl = 65533, Iu = 42, On = 43, q0 = 44, W0 = 58, X0 = 59, _a = 46, J0 = 0, z0 = 8, Y0 = 11, Z0 = 14, $0 = 31, A1 = 127, Qr = -1, jf = 48, Vf = 97, qf = 101, e1 = 102, t1 = 117, r1 = 122, Wf = 65, Xf = 69, Jf = 70, n1 = 85, i1 = 90, gt = function(t) {
  return t >= jf && t <= 57;
}, a1 = function(t) {
  return t >= 55296 && t <= 57343;
}, vi = function(t) {
  return gt(t) || t >= Wf && t <= Jf || t >= Vf && t <= e1;
}, s1 = function(t) {
  return t >= Vf && t <= r1;
}, o1 = function(t) {
  return t >= Wf && t <= i1;
}, u1 = function(t) {
  return s1(t) || o1(t);
}, c1 = function(t) {
  return t >= V0;
}, ks = function(t) {
  return t === co || t === I0 || t === x0;
}, lo = function(t) {
  return u1(t) || c1(t) || t === _0;
}, Nl = function(t) {
  return lo(t) || gt(t) || t === Lt;
}, l1 = function(t) {
  return t >= J0 && t <= z0 || t === Y0 || t >= Z0 && t <= $0 || t === A1;
}, cn = function(t, A) {
  return t !== La ? !1 : A !== co;
}, Rs = function(t, A, e) {
  return t === Lt ? lo(A) || cn(A, e) : lo(t) ? !0 : !!(t === La && cn(t, A));
}, xu = function(t, A, e) {
  return t === On || t === Lt ? gt(A) ? !0 : A === _a && gt(e) : gt(t === _a ? A : t);
}, f1 = function(t) {
  var A = 0, e = 1;
  (t[A] === On || t[A] === Lt) && (t[A] === Lt && (e = -1), A++);
  for (var r = []; gt(t[A]); )
    r.push(t[A++]);
  var n = r.length ? parseInt(Me.apply(void 0, r), 10) : 0;
  t[A] === _a && A++;
  for (var i = []; gt(t[A]); )
    i.push(t[A++]);
  var s = i.length, u = s ? parseInt(Me.apply(void 0, i), 10) : 0;
  (t[A] === Xf || t[A] === qf) && A++;
  var c = 1;
  (t[A] === On || t[A] === Lt) && (t[A] === Lt && (c = -1), A++);
  for (var h = []; gt(t[A]); )
    h.push(t[A++]);
  var g = h.length ? parseInt(Me.apply(void 0, h), 10) : 0;
  return e * (n + u * Math.pow(10, -s)) * Math.pow(10, c * g);
}, h1 = {
  type: 2
  /* LEFT_PARENTHESIS_TOKEN */
}, B1 = {
  type: 3
  /* RIGHT_PARENTHESIS_TOKEN */
}, g1 = {
  type: 4
  /* COMMA_TOKEN */
}, d1 = {
  type: 13
  /* SUFFIX_MATCH_TOKEN */
}, p1 = {
  type: 8
  /* PREFIX_MATCH_TOKEN */
}, w1 = {
  type: 21
  /* COLUMN_TOKEN */
}, v1 = {
  type: 9
  /* DASH_MATCH_TOKEN */
}, m1 = {
  type: 10
  /* INCLUDE_MATCH_TOKEN */
}, C1 = {
  type: 11
  /* LEFT_CURLY_BRACKET_TOKEN */
}, Q1 = {
  type: 12
  /* RIGHT_CURLY_BRACKET_TOKEN */
}, F1 = {
  type: 14
  /* SUBSTRING_MATCH_TOKEN */
}, Gs = {
  type: 23
  /* BAD_URL_TOKEN */
}, U1 = {
  type: 1
  /* BAD_STRING_TOKEN */
}, y1 = {
  type: 25
  /* CDO_TOKEN */
}, b1 = {
  type: 24
  /* CDC_TOKEN */
}, L1 = {
  type: 26
  /* COLON_TOKEN */
}, E1 = {
  type: 27
  /* SEMICOLON_TOKEN */
}, I1 = {
  type: 28
  /* LEFT_SQUARE_BRACKET_TOKEN */
}, x1 = {
  type: 29
  /* RIGHT_SQUARE_BRACKET_TOKEN */
}, H1 = {
  type: 31
  /* WHITESPACE_TOKEN */
}, fc = {
  type: 32
  /* EOF_TOKEN */
}, zf = (
  /** @class */
  function() {
    function t() {
      this._value = [];
    }
    return t.prototype.write = function(A) {
      this._value = this._value.concat(Uo(A));
    }, t.prototype.read = function() {
      for (var A = [], e = this.consumeToken(); e !== fc; )
        A.push(e), e = this.consumeToken();
      return A;
    }, t.prototype.consumeToken = function() {
      var A = this.consumeCodePoint();
      switch (A) {
        case Os:
          return this.consumeStringToken(Os);
        case H0:
          var e = this.peekCodePoint(0), r = this.peekCodePoint(1), n = this.peekCodePoint(2);
          if (Nl(e) || cn(r, n)) {
            var i = Rs(e, r, n) ? E0 : L0, s = this.consumeName();
            return { type: 5, value: s, flags: i };
          }
          break;
        case S0:
          if (this.peekCodePoint(0) === da)
            return this.consumeCodePoint(), d1;
          break;
        case Ps:
          return this.consumeStringToken(Ps);
        case Ms:
          return h1;
        case pa:
          return B1;
        case Iu:
          if (this.peekCodePoint(0) === da)
            return this.consumeCodePoint(), F1;
          break;
        case On:
          if (xu(A, this.peekCodePoint(0), this.peekCodePoint(1)))
            return this.reconsumeCodePoint(A), this.consumeNumericToken();
          break;
        case q0:
          return g1;
        case Lt:
          var u = A, c = this.peekCodePoint(0), h = this.peekCodePoint(1);
          if (xu(u, c, h))
            return this.reconsumeCodePoint(A), this.consumeNumericToken();
          if (Rs(u, c, h))
            return this.reconsumeCodePoint(A), this.consumeIdentLikeToken();
          if (c === Lt && h === O0)
            return this.consumeCodePoint(), this.consumeCodePoint(), b1;
          break;
        case _a:
          if (xu(A, this.peekCodePoint(0), this.peekCodePoint(1)))
            return this.reconsumeCodePoint(A), this.consumeNumericToken();
          break;
        case xl:
          if (this.peekCodePoint(0) === Iu)
            for (this.consumeCodePoint(); ; ) {
              var g = this.consumeCodePoint();
              if (g === Iu && (g = this.consumeCodePoint(), g === xl))
                return this.consumeToken();
              if (g === Qr)
                return this.consumeToken();
            }
          break;
        case W0:
          return L1;
        case X0:
          return E1;
        case T0:
          if (this.peekCodePoint(0) === D0 && this.peekCodePoint(1) === Lt && this.peekCodePoint(2) === Lt)
            return this.consumeCodePoint(), this.consumeCodePoint(), y1;
          break;
        case P0:
          var p = this.peekCodePoint(0), w = this.peekCodePoint(1), B = this.peekCodePoint(2);
          if (Rs(p, w, B)) {
            var s = this.consumeName();
            return { type: 7, value: s };
          }
          break;
        case M0:
          return I1;
        case La:
          if (cn(A, this.peekCodePoint(0)))
            return this.reconsumeCodePoint(A), this.consumeIdentLikeToken();
          break;
        case K0:
          return x1;
        case k0:
          if (this.peekCodePoint(0) === da)
            return this.consumeCodePoint(), p1;
          break;
        case R0:
          return C1;
        case G0:
          return Q1;
        case t1:
        case n1:
          var L = this.peekCodePoint(0), y = this.peekCodePoint(1);
          return L === On && (vi(y) || y === Ks) && (this.consumeCodePoint(), this.consumeUnicodeRangeToken()), this.reconsumeCodePoint(A), this.consumeIdentLikeToken();
        case Hl:
          if (this.peekCodePoint(0) === da)
            return this.consumeCodePoint(), v1;
          if (this.peekCodePoint(0) === Hl)
            return this.consumeCodePoint(), w1;
          break;
        case j0:
          if (this.peekCodePoint(0) === da)
            return this.consumeCodePoint(), m1;
          break;
        case Qr:
          return fc;
      }
      return ks(A) ? (this.consumeWhiteSpace(), H1) : gt(A) ? (this.reconsumeCodePoint(A), this.consumeNumericToken()) : lo(A) ? (this.reconsumeCodePoint(A), this.consumeIdentLikeToken()) : { type: 6, value: Me(A) };
    }, t.prototype.consumeCodePoint = function() {
      var A = this._value.shift();
      return typeof A > "u" ? -1 : A;
    }, t.prototype.reconsumeCodePoint = function(A) {
      this._value.unshift(A);
    }, t.prototype.peekCodePoint = function(A) {
      return A >= this._value.length ? -1 : this._value[A];
    }, t.prototype.consumeUnicodeRangeToken = function() {
      for (var A = [], e = this.consumeCodePoint(); vi(e) && A.length < 6; )
        A.push(e), e = this.consumeCodePoint();
      for (var r = !1; e === Ks && A.length < 6; )
        A.push(e), e = this.consumeCodePoint(), r = !0;
      if (r) {
        var n = parseInt(Me.apply(void 0, A.map(function(c) {
          return c === Ks ? jf : c;
        })), 16), i = parseInt(Me.apply(void 0, A.map(function(c) {
          return c === Ks ? Jf : c;
        })), 16);
        return { type: 30, start: n, end: i };
      }
      var s = parseInt(Me.apply(void 0, A), 16);
      if (this.peekCodePoint(0) === Lt && vi(this.peekCodePoint(1))) {
        this.consumeCodePoint(), e = this.consumeCodePoint();
        for (var u = []; vi(e) && u.length < 6; )
          u.push(e), e = this.consumeCodePoint();
        var i = parseInt(Me.apply(void 0, u), 16);
        return { type: 30, start: s, end: i };
      } else
        return { type: 30, start: s, end: s };
    }, t.prototype.consumeIdentLikeToken = function() {
      var A = this.consumeName();
      return A.toLowerCase() === "url" && this.peekCodePoint(0) === Ms ? (this.consumeCodePoint(), this.consumeUrlToken()) : this.peekCodePoint(0) === Ms ? (this.consumeCodePoint(), { type: 19, value: A }) : { type: 20, value: A };
    }, t.prototype.consumeUrlToken = function() {
      var A = [];
      if (this.consumeWhiteSpace(), this.peekCodePoint(0) === Qr)
        return { type: 22, value: "" };
      var e = this.peekCodePoint(0);
      if (e === Ps || e === Os) {
        var r = this.consumeStringToken(this.consumeCodePoint());
        return r.type === 0 && (this.consumeWhiteSpace(), this.peekCodePoint(0) === Qr || this.peekCodePoint(0) === pa) ? (this.consumeCodePoint(), { type: 22, value: r.value }) : (this.consumeBadUrlRemnants(), Gs);
      }
      for (; ; ) {
        var n = this.consumeCodePoint();
        if (n === Qr || n === pa)
          return { type: 22, value: Me.apply(void 0, A) };
        if (ks(n))
          return this.consumeWhiteSpace(), this.peekCodePoint(0) === Qr || this.peekCodePoint(0) === pa ? (this.consumeCodePoint(), { type: 22, value: Me.apply(void 0, A) }) : (this.consumeBadUrlRemnants(), Gs);
        if (n === Os || n === Ps || n === Ms || l1(n))
          return this.consumeBadUrlRemnants(), Gs;
        if (n === La)
          if (cn(n, this.peekCodePoint(0)))
            A.push(this.consumeEscapedCodePoint());
          else
            return this.consumeBadUrlRemnants(), Gs;
        else
          A.push(n);
      }
    }, t.prototype.consumeWhiteSpace = function() {
      for (; ks(this.peekCodePoint(0)); )
        this.consumeCodePoint();
    }, t.prototype.consumeBadUrlRemnants = function() {
      for (; ; ) {
        var A = this.consumeCodePoint();
        if (A === pa || A === Qr)
          return;
        cn(A, this.peekCodePoint(0)) && this.consumeEscapedCodePoint();
      }
    }, t.prototype.consumeStringSlice = function(A) {
      for (var e = 5e4, r = ""; A > 0; ) {
        var n = Math.min(e, A);
        r += Me.apply(void 0, this._value.splice(0, n)), A -= n;
      }
      return this._value.shift(), r;
    }, t.prototype.consumeStringToken = function(A) {
      var e = "", r = 0;
      do {
        var n = this._value[r];
        if (n === Qr || n === void 0 || n === A)
          return e += this.consumeStringSlice(r), { type: 0, value: e };
        if (n === co)
          return this._value.splice(0, r), U1;
        if (n === La) {
          var i = this._value[r + 1];
          i !== Qr && i !== void 0 && (i === co ? (e += this.consumeStringSlice(r), r = -1, this._value.shift()) : cn(n, i) && (e += this.consumeStringSlice(r), e += Me(this.consumeEscapedCodePoint()), r = -1));
        }
        r++;
      } while (!0);
    }, t.prototype.consumeNumber = function() {
      var A = [], e = Oa, r = this.peekCodePoint(0);
      for ((r === On || r === Lt) && A.push(this.consumeCodePoint()); gt(this.peekCodePoint(0)); )
        A.push(this.consumeCodePoint());
      r = this.peekCodePoint(0);
      var n = this.peekCodePoint(1);
      if (r === _a && gt(n))
        for (A.push(this.consumeCodePoint(), this.consumeCodePoint()), e = Il; gt(this.peekCodePoint(0)); )
          A.push(this.consumeCodePoint());
      r = this.peekCodePoint(0), n = this.peekCodePoint(1);
      var i = this.peekCodePoint(2);
      if ((r === Xf || r === qf) && ((n === On || n === Lt) && gt(i) || gt(n)))
        for (A.push(this.consumeCodePoint(), this.consumeCodePoint()), e = Il; gt(this.peekCodePoint(0)); )
          A.push(this.consumeCodePoint());
      return [f1(A), e];
    }, t.prototype.consumeNumericToken = function() {
      var A = this.consumeNumber(), e = A[0], r = A[1], n = this.peekCodePoint(0), i = this.peekCodePoint(1), s = this.peekCodePoint(2);
      if (Rs(n, i, s)) {
        var u = this.consumeName();
        return { type: 15, number: e, flags: r, unit: u };
      }
      return n === N0 ? (this.consumeCodePoint(), { type: 16, number: e, flags: r }) : { type: 17, number: e, flags: r };
    }, t.prototype.consumeEscapedCodePoint = function() {
      var A = this.consumeCodePoint();
      if (vi(A)) {
        for (var e = Me(A); vi(this.peekCodePoint(0)) && e.length < 6; )
          e += Me(this.consumeCodePoint());
        ks(this.peekCodePoint(0)) && this.consumeCodePoint();
        var r = parseInt(e, 16);
        return r === 0 || a1(r) || r > 1114111 ? Sl : r;
      }
      return A === Qr ? Sl : A;
    }, t.prototype.consumeName = function() {
      for (var A = ""; ; ) {
        var e = this.consumeCodePoint();
        if (Nl(e))
          A += Me(e);
        else if (cn(e, this.peekCodePoint(0)))
          A += Me(this.consumeEscapedCodePoint());
        else
          return this.reconsumeCodePoint(e), A;
      }
    }, t;
  }()
), Yf = (
  /** @class */
  function() {
    function t(A) {
      this._tokens = A;
    }
    return t.create = function(A) {
      var e = new zf();
      return e.write(A), new t(e.read());
    }, t.parseValue = function(A) {
      return t.create(A).parseComponentValue();
    }, t.parseValues = function(A) {
      return t.create(A).parseComponentValues();
    }, t.prototype.parseComponentValue = function() {
      for (var A = this.consumeToken(); A.type === 31; )
        A = this.consumeToken();
      if (A.type === 32)
        throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
      this.reconsumeToken(A);
      var e = this.consumeComponentValue();
      do
        A = this.consumeToken();
      while (A.type === 31);
      if (A.type === 32)
        return e;
      throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
    }, t.prototype.parseComponentValues = function() {
      for (var A = []; ; ) {
        var e = this.consumeComponentValue();
        if (e.type === 32)
          return A;
        A.push(e), A.push();
      }
    }, t.prototype.consumeComponentValue = function() {
      var A = this.consumeToken();
      switch (A.type) {
        case 11:
        case 28:
        case 2:
          return this.consumeSimpleBlock(A.type);
        case 19:
          return this.consumeFunction(A);
      }
      return A;
    }, t.prototype.consumeSimpleBlock = function(A) {
      for (var e = { type: A, values: [] }, r = this.consumeToken(); ; ) {
        if (r.type === 32 || N1(r, A))
          return e;
        this.reconsumeToken(r), e.values.push(this.consumeComponentValue()), r = this.consumeToken();
      }
    }, t.prototype.consumeFunction = function(A) {
      for (var e = {
        name: A.value,
        values: [],
        type: 18
        /* FUNCTION */
      }; ; ) {
        var r = this.consumeToken();
        if (r.type === 32 || r.type === 3)
          return e;
        this.reconsumeToken(r), e.values.push(this.consumeComponentValue());
      }
    }, t.prototype.consumeToken = function() {
      var A = this._tokens.shift();
      return typeof A > "u" ? fc : A;
    }, t.prototype.reconsumeToken = function(A) {
      this._tokens.unshift(A);
    }, t;
  }()
), Pa = function(t) {
  return t.type === 15;
}, Oi = function(t) {
  return t.type === 17;
}, ve = function(t) {
  return t.type === 20;
}, S1 = function(t) {
  return t.type === 0;
}, hc = function(t, A) {
  return ve(t) && t.value === A;
}, Zf = function(t) {
  return t.type !== 31;
}, Ti = function(t) {
  return t.type !== 31 && t.type !== 4;
}, br = function(t) {
  var A = [], e = [];
  return t.forEach(function(r) {
    if (r.type === 4) {
      if (e.length === 0)
        throw new Error("Error parsing function args, zero tokens for arg");
      A.push(e), e = [];
      return;
    }
    r.type !== 31 && e.push(r);
  }), e.length && A.push(e), A;
}, N1 = function(t, A) {
  return A === 11 && t.type === 12 || A === 28 && t.type === 29 ? !0 : A === 2 && t.type === 3;
}, pn = function(t) {
  return t.type === 17 || t.type === 15;
}, We = function(t) {
  return t.type === 16 || pn(t);
}, $f = function(t) {
  return t.length > 1 ? [t[0], t[1]] : [t[0]];
}, at = {
  type: 17,
  number: 0,
  flags: Oa
}, Dc = {
  type: 16,
  number: 50,
  flags: Oa
}, fn = {
  type: 16,
  number: 100,
  flags: Oa
}, Ua = function(t, A, e) {
  var r = t[0], n = t[1];
  return [ye(r, A), ye(typeof n < "u" ? n : r, e)];
}, ye = function(t, A) {
  if (t.type === 16)
    return t.number / 100 * A;
  if (Pa(t))
    switch (t.unit) {
      case "rem":
      case "em":
        return 16 * t.number;
      // TODO use correct font-size
      case "px":
      default:
        return t.number;
    }
  return t.number;
}, Ah = "deg", eh = "grad", th = "rad", rh = "turn", yo = {
  name: "angle",
  parse: function(t, A) {
    if (A.type === 15)
      switch (A.unit) {
        case Ah:
          return Math.PI * A.number / 180;
        case eh:
          return Math.PI / 200 * A.number;
        case th:
          return A.number;
        case rh:
          return Math.PI * 2 * A.number;
      }
    throw new Error("Unsupported angle type");
  }
}, nh = function(t) {
  return t.type === 15 && (t.unit === Ah || t.unit === eh || t.unit === th || t.unit === rh);
}, ih = function(t) {
  var A = t.filter(ve).map(function(e) {
    return e.value;
  }).join(" ");
  switch (A) {
    case "to bottom right":
    case "to right bottom":
    case "left top":
    case "top left":
      return [at, at];
    case "to top":
    case "bottom":
      return qt(0);
    case "to bottom left":
    case "to left bottom":
    case "right top":
    case "top right":
      return [at, fn];
    case "to right":
    case "left":
      return qt(90);
    case "to top left":
    case "to left top":
    case "right bottom":
    case "bottom right":
      return [fn, fn];
    case "to bottom":
    case "top":
      return qt(180);
    case "to top right":
    case "to right top":
    case "left bottom":
    case "bottom left":
      return [fn, at];
    case "to left":
    case "right":
      return qt(270);
  }
  return 0;
}, qt = function(t) {
  return Math.PI * t / 180;
}, gn = {
  name: "color",
  parse: function(t, A) {
    if (A.type === 18) {
      var e = _1[A.name];
      if (typeof e > "u")
        throw new Error('Attempting to parse an unsupported color function "' + A.name + '"');
      return e(t, A.values);
    }
    if (A.type === 5) {
      if (A.value.length === 3) {
        var r = A.value.substring(0, 1), n = A.value.substring(1, 2), i = A.value.substring(2, 3);
        return hn(parseInt(r + r, 16), parseInt(n + n, 16), parseInt(i + i, 16), 1);
      }
      if (A.value.length === 4) {
        var r = A.value.substring(0, 1), n = A.value.substring(1, 2), i = A.value.substring(2, 3), s = A.value.substring(3, 4);
        return hn(parseInt(r + r, 16), parseInt(n + n, 16), parseInt(i + i, 16), parseInt(s + s, 16) / 255);
      }
      if (A.value.length === 6) {
        var r = A.value.substring(0, 2), n = A.value.substring(2, 4), i = A.value.substring(4, 6);
        return hn(parseInt(r, 16), parseInt(n, 16), parseInt(i, 16), 1);
      }
      if (A.value.length === 8) {
        var r = A.value.substring(0, 2), n = A.value.substring(2, 4), i = A.value.substring(4, 6), s = A.value.substring(6, 8);
        return hn(parseInt(r, 16), parseInt(n, 16), parseInt(i, 16), parseInt(s, 16) / 255);
      }
    }
    if (A.type === 20) {
      var u = Gr[A.value.toUpperCase()];
      if (typeof u < "u")
        return u;
    }
    return Gr.TRANSPARENT;
  }
}, dn = function(t) {
  return (255 & t) === 0;
}, At = function(t) {
  var A = 255 & t, e = 255 & t >> 8, r = 255 & t >> 16, n = 255 & t >> 24;
  return A < 255 ? "rgba(" + n + "," + r + "," + e + "," + A / 255 + ")" : "rgb(" + n + "," + r + "," + e + ")";
}, hn = function(t, A, e, r) {
  return (t << 24 | A << 16 | e << 8 | Math.round(r * 255) << 0) >>> 0;
}, _l = function(t, A) {
  if (t.type === 17)
    return t.number;
  if (t.type === 16) {
    var e = A === 3 ? 1 : 255;
    return A === 3 ? t.number / 100 * e : Math.round(t.number / 100 * e);
  }
  return 0;
}, Dl = function(t, A) {
  var e = A.filter(Ti);
  if (e.length === 3) {
    var r = e.map(_l), n = r[0], i = r[1], s = r[2];
    return hn(n, i, s, 1);
  }
  if (e.length === 4) {
    var u = e.map(_l), n = u[0], i = u[1], s = u[2], c = u[3];
    return hn(n, i, s, c);
  }
  return 0;
};
function Hu(t, A, e) {
  return e < 0 && (e += 1), e >= 1 && (e -= 1), e < 1 / 6 ? (A - t) * e * 6 + t : e < 1 / 2 ? A : e < 2 / 3 ? (A - t) * 6 * (2 / 3 - e) + t : t;
}
var Tl = function(t, A) {
  var e = A.filter(Ti), r = e[0], n = e[1], i = e[2], s = e[3], u = (r.type === 17 ? qt(r.number) : yo.parse(t, r)) / (Math.PI * 2), c = We(n) ? n.number / 100 : 0, h = We(i) ? i.number / 100 : 0, g = typeof s < "u" && We(s) ? ye(s, 1) : 1;
  if (c === 0)
    return hn(h * 255, h * 255, h * 255, 1);
  var p = h <= 0.5 ? h * (c + 1) : h + c - h * c, w = h * 2 - p, B = Hu(w, p, u + 1 / 3), L = Hu(w, p, u), y = Hu(w, p, u - 1 / 3);
  return hn(B * 255, L * 255, y * 255, g);
}, _1 = {
  hsl: Tl,
  hsla: Tl,
  rgb: Dl,
  rgba: Dl
}, Ea = function(t, A) {
  return gn.parse(t, Yf.create(A).parseComponentValue());
}, Gr = {
  ALICEBLUE: 4042850303,
  ANTIQUEWHITE: 4209760255,
  AQUA: 16777215,
  AQUAMARINE: 2147472639,
  AZURE: 4043309055,
  BEIGE: 4126530815,
  BISQUE: 4293182719,
  BLACK: 255,
  BLANCHEDALMOND: 4293643775,
  BLUE: 65535,
  BLUEVIOLET: 2318131967,
  BROWN: 2771004159,
  BURLYWOOD: 3736635391,
  CADETBLUE: 1604231423,
  CHARTREUSE: 2147418367,
  CHOCOLATE: 3530104575,
  CORAL: 4286533887,
  CORNFLOWERBLUE: 1687547391,
  CORNSILK: 4294499583,
  CRIMSON: 3692313855,
  CYAN: 16777215,
  DARKBLUE: 35839,
  DARKCYAN: 9145343,
  DARKGOLDENROD: 3095837695,
  DARKGRAY: 2846468607,
  DARKGREEN: 6553855,
  DARKGREY: 2846468607,
  DARKKHAKI: 3182914559,
  DARKMAGENTA: 2332068863,
  DARKOLIVEGREEN: 1433087999,
  DARKORANGE: 4287365375,
  DARKORCHID: 2570243327,
  DARKRED: 2332033279,
  DARKSALMON: 3918953215,
  DARKSEAGREEN: 2411499519,
  DARKSLATEBLUE: 1211993087,
  DARKSLATEGRAY: 793726975,
  DARKSLATEGREY: 793726975,
  DARKTURQUOISE: 13554175,
  DARKVIOLET: 2483082239,
  DEEPPINK: 4279538687,
  DEEPSKYBLUE: 12582911,
  DIMGRAY: 1768516095,
  DIMGREY: 1768516095,
  DODGERBLUE: 512819199,
  FIREBRICK: 2988581631,
  FLORALWHITE: 4294635775,
  FORESTGREEN: 579543807,
  FUCHSIA: 4278255615,
  GAINSBORO: 3705462015,
  GHOSTWHITE: 4177068031,
  GOLD: 4292280575,
  GOLDENROD: 3668254975,
  GRAY: 2155905279,
  GREEN: 8388863,
  GREENYELLOW: 2919182335,
  GREY: 2155905279,
  HONEYDEW: 4043305215,
  HOTPINK: 4285117695,
  INDIANRED: 3445382399,
  INDIGO: 1258324735,
  IVORY: 4294963455,
  KHAKI: 4041641215,
  LAVENDER: 3873897215,
  LAVENDERBLUSH: 4293981695,
  LAWNGREEN: 2096890111,
  LEMONCHIFFON: 4294626815,
  LIGHTBLUE: 2916673279,
  LIGHTCORAL: 4034953471,
  LIGHTCYAN: 3774873599,
  LIGHTGOLDENRODYELLOW: 4210742015,
  LIGHTGRAY: 3553874943,
  LIGHTGREEN: 2431553791,
  LIGHTGREY: 3553874943,
  LIGHTPINK: 4290167295,
  LIGHTSALMON: 4288707327,
  LIGHTSEAGREEN: 548580095,
  LIGHTSKYBLUE: 2278488831,
  LIGHTSLATEGRAY: 2005441023,
  LIGHTSLATEGREY: 2005441023,
  LIGHTSTEELBLUE: 2965692159,
  LIGHTYELLOW: 4294959359,
  LIME: 16711935,
  LIMEGREEN: 852308735,
  LINEN: 4210091775,
  MAGENTA: 4278255615,
  MAROON: 2147483903,
  MEDIUMAQUAMARINE: 1724754687,
  MEDIUMBLUE: 52735,
  MEDIUMORCHID: 3126187007,
  MEDIUMPURPLE: 2473647103,
  MEDIUMSEAGREEN: 1018393087,
  MEDIUMSLATEBLUE: 2070474495,
  MEDIUMSPRINGGREEN: 16423679,
  MEDIUMTURQUOISE: 1221709055,
  MEDIUMVIOLETRED: 3340076543,
  MIDNIGHTBLUE: 421097727,
  MINTCREAM: 4127193855,
  MISTYROSE: 4293190143,
  MOCCASIN: 4293178879,
  NAVAJOWHITE: 4292783615,
  NAVY: 33023,
  OLDLACE: 4260751103,
  OLIVE: 2155872511,
  OLIVEDRAB: 1804477439,
  ORANGE: 4289003775,
  ORANGERED: 4282712319,
  ORCHID: 3664828159,
  PALEGOLDENROD: 4008225535,
  PALEGREEN: 2566625535,
  PALETURQUOISE: 2951671551,
  PALEVIOLETRED: 3681588223,
  PAPAYAWHIP: 4293907967,
  PEACHPUFF: 4292524543,
  PERU: 3448061951,
  PINK: 4290825215,
  PLUM: 3718307327,
  POWDERBLUE: 2967529215,
  PURPLE: 2147516671,
  REBECCAPURPLE: 1714657791,
  RED: 4278190335,
  ROSYBROWN: 3163525119,
  ROYALBLUE: 1097458175,
  SADDLEBROWN: 2336560127,
  SALMON: 4202722047,
  SANDYBROWN: 4104413439,
  SEAGREEN: 780883967,
  SEASHELL: 4294307583,
  SIENNA: 2689740287,
  SILVER: 3233857791,
  SKYBLUE: 2278484991,
  SLATEBLUE: 1784335871,
  SLATEGRAY: 1887473919,
  SLATEGREY: 1887473919,
  SNOW: 4294638335,
  SPRINGGREEN: 16744447,
  STEELBLUE: 1182971135,
  TAN: 3535047935,
  TEAL: 8421631,
  THISTLE: 3636451583,
  TOMATO: 4284696575,
  TRANSPARENT: 0,
  TURQUOISE: 1088475391,
  VIOLET: 4001558271,
  WHEAT: 4125012991,
  WHITE: 4294967295,
  WHITESMOKE: 4126537215,
  YELLOW: 4294902015,
  YELLOWGREEN: 2597139199
}, D1 = {
  name: "background-clip",
  initialValue: "border-box",
  prefix: !1,
  type: 1,
  parse: function(t, A) {
    return A.map(function(e) {
      if (ve(e))
        switch (e.value) {
          case "padding-box":
            return 1;
          case "content-box":
            return 2;
        }
      return 0;
    });
  }
}, T1 = {
  name: "background-color",
  initialValue: "transparent",
  prefix: !1,
  type: 3,
  format: "color"
}, bo = function(t, A) {
  var e = gn.parse(t, A[0]), r = A[1];
  return r && We(r) ? { color: e, stop: r } : { color: e, stop: null };
}, Ol = function(t, A) {
  var e = t[0], r = t[t.length - 1];
  e.stop === null && (e.stop = at), r.stop === null && (r.stop = fn);
  for (var n = [], i = 0, s = 0; s < t.length; s++) {
    var u = t[s].stop;
    if (u !== null) {
      var c = ye(u, A);
      c > i ? n.push(c) : n.push(i), i = c;
    } else
      n.push(null);
  }
  for (var h = null, s = 0; s < n.length; s++) {
    var g = n[s];
    if (g === null)
      h === null && (h = s);
    else if (h !== null) {
      for (var p = s - h, w = n[h - 1], B = (g - w) / (p + 1), L = 1; L <= p; L++)
        n[h + L - 1] = B * L;
      h = null;
    }
  }
  return t.map(function(y, N) {
    var F = y.color;
    return { color: F, stop: Math.max(Math.min(1, n[N] / A), 0) };
  });
}, O1 = function(t, A, e) {
  var r = A / 2, n = e / 2, i = ye(t[0], A) - r, s = n - ye(t[1], e);
  return (Math.atan2(s, i) + Math.PI * 2) % (Math.PI * 2);
}, P1 = function(t, A, e) {
  var r = typeof t == "number" ? t : O1(t, A, e), n = Math.abs(A * Math.sin(r)) + Math.abs(e * Math.cos(r)), i = A / 2, s = e / 2, u = n / 2, c = Math.sin(r - Math.PI / 2) * u, h = Math.cos(r - Math.PI / 2) * u;
  return [n, i - h, i + h, s - c, s + c];
}, sr = function(t, A) {
  return Math.sqrt(t * t + A * A);
}, Pl = function(t, A, e, r, n) {
  var i = [
    [0, 0],
    [0, A],
    [t, 0],
    [t, A]
  ];
  return i.reduce(function(s, u) {
    var c = u[0], h = u[1], g = sr(e - c, r - h);
    return (n ? g < s.optimumDistance : g > s.optimumDistance) ? {
      optimumCorner: u,
      optimumDistance: g
    } : s;
  }, {
    optimumDistance: n ? 1 / 0 : -1 / 0,
    optimumCorner: null
  }).optimumCorner;
}, M1 = function(t, A, e, r, n) {
  var i = 0, s = 0;
  switch (t.size) {
    case 0:
      t.shape === 0 ? i = s = Math.min(Math.abs(A), Math.abs(A - r), Math.abs(e), Math.abs(e - n)) : t.shape === 1 && (i = Math.min(Math.abs(A), Math.abs(A - r)), s = Math.min(Math.abs(e), Math.abs(e - n)));
      break;
    case 2:
      if (t.shape === 0)
        i = s = Math.min(sr(A, e), sr(A, e - n), sr(A - r, e), sr(A - r, e - n));
      else if (t.shape === 1) {
        var u = Math.min(Math.abs(e), Math.abs(e - n)) / Math.min(Math.abs(A), Math.abs(A - r)), c = Pl(r, n, A, e, !0), h = c[0], g = c[1];
        i = sr(h - A, (g - e) / u), s = u * i;
      }
      break;
    case 1:
      t.shape === 0 ? i = s = Math.max(Math.abs(A), Math.abs(A - r), Math.abs(e), Math.abs(e - n)) : t.shape === 1 && (i = Math.max(Math.abs(A), Math.abs(A - r)), s = Math.max(Math.abs(e), Math.abs(e - n)));
      break;
    case 3:
      if (t.shape === 0)
        i = s = Math.max(sr(A, e), sr(A, e - n), sr(A - r, e), sr(A - r, e - n));
      else if (t.shape === 1) {
        var u = Math.max(Math.abs(e), Math.abs(e - n)) / Math.max(Math.abs(A), Math.abs(A - r)), p = Pl(r, n, A, e, !1), h = p[0], g = p[1];
        i = sr(h - A, (g - e) / u), s = u * i;
      }
      break;
  }
  return Array.isArray(t.size) && (i = ye(t.size[0], r), s = t.size.length === 2 ? ye(t.size[1], n) : i), [i, s];
}, K1 = function(t, A) {
  var e = qt(180), r = [];
  return br(A).forEach(function(n, i) {
    if (i === 0) {
      var s = n[0];
      if (s.type === 20 && s.value === "to") {
        e = ih(n);
        return;
      } else if (nh(s)) {
        e = yo.parse(t, s);
        return;
      }
    }
    var u = bo(t, n);
    r.push(u);
  }), {
    angle: e,
    stops: r,
    type: 1
    /* LINEAR_GRADIENT */
  };
}, js = function(t, A) {
  var e = qt(180), r = [];
  return br(A).forEach(function(n, i) {
    if (i === 0) {
      var s = n[0];
      if (s.type === 20 && ["top", "left", "right", "bottom"].indexOf(s.value) !== -1) {
        e = ih(n);
        return;
      } else if (nh(s)) {
        e = (yo.parse(t, s) + qt(270)) % qt(360);
        return;
      }
    }
    var u = bo(t, n);
    r.push(u);
  }), {
    angle: e,
    stops: r,
    type: 1
    /* LINEAR_GRADIENT */
  };
}, k1 = function(t, A) {
  var e = qt(180), r = [], n = 1, i = 0, s = 3, u = [];
  return br(A).forEach(function(c, h) {
    var g = c[0];
    if (h === 0) {
      if (ve(g) && g.value === "linear") {
        n = 1;
        return;
      } else if (ve(g) && g.value === "radial") {
        n = 2;
        return;
      }
    }
    if (g.type === 18) {
      if (g.name === "from") {
        var p = gn.parse(t, g.values[0]);
        r.push({ stop: at, color: p });
      } else if (g.name === "to") {
        var p = gn.parse(t, g.values[0]);
        r.push({ stop: fn, color: p });
      } else if (g.name === "color-stop") {
        var w = g.values.filter(Ti);
        if (w.length === 2) {
          var p = gn.parse(t, w[1]), B = w[0];
          Oi(B) && r.push({
            stop: { type: 16, number: B.number * 100, flags: B.flags },
            color: p
          });
        }
      }
    }
  }), n === 1 ? {
    angle: (e + qt(180)) % qt(360),
    stops: r,
    type: n
  } : { size: s, shape: i, stops: r, position: u, type: n };
}, ah = "closest-side", sh = "farthest-side", oh = "closest-corner", uh = "farthest-corner", ch = "circle", lh = "ellipse", fh = "cover", hh = "contain", R1 = function(t, A) {
  var e = 0, r = 3, n = [], i = [];
  return br(A).forEach(function(s, u) {
    var c = !0;
    if (u === 0) {
      var h = !1;
      c = s.reduce(function(p, w) {
        if (h)
          if (ve(w))
            switch (w.value) {
              case "center":
                return i.push(Dc), p;
              case "top":
              case "left":
                return i.push(at), p;
              case "right":
              case "bottom":
                return i.push(fn), p;
            }
          else (We(w) || pn(w)) && i.push(w);
        else if (ve(w))
          switch (w.value) {
            case ch:
              return e = 0, !1;
            case lh:
              return e = 1, !1;
            case "at":
              return h = !0, !1;
            case ah:
              return r = 0, !1;
            case fh:
            case sh:
              return r = 1, !1;
            case hh:
            case oh:
              return r = 2, !1;
            case uh:
              return r = 3, !1;
          }
        else if (pn(w) || We(w))
          return Array.isArray(r) || (r = []), r.push(w), !1;
        return p;
      }, c);
    }
    if (c) {
      var g = bo(t, s);
      n.push(g);
    }
  }), {
    size: r,
    shape: e,
    stops: n,
    position: i,
    type: 2
    /* RADIAL_GRADIENT */
  };
}, Vs = function(t, A) {
  var e = 0, r = 3, n = [], i = [];
  return br(A).forEach(function(s, u) {
    var c = !0;
    if (u === 0 ? c = s.reduce(function(g, p) {
      if (ve(p))
        switch (p.value) {
          case "center":
            return i.push(Dc), !1;
          case "top":
          case "left":
            return i.push(at), !1;
          case "right":
          case "bottom":
            return i.push(fn), !1;
        }
      else if (We(p) || pn(p))
        return i.push(p), !1;
      return g;
    }, c) : u === 1 && (c = s.reduce(function(g, p) {
      if (ve(p))
        switch (p.value) {
          case ch:
            return e = 0, !1;
          case lh:
            return e = 1, !1;
          case hh:
          case ah:
            return r = 0, !1;
          case sh:
            return r = 1, !1;
          case oh:
            return r = 2, !1;
          case fh:
          case uh:
            return r = 3, !1;
        }
      else if (pn(p) || We(p))
        return Array.isArray(r) || (r = []), r.push(p), !1;
      return g;
    }, c)), c) {
      var h = bo(t, s);
      n.push(h);
    }
  }), {
    size: r,
    shape: e,
    stops: n,
    position: i,
    type: 2
    /* RADIAL_GRADIENT */
  };
}, G1 = function(t) {
  return t.type === 1;
}, j1 = function(t) {
  return t.type === 2;
}, Tc = {
  name: "image",
  parse: function(t, A) {
    if (A.type === 22) {
      var e = {
        url: A.value,
        type: 0
        /* URL */
      };
      return t.cache.addImage(A.value), e;
    }
    if (A.type === 18) {
      var r = Bh[A.name];
      if (typeof r > "u")
        throw new Error('Attempting to parse an unsupported image function "' + A.name + '"');
      return r(t, A.values);
    }
    throw new Error("Unsupported image type " + A.type);
  }
};
function V1(t) {
  return !(t.type === 20 && t.value === "none") && (t.type !== 18 || !!Bh[t.name]);
}
var Bh = {
  "linear-gradient": K1,
  "-moz-linear-gradient": js,
  "-ms-linear-gradient": js,
  "-o-linear-gradient": js,
  "-webkit-linear-gradient": js,
  "radial-gradient": R1,
  "-moz-radial-gradient": Vs,
  "-ms-radial-gradient": Vs,
  "-o-radial-gradient": Vs,
  "-webkit-radial-gradient": Vs,
  "-webkit-gradient": k1
}, q1 = {
  name: "background-image",
  initialValue: "none",
  type: 1,
  prefix: !1,
  parse: function(t, A) {
    if (A.length === 0)
      return [];
    var e = A[0];
    return e.type === 20 && e.value === "none" ? [] : A.filter(function(r) {
      return Ti(r) && V1(r);
    }).map(function(r) {
      return Tc.parse(t, r);
    });
  }
}, W1 = {
  name: "background-origin",
  initialValue: "border-box",
  prefix: !1,
  type: 1,
  parse: function(t, A) {
    return A.map(function(e) {
      if (ve(e))
        switch (e.value) {
          case "padding-box":
            return 1;
          case "content-box":
            return 2;
        }
      return 0;
    });
  }
}, X1 = {
  name: "background-position",
  initialValue: "0% 0%",
  type: 1,
  prefix: !1,
  parse: function(t, A) {
    return br(A).map(function(e) {
      return e.filter(We);
    }).map($f);
  }
}, J1 = {
  name: "background-repeat",
  initialValue: "repeat",
  prefix: !1,
  type: 1,
  parse: function(t, A) {
    return br(A).map(function(e) {
      return e.filter(ve).map(function(r) {
        return r.value;
      }).join(" ");
    }).map(z1);
  }
}, z1 = function(t) {
  switch (t) {
    case "no-repeat":
      return 1;
    case "repeat-x":
    case "repeat no-repeat":
      return 2;
    case "repeat-y":
    case "no-repeat repeat":
      return 3;
    case "repeat":
    default:
      return 0;
  }
}, Hi;
(function(t) {
  t.AUTO = "auto", t.CONTAIN = "contain", t.COVER = "cover";
})(Hi || (Hi = {}));
var Y1 = {
  name: "background-size",
  initialValue: "0",
  prefix: !1,
  type: 1,
  parse: function(t, A) {
    return br(A).map(function(e) {
      return e.filter(Z1);
    });
  }
}, Z1 = function(t) {
  return ve(t) || We(t);
}, Lo = function(t) {
  return {
    name: "border-" + t + "-color",
    initialValue: "transparent",
    prefix: !1,
    type: 3,
    format: "color"
  };
}, $1 = Lo("top"), Ag = Lo("right"), eg = Lo("bottom"), tg = Lo("left"), Eo = function(t) {
  return {
    name: "border-radius-" + t,
    initialValue: "0 0",
    prefix: !1,
    type: 1,
    parse: function(A, e) {
      return $f(e.filter(We));
    }
  };
}, rg = Eo("top-left"), ng = Eo("top-right"), ig = Eo("bottom-right"), ag = Eo("bottom-left"), Io = function(t) {
  return {
    name: "border-" + t + "-style",
    initialValue: "solid",
    prefix: !1,
    type: 2,
    parse: function(A, e) {
      switch (e) {
        case "none":
          return 0;
        case "dashed":
          return 2;
        case "dotted":
          return 3;
        case "double":
          return 4;
      }
      return 1;
    }
  };
}, sg = Io("top"), og = Io("right"), ug = Io("bottom"), cg = Io("left"), xo = function(t) {
  return {
    name: "border-" + t + "-width",
    initialValue: "0",
    type: 0,
    prefix: !1,
    parse: function(A, e) {
      return Pa(e) ? e.number : 0;
    }
  };
}, lg = xo("top"), fg = xo("right"), hg = xo("bottom"), Bg = xo("left"), gg = {
  name: "color",
  initialValue: "transparent",
  prefix: !1,
  type: 3,
  format: "color"
}, dg = {
  name: "direction",
  initialValue: "ltr",
  prefix: !1,
  type: 2,
  parse: function(t, A) {
    switch (A) {
      case "rtl":
        return 1;
      case "ltr":
      default:
        return 0;
    }
  }
}, pg = {
  name: "display",
  initialValue: "inline-block",
  prefix: !1,
  type: 1,
  parse: function(t, A) {
    return A.filter(ve).reduce(
      function(e, r) {
        return e | wg(r.value);
      },
      0
      /* NONE */
    );
  }
}, wg = function(t) {
  switch (t) {
    case "block":
    case "-webkit-box":
      return 2;
    case "inline":
      return 4;
    case "run-in":
      return 8;
    case "flow":
      return 16;
    case "flow-root":
      return 32;
    case "table":
      return 64;
    case "flex":
    case "-webkit-flex":
      return 128;
    case "grid":
    case "-ms-grid":
      return 256;
    case "ruby":
      return 512;
    case "subgrid":
      return 1024;
    case "list-item":
      return 2048;
    case "table-row-group":
      return 4096;
    case "table-header-group":
      return 8192;
    case "table-footer-group":
      return 16384;
    case "table-row":
      return 32768;
    case "table-cell":
      return 65536;
    case "table-column-group":
      return 131072;
    case "table-column":
      return 262144;
    case "table-caption":
      return 524288;
    case "ruby-base":
      return 1048576;
    case "ruby-text":
      return 2097152;
    case "ruby-base-container":
      return 4194304;
    case "ruby-text-container":
      return 8388608;
    case "contents":
      return 16777216;
    case "inline-block":
      return 33554432;
    case "inline-list-item":
      return 67108864;
    case "inline-table":
      return 134217728;
    case "inline-flex":
      return 268435456;
    case "inline-grid":
      return 536870912;
  }
  return 0;
}, vg = {
  name: "float",
  initialValue: "none",
  prefix: !1,
  type: 2,
  parse: function(t, A) {
    switch (A) {
      case "left":
        return 1;
      case "right":
        return 2;
      case "inline-start":
        return 3;
      case "inline-end":
        return 4;
    }
    return 0;
  }
}, mg = {
  name: "letter-spacing",
  initialValue: "0",
  prefix: !1,
  type: 0,
  parse: function(t, A) {
    return A.type === 20 && A.value === "normal" ? 0 : A.type === 17 || A.type === 15 ? A.number : 0;
  }
}, fo;
(function(t) {
  t.NORMAL = "normal", t.STRICT = "strict";
})(fo || (fo = {}));
var Cg = {
  name: "line-break",
  initialValue: "normal",
  prefix: !1,
  type: 2,
  parse: function(t, A) {
    switch (A) {
      case "strict":
        return fo.STRICT;
      case "normal":
      default:
        return fo.NORMAL;
    }
  }
}, Qg = {
  name: "line-height",
  initialValue: "normal",
  prefix: !1,
  type: 4
  /* TOKEN_VALUE */
}, Ml = function(t, A) {
  return ve(t) && t.value === "normal" ? 1.2 * A : t.type === 17 ? A * t.number : We(t) ? ye(t, A) : A;
}, Fg = {
  name: "list-style-image",
  initialValue: "none",
  type: 0,
  prefix: !1,
  parse: function(t, A) {
    return A.type === 20 && A.value === "none" ? null : Tc.parse(t, A);
  }
}, Ug = {
  name: "list-style-position",
  initialValue: "outside",
  prefix: !1,
  type: 2,
  parse: function(t, A) {
    switch (A) {
      case "inside":
        return 0;
      case "outside":
      default:
        return 1;
    }
  }
}, Bc = {
  name: "list-style-type",
  initialValue: "none",
  prefix: !1,
  type: 2,
  parse: function(t, A) {
    switch (A) {
      case "disc":
        return 0;
      case "circle":
        return 1;
      case "square":
        return 2;
      case "decimal":
        return 3;
      case "cjk-decimal":
        return 4;
      case "decimal-leading-zero":
        return 5;
      case "lower-roman":
        return 6;
      case "upper-roman":
        return 7;
      case "lower-greek":
        return 8;
      case "lower-alpha":
        return 9;
      case "upper-alpha":
        return 10;
      case "arabic-indic":
        return 11;
      case "armenian":
        return 12;
      case "bengali":
        return 13;
      case "cambodian":
        return 14;
      case "cjk-earthly-branch":
        return 15;
      case "cjk-heavenly-stem":
        return 16;
      case "cjk-ideographic":
        return 17;
      case "devanagari":
        return 18;
      case "ethiopic-numeric":
        return 19;
      case "georgian":
        return 20;
      case "gujarati":
        return 21;
      case "gurmukhi":
        return 22;
      case "hebrew":
        return 22;
      case "hiragana":
        return 23;
      case "hiragana-iroha":
        return 24;
      case "japanese-formal":
        return 25;
      case "japanese-informal":
        return 26;
      case "kannada":
        return 27;
      case "katakana":
        return 28;
      case "katakana-iroha":
        return 29;
      case "khmer":
        return 30;
      case "korean-hangul-formal":
        return 31;
      case "korean-hanja-formal":
        return 32;
      case "korean-hanja-informal":
        return 33;
      case "lao":
        return 34;
      case "lower-armenian":
        return 35;
      case "malayalam":
        return 36;
      case "mongolian":
        return 37;
      case "myanmar":
        return 38;
      case "oriya":
        return 39;
      case "persian":
        return 40;
      case "simp-chinese-formal":
        return 41;
      case "simp-chinese-informal":
        return 42;
      case "tamil":
        return 43;
      case "telugu":
        return 44;
      case "thai":
        return 45;
      case "tibetan":
        return 46;
      case "trad-chinese-formal":
        return 47;
      case "trad-chinese-informal":
        return 48;
      case "upper-armenian":
        return 49;
      case "disclosure-open":
        return 50;
      case "disclosure-closed":
        return 51;
      case "none":
      default:
        return -1;
    }
  }
}, Ho = function(t) {
  return {
    name: "margin-" + t,
    initialValue: "0",
    prefix: !1,
    type: 4
    /* TOKEN_VALUE */
  };
}, yg = Ho("top"), bg = Ho("right"), Lg = Ho("bottom"), Eg = Ho("left"), Ig = {
  name: "overflow",
  initialValue: "visible",
  prefix: !1,
  type: 1,
  parse: function(t, A) {
    return A.filter(ve).map(function(e) {
      switch (e.value) {
        case "hidden":
          return 1;
        case "scroll":
          return 2;
        case "clip":
          return 3;
        case "auto":
          return 4;
        case "visible":
        default:
          return 0;
      }
    });
  }
}, xg = {
  name: "overflow-wrap",
  initialValue: "normal",
  prefix: !1,
  type: 2,
  parse: function(t, A) {
    switch (A) {
      case "break-word":
        return "break-word";
      case "normal":
      default:
        return "normal";
    }
  }
}, So = function(t) {
  return {
    name: "padding-" + t,
    initialValue: "0",
    prefix: !1,
    type: 3,
    format: "length-percentage"
  };
}, Hg = So("top"), Sg = So("right"), Ng = So("bottom"), _g = So("left"), Dg = {
  name: "text-align",
  initialValue: "left",
  prefix: !1,
  type: 2,
  parse: function(t, A) {
    switch (A) {
      case "right":
        return 2;
      case "center":
      case "justify":
        return 1;
      case "left":
      default:
        return 0;
    }
  }
}, Tg = {
  name: "position",
  initialValue: "static",
  prefix: !1,
  type: 2,
  parse: function(t, A) {
    switch (A) {
      case "relative":
        return 1;
      case "absolute":
        return 2;
      case "fixed":
        return 3;
      case "sticky":
        return 4;
    }
    return 0;
  }
}, Og = {
  name: "text-shadow",
  initialValue: "none",
  type: 1,
  prefix: !1,
  parse: function(t, A) {
    return A.length === 1 && hc(A[0], "none") ? [] : br(A).map(function(e) {
      for (var r = {
        color: Gr.TRANSPARENT,
        offsetX: at,
        offsetY: at,
        blur: at
      }, n = 0, i = 0; i < e.length; i++) {
        var s = e[i];
        pn(s) ? (n === 0 ? r.offsetX = s : n === 1 ? r.offsetY = s : r.blur = s, n++) : r.color = gn.parse(t, s);
      }
      return r;
    });
  }
}, Pg = {
  name: "text-transform",
  initialValue: "none",
  prefix: !1,
  type: 2,
  parse: function(t, A) {
    switch (A) {
      case "uppercase":
        return 2;
      case "lowercase":
        return 1;
      case "capitalize":
        return 3;
    }
    return 0;
  }
}, Mg = {
  name: "transform",
  initialValue: "none",
  prefix: !0,
  type: 0,
  parse: function(t, A) {
    if (A.type === 20 && A.value === "none")
      return null;
    if (A.type === 18) {
      var e = Rg[A.name];
      if (typeof e > "u")
        throw new Error('Attempting to parse an unsupported transform function "' + A.name + '"');
      return e(A.values);
    }
    return null;
  }
}, Kg = function(t) {
  var A = t.filter(function(e) {
    return e.type === 17;
  }).map(function(e) {
    return e.number;
  });
  return A.length === 6 ? A : null;
}, kg = function(t) {
  var A = t.filter(function(c) {
    return c.type === 17;
  }).map(function(c) {
    return c.number;
  }), e = A[0], r = A[1];
  A[2], A[3];
  var n = A[4], i = A[5];
  A[6], A[7], A[8], A[9], A[10], A[11];
  var s = A[12], u = A[13];
  return A[14], A[15], A.length === 16 ? [e, r, n, i, s, u] : null;
}, Rg = {
  matrix: Kg,
  matrix3d: kg
}, Kl = {
  type: 16,
  number: 50,
  flags: Oa
}, Gg = [Kl, Kl], jg = {
  name: "transform-origin",
  initialValue: "50% 50%",
  prefix: !0,
  type: 1,
  parse: function(t, A) {
    var e = A.filter(We);
    return e.length !== 2 ? Gg : [e[0], e[1]];
  }
}, Vg = {
  name: "visible",
  initialValue: "none",
  prefix: !1,
  type: 2,
  parse: function(t, A) {
    switch (A) {
      case "hidden":
        return 1;
      case "collapse":
        return 2;
      case "visible":
      default:
        return 0;
    }
  }
}, Ia;
(function(t) {
  t.NORMAL = "normal", t.BREAK_ALL = "break-all", t.KEEP_ALL = "keep-all";
})(Ia || (Ia = {}));
var qg = {
  name: "word-break",
  initialValue: "normal",
  prefix: !1,
  type: 2,
  parse: function(t, A) {
    switch (A) {
      case "break-all":
        return Ia.BREAK_ALL;
      case "keep-all":
        return Ia.KEEP_ALL;
      case "normal":
      default:
        return Ia.NORMAL;
    }
  }
}, Wg = {
  name: "z-index",
  initialValue: "auto",
  prefix: !1,
  type: 0,
  parse: function(t, A) {
    if (A.type === 20)
      return { auto: !0, order: 0 };
    if (Oi(A))
      return { auto: !1, order: A.number };
    throw new Error("Invalid z-index number parsed");
  }
}, gh = {
  name: "time",
  parse: function(t, A) {
    if (A.type === 15)
      switch (A.unit.toLowerCase()) {
        case "s":
          return 1e3 * A.number;
        case "ms":
          return A.number;
      }
    throw new Error("Unsupported time type");
  }
}, Xg = {
  name: "opacity",
  initialValue: "1",
  type: 0,
  prefix: !1,
  parse: function(t, A) {
    return Oi(A) ? A.number : 1;
  }
}, Jg = {
  name: "text-decoration-color",
  initialValue: "transparent",
  prefix: !1,
  type: 3,
  format: "color"
}, zg = {
  name: "text-decoration-line",
  initialValue: "none",
  prefix: !1,
  type: 1,
  parse: function(t, A) {
    return A.filter(ve).map(function(e) {
      switch (e.value) {
        case "underline":
          return 1;
        case "overline":
          return 2;
        case "line-through":
          return 3;
        case "none":
          return 4;
      }
      return 0;
    }).filter(function(e) {
      return e !== 0;
    });
  }
}, Yg = {
  name: "font-family",
  initialValue: "",
  prefix: !1,
  type: 1,
  parse: function(t, A) {
    var e = [], r = [];
    return A.forEach(function(n) {
      switch (n.type) {
        case 20:
        case 0:
          e.push(n.value);
          break;
        case 17:
          e.push(n.number.toString());
          break;
        case 4:
          r.push(e.join(" ")), e.length = 0;
          break;
      }
    }), e.length && r.push(e.join(" ")), r.map(function(n) {
      return n.indexOf(" ") === -1 ? n : "'" + n + "'";
    });
  }
}, Zg = {
  name: "font-size",
  initialValue: "0",
  prefix: !1,
  type: 3,
  format: "length"
}, $g = {
  name: "font-weight",
  initialValue: "normal",
  type: 0,
  prefix: !1,
  parse: function(t, A) {
    if (Oi(A))
      return A.number;
    if (ve(A))
      switch (A.value) {
        case "bold":
          return 700;
        case "normal":
        default:
          return 400;
      }
    return 400;
  }
}, A2 = {
  name: "font-variant",
  initialValue: "none",
  type: 1,
  prefix: !1,
  parse: function(t, A) {
    return A.filter(ve).map(function(e) {
      return e.value;
    });
  }
}, e2 = {
  name: "font-style",
  initialValue: "normal",
  prefix: !1,
  type: 2,
  parse: function(t, A) {
    switch (A) {
      case "oblique":
        return "oblique";
      case "italic":
        return "italic";
      case "normal":
      default:
        return "normal";
    }
  }
}, ze = function(t, A) {
  return (t & A) !== 0;
}, t2 = {
  name: "content",
  initialValue: "none",
  type: 1,
  prefix: !1,
  parse: function(t, A) {
    if (A.length === 0)
      return [];
    var e = A[0];
    return e.type === 20 && e.value === "none" ? [] : A;
  }
}, r2 = {
  name: "counter-increment",
  initialValue: "none",
  prefix: !0,
  type: 1,
  parse: function(t, A) {
    if (A.length === 0)
      return null;
    var e = A[0];
    if (e.type === 20 && e.value === "none")
      return null;
    for (var r = [], n = A.filter(Zf), i = 0; i < n.length; i++) {
      var s = n[i], u = n[i + 1];
      if (s.type === 20) {
        var c = u && Oi(u) ? u.number : 1;
        r.push({ counter: s.value, increment: c });
      }
    }
    return r;
  }
}, n2 = {
  name: "counter-reset",
  initialValue: "none",
  prefix: !0,
  type: 1,
  parse: function(t, A) {
    if (A.length === 0)
      return [];
    for (var e = [], r = A.filter(Zf), n = 0; n < r.length; n++) {
      var i = r[n], s = r[n + 1];
      if (ve(i) && i.value !== "none") {
        var u = s && Oi(s) ? s.number : 0;
        e.push({ counter: i.value, reset: u });
      }
    }
    return e;
  }
}, i2 = {
  name: "duration",
  initialValue: "0s",
  prefix: !1,
  type: 1,
  parse: function(t, A) {
    return A.filter(Pa).map(function(e) {
      return gh.parse(t, e);
    });
  }
}, a2 = {
  name: "quotes",
  initialValue: "none",
  prefix: !0,
  type: 1,
  parse: function(t, A) {
    if (A.length === 0)
      return null;
    var e = A[0];
    if (e.type === 20 && e.value === "none")
      return null;
    var r = [], n = A.filter(S1);
    if (n.length % 2 !== 0)
      return null;
    for (var i = 0; i < n.length; i += 2) {
      var s = n[i].value, u = n[i + 1].value;
      r.push({ open: s, close: u });
    }
    return r;
  }
}, kl = function(t, A, e) {
  if (!t)
    return "";
  var r = t[Math.min(A, t.length - 1)];
  return r ? e ? r.open : r.close : "";
}, s2 = {
  name: "box-shadow",
  initialValue: "none",
  type: 1,
  prefix: !1,
  parse: function(t, A) {
    return A.length === 1 && hc(A[0], "none") ? [] : br(A).map(function(e) {
      for (var r = {
        color: 255,
        offsetX: at,
        offsetY: at,
        blur: at,
        spread: at,
        inset: !1
      }, n = 0, i = 0; i < e.length; i++) {
        var s = e[i];
        hc(s, "inset") ? r.inset = !0 : pn(s) ? (n === 0 ? r.offsetX = s : n === 1 ? r.offsetY = s : n === 2 ? r.blur = s : r.spread = s, n++) : r.color = gn.parse(t, s);
      }
      return r;
    });
  }
}, o2 = {
  name: "paint-order",
  initialValue: "normal",
  prefix: !1,
  type: 1,
  parse: function(t, A) {
    var e = [
      0,
      1,
      2
      /* MARKERS */
    ], r = [];
    return A.filter(ve).forEach(function(n) {
      switch (n.value) {
        case "stroke":
          r.push(
            1
            /* STROKE */
          );
          break;
        case "fill":
          r.push(
            0
            /* FILL */
          );
          break;
        case "markers":
          r.push(
            2
            /* MARKERS */
          );
          break;
      }
    }), e.forEach(function(n) {
      r.indexOf(n) === -1 && r.push(n);
    }), r;
  }
}, u2 = {
  name: "-webkit-text-stroke-color",
  initialValue: "currentcolor",
  prefix: !1,
  type: 3,
  format: "color"
}, c2 = {
  name: "-webkit-text-stroke-width",
  initialValue: "0",
  type: 0,
  prefix: !1,
  parse: function(t, A) {
    return Pa(A) ? A.number : 0;
  }
}, l2 = (
  /** @class */
  function() {
    function t(A, e) {
      var r, n;
      this.animationDuration = TA(A, i2, e.animationDuration), this.backgroundClip = TA(A, D1, e.backgroundClip), this.backgroundColor = TA(A, T1, e.backgroundColor), this.backgroundImage = TA(A, q1, e.backgroundImage), this.backgroundOrigin = TA(A, W1, e.backgroundOrigin), this.backgroundPosition = TA(A, X1, e.backgroundPosition), this.backgroundRepeat = TA(A, J1, e.backgroundRepeat), this.backgroundSize = TA(A, Y1, e.backgroundSize), this.borderTopColor = TA(A, $1, e.borderTopColor), this.borderRightColor = TA(A, Ag, e.borderRightColor), this.borderBottomColor = TA(A, eg, e.borderBottomColor), this.borderLeftColor = TA(A, tg, e.borderLeftColor), this.borderTopLeftRadius = TA(A, rg, e.borderTopLeftRadius), this.borderTopRightRadius = TA(A, ng, e.borderTopRightRadius), this.borderBottomRightRadius = TA(A, ig, e.borderBottomRightRadius), this.borderBottomLeftRadius = TA(A, ag, e.borderBottomLeftRadius), this.borderTopStyle = TA(A, sg, e.borderTopStyle), this.borderRightStyle = TA(A, og, e.borderRightStyle), this.borderBottomStyle = TA(A, ug, e.borderBottomStyle), this.borderLeftStyle = TA(A, cg, e.borderLeftStyle), this.borderTopWidth = TA(A, lg, e.borderTopWidth), this.borderRightWidth = TA(A, fg, e.borderRightWidth), this.borderBottomWidth = TA(A, hg, e.borderBottomWidth), this.borderLeftWidth = TA(A, Bg, e.borderLeftWidth), this.boxShadow = TA(A, s2, e.boxShadow), this.color = TA(A, gg, e.color), this.direction = TA(A, dg, e.direction), this.display = TA(A, pg, e.display), this.float = TA(A, vg, e.cssFloat), this.fontFamily = TA(A, Yg, e.fontFamily), this.fontSize = TA(A, Zg, e.fontSize), this.fontStyle = TA(A, e2, e.fontStyle), this.fontVariant = TA(A, A2, e.fontVariant), this.fontWeight = TA(A, $g, e.fontWeight), this.letterSpacing = TA(A, mg, e.letterSpacing), this.lineBreak = TA(A, Cg, e.lineBreak), this.lineHeight = TA(A, Qg, e.lineHeight), this.listStyleImage = TA(A, Fg, e.listStyleImage), this.listStylePosition = TA(A, Ug, e.listStylePosition), this.listStyleType = TA(A, Bc, e.listStyleType), this.marginTop = TA(A, yg, e.marginTop), this.marginRight = TA(A, bg, e.marginRight), this.marginBottom = TA(A, Lg, e.marginBottom), this.marginLeft = TA(A, Eg, e.marginLeft), this.opacity = TA(A, Xg, e.opacity);
      var i = TA(A, Ig, e.overflow);
      this.overflowX = i[0], this.overflowY = i[i.length > 1 ? 1 : 0], this.overflowWrap = TA(A, xg, e.overflowWrap), this.paddingTop = TA(A, Hg, e.paddingTop), this.paddingRight = TA(A, Sg, e.paddingRight), this.paddingBottom = TA(A, Ng, e.paddingBottom), this.paddingLeft = TA(A, _g, e.paddingLeft), this.paintOrder = TA(A, o2, e.paintOrder), this.position = TA(A, Tg, e.position), this.textAlign = TA(A, Dg, e.textAlign), this.textDecorationColor = TA(A, Jg, (r = e.textDecorationColor) !== null && r !== void 0 ? r : e.color), this.textDecorationLine = TA(A, zg, (n = e.textDecorationLine) !== null && n !== void 0 ? n : e.textDecoration), this.textShadow = TA(A, Og, e.textShadow), this.textTransform = TA(A, Pg, e.textTransform), this.transform = TA(A, Mg, e.transform), this.transformOrigin = TA(A, jg, e.transformOrigin), this.visibility = TA(A, Vg, e.visibility), this.webkitTextStrokeColor = TA(A, u2, e.webkitTextStrokeColor), this.webkitTextStrokeWidth = TA(A, c2, e.webkitTextStrokeWidth), this.wordBreak = TA(A, qg, e.wordBreak), this.zIndex = TA(A, Wg, e.zIndex);
    }
    return t.prototype.isVisible = function() {
      return this.display > 0 && this.opacity > 0 && this.visibility === 0;
    }, t.prototype.isTransparent = function() {
      return dn(this.backgroundColor);
    }, t.prototype.isTransformed = function() {
      return this.transform !== null;
    }, t.prototype.isPositioned = function() {
      return this.position !== 0;
    }, t.prototype.isPositionedWithZIndex = function() {
      return this.isPositioned() && !this.zIndex.auto;
    }, t.prototype.isFloating = function() {
      return this.float !== 0;
    }, t.prototype.isInlineLevel = function() {
      return ze(
        this.display,
        4
        /* INLINE */
      ) || ze(
        this.display,
        33554432
        /* INLINE_BLOCK */
      ) || ze(
        this.display,
        268435456
        /* INLINE_FLEX */
      ) || ze(
        this.display,
        536870912
        /* INLINE_GRID */
      ) || ze(
        this.display,
        67108864
        /* INLINE_LIST_ITEM */
      ) || ze(
        this.display,
        134217728
        /* INLINE_TABLE */
      );
    }, t;
  }()
), f2 = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(A, e) {
      this.content = TA(A, t2, e.content), this.quotes = TA(A, a2, e.quotes);
    }
    return t;
  }()
), Rl = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(A, e) {
      this.counterIncrement = TA(A, r2, e.counterIncrement), this.counterReset = TA(A, n2, e.counterReset);
    }
    return t;
  }()
), TA = function(t, A, e) {
  var r = new zf(), n = e !== null && typeof e < "u" ? e.toString() : A.initialValue;
  r.write(n);
  var i = new Yf(r.read());
  switch (A.type) {
    case 2:
      var s = i.parseComponentValue();
      return A.parse(t, ve(s) ? s.value : A.initialValue);
    case 0:
      return A.parse(t, i.parseComponentValue());
    case 1:
      return A.parse(t, i.parseComponentValues());
    case 4:
      return i.parseComponentValue();
    case 3:
      switch (A.format) {
        case "angle":
          return yo.parse(t, i.parseComponentValue());
        case "color":
          return gn.parse(t, i.parseComponentValue());
        case "image":
          return Tc.parse(t, i.parseComponentValue());
        case "length":
          var u = i.parseComponentValue();
          return pn(u) ? u : at;
        case "length-percentage":
          var c = i.parseComponentValue();
          return We(c) ? c : at;
        case "time":
          return gh.parse(t, i.parseComponentValue());
      }
      break;
  }
}, h2 = "data-html2canvas-debug", B2 = function(t) {
  var A = t.getAttribute(h2);
  switch (A) {
    case "all":
      return 1;
    case "clone":
      return 2;
    case "parse":
      return 3;
    case "render":
      return 4;
    default:
      return 0;
  }
}, gc = function(t, A) {
  var e = B2(t);
  return e === 1 || A === e;
}, Lr = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(A, e) {
      if (this.context = A, this.textNodes = [], this.elements = [], this.flags = 0, gc(
        e,
        3
        /* PARSE */
      ))
        debugger;
      this.styles = new l2(A, window.getComputedStyle(e, null)), wc(e) && (this.styles.animationDuration.some(function(r) {
        return r > 0;
      }) && (e.style.animationDuration = "0s"), this.styles.transform !== null && (e.style.transform = "none")), this.bounds = Fo(this.context, e), gc(
        e,
        4
        /* RENDER */
      ) && (this.flags |= 16);
    }
    return t;
  }()
), g2 = "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", Gl = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", ya = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var qs = 0; qs < Gl.length; qs++)
  ya[Gl.charCodeAt(qs)] = qs;
var d2 = function(t) {
  var A = t.length * 0.75, e = t.length, r, n = 0, i, s, u, c;
  t[t.length - 1] === "=" && (A--, t[t.length - 2] === "=" && A--);
  var h = typeof ArrayBuffer < "u" && typeof Uint8Array < "u" && typeof Uint8Array.prototype.slice < "u" ? new ArrayBuffer(A) : new Array(A), g = Array.isArray(h) ? h : new Uint8Array(h);
  for (r = 0; r < e; r += 4)
    i = ya[t.charCodeAt(r)], s = ya[t.charCodeAt(r + 1)], u = ya[t.charCodeAt(r + 2)], c = ya[t.charCodeAt(r + 3)], g[n++] = i << 2 | s >> 4, g[n++] = (s & 15) << 4 | u >> 2, g[n++] = (u & 3) << 6 | c & 63;
  return h;
}, p2 = function(t) {
  for (var A = t.length, e = [], r = 0; r < A; r += 2)
    e.push(t[r + 1] << 8 | t[r]);
  return e;
}, w2 = function(t) {
  for (var A = t.length, e = [], r = 0; r < A; r += 4)
    e.push(t[r + 3] << 24 | t[r + 2] << 16 | t[r + 1] << 8 | t[r]);
  return e;
}, Mn = 5, Oc = 11, Su = 2, v2 = Oc - Mn, dh = 65536 >> Mn, m2 = 1 << Mn, Nu = m2 - 1, C2 = 1024 >> Mn, Q2 = dh + C2, F2 = Q2, U2 = 32, y2 = F2 + U2, b2 = 65536 >> Oc, L2 = 1 << v2, E2 = L2 - 1, jl = function(t, A, e) {
  return t.slice ? t.slice(A, e) : new Uint16Array(Array.prototype.slice.call(t, A, e));
}, I2 = function(t, A, e) {
  return t.slice ? t.slice(A, e) : new Uint32Array(Array.prototype.slice.call(t, A, e));
}, x2 = function(t, A) {
  var e = d2(t), r = Array.isArray(e) ? w2(e) : new Uint32Array(e), n = Array.isArray(e) ? p2(e) : new Uint16Array(e), i = 24, s = jl(n, i / 2, r[4] / 2), u = r[5] === 2 ? jl(n, (i + r[4]) / 2) : I2(r, Math.ceil((i + r[4]) / 4));
  return new H2(r[0], r[1], r[2], r[3], s, u);
}, H2 = (
  /** @class */
  function() {
    function t(A, e, r, n, i, s) {
      this.initialValue = A, this.errorValue = e, this.highStart = r, this.highValueIndex = n, this.index = i, this.data = s;
    }
    return t.prototype.get = function(A) {
      var e;
      if (A >= 0) {
        if (A < 55296 || A > 56319 && A <= 65535)
          return e = this.index[A >> Mn], e = (e << Su) + (A & Nu), this.data[e];
        if (A <= 65535)
          return e = this.index[dh + (A - 55296 >> Mn)], e = (e << Su) + (A & Nu), this.data[e];
        if (A < this.highStart)
          return e = y2 - b2 + (A >> Oc), e = this.index[e], e += A >> Mn & E2, e = this.index[e], e = (e << Su) + (A & Nu), this.data[e];
        if (A <= 1114111)
          return this.data[this.highValueIndex];
      }
      return this.errorValue;
    }, t;
  }()
), Vl = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", S2 = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var Ws = 0; Ws < Vl.length; Ws++)
  S2[Vl.charCodeAt(Ws)] = Ws;
var N2 = 1, _u = 2, Du = 3, ql = 4, Wl = 5, _2 = 7, Xl = 8, Tu = 9, Ou = 10, Jl = 11, zl = 12, Yl = 13, Zl = 14, Pu = 15, D2 = function(t) {
  for (var A = [], e = 0, r = t.length; e < r; ) {
    var n = t.charCodeAt(e++);
    if (n >= 55296 && n <= 56319 && e < r) {
      var i = t.charCodeAt(e++);
      (i & 64512) === 56320 ? A.push(((n & 1023) << 10) + (i & 1023) + 65536) : (A.push(n), e--);
    } else
      A.push(n);
  }
  return A;
}, T2 = function() {
  for (var t = [], A = 0; A < arguments.length; A++)
    t[A] = arguments[A];
  if (String.fromCodePoint)
    return String.fromCodePoint.apply(String, t);
  var e = t.length;
  if (!e)
    return "";
  for (var r = [], n = -1, i = ""; ++n < e; ) {
    var s = t[n];
    s <= 65535 ? r.push(s) : (s -= 65536, r.push((s >> 10) + 55296, s % 1024 + 56320)), (n + 1 === e || r.length > 16384) && (i += String.fromCharCode.apply(String, r), r.length = 0);
  }
  return i;
}, O2 = x2(g2), jt = "×", Mu = "÷", P2 = function(t) {
  return O2.get(t);
}, M2 = function(t, A, e) {
  var r = e - 2, n = A[r], i = A[e - 1], s = A[e];
  if (i === _u && s === Du)
    return jt;
  if (i === _u || i === Du || i === ql || s === _u || s === Du || s === ql)
    return Mu;
  if (i === Xl && [Xl, Tu, Jl, zl].indexOf(s) !== -1 || (i === Jl || i === Tu) && (s === Tu || s === Ou) || (i === zl || i === Ou) && s === Ou || s === Yl || s === Wl || s === _2 || i === N2)
    return jt;
  if (i === Yl && s === Zl) {
    for (; n === Wl; )
      n = A[--r];
    if (n === Zl)
      return jt;
  }
  if (i === Pu && s === Pu) {
    for (var u = 0; n === Pu; )
      u++, n = A[--r];
    if (u % 2 === 0)
      return jt;
  }
  return Mu;
}, K2 = function(t) {
  var A = D2(t), e = A.length, r = 0, n = 0, i = A.map(P2);
  return {
    next: function() {
      if (r >= e)
        return { done: !0, value: null };
      for (var s = jt; r < e && (s = M2(A, i, ++r)) === jt; )
        ;
      if (s !== jt || r === e) {
        var u = T2.apply(null, A.slice(n, r));
        return n = r, { value: u, done: !1 };
      }
      return { done: !0, value: null };
    }
  };
}, k2 = function(t) {
  for (var A = K2(t), e = [], r; !(r = A.next()).done; )
    r.value && e.push(r.value.slice());
  return e;
}, R2 = function(t) {
  var A = 123;
  if (t.createRange) {
    var e = t.createRange();
    if (e.getBoundingClientRect) {
      var r = t.createElement("boundtest");
      r.style.height = A + "px", r.style.display = "block", t.body.appendChild(r), e.selectNode(r);
      var n = e.getBoundingClientRect(), i = Math.round(n.height);
      if (t.body.removeChild(r), i === A)
        return !0;
    }
  }
  return !1;
}, G2 = function(t) {
  var A = t.createElement("boundtest");
  A.style.width = "50px", A.style.display = "block", A.style.fontSize = "12px", A.style.letterSpacing = "0px", A.style.wordSpacing = "0px", t.body.appendChild(A);
  var e = t.createRange();
  A.innerHTML = typeof "".repeat == "function" ? "&#128104;".repeat(10) : "";
  var r = A.firstChild, n = Uo(r.data).map(function(c) {
    return Me(c);
  }), i = 0, s = {}, u = n.every(function(c, h) {
    e.setStart(r, i), e.setEnd(r, i + c.length);
    var g = e.getBoundingClientRect();
    i += c.length;
    var p = g.x > s.x || g.y > s.y;
    return s = g, h === 0 ? !0 : p;
  });
  return t.body.removeChild(A), u;
}, j2 = function() {
  return typeof new Image().crossOrigin < "u";
}, V2 = function() {
  return typeof new XMLHttpRequest().responseType == "string";
}, q2 = function(t) {
  var A = new Image(), e = t.createElement("canvas"), r = e.getContext("2d");
  if (!r)
    return !1;
  A.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
  try {
    r.drawImage(A, 0, 0), e.toDataURL();
  } catch {
    return !1;
  }
  return !0;
}, $l = function(t) {
  return t[0] === 0 && t[1] === 255 && t[2] === 0 && t[3] === 255;
}, W2 = function(t) {
  var A = t.createElement("canvas"), e = 100;
  A.width = e, A.height = e;
  var r = A.getContext("2d");
  if (!r)
    return Promise.reject(!1);
  r.fillStyle = "rgb(0, 255, 0)", r.fillRect(0, 0, e, e);
  var n = new Image(), i = A.toDataURL();
  n.src = i;
  var s = dc(e, e, 0, 0, n);
  return r.fillStyle = "red", r.fillRect(0, 0, e, e), Af(s).then(function(u) {
    r.drawImage(u, 0, 0);
    var c = r.getImageData(0, 0, e, e).data;
    r.fillStyle = "red", r.fillRect(0, 0, e, e);
    var h = t.createElement("div");
    return h.style.backgroundImage = "url(" + i + ")", h.style.height = e + "px", $l(c) ? Af(dc(e, e, 0, 0, h)) : Promise.reject(!1);
  }).then(function(u) {
    return r.drawImage(u, 0, 0), $l(r.getImageData(0, 0, e, e).data);
  }).catch(function() {
    return !1;
  });
}, dc = function(t, A, e, r, n) {
  var i = "http://www.w3.org/2000/svg", s = document.createElementNS(i, "svg"), u = document.createElementNS(i, "foreignObject");
  return s.setAttributeNS(null, "width", t.toString()), s.setAttributeNS(null, "height", A.toString()), u.setAttributeNS(null, "width", "100%"), u.setAttributeNS(null, "height", "100%"), u.setAttributeNS(null, "x", e.toString()), u.setAttributeNS(null, "y", r.toString()), u.setAttributeNS(null, "externalResourcesRequired", "true"), s.appendChild(u), u.appendChild(n), s;
}, Af = function(t) {
  return new Promise(function(A, e) {
    var r = new Image();
    r.onload = function() {
      return A(r);
    }, r.onerror = e, r.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(t));
  });
}, it = {
  get SUPPORT_RANGE_BOUNDS() {
    var t = R2(document);
    return Object.defineProperty(it, "SUPPORT_RANGE_BOUNDS", { value: t }), t;
  },
  get SUPPORT_WORD_BREAKING() {
    var t = it.SUPPORT_RANGE_BOUNDS && G2(document);
    return Object.defineProperty(it, "SUPPORT_WORD_BREAKING", { value: t }), t;
  },
  get SUPPORT_SVG_DRAWING() {
    var t = q2(document);
    return Object.defineProperty(it, "SUPPORT_SVG_DRAWING", { value: t }), t;
  },
  get SUPPORT_FOREIGNOBJECT_DRAWING() {
    var t = typeof Array.from == "function" && typeof window.fetch == "function" ? W2(document) : Promise.resolve(!1);
    return Object.defineProperty(it, "SUPPORT_FOREIGNOBJECT_DRAWING", { value: t }), t;
  },
  get SUPPORT_CORS_IMAGES() {
    var t = j2();
    return Object.defineProperty(it, "SUPPORT_CORS_IMAGES", { value: t }), t;
  },
  get SUPPORT_RESPONSE_TYPE() {
    var t = V2();
    return Object.defineProperty(it, "SUPPORT_RESPONSE_TYPE", { value: t }), t;
  },
  get SUPPORT_CORS_XHR() {
    var t = "withCredentials" in new XMLHttpRequest();
    return Object.defineProperty(it, "SUPPORT_CORS_XHR", { value: t }), t;
  },
  get SUPPORT_NATIVE_TEXT_SEGMENTATION() {
    var t = !!(typeof Intl < "u" && Intl.Segmenter);
    return Object.defineProperty(it, "SUPPORT_NATIVE_TEXT_SEGMENTATION", { value: t }), t;
  }
}, xa = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(A, e) {
      this.text = A, this.bounds = e;
    }
    return t;
  }()
), X2 = function(t, A, e, r) {
  var n = Y2(A, e), i = [], s = 0;
  return n.forEach(function(u) {
    if (e.textDecorationLine.length || u.trim().length > 0)
      if (it.SUPPORT_RANGE_BOUNDS) {
        var c = ef(r, s, u.length).getClientRects();
        if (c.length > 1) {
          var h = Pc(u), g = 0;
          h.forEach(function(w) {
            i.push(new xa(w, jr.fromDOMRectList(t, ef(r, g + s, w.length).getClientRects()))), g += w.length;
          });
        } else
          i.push(new xa(u, jr.fromDOMRectList(t, c)));
      } else {
        var p = r.splitText(u.length);
        i.push(new xa(u, J2(t, r))), r = p;
      }
    else it.SUPPORT_RANGE_BOUNDS || (r = r.splitText(u.length));
    s += u.length;
  }), i;
}, J2 = function(t, A) {
  var e = A.ownerDocument;
  if (e) {
    var r = e.createElement("html2canvaswrapper");
    r.appendChild(A.cloneNode(!0));
    var n = A.parentNode;
    if (n) {
      n.replaceChild(r, A);
      var i = Fo(t, r);
      return r.firstChild && n.replaceChild(r.firstChild, r), i;
    }
  }
  return jr.EMPTY;
}, ef = function(t, A, e) {
  var r = t.ownerDocument;
  if (!r)
    throw new Error("Node has no owner document");
  var n = r.createRange();
  return n.setStart(t, A), n.setEnd(t, A + e), n;
}, Pc = function(t) {
  if (it.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
    var A = new Intl.Segmenter(void 0, { granularity: "grapheme" });
    return Array.from(A.segment(t)).map(function(e) {
      return e.segment;
    });
  }
  return k2(t);
}, z2 = function(t, A) {
  if (it.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
    var e = new Intl.Segmenter(void 0, {
      granularity: "word"
    });
    return Array.from(e.segment(t)).map(function(r) {
      return r.segment;
    });
  }
  return $2(t, A);
}, Y2 = function(t, A) {
  return A.letterSpacing !== 0 ? Pc(t) : z2(t, A);
}, Z2 = [32, 160, 4961, 65792, 65793, 4153, 4241], $2 = function(t, A) {
  for (var e = b0(t, {
    lineBreak: A.lineBreak,
    wordBreak: A.overflowWrap === "break-word" ? "break-word" : A.wordBreak
  }), r = [], n, i = function() {
    if (n.value) {
      var s = n.value.slice(), u = Uo(s), c = "";
      u.forEach(function(h) {
        Z2.indexOf(h) === -1 ? c += Me(h) : (c.length && r.push(c), r.push(Me(h)), c = "");
      }), c.length && r.push(c);
    }
  }; !(n = e.next()).done; )
    i();
  return r;
}, Ad = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(A, e, r) {
      this.text = ed(e.data, r.textTransform), this.textBounds = X2(A, this.text, r, e);
    }
    return t;
  }()
), ed = function(t, A) {
  switch (A) {
    case 1:
      return t.toLowerCase();
    case 3:
      return t.replace(td, rd);
    case 2:
      return t.toUpperCase();
    default:
      return t;
  }
}, td = /(^|\s|:|-|\(|\))([a-z])/g, rd = function(t, A, e) {
  return t.length > 0 ? A + e.toUpperCase() : t;
}, ph = (
  /** @class */
  function(t) {
    ur(A, t);
    function A(e, r) {
      var n = t.call(this, e, r) || this;
      return n.src = r.currentSrc || r.src, n.intrinsicWidth = r.naturalWidth, n.intrinsicHeight = r.naturalHeight, n.context.cache.addImage(n.src), n;
    }
    return A;
  }(Lr)
), wh = (
  /** @class */
  function(t) {
    ur(A, t);
    function A(e, r) {
      var n = t.call(this, e, r) || this;
      return n.canvas = r, n.intrinsicWidth = r.width, n.intrinsicHeight = r.height, n;
    }
    return A;
  }(Lr)
), vh = (
  /** @class */
  function(t) {
    ur(A, t);
    function A(e, r) {
      var n = t.call(this, e, r) || this, i = new XMLSerializer(), s = Fo(e, r);
      return r.setAttribute("width", s.width + "px"), r.setAttribute("height", s.height + "px"), n.svg = "data:image/svg+xml," + encodeURIComponent(i.serializeToString(r)), n.intrinsicWidth = r.width.baseVal.value, n.intrinsicHeight = r.height.baseVal.value, n.context.cache.addImage(n.svg), n;
    }
    return A;
  }(Lr)
), mh = (
  /** @class */
  function(t) {
    ur(A, t);
    function A(e, r) {
      var n = t.call(this, e, r) || this;
      return n.value = r.value, n;
    }
    return A;
  }(Lr)
), pc = (
  /** @class */
  function(t) {
    ur(A, t);
    function A(e, r) {
      var n = t.call(this, e, r) || this;
      return n.start = r.start, n.reversed = typeof r.reversed == "boolean" && r.reversed === !0, n;
    }
    return A;
  }(Lr)
), nd = [
  {
    type: 15,
    flags: 0,
    unit: "px",
    number: 3
  }
], id = [
  {
    type: 16,
    flags: 0,
    number: 50
  }
], ad = function(t) {
  return t.width > t.height ? new jr(t.left + (t.width - t.height) / 2, t.top, t.height, t.height) : t.width < t.height ? new jr(t.left, t.top + (t.height - t.width) / 2, t.width, t.width) : t;
}, sd = function(t) {
  var A = t.type === od ? new Array(t.value.length + 1).join("•") : t.value;
  return A.length === 0 ? t.placeholder || "" : A;
}, ho = "checkbox", Bo = "radio", od = "password", tf = 707406591, Mc = (
  /** @class */
  function(t) {
    ur(A, t);
    function A(e, r) {
      var n = t.call(this, e, r) || this;
      switch (n.type = r.type.toLowerCase(), n.checked = r.checked, n.value = sd(r), (n.type === ho || n.type === Bo) && (n.styles.backgroundColor = 3739148031, n.styles.borderTopColor = n.styles.borderRightColor = n.styles.borderBottomColor = n.styles.borderLeftColor = 2779096575, n.styles.borderTopWidth = n.styles.borderRightWidth = n.styles.borderBottomWidth = n.styles.borderLeftWidth = 1, n.styles.borderTopStyle = n.styles.borderRightStyle = n.styles.borderBottomStyle = n.styles.borderLeftStyle = 1, n.styles.backgroundClip = [
        0
        /* BORDER_BOX */
      ], n.styles.backgroundOrigin = [
        0
        /* BORDER_BOX */
      ], n.bounds = ad(n.bounds)), n.type) {
        case ho:
          n.styles.borderTopRightRadius = n.styles.borderTopLeftRadius = n.styles.borderBottomRightRadius = n.styles.borderBottomLeftRadius = nd;
          break;
        case Bo:
          n.styles.borderTopRightRadius = n.styles.borderTopLeftRadius = n.styles.borderBottomRightRadius = n.styles.borderBottomLeftRadius = id;
          break;
      }
      return n;
    }
    return A;
  }(Lr)
), Ch = (
  /** @class */
  function(t) {
    ur(A, t);
    function A(e, r) {
      var n = t.call(this, e, r) || this, i = r.options[r.selectedIndex || 0];
      return n.value = i && i.text || "", n;
    }
    return A;
  }(Lr)
), Qh = (
  /** @class */
  function(t) {
    ur(A, t);
    function A(e, r) {
      var n = t.call(this, e, r) || this;
      return n.value = r.value, n;
    }
    return A;
  }(Lr)
), Fh = (
  /** @class */
  function(t) {
    ur(A, t);
    function A(e, r) {
      var n = t.call(this, e, r) || this;
      n.src = r.src, n.width = parseInt(r.width, 10) || 0, n.height = parseInt(r.height, 10) || 0, n.backgroundColor = n.styles.backgroundColor;
      try {
        if (r.contentWindow && r.contentWindow.document && r.contentWindow.document.documentElement) {
          n.tree = yh(e, r.contentWindow.document.documentElement);
          var i = r.contentWindow.document.documentElement ? Ea(e, getComputedStyle(r.contentWindow.document.documentElement).backgroundColor) : Gr.TRANSPARENT, s = r.contentWindow.document.body ? Ea(e, getComputedStyle(r.contentWindow.document.body).backgroundColor) : Gr.TRANSPARENT;
          n.backgroundColor = dn(i) ? dn(s) ? n.styles.backgroundColor : s : i;
        }
      } catch {
      }
      return n;
    }
    return A;
  }(Lr)
), ud = ["OL", "UL", "MENU"], no = function(t, A, e, r) {
  for (var n = A.firstChild, i = void 0; n; n = i)
    if (i = n.nextSibling, bh(n) && n.data.trim().length > 0)
      e.textNodes.push(new Ad(t, n, e.styles));
    else if (Ii(n))
      if (xh(n) && n.assignedNodes)
        n.assignedNodes().forEach(function(u) {
          return no(t, u, e, r);
        });
      else {
        var s = Uh(t, n);
        s.styles.isVisible() && (cd(n, s, r) ? s.flags |= 4 : ld(s.styles) && (s.flags |= 2), ud.indexOf(n.tagName) !== -1 && (s.flags |= 8), e.elements.push(s), n.slot, n.shadowRoot ? no(t, n.shadowRoot, s, r) : !go(n) && !Lh(n) && !po(n) && no(t, n, s, r));
      }
}, Uh = function(t, A) {
  return vc(A) ? new ph(t, A) : Eh(A) ? new wh(t, A) : Lh(A) ? new vh(t, A) : fd(A) ? new mh(t, A) : hd(A) ? new pc(t, A) : Bd(A) ? new Mc(t, A) : po(A) ? new Ch(t, A) : go(A) ? new Qh(t, A) : Ih(A) ? new Fh(t, A) : new Lr(t, A);
}, yh = function(t, A) {
  var e = Uh(t, A);
  return e.flags |= 4, no(t, A, e, e), e;
}, cd = function(t, A, e) {
  return A.styles.isPositionedWithZIndex() || A.styles.opacity < 1 || A.styles.isTransformed() || Kc(t) && e.styles.isTransparent();
}, ld = function(t) {
  return t.isPositioned() || t.isFloating();
}, bh = function(t) {
  return t.nodeType === Node.TEXT_NODE;
}, Ii = function(t) {
  return t.nodeType === Node.ELEMENT_NODE;
}, wc = function(t) {
  return Ii(t) && typeof t.style < "u" && !io(t);
}, io = function(t) {
  return typeof t.className == "object";
}, fd = function(t) {
  return t.tagName === "LI";
}, hd = function(t) {
  return t.tagName === "OL";
}, Bd = function(t) {
  return t.tagName === "INPUT";
}, gd = function(t) {
  return t.tagName === "HTML";
}, Lh = function(t) {
  return t.tagName === "svg";
}, Kc = function(t) {
  return t.tagName === "BODY";
}, Eh = function(t) {
  return t.tagName === "CANVAS";
}, rf = function(t) {
  return t.tagName === "VIDEO";
}, vc = function(t) {
  return t.tagName === "IMG";
}, Ih = function(t) {
  return t.tagName === "IFRAME";
}, nf = function(t) {
  return t.tagName === "STYLE";
}, dd = function(t) {
  return t.tagName === "SCRIPT";
}, go = function(t) {
  return t.tagName === "TEXTAREA";
}, po = function(t) {
  return t.tagName === "SELECT";
}, xh = function(t) {
  return t.tagName === "SLOT";
}, af = function(t) {
  return t.tagName.indexOf("-") > 0;
}, pd = (
  /** @class */
  function() {
    function t() {
      this.counters = {};
    }
    return t.prototype.getCounterValue = function(A) {
      var e = this.counters[A];
      return e && e.length ? e[e.length - 1] : 1;
    }, t.prototype.getCounterValues = function(A) {
      var e = this.counters[A];
      return e || [];
    }, t.prototype.pop = function(A) {
      var e = this;
      A.forEach(function(r) {
        return e.counters[r].pop();
      });
    }, t.prototype.parse = function(A) {
      var e = this, r = A.counterIncrement, n = A.counterReset, i = !0;
      r !== null && r.forEach(function(u) {
        var c = e.counters[u.counter];
        c && u.increment !== 0 && (i = !1, c.length || c.push(1), c[Math.max(0, c.length - 1)] += u.increment);
      });
      var s = [];
      return i && n.forEach(function(u) {
        var c = e.counters[u.counter];
        s.push(u.counter), c || (c = e.counters[u.counter] = []), c.push(u.reset);
      }), s;
    }, t;
  }()
), sf = {
  integers: [1e3, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1],
  values: ["M", "CM", "D", "CD", "C", "XC", "L", "XL", "X", "IX", "V", "IV", "I"]
}, of = {
  integers: [
    9e3,
    8e3,
    7e3,
    6e3,
    5e3,
    4e3,
    3e3,
    2e3,
    1e3,
    900,
    800,
    700,
    600,
    500,
    400,
    300,
    200,
    100,
    90,
    80,
    70,
    60,
    50,
    40,
    30,
    20,
    10,
    9,
    8,
    7,
    6,
    5,
    4,
    3,
    2,
    1
  ],
  values: [
    "Ք",
    "Փ",
    "Ւ",
    "Ց",
    "Ր",
    "Տ",
    "Վ",
    "Ս",
    "Ռ",
    "Ջ",
    "Պ",
    "Չ",
    "Ո",
    "Շ",
    "Ն",
    "Յ",
    "Մ",
    "Ճ",
    "Ղ",
    "Ձ",
    "Հ",
    "Կ",
    "Ծ",
    "Խ",
    "Լ",
    "Ի",
    "Ժ",
    "Թ",
    "Ը",
    "Է",
    "Զ",
    "Ե",
    "Դ",
    "Գ",
    "Բ",
    "Ա"
  ]
}, wd = {
  integers: [
    1e4,
    9e3,
    8e3,
    7e3,
    6e3,
    5e3,
    4e3,
    3e3,
    2e3,
    1e3,
    400,
    300,
    200,
    100,
    90,
    80,
    70,
    60,
    50,
    40,
    30,
    20,
    19,
    18,
    17,
    16,
    15,
    10,
    9,
    8,
    7,
    6,
    5,
    4,
    3,
    2,
    1
  ],
  values: [
    "י׳",
    "ט׳",
    "ח׳",
    "ז׳",
    "ו׳",
    "ה׳",
    "ד׳",
    "ג׳",
    "ב׳",
    "א׳",
    "ת",
    "ש",
    "ר",
    "ק",
    "צ",
    "פ",
    "ע",
    "ס",
    "נ",
    "מ",
    "ל",
    "כ",
    "יט",
    "יח",
    "יז",
    "טז",
    "טו",
    "י",
    "ט",
    "ח",
    "ז",
    "ו",
    "ה",
    "ד",
    "ג",
    "ב",
    "א"
  ]
}, vd = {
  integers: [
    1e4,
    9e3,
    8e3,
    7e3,
    6e3,
    5e3,
    4e3,
    3e3,
    2e3,
    1e3,
    900,
    800,
    700,
    600,
    500,
    400,
    300,
    200,
    100,
    90,
    80,
    70,
    60,
    50,
    40,
    30,
    20,
    10,
    9,
    8,
    7,
    6,
    5,
    4,
    3,
    2,
    1
  ],
  values: [
    "ჵ",
    "ჰ",
    "ჯ",
    "ჴ",
    "ხ",
    "ჭ",
    "წ",
    "ძ",
    "ც",
    "ჩ",
    "შ",
    "ყ",
    "ღ",
    "ქ",
    "ფ",
    "ჳ",
    "ტ",
    "ს",
    "რ",
    "ჟ",
    "პ",
    "ო",
    "ჲ",
    "ნ",
    "მ",
    "ლ",
    "კ",
    "ი",
    "თ",
    "ჱ",
    "ზ",
    "ვ",
    "ე",
    "დ",
    "გ",
    "ბ",
    "ა"
  ]
}, mi = function(t, A, e, r, n, i) {
  return t < A || t > e ? Da(t, n, i.length > 0) : r.integers.reduce(function(s, u, c) {
    for (; t >= u; )
      t -= u, s += r.values[c];
    return s;
  }, "") + i;
}, Hh = function(t, A, e, r) {
  var n = "";
  do
    e || t--, n = r(t) + n, t /= A;
  while (t * A >= A);
  return n;
}, Pe = function(t, A, e, r, n) {
  var i = e - A + 1;
  return (t < 0 ? "-" : "") + (Hh(Math.abs(t), i, r, function(s) {
    return Me(Math.floor(s % i) + A);
  }) + n);
}, Nn = function(t, A, e) {
  e === void 0 && (e = ". ");
  var r = A.length;
  return Hh(Math.abs(t), r, !1, function(n) {
    return A[Math.floor(n % r)];
  }) + e;
}, yi = 1, on = 2, un = 4, ba = 8, kr = function(t, A, e, r, n, i) {
  if (t < -9999 || t > 9999)
    return Da(t, 4, n.length > 0);
  var s = Math.abs(t), u = n;
  if (s === 0)
    return A[0] + u;
  for (var c = 0; s > 0 && c <= 4; c++) {
    var h = s % 10;
    h === 0 && ze(i, yi) && u !== "" ? u = A[h] + u : h > 1 || h === 1 && c === 0 || h === 1 && c === 1 && ze(i, on) || h === 1 && c === 1 && ze(i, un) && t > 100 || h === 1 && c > 1 && ze(i, ba) ? u = A[h] + (c > 0 ? e[c - 1] : "") + u : h === 1 && c > 0 && (u = e[c - 1] + u), s = Math.floor(s / 10);
  }
  return (t < 0 ? r : "") + u;
}, uf = "十百千萬", cf = "拾佰仟萬", lf = "マイナス", Ku = "마이너스", Da = function(t, A, e) {
  var r = e ? ". " : "", n = e ? "、" : "", i = e ? ", " : "", s = e ? " " : "";
  switch (A) {
    case 0:
      return "•" + s;
    case 1:
      return "◦" + s;
    case 2:
      return "◾" + s;
    case 5:
      var u = Pe(t, 48, 57, !0, r);
      return u.length < 4 ? "0" + u : u;
    case 4:
      return Nn(t, "〇一二三四五六七八九", n);
    case 6:
      return mi(t, 1, 3999, sf, 3, r).toLowerCase();
    case 7:
      return mi(t, 1, 3999, sf, 3, r);
    case 8:
      return Pe(t, 945, 969, !1, r);
    case 9:
      return Pe(t, 97, 122, !1, r);
    case 10:
      return Pe(t, 65, 90, !1, r);
    case 11:
      return Pe(t, 1632, 1641, !0, r);
    case 12:
    case 49:
      return mi(t, 1, 9999, of, 3, r);
    case 35:
      return mi(t, 1, 9999, of, 3, r).toLowerCase();
    case 13:
      return Pe(t, 2534, 2543, !0, r);
    case 14:
    case 30:
      return Pe(t, 6112, 6121, !0, r);
    case 15:
      return Nn(t, "子丑寅卯辰巳午未申酉戌亥", n);
    case 16:
      return Nn(t, "甲乙丙丁戊己庚辛壬癸", n);
    case 17:
    case 48:
      return kr(t, "零一二三四五六七八九", uf, "負", n, on | un | ba);
    case 47:
      return kr(t, "零壹貳參肆伍陸柒捌玖", cf, "負", n, yi | on | un | ba);
    case 42:
      return kr(t, "零一二三四五六七八九", uf, "负", n, on | un | ba);
    case 41:
      return kr(t, "零壹贰叁肆伍陆柒捌玖", cf, "负", n, yi | on | un | ba);
    case 26:
      return kr(t, "〇一二三四五六七八九", "十百千万", lf, n, 0);
    case 25:
      return kr(t, "零壱弐参四伍六七八九", "拾百千万", lf, n, yi | on | un);
    case 31:
      return kr(t, "영일이삼사오육칠팔구", "십백천만", Ku, i, yi | on | un);
    case 33:
      return kr(t, "零一二三四五六七八九", "十百千萬", Ku, i, 0);
    case 32:
      return kr(t, "零壹貳參四五六七八九", "拾百千", Ku, i, yi | on | un);
    case 18:
      return Pe(t, 2406, 2415, !0, r);
    case 20:
      return mi(t, 1, 19999, vd, 3, r);
    case 21:
      return Pe(t, 2790, 2799, !0, r);
    case 22:
      return Pe(t, 2662, 2671, !0, r);
    case 22:
      return mi(t, 1, 10999, wd, 3, r);
    case 23:
      return Nn(t, "あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん");
    case 24:
      return Nn(t, "いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす");
    case 27:
      return Pe(t, 3302, 3311, !0, r);
    case 28:
      return Nn(t, "アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン", n);
    case 29:
      return Nn(t, "イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス", n);
    case 34:
      return Pe(t, 3792, 3801, !0, r);
    case 37:
      return Pe(t, 6160, 6169, !0, r);
    case 38:
      return Pe(t, 4160, 4169, !0, r);
    case 39:
      return Pe(t, 2918, 2927, !0, r);
    case 40:
      return Pe(t, 1776, 1785, !0, r);
    case 43:
      return Pe(t, 3046, 3055, !0, r);
    case 44:
      return Pe(t, 3174, 3183, !0, r);
    case 45:
      return Pe(t, 3664, 3673, !0, r);
    case 46:
      return Pe(t, 3872, 3881, !0, r);
    case 3:
    default:
      return Pe(t, 48, 57, !0, r);
  }
}, Sh = "data-html2canvas-ignore", ff = (
  /** @class */
  function() {
    function t(A, e, r) {
      if (this.context = A, this.options = r, this.scrolledElements = [], this.referenceElement = e, this.counters = new pd(), this.quoteDepth = 0, !e.ownerDocument)
        throw new Error("Cloned element does not have an owner document");
      this.documentElement = this.cloneNode(e.ownerDocument.documentElement, !1);
    }
    return t.prototype.toIFrame = function(A, e) {
      var r = this, n = md(A, e);
      if (!n.contentWindow)
        return Promise.reject("Unable to find iframe window");
      var i = A.defaultView.pageXOffset, s = A.defaultView.pageYOffset, u = n.contentWindow, c = u.document, h = Fd(n).then(function() {
        return mt(r, void 0, void 0, function() {
          var g, p;
          return Bt(this, function(w) {
            switch (w.label) {
              case 0:
                return this.scrolledElements.forEach(Ld), u && (u.scrollTo(e.left, e.top), /(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (u.scrollY !== e.top || u.scrollX !== e.left) && (this.context.logger.warn("Unable to restore scroll position for cloned document"), this.context.windowBounds = this.context.windowBounds.add(u.scrollX - e.left, u.scrollY - e.top, 0, 0))), g = this.options.onclone, p = this.clonedReferenceElement, typeof p > "u" ? [2, Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")] : c.fonts && c.fonts.ready ? [4, c.fonts.ready] : [3, 2];
              case 1:
                w.sent(), w.label = 2;
              case 2:
                return /(AppleWebKit)/g.test(navigator.userAgent) ? [4, Qd(c)] : [3, 4];
              case 3:
                w.sent(), w.label = 4;
              case 4:
                return typeof g == "function" ? [2, Promise.resolve().then(function() {
                  return g(c, p);
                }).then(function() {
                  return n;
                })] : [2, n];
            }
          });
        });
      });
      return c.open(), c.write(yd(document.doctype) + "<html></html>"), bd(this.referenceElement.ownerDocument, i, s), c.replaceChild(c.adoptNode(this.documentElement), c.documentElement), c.close(), h;
    }, t.prototype.createElementClone = function(A) {
      if (gc(
        A,
        2
        /* CLONE */
      ))
        debugger;
      if (Eh(A))
        return this.createCanvasClone(A);
      if (rf(A))
        return this.createVideoClone(A);
      if (nf(A))
        return this.createStyleClone(A);
      var e = A.cloneNode(!1);
      return vc(e) && (vc(A) && A.currentSrc && A.currentSrc !== A.src && (e.src = A.currentSrc, e.srcset = ""), e.loading === "lazy" && (e.loading = "eager")), af(e) ? this.createCustomElementClone(e) : e;
    }, t.prototype.createCustomElementClone = function(A) {
      var e = document.createElement("html2canvascustomelement");
      return ku(A.style, e), e;
    }, t.prototype.createStyleClone = function(A) {
      try {
        var e = A.sheet;
        if (e && e.cssRules) {
          var r = [].slice.call(e.cssRules, 0).reduce(function(i, s) {
            return s && typeof s.cssText == "string" ? i + s.cssText : i;
          }, ""), n = A.cloneNode(!1);
          return n.textContent = r, n;
        }
      } catch (i) {
        if (this.context.logger.error("Unable to access cssRules property", i), i.name !== "SecurityError")
          throw i;
      }
      return A.cloneNode(!1);
    }, t.prototype.createCanvasClone = function(A) {
      var e;
      if (this.options.inlineImages && A.ownerDocument) {
        var r = A.ownerDocument.createElement("img");
        try {
          return r.src = A.toDataURL(), r;
        } catch {
          this.context.logger.info("Unable to inline canvas contents, canvas is tainted", A);
        }
      }
      var n = A.cloneNode(!1);
      try {
        n.width = A.width, n.height = A.height;
        var i = A.getContext("2d"), s = n.getContext("2d");
        if (s)
          if (!this.options.allowTaint && i)
            s.putImageData(i.getImageData(0, 0, A.width, A.height), 0, 0);
          else {
            var u = (e = A.getContext("webgl2")) !== null && e !== void 0 ? e : A.getContext("webgl");
            if (u) {
              var c = u.getContextAttributes();
              (c == null ? void 0 : c.preserveDrawingBuffer) === !1 && this.context.logger.warn("Unable to clone WebGL context as it has preserveDrawingBuffer=false", A);
            }
            s.drawImage(A, 0, 0);
          }
        return n;
      } catch {
        this.context.logger.info("Unable to clone canvas as it is tainted", A);
      }
      return n;
    }, t.prototype.createVideoClone = function(A) {
      var e = A.ownerDocument.createElement("canvas");
      e.width = A.offsetWidth, e.height = A.offsetHeight;
      var r = e.getContext("2d");
      try {
        return r && (r.drawImage(A, 0, 0, e.width, e.height), this.options.allowTaint || r.getImageData(0, 0, e.width, e.height)), e;
      } catch {
        this.context.logger.info("Unable to clone video as it is tainted", A);
      }
      var n = A.ownerDocument.createElement("canvas");
      return n.width = A.offsetWidth, n.height = A.offsetHeight, n;
    }, t.prototype.appendChildNode = function(A, e, r) {
      (!Ii(e) || !dd(e) && !e.hasAttribute(Sh) && (typeof this.options.ignoreElements != "function" || !this.options.ignoreElements(e))) && (!this.options.copyStyles || !Ii(e) || !nf(e)) && A.appendChild(this.cloneNode(e, r));
    }, t.prototype.cloneChildNodes = function(A, e, r) {
      for (var n = this, i = A.shadowRoot ? A.shadowRoot.firstChild : A.firstChild; i; i = i.nextSibling)
        if (Ii(i) && xh(i) && typeof i.assignedNodes == "function") {
          var s = i.assignedNodes();
          s.length && s.forEach(function(u) {
            return n.appendChildNode(e, u, r);
          });
        } else
          this.appendChildNode(e, i, r);
    }, t.prototype.cloneNode = function(A, e) {
      if (bh(A))
        return document.createTextNode(A.data);
      if (!A.ownerDocument)
        return A.cloneNode(!1);
      var r = A.ownerDocument.defaultView;
      if (r && Ii(A) && (wc(A) || io(A))) {
        var n = this.createElementClone(A);
        n.style.transitionProperty = "none";
        var i = r.getComputedStyle(A), s = r.getComputedStyle(A, ":before"), u = r.getComputedStyle(A, ":after");
        this.referenceElement === A && wc(n) && (this.clonedReferenceElement = n), Kc(n) && xd(n);
        var c = this.counters.parse(new Rl(this.context, i)), h = this.resolvePseudoContent(A, n, s, Ha.BEFORE);
        af(A) && (e = !0), rf(A) || this.cloneChildNodes(A, n, e), h && n.insertBefore(h, n.firstChild);
        var g = this.resolvePseudoContent(A, n, u, Ha.AFTER);
        return g && n.appendChild(g), this.counters.pop(c), (i && (this.options.copyStyles || io(A)) && !Ih(A) || e) && ku(i, n), (A.scrollTop !== 0 || A.scrollLeft !== 0) && this.scrolledElements.push([n, A.scrollLeft, A.scrollTop]), (go(A) || po(A)) && (go(n) || po(n)) && (n.value = A.value), n;
      }
      return A.cloneNode(!1);
    }, t.prototype.resolvePseudoContent = function(A, e, r, n) {
      var i = this;
      if (r) {
        var s = r.content, u = e.ownerDocument;
        if (!(!u || !s || s === "none" || s === "-moz-alt-content" || r.display === "none")) {
          this.counters.parse(new Rl(this.context, r));
          var c = new f2(this.context, r), h = u.createElement("html2canvaspseudoelement");
          ku(r, h), c.content.forEach(function(p) {
            if (p.type === 0)
              h.appendChild(u.createTextNode(p.value));
            else if (p.type === 22) {
              var w = u.createElement("img");
              w.src = p.value, w.style.opacity = "1", h.appendChild(w);
            } else if (p.type === 18) {
              if (p.name === "attr") {
                var B = p.values.filter(ve);
                B.length && h.appendChild(u.createTextNode(A.getAttribute(B[0].value) || ""));
              } else if (p.name === "counter") {
                var L = p.values.filter(Ti), y = L[0], N = L[1];
                if (y && ve(y)) {
                  var F = i.counters.getCounterValue(y.value), x = N && ve(N) ? Bc.parse(i.context, N.value) : 3;
                  h.appendChild(u.createTextNode(Da(F, x, !1)));
                }
              } else if (p.name === "counters") {
                var R = p.values.filter(Ti), y = R[0], Y = R[1], N = R[2];
                if (y && ve(y)) {
                  var Z = i.counters.getCounterValues(y.value), $ = N && ve(N) ? Bc.parse(i.context, N.value) : 3, J = Y && Y.type === 0 ? Y.value : "", O = Z.map(function(I) {
                    return Da(I, $, !1);
                  }).join(J);
                  h.appendChild(u.createTextNode(O));
                }
              }
            } else if (p.type === 20)
              switch (p.value) {
                case "open-quote":
                  h.appendChild(u.createTextNode(kl(c.quotes, i.quoteDepth++, !0)));
                  break;
                case "close-quote":
                  h.appendChild(u.createTextNode(kl(c.quotes, --i.quoteDepth, !1)));
                  break;
                default:
                  h.appendChild(u.createTextNode(p.value));
              }
          }), h.className = mc + " " + Cc;
          var g = n === Ha.BEFORE ? " " + mc : " " + Cc;
          return io(e) ? e.className.baseValue += g : e.className += g, h;
        }
      }
    }, t.destroy = function(A) {
      return A.parentNode ? (A.parentNode.removeChild(A), !0) : !1;
    }, t;
  }()
), Ha;
(function(t) {
  t[t.BEFORE = 0] = "BEFORE", t[t.AFTER = 1] = "AFTER";
})(Ha || (Ha = {}));
var md = function(t, A) {
  var e = t.createElement("iframe");
  return e.className = "html2canvas-container", e.style.visibility = "hidden", e.style.position = "fixed", e.style.left = "-10000px", e.style.top = "0px", e.style.border = "0", e.width = A.width.toString(), e.height = A.height.toString(), e.scrolling = "no", e.setAttribute(Sh, "true"), t.body.appendChild(e), e;
}, Cd = function(t) {
  return new Promise(function(A) {
    if (t.complete) {
      A();
      return;
    }
    if (!t.src) {
      A();
      return;
    }
    t.onload = A, t.onerror = A;
  });
}, Qd = function(t) {
  return Promise.all([].slice.call(t.images, 0).map(Cd));
}, Fd = function(t) {
  return new Promise(function(A, e) {
    var r = t.contentWindow;
    if (!r)
      return e("No window assigned for iframe");
    var n = r.document;
    r.onload = t.onload = function() {
      r.onload = t.onload = null;
      var i = setInterval(function() {
        n.body.childNodes.length > 0 && n.readyState === "complete" && (clearInterval(i), A(t));
      }, 50);
    };
  });
}, Ud = [
  "all",
  "d",
  "content"
  // Safari shows pseudoelements if content is set
], ku = function(t, A) {
  for (var e = t.length - 1; e >= 0; e--) {
    var r = t.item(e);
    Ud.indexOf(r) === -1 && A.style.setProperty(r, t.getPropertyValue(r));
  }
  return A;
}, yd = function(t) {
  var A = "";
  return t && (A += "<!DOCTYPE ", t.name && (A += t.name), t.internalSubset && (A += t.internalSubset), t.publicId && (A += '"' + t.publicId + '"'), t.systemId && (A += '"' + t.systemId + '"'), A += ">"), A;
}, bd = function(t, A, e) {
  t && t.defaultView && (A !== t.defaultView.pageXOffset || e !== t.defaultView.pageYOffset) && t.defaultView.scrollTo(A, e);
}, Ld = function(t) {
  var A = t[0], e = t[1], r = t[2];
  A.scrollLeft = e, A.scrollTop = r;
}, Ed = ":before", Id = ":after", mc = "___html2canvas___pseudoelement_before", Cc = "___html2canvas___pseudoelement_after", hf = `{
    content: "" !important;
    display: none !important;
}`, xd = function(t) {
  Hd(t, "." + mc + Ed + hf + `
         .` + Cc + Id + hf);
}, Hd = function(t, A) {
  var e = t.ownerDocument;
  if (e) {
    var r = e.createElement("style");
    r.textContent = A, t.appendChild(r);
  }
}, Nh = (
  /** @class */
  function() {
    function t() {
    }
    return t.getOrigin = function(A) {
      var e = t._link;
      return e ? (e.href = A, e.href = e.href, e.protocol + e.hostname + e.port) : "about:blank";
    }, t.isSameOrigin = function(A) {
      return t.getOrigin(A) === t._origin;
    }, t.setContext = function(A) {
      t._link = A.document.createElement("a"), t._origin = t.getOrigin(A.location.href);
    }, t._origin = "about:blank", t;
  }()
), Sd = (
  /** @class */
  function() {
    function t(A, e) {
      this.context = A, this._options = e, this._cache = {};
    }
    return t.prototype.addImage = function(A) {
      var e = Promise.resolve();
      return this.has(A) || (Gu(A) || Td(A)) && (this._cache[A] = this.loadImage(A)).catch(function() {
      }), e;
    }, t.prototype.match = function(A) {
      return this._cache[A];
    }, t.prototype.loadImage = function(A) {
      return mt(this, void 0, void 0, function() {
        var e, r, n, i, s = this;
        return Bt(this, function(u) {
          switch (u.label) {
            case 0:
              return e = Nh.isSameOrigin(A), r = !Ru(A) && this._options.useCORS === !0 && it.SUPPORT_CORS_IMAGES && !e, n = !Ru(A) && !e && !Gu(A) && typeof this._options.proxy == "string" && it.SUPPORT_CORS_XHR && !r, !e && this._options.allowTaint === !1 && !Ru(A) && !Gu(A) && !n && !r ? [
                2
                /*return*/
              ] : (i = A, n ? [4, this.proxy(i)] : [3, 2]);
            case 1:
              i = u.sent(), u.label = 2;
            case 2:
              return this.context.logger.debug("Added image " + A.substring(0, 256)), [4, new Promise(function(c, h) {
                var g = new Image();
                g.onload = function() {
                  return c(g);
                }, g.onerror = h, (Od(i) || r) && (g.crossOrigin = "anonymous"), g.src = i, g.complete === !0 && setTimeout(function() {
                  return c(g);
                }, 500), s._options.imageTimeout > 0 && setTimeout(function() {
                  return h("Timed out (" + s._options.imageTimeout + "ms) loading image");
                }, s._options.imageTimeout);
              })];
            case 3:
              return [2, u.sent()];
          }
        });
      });
    }, t.prototype.has = function(A) {
      return typeof this._cache[A] < "u";
    }, t.prototype.keys = function() {
      return Promise.resolve(Object.keys(this._cache));
    }, t.prototype.proxy = function(A) {
      var e = this, r = this._options.proxy;
      if (!r)
        throw new Error("No proxy defined");
      var n = A.substring(0, 256);
      return new Promise(function(i, s) {
        var u = it.SUPPORT_RESPONSE_TYPE ? "blob" : "text", c = new XMLHttpRequest();
        c.onload = function() {
          if (c.status === 200)
            if (u === "text")
              i(c.response);
            else {
              var p = new FileReader();
              p.addEventListener("load", function() {
                return i(p.result);
              }, !1), p.addEventListener("error", function(w) {
                return s(w);
              }, !1), p.readAsDataURL(c.response);
            }
          else
            s("Failed to proxy resource " + n + " with status code " + c.status);
        }, c.onerror = s;
        var h = r.indexOf("?") > -1 ? "&" : "?";
        if (c.open("GET", "" + r + h + "url=" + encodeURIComponent(A) + "&responseType=" + u), u !== "text" && c instanceof XMLHttpRequest && (c.responseType = u), e._options.imageTimeout) {
          var g = e._options.imageTimeout;
          c.timeout = g, c.ontimeout = function() {
            return s("Timed out (" + g + "ms) proxying " + n);
          };
        }
        c.send();
      });
    }, t;
  }()
), Nd = /^data:image\/svg\+xml/i, _d = /^data:image\/.*;base64,/i, Dd = /^data:image\/.*/i, Td = function(t) {
  return it.SUPPORT_SVG_DRAWING || !Pd(t);
}, Ru = function(t) {
  return Dd.test(t);
}, Od = function(t) {
  return _d.test(t);
}, Gu = function(t) {
  return t.substr(0, 4) === "blob";
}, Pd = function(t) {
  return t.substr(-3).toLowerCase() === "svg" || Nd.test(t);
}, NA = (
  /** @class */
  function() {
    function t(A, e) {
      this.type = 0, this.x = A, this.y = e;
    }
    return t.prototype.add = function(A, e) {
      return new t(this.x + A, this.y + e);
    }, t;
  }()
), Ci = function(t, A, e) {
  return new NA(t.x + (A.x - t.x) * e, t.y + (A.y - t.y) * e);
}, Xs = (
  /** @class */
  function() {
    function t(A, e, r, n) {
      this.type = 1, this.start = A, this.startControl = e, this.endControl = r, this.end = n;
    }
    return t.prototype.subdivide = function(A, e) {
      var r = Ci(this.start, this.startControl, A), n = Ci(this.startControl, this.endControl, A), i = Ci(this.endControl, this.end, A), s = Ci(r, n, A), u = Ci(n, i, A), c = Ci(s, u, A);
      return e ? new t(this.start, r, s, c) : new t(c, u, i, this.end);
    }, t.prototype.add = function(A, e) {
      return new t(this.start.add(A, e), this.startControl.add(A, e), this.endControl.add(A, e), this.end.add(A, e));
    }, t.prototype.reverse = function() {
      return new t(this.end, this.endControl, this.startControl, this.start);
    }, t;
  }()
), Vt = function(t) {
  return t.type === 1;
}, Md = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(A) {
      var e = A.styles, r = A.bounds, n = Ua(e.borderTopLeftRadius, r.width, r.height), i = n[0], s = n[1], u = Ua(e.borderTopRightRadius, r.width, r.height), c = u[0], h = u[1], g = Ua(e.borderBottomRightRadius, r.width, r.height), p = g[0], w = g[1], B = Ua(e.borderBottomLeftRadius, r.width, r.height), L = B[0], y = B[1], N = [];
      N.push((i + c) / r.width), N.push((L + p) / r.width), N.push((s + y) / r.height), N.push((h + w) / r.height);
      var F = Math.max.apply(Math, N);
      F > 1 && (i /= F, s /= F, c /= F, h /= F, p /= F, w /= F, L /= F, y /= F);
      var x = r.width - c, R = r.height - w, Y = r.width - p, Z = r.height - y, $ = e.borderTopWidth, J = e.borderRightWidth, O = e.borderBottomWidth, W = e.borderLeftWidth, cA = ye(e.paddingTop, A.bounds.width), I = ye(e.paddingRight, A.bounds.width), H = ye(e.paddingBottom, A.bounds.width), K = ye(e.paddingLeft, A.bounds.width);
      this.topLeftBorderDoubleOuterBox = i > 0 || s > 0 ? Ee(r.left + W / 3, r.top + $ / 3, i - W / 3, s - $ / 3, he.TOP_LEFT) : new NA(r.left + W / 3, r.top + $ / 3), this.topRightBorderDoubleOuterBox = i > 0 || s > 0 ? Ee(r.left + x, r.top + $ / 3, c - J / 3, h - $ / 3, he.TOP_RIGHT) : new NA(r.left + r.width - J / 3, r.top + $ / 3), this.bottomRightBorderDoubleOuterBox = p > 0 || w > 0 ? Ee(r.left + Y, r.top + R, p - J / 3, w - O / 3, he.BOTTOM_RIGHT) : new NA(r.left + r.width - J / 3, r.top + r.height - O / 3), this.bottomLeftBorderDoubleOuterBox = L > 0 || y > 0 ? Ee(r.left + W / 3, r.top + Z, L - W / 3, y - O / 3, he.BOTTOM_LEFT) : new NA(r.left + W / 3, r.top + r.height - O / 3), this.topLeftBorderDoubleInnerBox = i > 0 || s > 0 ? Ee(r.left + W * 2 / 3, r.top + $ * 2 / 3, i - W * 2 / 3, s - $ * 2 / 3, he.TOP_LEFT) : new NA(r.left + W * 2 / 3, r.top + $ * 2 / 3), this.topRightBorderDoubleInnerBox = i > 0 || s > 0 ? Ee(r.left + x, r.top + $ * 2 / 3, c - J * 2 / 3, h - $ * 2 / 3, he.TOP_RIGHT) : new NA(r.left + r.width - J * 2 / 3, r.top + $ * 2 / 3), this.bottomRightBorderDoubleInnerBox = p > 0 || w > 0 ? Ee(r.left + Y, r.top + R, p - J * 2 / 3, w - O * 2 / 3, he.BOTTOM_RIGHT) : new NA(r.left + r.width - J * 2 / 3, r.top + r.height - O * 2 / 3), this.bottomLeftBorderDoubleInnerBox = L > 0 || y > 0 ? Ee(r.left + W * 2 / 3, r.top + Z, L - W * 2 / 3, y - O * 2 / 3, he.BOTTOM_LEFT) : new NA(r.left + W * 2 / 3, r.top + r.height - O * 2 / 3), this.topLeftBorderStroke = i > 0 || s > 0 ? Ee(r.left + W / 2, r.top + $ / 2, i - W / 2, s - $ / 2, he.TOP_LEFT) : new NA(r.left + W / 2, r.top + $ / 2), this.topRightBorderStroke = i > 0 || s > 0 ? Ee(r.left + x, r.top + $ / 2, c - J / 2, h - $ / 2, he.TOP_RIGHT) : new NA(r.left + r.width - J / 2, r.top + $ / 2), this.bottomRightBorderStroke = p > 0 || w > 0 ? Ee(r.left + Y, r.top + R, p - J / 2, w - O / 2, he.BOTTOM_RIGHT) : new NA(r.left + r.width - J / 2, r.top + r.height - O / 2), this.bottomLeftBorderStroke = L > 0 || y > 0 ? Ee(r.left + W / 2, r.top + Z, L - W / 2, y - O / 2, he.BOTTOM_LEFT) : new NA(r.left + W / 2, r.top + r.height - O / 2), this.topLeftBorderBox = i > 0 || s > 0 ? Ee(r.left, r.top, i, s, he.TOP_LEFT) : new NA(r.left, r.top), this.topRightBorderBox = c > 0 || h > 0 ? Ee(r.left + x, r.top, c, h, he.TOP_RIGHT) : new NA(r.left + r.width, r.top), this.bottomRightBorderBox = p > 0 || w > 0 ? Ee(r.left + Y, r.top + R, p, w, he.BOTTOM_RIGHT) : new NA(r.left + r.width, r.top + r.height), this.bottomLeftBorderBox = L > 0 || y > 0 ? Ee(r.left, r.top + Z, L, y, he.BOTTOM_LEFT) : new NA(r.left, r.top + r.height), this.topLeftPaddingBox = i > 0 || s > 0 ? Ee(r.left + W, r.top + $, Math.max(0, i - W), Math.max(0, s - $), he.TOP_LEFT) : new NA(r.left + W, r.top + $), this.topRightPaddingBox = c > 0 || h > 0 ? Ee(r.left + Math.min(x, r.width - J), r.top + $, x > r.width + J ? 0 : Math.max(0, c - J), Math.max(0, h - $), he.TOP_RIGHT) : new NA(r.left + r.width - J, r.top + $), this.bottomRightPaddingBox = p > 0 || w > 0 ? Ee(r.left + Math.min(Y, r.width - W), r.top + Math.min(R, r.height - O), Math.max(0, p - J), Math.max(0, w - O), he.BOTTOM_RIGHT) : new NA(r.left + r.width - J, r.top + r.height - O), this.bottomLeftPaddingBox = L > 0 || y > 0 ? Ee(r.left + W, r.top + Math.min(Z, r.height - O), Math.max(0, L - W), Math.max(0, y - O), he.BOTTOM_LEFT) : new NA(r.left + W, r.top + r.height - O), this.topLeftContentBox = i > 0 || s > 0 ? Ee(r.left + W + K, r.top + $ + cA, Math.max(0, i - (W + K)), Math.max(0, s - ($ + cA)), he.TOP_LEFT) : new NA(r.left + W + K, r.top + $ + cA), this.topRightContentBox = c > 0 || h > 0 ? Ee(r.left + Math.min(x, r.width + W + K), r.top + $ + cA, x > r.width + W + K ? 0 : c - W + K, h - ($ + cA), he.TOP_RIGHT) : new NA(r.left + r.width - (J + I), r.top + $ + cA), this.bottomRightContentBox = p > 0 || w > 0 ? Ee(r.left + Math.min(Y, r.width - (W + K)), r.top + Math.min(R, r.height + $ + cA), Math.max(0, p - (J + I)), w - (O + H), he.BOTTOM_RIGHT) : new NA(r.left + r.width - (J + I), r.top + r.height - (O + H)), this.bottomLeftContentBox = L > 0 || y > 0 ? Ee(r.left + W + K, r.top + Z, Math.max(0, L - (W + K)), y - (O + H), he.BOTTOM_LEFT) : new NA(r.left + W + K, r.top + r.height - (O + H));
    }
    return t;
  }()
), he;
(function(t) {
  t[t.TOP_LEFT = 0] = "TOP_LEFT", t[t.TOP_RIGHT = 1] = "TOP_RIGHT", t[t.BOTTOM_RIGHT = 2] = "BOTTOM_RIGHT", t[t.BOTTOM_LEFT = 3] = "BOTTOM_LEFT";
})(he || (he = {}));
var Ee = function(t, A, e, r, n) {
  var i = 4 * ((Math.sqrt(2) - 1) / 3), s = e * i, u = r * i, c = t + e, h = A + r;
  switch (n) {
    case he.TOP_LEFT:
      return new Xs(new NA(t, h), new NA(t, h - u), new NA(c - s, A), new NA(c, A));
    case he.TOP_RIGHT:
      return new Xs(new NA(t, A), new NA(t + s, A), new NA(c, h - u), new NA(c, h));
    case he.BOTTOM_RIGHT:
      return new Xs(new NA(c, A), new NA(c, A + u), new NA(t + s, h), new NA(t, h));
    case he.BOTTOM_LEFT:
    default:
      return new Xs(new NA(c, h), new NA(c - s, h), new NA(t, A + u), new NA(t, A));
  }
}, wo = function(t) {
  return [t.topLeftBorderBox, t.topRightBorderBox, t.bottomRightBorderBox, t.bottomLeftBorderBox];
}, Kd = function(t) {
  return [
    t.topLeftContentBox,
    t.topRightContentBox,
    t.bottomRightContentBox,
    t.bottomLeftContentBox
  ];
}, vo = function(t) {
  return [
    t.topLeftPaddingBox,
    t.topRightPaddingBox,
    t.bottomRightPaddingBox,
    t.bottomLeftPaddingBox
  ];
}, kd = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(A, e, r) {
      this.offsetX = A, this.offsetY = e, this.matrix = r, this.type = 0, this.target = 6;
    }
    return t;
  }()
), Js = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(A, e) {
      this.path = A, this.target = e, this.type = 1;
    }
    return t;
  }()
), Rd = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(A) {
      this.opacity = A, this.type = 2, this.target = 6;
    }
    return t;
  }()
), Gd = function(t) {
  return t.type === 0;
}, _h = function(t) {
  return t.type === 1;
}, jd = function(t) {
  return t.type === 2;
}, Bf = function(t, A) {
  return t.length === A.length ? t.some(function(e, r) {
    return e === A[r];
  }) : !1;
}, Vd = function(t, A, e, r, n) {
  return t.map(function(i, s) {
    switch (s) {
      case 0:
        return i.add(A, e);
      case 1:
        return i.add(A + r, e);
      case 2:
        return i.add(A + r, e + n);
      case 3:
        return i.add(A, e + n);
    }
    return i;
  });
}, Dh = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(A) {
      this.element = A, this.inlineLevel = [], this.nonInlineLevel = [], this.negativeZIndex = [], this.zeroOrAutoZIndexOrTransformedOrOpacity = [], this.positiveZIndex = [], this.nonPositionedFloats = [], this.nonPositionedInlineLevel = [];
    }
    return t;
  }()
), Th = (
  /** @class */
  function() {
    function t(A, e) {
      if (this.container = A, this.parent = e, this.effects = [], this.curves = new Md(this.container), this.container.styles.opacity < 1 && this.effects.push(new Rd(this.container.styles.opacity)), this.container.styles.transform !== null) {
        var r = this.container.bounds.left + this.container.styles.transformOrigin[0].number, n = this.container.bounds.top + this.container.styles.transformOrigin[1].number, i = this.container.styles.transform;
        this.effects.push(new kd(r, n, i));
      }
      if (this.container.styles.overflowX !== 0) {
        var s = wo(this.curves), u = vo(this.curves);
        Bf(s, u) ? this.effects.push(new Js(
          s,
          6
          /* CONTENT */
        )) : (this.effects.push(new Js(
          s,
          2
          /* BACKGROUND_BORDERS */
        )), this.effects.push(new Js(
          u,
          4
          /* CONTENT */
        )));
      }
    }
    return t.prototype.getEffects = function(A) {
      for (var e = [
        2,
        3
        /* FIXED */
      ].indexOf(this.container.styles.position) === -1, r = this.parent, n = this.effects.slice(0); r; ) {
        var i = r.effects.filter(function(c) {
          return !_h(c);
        });
        if (e || r.container.styles.position !== 0 || !r.parent) {
          if (n.unshift.apply(n, i), e = [
            2,
            3
            /* FIXED */
          ].indexOf(r.container.styles.position) === -1, r.container.styles.overflowX !== 0) {
            var s = wo(r.curves), u = vo(r.curves);
            Bf(s, u) || n.unshift(new Js(
              u,
              6
              /* CONTENT */
            ));
          }
        } else
          n.unshift.apply(n, i);
        r = r.parent;
      }
      return n.filter(function(c) {
        return ze(c.target, A);
      });
    }, t;
  }()
), Qc = function(t, A, e, r) {
  t.container.elements.forEach(function(n) {
    var i = ze(
      n.flags,
      4
      /* CREATES_REAL_STACKING_CONTEXT */
    ), s = ze(
      n.flags,
      2
      /* CREATES_STACKING_CONTEXT */
    ), u = new Th(n, t);
    ze(
      n.styles.display,
      2048
      /* LIST_ITEM */
    ) && r.push(u);
    var c = ze(
      n.flags,
      8
      /* IS_LIST_OWNER */
    ) ? [] : r;
    if (i || s) {
      var h = i || n.styles.isPositioned() ? e : A, g = new Dh(u);
      if (n.styles.isPositioned() || n.styles.opacity < 1 || n.styles.isTransformed()) {
        var p = n.styles.zIndex.order;
        if (p < 0) {
          var w = 0;
          h.negativeZIndex.some(function(L, y) {
            return p > L.element.container.styles.zIndex.order ? (w = y, !1) : w > 0;
          }), h.negativeZIndex.splice(w, 0, g);
        } else if (p > 0) {
          var B = 0;
          h.positiveZIndex.some(function(L, y) {
            return p >= L.element.container.styles.zIndex.order ? (B = y + 1, !1) : B > 0;
          }), h.positiveZIndex.splice(B, 0, g);
        } else
          h.zeroOrAutoZIndexOrTransformedOrOpacity.push(g);
      } else
        n.styles.isFloating() ? h.nonPositionedFloats.push(g) : h.nonPositionedInlineLevel.push(g);
      Qc(u, g, i ? g : e, c);
    } else
      n.styles.isInlineLevel() ? A.inlineLevel.push(u) : A.nonInlineLevel.push(u), Qc(u, A, e, c);
    ze(
      n.flags,
      8
      /* IS_LIST_OWNER */
    ) && Oh(n, c);
  });
}, Oh = function(t, A) {
  for (var e = t instanceof pc ? t.start : 1, r = t instanceof pc ? t.reversed : !1, n = 0; n < A.length; n++) {
    var i = A[n];
    i.container instanceof mh && typeof i.container.value == "number" && i.container.value !== 0 && (e = i.container.value), i.listValue = Da(e, i.container.styles.listStyleType, !0), e += r ? -1 : 1;
  }
}, qd = function(t) {
  var A = new Th(t, null), e = new Dh(A), r = [];
  return Qc(A, e, e, r), Oh(A.container, r), e;
}, gf = function(t, A) {
  switch (A) {
    case 0:
      return Wt(t.topLeftBorderBox, t.topLeftPaddingBox, t.topRightBorderBox, t.topRightPaddingBox);
    case 1:
      return Wt(t.topRightBorderBox, t.topRightPaddingBox, t.bottomRightBorderBox, t.bottomRightPaddingBox);
    case 2:
      return Wt(t.bottomRightBorderBox, t.bottomRightPaddingBox, t.bottomLeftBorderBox, t.bottomLeftPaddingBox);
    case 3:
    default:
      return Wt(t.bottomLeftBorderBox, t.bottomLeftPaddingBox, t.topLeftBorderBox, t.topLeftPaddingBox);
  }
}, Wd = function(t, A) {
  switch (A) {
    case 0:
      return Wt(t.topLeftBorderBox, t.topLeftBorderDoubleOuterBox, t.topRightBorderBox, t.topRightBorderDoubleOuterBox);
    case 1:
      return Wt(t.topRightBorderBox, t.topRightBorderDoubleOuterBox, t.bottomRightBorderBox, t.bottomRightBorderDoubleOuterBox);
    case 2:
      return Wt(t.bottomRightBorderBox, t.bottomRightBorderDoubleOuterBox, t.bottomLeftBorderBox, t.bottomLeftBorderDoubleOuterBox);
    case 3:
    default:
      return Wt(t.bottomLeftBorderBox, t.bottomLeftBorderDoubleOuterBox, t.topLeftBorderBox, t.topLeftBorderDoubleOuterBox);
  }
}, Xd = function(t, A) {
  switch (A) {
    case 0:
      return Wt(t.topLeftBorderDoubleInnerBox, t.topLeftPaddingBox, t.topRightBorderDoubleInnerBox, t.topRightPaddingBox);
    case 1:
      return Wt(t.topRightBorderDoubleInnerBox, t.topRightPaddingBox, t.bottomRightBorderDoubleInnerBox, t.bottomRightPaddingBox);
    case 2:
      return Wt(t.bottomRightBorderDoubleInnerBox, t.bottomRightPaddingBox, t.bottomLeftBorderDoubleInnerBox, t.bottomLeftPaddingBox);
    case 3:
    default:
      return Wt(t.bottomLeftBorderDoubleInnerBox, t.bottomLeftPaddingBox, t.topLeftBorderDoubleInnerBox, t.topLeftPaddingBox);
  }
}, Jd = function(t, A) {
  switch (A) {
    case 0:
      return zs(t.topLeftBorderStroke, t.topRightBorderStroke);
    case 1:
      return zs(t.topRightBorderStroke, t.bottomRightBorderStroke);
    case 2:
      return zs(t.bottomRightBorderStroke, t.bottomLeftBorderStroke);
    case 3:
    default:
      return zs(t.bottomLeftBorderStroke, t.topLeftBorderStroke);
  }
}, zs = function(t, A) {
  var e = [];
  return Vt(t) ? e.push(t.subdivide(0.5, !1)) : e.push(t), Vt(A) ? e.push(A.subdivide(0.5, !0)) : e.push(A), e;
}, Wt = function(t, A, e, r) {
  var n = [];
  return Vt(t) ? n.push(t.subdivide(0.5, !1)) : n.push(t), Vt(e) ? n.push(e.subdivide(0.5, !0)) : n.push(e), Vt(r) ? n.push(r.subdivide(0.5, !0).reverse()) : n.push(r), Vt(A) ? n.push(A.subdivide(0.5, !1).reverse()) : n.push(A), n;
}, Ph = function(t) {
  var A = t.bounds, e = t.styles;
  return A.add(e.borderLeftWidth, e.borderTopWidth, -(e.borderRightWidth + e.borderLeftWidth), -(e.borderTopWidth + e.borderBottomWidth));
}, mo = function(t) {
  var A = t.styles, e = t.bounds, r = ye(A.paddingLeft, e.width), n = ye(A.paddingRight, e.width), i = ye(A.paddingTop, e.width), s = ye(A.paddingBottom, e.width);
  return e.add(r + A.borderLeftWidth, i + A.borderTopWidth, -(A.borderRightWidth + A.borderLeftWidth + r + n), -(A.borderTopWidth + A.borderBottomWidth + i + s));
}, zd = function(t, A) {
  return t === 0 ? A.bounds : t === 2 ? mo(A) : Ph(A);
}, Yd = function(t, A) {
  return t === 0 ? A.bounds : t === 2 ? mo(A) : Ph(A);
}, ju = function(t, A, e) {
  var r = zd(bi(t.styles.backgroundOrigin, A), t), n = Yd(bi(t.styles.backgroundClip, A), t), i = Zd(bi(t.styles.backgroundSize, A), e, r), s = i[0], u = i[1], c = Ua(bi(t.styles.backgroundPosition, A), r.width - s, r.height - u), h = $d(bi(t.styles.backgroundRepeat, A), c, i, r, n), g = Math.round(r.left + c[0]), p = Math.round(r.top + c[1]);
  return [h, g, p, s, u];
}, Qi = function(t) {
  return ve(t) && t.value === Hi.AUTO;
}, Ys = function(t) {
  return typeof t == "number";
}, Zd = function(t, A, e) {
  var r = A[0], n = A[1], i = A[2], s = t[0], u = t[1];
  if (!s)
    return [0, 0];
  if (We(s) && u && We(u))
    return [ye(s, e.width), ye(u, e.height)];
  var c = Ys(i);
  if (ve(s) && (s.value === Hi.CONTAIN || s.value === Hi.COVER)) {
    if (Ys(i)) {
      var h = e.width / e.height;
      return h < i != (s.value === Hi.COVER) ? [e.width, e.width / i] : [e.height * i, e.height];
    }
    return [e.width, e.height];
  }
  var g = Ys(r), p = Ys(n), w = g || p;
  if (Qi(s) && (!u || Qi(u))) {
    if (g && p)
      return [r, n];
    if (!c && !w)
      return [e.width, e.height];
    if (w && c) {
      var B = g ? r : n * i, L = p ? n : r / i;
      return [B, L];
    }
    var y = g ? r : e.width, N = p ? n : e.height;
    return [y, N];
  }
  if (c) {
    var F = 0, x = 0;
    return We(s) ? F = ye(s, e.width) : We(u) && (x = ye(u, e.height)), Qi(s) ? F = x * i : (!u || Qi(u)) && (x = F / i), [F, x];
  }
  var R = null, Y = null;
  if (We(s) ? R = ye(s, e.width) : u && We(u) && (Y = ye(u, e.height)), R !== null && (!u || Qi(u)) && (Y = g && p ? R / r * n : e.height), Y !== null && Qi(s) && (R = g && p ? Y / n * r : e.width), R !== null && Y !== null)
    return [R, Y];
  throw new Error("Unable to calculate background-size for element");
}, bi = function(t, A) {
  var e = t[A];
  return typeof e > "u" ? t[0] : e;
}, $d = function(t, A, e, r, n) {
  var i = A[0], s = A[1], u = e[0], c = e[1];
  switch (t) {
    case 2:
      return [
        new NA(Math.round(r.left), Math.round(r.top + s)),
        new NA(Math.round(r.left + r.width), Math.round(r.top + s)),
        new NA(Math.round(r.left + r.width), Math.round(c + r.top + s)),
        new NA(Math.round(r.left), Math.round(c + r.top + s))
      ];
    case 3:
      return [
        new NA(Math.round(r.left + i), Math.round(r.top)),
        new NA(Math.round(r.left + i + u), Math.round(r.top)),
        new NA(Math.round(r.left + i + u), Math.round(r.height + r.top)),
        new NA(Math.round(r.left + i), Math.round(r.height + r.top))
      ];
    case 1:
      return [
        new NA(Math.round(r.left + i), Math.round(r.top + s)),
        new NA(Math.round(r.left + i + u), Math.round(r.top + s)),
        new NA(Math.round(r.left + i + u), Math.round(r.top + s + c)),
        new NA(Math.round(r.left + i), Math.round(r.top + s + c))
      ];
    default:
      return [
        new NA(Math.round(n.left), Math.round(n.top)),
        new NA(Math.round(n.left + n.width), Math.round(n.top)),
        new NA(Math.round(n.left + n.width), Math.round(n.height + n.top)),
        new NA(Math.round(n.left), Math.round(n.height + n.top))
      ];
  }
}, Ap = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7", df = "Hidden Text", ep = (
  /** @class */
  function() {
    function t(A) {
      this._data = {}, this._document = A;
    }
    return t.prototype.parseMetrics = function(A, e) {
      var r = this._document.createElement("div"), n = this._document.createElement("img"), i = this._document.createElement("span"), s = this._document.body;
      r.style.visibility = "hidden", r.style.fontFamily = A, r.style.fontSize = e, r.style.margin = "0", r.style.padding = "0", r.style.whiteSpace = "nowrap", s.appendChild(r), n.src = Ap, n.width = 1, n.height = 1, n.style.margin = "0", n.style.padding = "0", n.style.verticalAlign = "baseline", i.style.fontFamily = A, i.style.fontSize = e, i.style.margin = "0", i.style.padding = "0", i.appendChild(this._document.createTextNode(df)), r.appendChild(i), r.appendChild(n);
      var u = n.offsetTop - i.offsetTop + 2;
      r.removeChild(i), r.appendChild(this._document.createTextNode(df)), r.style.lineHeight = "normal", n.style.verticalAlign = "super";
      var c = n.offsetTop - r.offsetTop + 2;
      return s.removeChild(r), { baseline: u, middle: c };
    }, t.prototype.getMetrics = function(A, e) {
      var r = A + " " + e;
      return typeof this._data[r] > "u" && (this._data[r] = this.parseMetrics(A, e)), this._data[r];
    }, t;
  }()
), Mh = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(A, e) {
      this.context = A, this.options = e;
    }
    return t;
  }()
), tp = 1e4, rp = (
  /** @class */
  function(t) {
    ur(A, t);
    function A(e, r) {
      var n = t.call(this, e, r) || this;
      return n._activeEffects = [], n.canvas = r.canvas ? r.canvas : document.createElement("canvas"), n.ctx = n.canvas.getContext("2d"), r.canvas || (n.canvas.width = Math.floor(r.width * r.scale), n.canvas.height = Math.floor(r.height * r.scale), n.canvas.style.width = r.width + "px", n.canvas.style.height = r.height + "px"), n.fontMetrics = new ep(document), n.ctx.scale(n.options.scale, n.options.scale), n.ctx.translate(-r.x, -r.y), n.ctx.textBaseline = "bottom", n._activeEffects = [], n.context.logger.debug("Canvas renderer initialized (" + r.width + "x" + r.height + ") with scale " + r.scale), n;
    }
    return A.prototype.applyEffects = function(e) {
      for (var r = this; this._activeEffects.length; )
        this.popEffect();
      e.forEach(function(n) {
        return r.applyEffect(n);
      });
    }, A.prototype.applyEffect = function(e) {
      this.ctx.save(), jd(e) && (this.ctx.globalAlpha = e.opacity), Gd(e) && (this.ctx.translate(e.offsetX, e.offsetY), this.ctx.transform(e.matrix[0], e.matrix[1], e.matrix[2], e.matrix[3], e.matrix[4], e.matrix[5]), this.ctx.translate(-e.offsetX, -e.offsetY)), _h(e) && (this.path(e.path), this.ctx.clip()), this._activeEffects.push(e);
    }, A.prototype.popEffect = function() {
      this._activeEffects.pop(), this.ctx.restore();
    }, A.prototype.renderStack = function(e) {
      return mt(this, void 0, void 0, function() {
        var r;
        return Bt(this, function(n) {
          switch (n.label) {
            case 0:
              return r = e.element.container.styles, r.isVisible() ? [4, this.renderStackContent(e)] : [3, 2];
            case 1:
              n.sent(), n.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, A.prototype.renderNode = function(e) {
      return mt(this, void 0, void 0, function() {
        return Bt(this, function(r) {
          switch (r.label) {
            case 0:
              if (ze(
                e.container.flags,
                16
                /* DEBUG_RENDER */
              ))
                debugger;
              return e.container.styles.isVisible() ? [4, this.renderNodeBackgroundAndBorders(e)] : [3, 3];
            case 1:
              return r.sent(), [4, this.renderNodeContent(e)];
            case 2:
              r.sent(), r.label = 3;
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, A.prototype.renderTextWithLetterSpacing = function(e, r, n) {
      var i = this;
      if (r === 0)
        this.ctx.fillText(e.text, e.bounds.left, e.bounds.top + n);
      else {
        var s = Pc(e.text);
        s.reduce(function(u, c) {
          return i.ctx.fillText(c, u, e.bounds.top + n), u + i.ctx.measureText(c).width;
        }, e.bounds.left);
      }
    }, A.prototype.createFontStyle = function(e) {
      var r = e.fontVariant.filter(function(s) {
        return s === "normal" || s === "small-caps";
      }).join(""), n = op(e.fontFamily).join(", "), i = Pa(e.fontSize) ? "" + e.fontSize.number + e.fontSize.unit : e.fontSize.number + "px";
      return [
        [e.fontStyle, r, e.fontWeight, i, n].join(" "),
        n,
        i
      ];
    }, A.prototype.renderTextNode = function(e, r) {
      return mt(this, void 0, void 0, function() {
        var n, i, s, u, c, h, g, p, w = this;
        return Bt(this, function(B) {
          return n = this.createFontStyle(r), i = n[0], s = n[1], u = n[2], this.ctx.font = i, this.ctx.direction = r.direction === 1 ? "rtl" : "ltr", this.ctx.textAlign = "left", this.ctx.textBaseline = "alphabetic", c = this.fontMetrics.getMetrics(s, u), h = c.baseline, g = c.middle, p = r.paintOrder, e.textBounds.forEach(function(L) {
            p.forEach(function(y) {
              switch (y) {
                case 0:
                  w.ctx.fillStyle = At(r.color), w.renderTextWithLetterSpacing(L, r.letterSpacing, h);
                  var N = r.textShadow;
                  N.length && L.text.trim().length && (N.slice(0).reverse().forEach(function(F) {
                    w.ctx.shadowColor = At(F.color), w.ctx.shadowOffsetX = F.offsetX.number * w.options.scale, w.ctx.shadowOffsetY = F.offsetY.number * w.options.scale, w.ctx.shadowBlur = F.blur.number, w.renderTextWithLetterSpacing(L, r.letterSpacing, h);
                  }), w.ctx.shadowColor = "", w.ctx.shadowOffsetX = 0, w.ctx.shadowOffsetY = 0, w.ctx.shadowBlur = 0), r.textDecorationLine.length && (w.ctx.fillStyle = At(r.textDecorationColor || r.color), r.textDecorationLine.forEach(function(F) {
                    switch (F) {
                      case 1:
                        w.ctx.fillRect(L.bounds.left, Math.round(L.bounds.top + h), L.bounds.width, 1);
                        break;
                      case 2:
                        w.ctx.fillRect(L.bounds.left, Math.round(L.bounds.top), L.bounds.width, 1);
                        break;
                      case 3:
                        w.ctx.fillRect(L.bounds.left, Math.ceil(L.bounds.top + g), L.bounds.width, 1);
                        break;
                    }
                  }));
                  break;
                case 1:
                  r.webkitTextStrokeWidth && L.text.trim().length && (w.ctx.strokeStyle = At(r.webkitTextStrokeColor), w.ctx.lineWidth = r.webkitTextStrokeWidth, w.ctx.lineJoin = window.chrome ? "miter" : "round", w.ctx.strokeText(L.text, L.bounds.left, L.bounds.top + h)), w.ctx.strokeStyle = "", w.ctx.lineWidth = 0, w.ctx.lineJoin = "miter";
                  break;
              }
            });
          }), [
            2
            /*return*/
          ];
        });
      });
    }, A.prototype.renderReplacedElement = function(e, r, n) {
      if (n && e.intrinsicWidth > 0 && e.intrinsicHeight > 0) {
        var i = mo(e), s = vo(r);
        this.path(s), this.ctx.save(), this.ctx.clip(), this.ctx.drawImage(n, 0, 0, e.intrinsicWidth, e.intrinsicHeight, i.left, i.top, i.width, i.height), this.ctx.restore();
      }
    }, A.prototype.renderNodeContent = function(e) {
      return mt(this, void 0, void 0, function() {
        var r, n, i, s, u, c, x, x, h, g, p, w, Y, B, L, Z, y, N, F, x, R, Y, Z;
        return Bt(this, function($) {
          switch ($.label) {
            case 0:
              this.applyEffects(e.getEffects(
                4
                /* CONTENT */
              )), r = e.container, n = e.curves, i = r.styles, s = 0, u = r.textNodes, $.label = 1;
            case 1:
              return s < u.length ? (c = u[s], [4, this.renderTextNode(c, i)]) : [3, 4];
            case 2:
              $.sent(), $.label = 3;
            case 3:
              return s++, [3, 1];
            case 4:
              if (!(r instanceof ph)) return [3, 8];
              $.label = 5;
            case 5:
              return $.trys.push([5, 7, , 8]), [4, this.context.cache.match(r.src)];
            case 6:
              return x = $.sent(), this.renderReplacedElement(r, n, x), [3, 8];
            case 7:
              return $.sent(), this.context.logger.error("Error loading image " + r.src), [3, 8];
            case 8:
              if (r instanceof wh && this.renderReplacedElement(r, n, r.canvas), !(r instanceof vh)) return [3, 12];
              $.label = 9;
            case 9:
              return $.trys.push([9, 11, , 12]), [4, this.context.cache.match(r.svg)];
            case 10:
              return x = $.sent(), this.renderReplacedElement(r, n, x), [3, 12];
            case 11:
              return $.sent(), this.context.logger.error("Error loading svg " + r.svg.substring(0, 255)), [3, 12];
            case 12:
              return r instanceof Fh && r.tree ? (h = new A(this.context, {
                scale: this.options.scale,
                backgroundColor: r.backgroundColor,
                x: 0,
                y: 0,
                width: r.width,
                height: r.height
              }), [4, h.render(r.tree)]) : [3, 14];
            case 13:
              g = $.sent(), r.width && r.height && this.ctx.drawImage(g, 0, 0, r.width, r.height, r.bounds.left, r.bounds.top, r.bounds.width, r.bounds.height), $.label = 14;
            case 14:
              if (r instanceof Mc && (p = Math.min(r.bounds.width, r.bounds.height), r.type === ho ? r.checked && (this.ctx.save(), this.path([
                new NA(r.bounds.left + p * 0.39363, r.bounds.top + p * 0.79),
                new NA(r.bounds.left + p * 0.16, r.bounds.top + p * 0.5549),
                new NA(r.bounds.left + p * 0.27347, r.bounds.top + p * 0.44071),
                new NA(r.bounds.left + p * 0.39694, r.bounds.top + p * 0.5649),
                new NA(r.bounds.left + p * 0.72983, r.bounds.top + p * 0.23),
                new NA(r.bounds.left + p * 0.84, r.bounds.top + p * 0.34085),
                new NA(r.bounds.left + p * 0.39363, r.bounds.top + p * 0.79)
              ]), this.ctx.fillStyle = At(tf), this.ctx.fill(), this.ctx.restore()) : r.type === Bo && r.checked && (this.ctx.save(), this.ctx.beginPath(), this.ctx.arc(r.bounds.left + p / 2, r.bounds.top + p / 2, p / 4, 0, Math.PI * 2, !0), this.ctx.fillStyle = At(tf), this.ctx.fill(), this.ctx.restore())), np(r) && r.value.length) {
                switch (w = this.createFontStyle(i), Y = w[0], B = w[1], L = this.fontMetrics.getMetrics(Y, B).baseline, this.ctx.font = Y, this.ctx.fillStyle = At(i.color), this.ctx.textBaseline = "alphabetic", this.ctx.textAlign = ap(r.styles.textAlign), Z = mo(r), y = 0, r.styles.textAlign) {
                  case 1:
                    y += Z.width / 2;
                    break;
                  case 2:
                    y += Z.width;
                    break;
                }
                N = Z.add(y, 0, 0, -Z.height / 2 + 1), this.ctx.save(), this.path([
                  new NA(Z.left, Z.top),
                  new NA(Z.left + Z.width, Z.top),
                  new NA(Z.left + Z.width, Z.top + Z.height),
                  new NA(Z.left, Z.top + Z.height)
                ]), this.ctx.clip(), this.renderTextWithLetterSpacing(new xa(r.value, N), i.letterSpacing, L), this.ctx.restore(), this.ctx.textBaseline = "alphabetic", this.ctx.textAlign = "left";
              }
              if (!ze(
                r.styles.display,
                2048
                /* LIST_ITEM */
              )) return [3, 20];
              if (r.styles.listStyleImage === null) return [3, 19];
              if (F = r.styles.listStyleImage, F.type !== 0) return [3, 18];
              x = void 0, R = F.url, $.label = 15;
            case 15:
              return $.trys.push([15, 17, , 18]), [4, this.context.cache.match(R)];
            case 16:
              return x = $.sent(), this.ctx.drawImage(x, r.bounds.left - (x.width + 10), r.bounds.top), [3, 18];
            case 17:
              return $.sent(), this.context.logger.error("Error loading list-style-image " + R), [3, 18];
            case 18:
              return [3, 20];
            case 19:
              e.listValue && r.styles.listStyleType !== -1 && (Y = this.createFontStyle(i)[0], this.ctx.font = Y, this.ctx.fillStyle = At(i.color), this.ctx.textBaseline = "middle", this.ctx.textAlign = "right", Z = new jr(r.bounds.left, r.bounds.top + ye(r.styles.paddingTop, r.bounds.width), r.bounds.width, Ml(i.lineHeight, i.fontSize.number) / 2 + 1), this.renderTextWithLetterSpacing(new xa(e.listValue, Z), i.letterSpacing, Ml(i.lineHeight, i.fontSize.number) / 2 + 2), this.ctx.textBaseline = "bottom", this.ctx.textAlign = "left"), $.label = 20;
            case 20:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, A.prototype.renderStackContent = function(e) {
      return mt(this, void 0, void 0, function() {
        var r, n, F, i, s, F, u, c, F, h, g, F, p, w, F, B, L, F, y, N, F;
        return Bt(this, function(x) {
          switch (x.label) {
            case 0:
              if (ze(
                e.element.container.flags,
                16
                /* DEBUG_RENDER */
              ))
                debugger;
              return [4, this.renderNodeBackgroundAndBorders(e.element)];
            case 1:
              x.sent(), r = 0, n = e.negativeZIndex, x.label = 2;
            case 2:
              return r < n.length ? (F = n[r], [4, this.renderStack(F)]) : [3, 5];
            case 3:
              x.sent(), x.label = 4;
            case 4:
              return r++, [3, 2];
            case 5:
              return [4, this.renderNodeContent(e.element)];
            case 6:
              x.sent(), i = 0, s = e.nonInlineLevel, x.label = 7;
            case 7:
              return i < s.length ? (F = s[i], [4, this.renderNode(F)]) : [3, 10];
            case 8:
              x.sent(), x.label = 9;
            case 9:
              return i++, [3, 7];
            case 10:
              u = 0, c = e.nonPositionedFloats, x.label = 11;
            case 11:
              return u < c.length ? (F = c[u], [4, this.renderStack(F)]) : [3, 14];
            case 12:
              x.sent(), x.label = 13;
            case 13:
              return u++, [3, 11];
            case 14:
              h = 0, g = e.nonPositionedInlineLevel, x.label = 15;
            case 15:
              return h < g.length ? (F = g[h], [4, this.renderStack(F)]) : [3, 18];
            case 16:
              x.sent(), x.label = 17;
            case 17:
              return h++, [3, 15];
            case 18:
              p = 0, w = e.inlineLevel, x.label = 19;
            case 19:
              return p < w.length ? (F = w[p], [4, this.renderNode(F)]) : [3, 22];
            case 20:
              x.sent(), x.label = 21;
            case 21:
              return p++, [3, 19];
            case 22:
              B = 0, L = e.zeroOrAutoZIndexOrTransformedOrOpacity, x.label = 23;
            case 23:
              return B < L.length ? (F = L[B], [4, this.renderStack(F)]) : [3, 26];
            case 24:
              x.sent(), x.label = 25;
            case 25:
              return B++, [3, 23];
            case 26:
              y = 0, N = e.positiveZIndex, x.label = 27;
            case 27:
              return y < N.length ? (F = N[y], [4, this.renderStack(F)]) : [3, 30];
            case 28:
              x.sent(), x.label = 29;
            case 29:
              return y++, [3, 27];
            case 30:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, A.prototype.mask = function(e) {
      this.ctx.beginPath(), this.ctx.moveTo(0, 0), this.ctx.lineTo(this.canvas.width, 0), this.ctx.lineTo(this.canvas.width, this.canvas.height), this.ctx.lineTo(0, this.canvas.height), this.ctx.lineTo(0, 0), this.formatPath(e.slice(0).reverse()), this.ctx.closePath();
    }, A.prototype.path = function(e) {
      this.ctx.beginPath(), this.formatPath(e), this.ctx.closePath();
    }, A.prototype.formatPath = function(e) {
      var r = this;
      e.forEach(function(n, i) {
        var s = Vt(n) ? n.start : n;
        i === 0 ? r.ctx.moveTo(s.x, s.y) : r.ctx.lineTo(s.x, s.y), Vt(n) && r.ctx.bezierCurveTo(n.startControl.x, n.startControl.y, n.endControl.x, n.endControl.y, n.end.x, n.end.y);
      });
    }, A.prototype.renderRepeat = function(e, r, n, i) {
      this.path(e), this.ctx.fillStyle = r, this.ctx.translate(n, i), this.ctx.fill(), this.ctx.translate(-n, -i);
    }, A.prototype.resizeImage = function(e, r, n) {
      var i;
      if (e.width === r && e.height === n)
        return e;
      var s = (i = this.canvas.ownerDocument) !== null && i !== void 0 ? i : document, u = s.createElement("canvas");
      u.width = Math.max(1, r), u.height = Math.max(1, n);
      var c = u.getContext("2d");
      return c.drawImage(e, 0, 0, e.width, e.height, 0, 0, r, n), u;
    }, A.prototype.renderBackgroundImage = function(e) {
      return mt(this, void 0, void 0, function() {
        var r, n, i, s, u, c;
        return Bt(this, function(h) {
          switch (h.label) {
            case 0:
              r = e.styles.backgroundImage.length - 1, n = function(g) {
                var p, w, B, cA, iA, uA, K, M, O, L, cA, iA, uA, K, M, y, N, F, x, R, Y, Z, $, J, O, W, cA, I, H, K, M, oA, iA, uA, eA, lA, hA, UA, U, _, T, k;
                return Bt(this, function(X) {
                  switch (X.label) {
                    case 0:
                      if (g.type !== 0) return [3, 5];
                      p = void 0, w = g.url, X.label = 1;
                    case 1:
                      return X.trys.push([1, 3, , 4]), [4, i.context.cache.match(w)];
                    case 2:
                      return p = X.sent(), [3, 4];
                    case 3:
                      return X.sent(), i.context.logger.error("Error loading background-image " + w), [3, 4];
                    case 4:
                      return p && (B = ju(e, r, [
                        p.width,
                        p.height,
                        p.width / p.height
                      ]), cA = B[0], iA = B[1], uA = B[2], K = B[3], M = B[4], O = i.ctx.createPattern(i.resizeImage(p, K, M), "repeat"), i.renderRepeat(cA, O, iA, uA)), [3, 6];
                    case 5:
                      G1(g) ? (L = ju(e, r, [null, null, null]), cA = L[0], iA = L[1], uA = L[2], K = L[3], M = L[4], y = P1(g.angle, K, M), N = y[0], F = y[1], x = y[2], R = y[3], Y = y[4], Z = document.createElement("canvas"), Z.width = K, Z.height = M, $ = Z.getContext("2d"), J = $.createLinearGradient(F, R, x, Y), Ol(g.stops, N).forEach(function(nA) {
                        return J.addColorStop(nA.stop, At(nA.color));
                      }), $.fillStyle = J, $.fillRect(0, 0, K, M), K > 0 && M > 0 && (O = i.ctx.createPattern(Z, "repeat"), i.renderRepeat(cA, O, iA, uA))) : j1(g) && (W = ju(e, r, [
                        null,
                        null,
                        null
                      ]), cA = W[0], I = W[1], H = W[2], K = W[3], M = W[4], oA = g.position.length === 0 ? [Dc] : g.position, iA = ye(oA[0], K), uA = ye(oA[oA.length - 1], M), eA = M1(g, iA, uA, K, M), lA = eA[0], hA = eA[1], lA > 0 && hA > 0 && (UA = i.ctx.createRadialGradient(I + iA, H + uA, 0, I + iA, H + uA, lA), Ol(g.stops, lA * 2).forEach(function(nA) {
                        return UA.addColorStop(nA.stop, At(nA.color));
                      }), i.path(cA), i.ctx.fillStyle = UA, lA !== hA ? (U = e.bounds.left + 0.5 * e.bounds.width, _ = e.bounds.top + 0.5 * e.bounds.height, T = hA / lA, k = 1 / T, i.ctx.save(), i.ctx.translate(U, _), i.ctx.transform(1, 0, 0, T, 0, 0), i.ctx.translate(-U, -_), i.ctx.fillRect(I, k * (H - _) + _, K, M * k), i.ctx.restore()) : i.ctx.fill())), X.label = 6;
                    case 6:
                      return r--, [
                        2
                        /*return*/
                      ];
                  }
                });
              }, i = this, s = 0, u = e.styles.backgroundImage.slice(0).reverse(), h.label = 1;
            case 1:
              return s < u.length ? (c = u[s], [5, n(c)]) : [3, 4];
            case 2:
              h.sent(), h.label = 3;
            case 3:
              return s++, [3, 1];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, A.prototype.renderSolidBorder = function(e, r, n) {
      return mt(this, void 0, void 0, function() {
        return Bt(this, function(i) {
          return this.path(gf(n, r)), this.ctx.fillStyle = At(e), this.ctx.fill(), [
            2
            /*return*/
          ];
        });
      });
    }, A.prototype.renderDoubleBorder = function(e, r, n, i) {
      return mt(this, void 0, void 0, function() {
        var s, u;
        return Bt(this, function(c) {
          switch (c.label) {
            case 0:
              return r < 3 ? [4, this.renderSolidBorder(e, n, i)] : [3, 2];
            case 1:
              return c.sent(), [
                2
                /*return*/
              ];
            case 2:
              return s = Wd(i, n), this.path(s), this.ctx.fillStyle = At(e), this.ctx.fill(), u = Xd(i, n), this.path(u), this.ctx.fill(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, A.prototype.renderNodeBackgroundAndBorders = function(e) {
      return mt(this, void 0, void 0, function() {
        var r, n, i, s, u, c, h, g, p = this;
        return Bt(this, function(w) {
          switch (w.label) {
            case 0:
              return this.applyEffects(e.getEffects(
                2
                /* BACKGROUND_BORDERS */
              )), r = e.container.styles, n = !dn(r.backgroundColor) || r.backgroundImage.length, i = [
                { style: r.borderTopStyle, color: r.borderTopColor, width: r.borderTopWidth },
                { style: r.borderRightStyle, color: r.borderRightColor, width: r.borderRightWidth },
                { style: r.borderBottomStyle, color: r.borderBottomColor, width: r.borderBottomWidth },
                { style: r.borderLeftStyle, color: r.borderLeftColor, width: r.borderLeftWidth }
              ], s = ip(bi(r.backgroundClip, 0), e.curves), n || r.boxShadow.length ? (this.ctx.save(), this.path(s), this.ctx.clip(), dn(r.backgroundColor) || (this.ctx.fillStyle = At(r.backgroundColor), this.ctx.fill()), [4, this.renderBackgroundImage(e.container)]) : [3, 2];
            case 1:
              w.sent(), this.ctx.restore(), r.boxShadow.slice(0).reverse().forEach(function(B) {
                p.ctx.save();
                var L = wo(e.curves), y = B.inset ? 0 : tp, N = Vd(L, -y + (B.inset ? 1 : -1) * B.spread.number, (B.inset ? 1 : -1) * B.spread.number, B.spread.number * (B.inset ? -2 : 2), B.spread.number * (B.inset ? -2 : 2));
                B.inset ? (p.path(L), p.ctx.clip(), p.mask(N)) : (p.mask(L), p.ctx.clip(), p.path(N)), p.ctx.shadowOffsetX = B.offsetX.number + y, p.ctx.shadowOffsetY = B.offsetY.number, p.ctx.shadowColor = At(B.color), p.ctx.shadowBlur = B.blur.number, p.ctx.fillStyle = B.inset ? At(B.color) : "rgba(0,0,0,1)", p.ctx.fill(), p.ctx.restore();
              }), w.label = 2;
            case 2:
              u = 0, c = 0, h = i, w.label = 3;
            case 3:
              return c < h.length ? (g = h[c], g.style !== 0 && !dn(g.color) && g.width > 0 ? g.style !== 2 ? [3, 5] : [4, this.renderDashedDottedBorder(
                g.color,
                g.width,
                u,
                e.curves,
                2
                /* DASHED */
              )] : [3, 11]) : [3, 13];
            case 4:
              return w.sent(), [3, 11];
            case 5:
              return g.style !== 3 ? [3, 7] : [4, this.renderDashedDottedBorder(
                g.color,
                g.width,
                u,
                e.curves,
                3
                /* DOTTED */
              )];
            case 6:
              return w.sent(), [3, 11];
            case 7:
              return g.style !== 4 ? [3, 9] : [4, this.renderDoubleBorder(g.color, g.width, u, e.curves)];
            case 8:
              return w.sent(), [3, 11];
            case 9:
              return [4, this.renderSolidBorder(g.color, u, e.curves)];
            case 10:
              w.sent(), w.label = 11;
            case 11:
              u++, w.label = 12;
            case 12:
              return c++, [3, 3];
            case 13:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, A.prototype.renderDashedDottedBorder = function(e, r, n, i, s) {
      return mt(this, void 0, void 0, function() {
        var u, c, h, g, p, w, B, L, y, N, F, x, R, Y, Z, $, Z, $;
        return Bt(this, function(J) {
          return this.ctx.save(), u = Jd(i, n), c = gf(i, n), s === 2 && (this.path(c), this.ctx.clip()), Vt(c[0]) ? (h = c[0].start.x, g = c[0].start.y) : (h = c[0].x, g = c[0].y), Vt(c[1]) ? (p = c[1].end.x, w = c[1].end.y) : (p = c[1].x, w = c[1].y), n === 0 || n === 2 ? B = Math.abs(h - p) : B = Math.abs(g - w), this.ctx.beginPath(), s === 3 ? this.formatPath(u) : this.formatPath(c.slice(0, 2)), L = r < 3 ? r * 3 : r * 2, y = r < 3 ? r * 2 : r, s === 3 && (L = r, y = r), N = !0, B <= L * 2 ? N = !1 : B <= L * 2 + y ? (F = B / (2 * L + y), L *= F, y *= F) : (x = Math.floor((B + y) / (L + y)), R = (B - x * L) / (x - 1), Y = (B - (x + 1) * L) / x, y = Y <= 0 || Math.abs(y - R) < Math.abs(y - Y) ? R : Y), N && (s === 3 ? this.ctx.setLineDash([0, L + y]) : this.ctx.setLineDash([L, y])), s === 3 ? (this.ctx.lineCap = "round", this.ctx.lineWidth = r) : this.ctx.lineWidth = r * 2 + 1.1, this.ctx.strokeStyle = At(e), this.ctx.stroke(), this.ctx.setLineDash([]), s === 2 && (Vt(c[0]) && (Z = c[3], $ = c[0], this.ctx.beginPath(), this.formatPath([new NA(Z.end.x, Z.end.y), new NA($.start.x, $.start.y)]), this.ctx.stroke()), Vt(c[1]) && (Z = c[1], $ = c[2], this.ctx.beginPath(), this.formatPath([new NA(Z.end.x, Z.end.y), new NA($.start.x, $.start.y)]), this.ctx.stroke())), this.ctx.restore(), [
            2
            /*return*/
          ];
        });
      });
    }, A.prototype.render = function(e) {
      return mt(this, void 0, void 0, function() {
        var r;
        return Bt(this, function(n) {
          switch (n.label) {
            case 0:
              return this.options.backgroundColor && (this.ctx.fillStyle = At(this.options.backgroundColor), this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height)), r = qd(e), [4, this.renderStack(r)];
            case 1:
              return n.sent(), this.applyEffects([]), [2, this.canvas];
          }
        });
      });
    }, A;
  }(Mh)
), np = function(t) {
  return t instanceof Qh || t instanceof Ch ? !0 : t instanceof Mc && t.type !== Bo && t.type !== ho;
}, ip = function(t, A) {
  switch (t) {
    case 0:
      return wo(A);
    case 2:
      return Kd(A);
    case 1:
    default:
      return vo(A);
  }
}, ap = function(t) {
  switch (t) {
    case 1:
      return "center";
    case 2:
      return "right";
    case 0:
    default:
      return "left";
  }
}, sp = ["-apple-system", "system-ui"], op = function(t) {
  return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? t.filter(function(A) {
    return sp.indexOf(A) === -1;
  }) : t;
}, up = (
  /** @class */
  function(t) {
    ur(A, t);
    function A(e, r) {
      var n = t.call(this, e, r) || this;
      return n.canvas = r.canvas ? r.canvas : document.createElement("canvas"), n.ctx = n.canvas.getContext("2d"), n.options = r, n.canvas.width = Math.floor(r.width * r.scale), n.canvas.height = Math.floor(r.height * r.scale), n.canvas.style.width = r.width + "px", n.canvas.style.height = r.height + "px", n.ctx.scale(n.options.scale, n.options.scale), n.ctx.translate(-r.x, -r.y), n.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + r.width + "x" + r.height + " at " + r.x + "," + r.y + ") with scale " + r.scale), n;
    }
    return A.prototype.render = function(e) {
      return mt(this, void 0, void 0, function() {
        var r, n;
        return Bt(this, function(i) {
          switch (i.label) {
            case 0:
              return r = dc(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, e), [4, cp(r)];
            case 1:
              return n = i.sent(), this.options.backgroundColor && (this.ctx.fillStyle = At(this.options.backgroundColor), this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale)), this.ctx.drawImage(n, -this.options.x * this.options.scale, -this.options.y * this.options.scale), [2, this.canvas];
          }
        });
      });
    }, A;
  }(Mh)
), cp = function(t) {
  return new Promise(function(A, e) {
    var r = new Image();
    r.onload = function() {
      A(r);
    }, r.onerror = e, r.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(t));
  });
}, lp = (
  /** @class */
  function() {
    function t(A) {
      var e = A.id, r = A.enabled;
      this.id = e, this.enabled = r, this.start = Date.now();
    }
    return t.prototype.debug = function() {
      for (var A = [], e = 0; e < arguments.length; e++)
        A[e] = arguments[e];
      this.enabled && (typeof window < "u" && window.console && typeof console.debug == "function" ? console.debug.apply(console, Is([this.id, this.getTime() + "ms"], A)) : this.info.apply(this, A));
    }, t.prototype.getTime = function() {
      return Date.now() - this.start;
    }, t.prototype.info = function() {
      for (var A = [], e = 0; e < arguments.length; e++)
        A[e] = arguments[e];
      this.enabled && typeof window < "u" && window.console && typeof console.info == "function" && console.info.apply(console, Is([this.id, this.getTime() + "ms"], A));
    }, t.prototype.warn = function() {
      for (var A = [], e = 0; e < arguments.length; e++)
        A[e] = arguments[e];
      this.enabled && (typeof window < "u" && window.console && typeof console.warn == "function" ? console.warn.apply(console, Is([this.id, this.getTime() + "ms"], A)) : this.info.apply(this, A));
    }, t.prototype.error = function() {
      for (var A = [], e = 0; e < arguments.length; e++)
        A[e] = arguments[e];
      this.enabled && (typeof window < "u" && window.console && typeof console.error == "function" ? console.error.apply(console, Is([this.id, this.getTime() + "ms"], A)) : this.info.apply(this, A));
    }, t.instances = {}, t;
  }()
), fp = (
  /** @class */
  function() {
    function t(A, e) {
      var r;
      this.windowBounds = e, this.instanceName = "#" + t.instanceCount++, this.logger = new lp({ id: this.instanceName, enabled: A.logging }), this.cache = (r = A.cache) !== null && r !== void 0 ? r : new Sd(this, A);
    }
    return t.instanceCount = 1, t;
  }()
), Kh = function(t, A) {
  return A === void 0 && (A = {}), hp(t, A);
};
typeof window < "u" && Nh.setContext(window);
var hp = function(t, A) {
  return mt(void 0, void 0, void 0, function() {
    var e, r, n, i, s, u, c, h, g, p, w, B, L, y, N, F, x, R, Y, Z, J, $, J, O, W, cA, I, H, K, M, oA, iA, uA, eA, lA, hA, UA, U, _, T;
    return Bt(this, function(k) {
      switch (k.label) {
        case 0:
          if (!t || typeof t != "object")
            return [2, Promise.reject("Invalid element provided as first argument")];
          if (e = t.ownerDocument, !e)
            throw new Error("Element is not attached to a Document");
          if (r = e.defaultView, !r)
            throw new Error("Document is not attached to a Window");
          return n = {
            allowTaint: (O = A.allowTaint) !== null && O !== void 0 ? O : !1,
            imageTimeout: (W = A.imageTimeout) !== null && W !== void 0 ? W : 15e3,
            proxy: A.proxy,
            useCORS: (cA = A.useCORS) !== null && cA !== void 0 ? cA : !1
          }, i = ec({ logging: (I = A.logging) !== null && I !== void 0 ? I : !0, cache: A.cache }, n), s = {
            windowWidth: (H = A.windowWidth) !== null && H !== void 0 ? H : r.innerWidth,
            windowHeight: (K = A.windowHeight) !== null && K !== void 0 ? K : r.innerHeight,
            scrollX: (M = A.scrollX) !== null && M !== void 0 ? M : r.pageXOffset,
            scrollY: (oA = A.scrollY) !== null && oA !== void 0 ? oA : r.pageYOffset
          }, u = new jr(s.scrollX, s.scrollY, s.windowWidth, s.windowHeight), c = new fp(i, u), h = (iA = A.foreignObjectRendering) !== null && iA !== void 0 ? iA : !1, g = {
            allowTaint: (uA = A.allowTaint) !== null && uA !== void 0 ? uA : !1,
            onclone: A.onclone,
            ignoreElements: A.ignoreElements,
            inlineImages: h,
            copyStyles: h
          }, c.logger.debug("Starting document clone with size " + u.width + "x" + u.height + " scrolled to " + -u.left + "," + -u.top), p = new ff(c, t, g), w = p.clonedReferenceElement, w ? [4, p.toIFrame(e, u)] : [2, Promise.reject("Unable to find element in cloned iframe")];
        case 1:
          return B = k.sent(), L = Kc(w) || gd(w) ? VB(w.ownerDocument) : Fo(c, w), y = L.width, N = L.height, F = L.left, x = L.top, R = Bp(c, w, A.backgroundColor), Y = {
            canvas: A.canvas,
            backgroundColor: R,
            scale: (lA = (eA = A.scale) !== null && eA !== void 0 ? eA : r.devicePixelRatio) !== null && lA !== void 0 ? lA : 1,
            x: ((hA = A.x) !== null && hA !== void 0 ? hA : 0) + F,
            y: ((UA = A.y) !== null && UA !== void 0 ? UA : 0) + x,
            width: (U = A.width) !== null && U !== void 0 ? U : Math.ceil(y),
            height: (_ = A.height) !== null && _ !== void 0 ? _ : Math.ceil(N)
          }, h ? (c.logger.debug("Document cloned, using foreign object rendering"), J = new up(c, Y), [4, J.render(w)]) : [3, 3];
        case 2:
          return Z = k.sent(), [3, 5];
        case 3:
          return c.logger.debug("Document cloned, element located at " + F + "," + x + " with size " + y + "x" + N + " using computed rendering"), c.logger.debug("Starting DOM parsing"), $ = yh(c, w), R === $.styles.backgroundColor && ($.styles.backgroundColor = Gr.TRANSPARENT), c.logger.debug("Starting renderer for element at " + Y.x + "," + Y.y + " with size " + Y.width + "x" + Y.height), J = new rp(c, Y), [4, J.render($)];
        case 4:
          Z = k.sent(), k.label = 5;
        case 5:
          return (!((T = A.removeContainer) !== null && T !== void 0) || T) && (ff.destroy(B) || c.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore")), c.logger.debug("Finished rendering"), [2, Z];
      }
    });
  });
}, Bp = function(t, A, e) {
  var r = A.ownerDocument, n = r.documentElement ? Ea(t, getComputedStyle(r.documentElement).backgroundColor) : Gr.TRANSPARENT, i = r.body ? Ea(t, getComputedStyle(r.body).backgroundColor) : Gr.TRANSPARENT, s = typeof e == "string" ? Ea(t, e) : e === null ? Gr.TRANSPARENT : 4294967295;
  return A === r.documentElement ? dn(n) ? dn(i) ? s : i : n : s;
};
const gp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Kh
}, Symbol.toStringTag, { value: "Module" }));
function de(t) {
  "@babel/helpers - typeof";
  return de = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(A) {
    return typeof A;
  } : function(A) {
    return A && typeof Symbol == "function" && A.constructor === Symbol && A !== Symbol.prototype ? "symbol" : typeof A;
  }, de(t);
}
var dt = Uint8Array, Dt = Uint16Array, kc = Int32Array, No = new dt([
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1,
  1,
  1,
  1,
  2,
  2,
  2,
  2,
  3,
  3,
  3,
  3,
  4,
  4,
  4,
  4,
  5,
  5,
  5,
  5,
  0,
  /* unused */
  0,
  0,
  /* impossible */
  0
]), _o = new dt([
  0,
  0,
  0,
  0,
  1,
  1,
  2,
  2,
  3,
  3,
  4,
  4,
  5,
  5,
  6,
  6,
  7,
  7,
  8,
  8,
  9,
  9,
  10,
  10,
  11,
  11,
  12,
  12,
  13,
  13,
  /* unused */
  0,
  0
]), Fc = new dt([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), kh = function(t, A) {
  for (var e = new Dt(31), r = 0; r < 31; ++r)
    e[r] = A += 1 << t[r - 1];
  for (var n = new kc(e[30]), r = 1; r < 30; ++r)
    for (var i = e[r]; i < e[r + 1]; ++i)
      n[i] = i - e[r] << 5 | r;
  return { b: e, r: n };
}, Rh = kh(No, 2), Gh = Rh.b, Uc = Rh.r;
Gh[28] = 258, Uc[258] = 28;
var jh = kh(_o, 0), dp = jh.b, pf = jh.r, yc = new Dt(32768);
for (var be = 0; be < 32768; ++be) {
  var an = (be & 43690) >> 1 | (be & 21845) << 1;
  an = (an & 52428) >> 2 | (an & 13107) << 2, an = (an & 61680) >> 4 | (an & 3855) << 4, yc[be] = ((an & 65280) >> 8 | (an & 255) << 8) >> 1;
}
var yr = function(t, A, e) {
  for (var r = t.length, n = 0, i = new Dt(A); n < r; ++n)
    t[n] && ++i[t[n] - 1];
  var s = new Dt(A);
  for (n = 1; n < A; ++n)
    s[n] = s[n - 1] + i[n - 1] << 1;
  var u;
  if (e) {
    u = new Dt(1 << A);
    var c = 15 - A;
    for (n = 0; n < r; ++n)
      if (t[n])
        for (var h = n << 4 | t[n], g = A - t[n], p = s[t[n] - 1]++ << g, w = p | (1 << g) - 1; p <= w; ++p)
          u[yc[p] >> c] = h;
  } else
    for (u = new Dt(r), n = 0; n < r; ++n)
      t[n] && (u[n] = yc[s[t[n] - 1]++] >> 15 - t[n]);
  return u;
}, wn = new dt(288);
for (var be = 0; be < 144; ++be)
  wn[be] = 8;
for (var be = 144; be < 256; ++be)
  wn[be] = 9;
for (var be = 256; be < 280; ++be)
  wn[be] = 7;
for (var be = 280; be < 288; ++be)
  wn[be] = 8;
var Ta = new dt(32);
for (var be = 0; be < 32; ++be)
  Ta[be] = 5;
var pp = /* @__PURE__ */ yr(wn, 9, 0), wp = /* @__PURE__ */ yr(wn, 9, 1), vp = /* @__PURE__ */ yr(Ta, 5, 0), mp = /* @__PURE__ */ yr(Ta, 5, 1), Vu = function(t) {
  for (var A = t[0], e = 1; e < t.length; ++e)
    t[e] > A && (A = t[e]);
  return A;
}, ir = function(t, A, e) {
  var r = A / 8 | 0;
  return (t[r] | t[r + 1] << 8) >> (A & 7) & e;
}, qu = function(t, A) {
  var e = A / 8 | 0;
  return (t[e] | t[e + 1] << 8 | t[e + 2] << 16) >> (A & 7);
}, Rc = function(t) {
  return (t + 7) / 8 | 0;
}, Vh = function(t, A, e) {
  return (e == null || e > t.length) && (e = t.length), new dt(t.subarray(A, e));
}, Cp = [
  "unexpected EOF",
  "invalid block type",
  "invalid length/literal",
  "invalid distance",
  "stream finished",
  "no stream handler",
  ,
  "no callback",
  "invalid UTF-8 data",
  "extra field too long",
  "date not in range 1980-2099",
  "filename too long",
  "stream finishing",
  "invalid zip data"
  // determined by unknown compression method
], or = function(t, A, e) {
  var r = new Error(A || Cp[t]);
  if (r.code = t, Error.captureStackTrace && Error.captureStackTrace(r, or), !e)
    throw r;
  return r;
}, Qp = function(t, A, e, r) {
  var n = t.length, i = 0;
  if (!n || A.f && !A.l)
    return e || new dt(0);
  var s = !e, u = s || A.i != 2, c = A.i;
  s && (e = new dt(n * 3));
  var h = function(QA) {
    var xA = e.length;
    if (QA > xA) {
      var LA = new dt(Math.max(xA * 2, QA));
      LA.set(e), e = LA;
    }
  }, g = A.f || 0, p = A.p || 0, w = A.b || 0, B = A.l, L = A.d, y = A.m, N = A.n, F = n * 8;
  do {
    if (!B) {
      g = ir(t, p, 1);
      var x = ir(t, p + 1, 3);
      if (p += 3, x)
        if (x == 1)
          B = wp, L = mp, y = 9, N = 5;
        else if (x == 2) {
          var $ = ir(t, p, 31) + 257, J = ir(t, p + 10, 15) + 4, O = $ + ir(t, p + 5, 31) + 1;
          p += 14;
          for (var W = new dt(O), cA = new dt(19), I = 0; I < J; ++I)
            cA[Fc[I]] = ir(t, p + I * 3, 7);
          p += J * 3;
          for (var H = Vu(cA), K = (1 << H) - 1, M = yr(cA, H, 1), I = 0; I < O; ) {
            var oA = M[ir(t, p, K)];
            p += oA & 15;
            var R = oA >> 4;
            if (R < 16)
              W[I++] = R;
            else {
              var iA = 0, uA = 0;
              for (R == 16 ? (uA = 3 + ir(t, p, 3), p += 2, iA = W[I - 1]) : R == 17 ? (uA = 3 + ir(t, p, 7), p += 3) : R == 18 && (uA = 11 + ir(t, p, 127), p += 7); uA--; )
                W[I++] = iA;
            }
          }
          var eA = W.subarray(0, $), lA = W.subarray($);
          y = Vu(eA), N = Vu(lA), B = yr(eA, y, 1), L = yr(lA, N, 1);
        } else
          or(1);
      else {
        var R = Rc(p) + 4, Y = t[R - 4] | t[R - 3] << 8, Z = R + Y;
        if (Z > n) {
          c && or(0);
          break;
        }
        u && h(w + Y), e.set(t.subarray(R, Z), w), A.b = w += Y, A.p = p = Z * 8, A.f = g;
        continue;
      }
      if (p > F) {
        c && or(0);
        break;
      }
    }
    u && h(w + 131072);
    for (var hA = (1 << y) - 1, UA = (1 << N) - 1, U = p; ; U = p) {
      var iA = B[qu(t, p) & hA], _ = iA >> 4;
      if (p += iA & 15, p > F) {
        c && or(0);
        break;
      }
      if (iA || or(2), _ < 256)
        e[w++] = _;
      else if (_ == 256) {
        U = p, B = null;
        break;
      } else {
        var T = _ - 254;
        if (_ > 264) {
          var I = _ - 257, k = No[I];
          T = ir(t, p, (1 << k) - 1) + Gh[I], p += k;
        }
        var X = L[qu(t, p) & UA], nA = X >> 4;
        X || or(3), p += X & 15;
        var lA = dp[nA];
        if (nA > 3) {
          var k = _o[nA];
          lA += qu(t, p) & (1 << k) - 1, p += k;
        }
        if (p > F) {
          c && or(0);
          break;
        }
        u && h(w + 131072);
        var aA = w + T;
        if (w < lA) {
          var sA = i - lA, FA = Math.min(lA, aA);
          for (sA + w < 0 && or(3); w < FA; ++w)
            e[w] = r[sA + w];
        }
        for (; w < aA; ++w)
          e[w] = e[w - lA];
      }
    }
    A.l = B, A.p = U, A.b = w, A.f = g, B && (g = 1, A.m = y, A.d = L, A.n = N);
  } while (!g);
  return w != e.length && s ? Vh(e, 0, w) : e.subarray(0, w);
}, Rr = function(t, A, e) {
  e <<= A & 7;
  var r = A / 8 | 0;
  t[r] |= e, t[r + 1] |= e >> 8;
}, wa = function(t, A, e) {
  e <<= A & 7;
  var r = A / 8 | 0;
  t[r] |= e, t[r + 1] |= e >> 8, t[r + 2] |= e >> 16;
}, Wu = function(t, A) {
  for (var e = [], r = 0; r < t.length; ++r)
    t[r] && e.push({ s: r, f: t[r] });
  var n = e.length, i = e.slice();
  if (!n)
    return { t: Wh, l: 0 };
  if (n == 1) {
    var s = new dt(e[0].s + 1);
    return s[e[0].s] = 1, { t: s, l: 1 };
  }
  e.sort(function(Z, $) {
    return Z.f - $.f;
  }), e.push({ s: -1, f: 25001 });
  var u = e[0], c = e[1], h = 0, g = 1, p = 2;
  for (e[0] = { s: -1, f: u.f + c.f, l: u, r: c }; g != n - 1; )
    u = e[e[h].f < e[p].f ? h++ : p++], c = e[h != g && e[h].f < e[p].f ? h++ : p++], e[g++] = { s: -1, f: u.f + c.f, l: u, r: c };
  for (var w = i[0].s, r = 1; r < n; ++r)
    i[r].s > w && (w = i[r].s);
  var B = new Dt(w + 1), L = bc(e[g - 1], B, 0);
  if (L > A) {
    var r = 0, y = 0, N = L - A, F = 1 << N;
    for (i.sort(function($, J) {
      return B[J.s] - B[$.s] || $.f - J.f;
    }); r < n; ++r) {
      var x = i[r].s;
      if (B[x] > A)
        y += F - (1 << L - B[x]), B[x] = A;
      else
        break;
    }
    for (y >>= N; y > 0; ) {
      var R = i[r].s;
      B[R] < A ? y -= 1 << A - B[R]++ - 1 : ++r;
    }
    for (; r >= 0 && y; --r) {
      var Y = i[r].s;
      B[Y] == A && (--B[Y], ++y);
    }
    L = A;
  }
  return { t: new dt(B), l: L };
}, bc = function(t, A, e) {
  return t.s == -1 ? Math.max(bc(t.l, A, e + 1), bc(t.r, A, e + 1)) : A[t.s] = e;
}, wf = function(t) {
  for (var A = t.length; A && !t[--A]; )
    ;
  for (var e = new Dt(++A), r = 0, n = t[0], i = 1, s = function(c) {
    e[r++] = c;
  }, u = 1; u <= A; ++u)
    if (t[u] == n && u != A)
      ++i;
    else {
      if (!n && i > 2) {
        for (; i > 138; i -= 138)
          s(32754);
        i > 2 && (s(i > 10 ? i - 11 << 5 | 28690 : i - 3 << 5 | 12305), i = 0);
      } else if (i > 3) {
        for (s(n), --i; i > 6; i -= 6)
          s(8304);
        i > 2 && (s(i - 3 << 5 | 8208), i = 0);
      }
      for (; i--; )
        s(n);
      i = 1, n = t[u];
    }
  return { c: e.subarray(0, r), n: A };
}, va = function(t, A) {
  for (var e = 0, r = 0; r < A.length; ++r)
    e += t[r] * A[r];
  return e;
}, qh = function(t, A, e) {
  var r = e.length, n = Rc(A + 2);
  t[n] = r & 255, t[n + 1] = r >> 8, t[n + 2] = t[n] ^ 255, t[n + 3] = t[n + 1] ^ 255;
  for (var i = 0; i < r; ++i)
    t[n + i + 4] = e[i];
  return (n + 4 + r) * 8;
}, vf = function(t, A, e, r, n, i, s, u, c, h, g) {
  Rr(A, g++, e), ++n[256];
  for (var p = Wu(n, 15), w = p.t, B = p.l, L = Wu(i, 15), y = L.t, N = L.l, F = wf(w), x = F.c, R = F.n, Y = wf(y), Z = Y.c, $ = Y.n, J = new Dt(19), O = 0; O < x.length; ++O)
    ++J[x[O] & 31];
  for (var O = 0; O < Z.length; ++O)
    ++J[Z[O] & 31];
  for (var W = Wu(J, 7), cA = W.t, I = W.l, H = 19; H > 4 && !cA[Fc[H - 1]]; --H)
    ;
  var K = h + 5 << 3, M = va(n, wn) + va(i, Ta) + s, oA = va(n, w) + va(i, y) + s + 14 + 3 * H + va(J, cA) + 2 * J[16] + 3 * J[17] + 7 * J[18];
  if (c >= 0 && K <= M && K <= oA)
    return qh(A, g, t.subarray(c, c + h));
  var iA, uA, eA, lA;
  if (Rr(A, g, 1 + (oA < M)), g += 2, oA < M) {
    iA = yr(w, B, 0), uA = w, eA = yr(y, N, 0), lA = y;
    var hA = yr(cA, I, 0);
    Rr(A, g, R - 257), Rr(A, g + 5, $ - 1), Rr(A, g + 10, H - 4), g += 14;
    for (var O = 0; O < H; ++O)
      Rr(A, g + 3 * O, cA[Fc[O]]);
    g += 3 * H;
    for (var UA = [x, Z], U = 0; U < 2; ++U)
      for (var _ = UA[U], O = 0; O < _.length; ++O) {
        var T = _[O] & 31;
        Rr(A, g, hA[T]), g += cA[T], T > 15 && (Rr(A, g, _[O] >> 5 & 127), g += _[O] >> 12);
      }
  } else
    iA = pp, uA = wn, eA = vp, lA = Ta;
  for (var O = 0; O < u; ++O) {
    var k = r[O];
    if (k > 255) {
      var T = k >> 18 & 31;
      wa(A, g, iA[T + 257]), g += uA[T + 257], T > 7 && (Rr(A, g, k >> 23 & 31), g += No[T]);
      var X = k & 31;
      wa(A, g, eA[X]), g += lA[X], X > 3 && (wa(A, g, k >> 5 & 8191), g += _o[X]);
    } else
      wa(A, g, iA[k]), g += uA[k];
  }
  return wa(A, g, iA[256]), g + uA[256];
}, Fp = /* @__PURE__ */ new kc([65540, 131080, 131088, 131104, 262176, 1048704, 1048832, 2114560, 2117632]), Wh = /* @__PURE__ */ new dt(0), Up = function(t, A, e, r, n, i) {
  var s = i.z || t.length, u = new dt(r + s + 5 * (1 + Math.ceil(s / 7e3)) + n), c = u.subarray(r, u.length - n), h = i.l, g = (i.r || 0) & 7;
  if (A) {
    g && (c[0] = i.r >> 3);
    for (var p = Fp[A - 1], w = p >> 13, B = p & 8191, L = (1 << e) - 1, y = i.p || new Dt(32768), N = i.h || new Dt(L + 1), F = Math.ceil(e / 3), x = 2 * F, R = function(jA) {
      return (t[jA] ^ t[jA + 1] << F ^ t[jA + 2] << x) & L;
    }, Y = new kc(25e3), Z = new Dt(288), $ = new Dt(32), J = 0, O = 0, W = i.i || 0, cA = 0, I = i.w || 0, H = 0; W + 2 < s; ++W) {
      var K = R(W), M = W & 32767, oA = N[K];
      if (y[M] = oA, N[K] = M, I <= W) {
        var iA = s - W;
        if ((J > 7e3 || cA > 24576) && (iA > 423 || !h)) {
          g = vf(t, c, 0, Y, Z, $, O, cA, H, W - H, g), cA = J = O = 0, H = W;
          for (var uA = 0; uA < 286; ++uA)
            Z[uA] = 0;
          for (var uA = 0; uA < 30; ++uA)
            $[uA] = 0;
        }
        var eA = 2, lA = 0, hA = B, UA = M - oA & 32767;
        if (iA > 2 && K == R(W - UA))
          for (var U = Math.min(w, iA) - 1, _ = Math.min(32767, W), T = Math.min(258, iA); UA <= _ && --hA && M != oA; ) {
            if (t[W + eA] == t[W + eA - UA]) {
              for (var k = 0; k < T && t[W + k] == t[W + k - UA]; ++k)
                ;
              if (k > eA) {
                if (eA = k, lA = UA, k > U)
                  break;
                for (var X = Math.min(UA, k - 2), nA = 0, uA = 0; uA < X; ++uA) {
                  var aA = W - UA + uA & 32767, sA = y[aA], FA = aA - sA & 32767;
                  FA > nA && (nA = FA, oA = aA);
                }
              }
            }
            M = oA, oA = y[M], UA += M - oA & 32767;
          }
        if (lA) {
          Y[cA++] = 268435456 | Uc[eA] << 18 | pf[lA];
          var QA = Uc[eA] & 31, xA = pf[lA] & 31;
          O += No[QA] + _o[xA], ++Z[257 + QA], ++$[xA], I = W + eA, ++J;
        } else
          Y[cA++] = t[W], ++Z[t[W]];
      }
    }
    for (W = Math.max(W, I); W < s; ++W)
      Y[cA++] = t[W], ++Z[t[W]];
    g = vf(t, c, h, Y, Z, $, O, cA, H, W - H, g), h || (i.r = g & 7 | c[g / 8 | 0] << 3, g -= 7, i.h = N, i.p = y, i.i = W, i.w = I);
  } else {
    for (var W = i.w || 0; W < s + h; W += 65535) {
      var LA = W + 65535;
      LA >= s && (c[g / 8 | 0] = h, LA = s), g = qh(c, g + 1, t.subarray(W, LA));
    }
    i.i = s;
  }
  return Vh(u, 0, r + Rc(g) + n);
}, Xh = function() {
  var t = 1, A = 0;
  return {
    p: function(e) {
      for (var r = t, n = A, i = e.length | 0, s = 0; s != i; ) {
        for (var u = Math.min(s + 2655, i); s < u; ++s)
          n += r += e[s];
        r = (r & 65535) + 15 * (r >> 16), n = (n & 65535) + 15 * (n >> 16);
      }
      t = r, A = n;
    },
    d: function() {
      return t %= 65521, A %= 65521, (t & 255) << 24 | (t & 65280) << 8 | (A & 255) << 8 | A >> 8;
    }
  };
}, yp = function(t, A, e, r, n) {
  if (!n && (n = { l: 1 }, A.dictionary)) {
    var i = A.dictionary.subarray(-32768), s = new dt(i.length + t.length);
    s.set(i), s.set(t, i.length), t = s, n.w = i.length;
  }
  return Up(t, A.level == null ? 6 : A.level, A.mem == null ? n.l ? Math.ceil(Math.max(8, Math.min(13, Math.log(t.length))) * 1.5) : 20 : 12 + A.mem, e, r, n);
}, Jh = function(t, A, e) {
  for (; e; ++A)
    t[A] = e, e >>>= 8;
}, bp = function(t, A) {
  var e = A.level, r = e == 0 ? 0 : e < 6 ? 1 : e == 9 ? 3 : 2;
  if (t[0] = 120, t[1] = r << 6 | (A.dictionary && 32), t[1] |= 31 - (t[0] << 8 | t[1]) % 31, A.dictionary) {
    var n = Xh();
    n.p(A.dictionary), Jh(t, 2, n.d());
  }
}, Lp = function(t, A) {
  return ((t[0] & 15) != 8 || t[0] >> 4 > 7 || (t[0] << 8 | t[1]) % 31) && or(6, "invalid zlib data"), (t[1] >> 5 & 1) == 1 && or(6, "invalid zlib data: " + (t[1] & 32 ? "need" : "unexpected") + " dictionary"), (t[1] >> 3 & 4) + 2;
};
function Lc(t, A) {
  A || (A = {});
  var e = Xh();
  e.p(t);
  var r = yp(t, A, A.dictionary ? 6 : 2, 4);
  return bp(r, A), Jh(r, r.length - 4, e.d()), r;
}
function Ep(t, A) {
  return Qp(t.subarray(Lp(t), -4), { i: 2 }, A, A);
}
var Ip = typeof TextDecoder < "u" && /* @__PURE__ */ new TextDecoder(), xp = 0;
try {
  Ip.decode(Wh, { stream: !0 }), xp = 1;
} catch {
}
/** @license
 *
 * jsPDF - PDF Document creation from JavaScript
 * Version 3.0.1 Built on 2025-03-17T14:19:36.873Z
 *                      CommitID 00000000
 *
 * Copyright (c) 2010-2021 James Hall <james@parall.ax>, https://github.com/MrRio/jsPDF
 *               2015-2021 yWorks GmbH, http://www.yworks.com
 *               2015-2021 Lukas Holländer <lukas.hollaender@yworks.com>, https://github.com/HackbrettXXX
 *               2016-2018 Aras Abbasi <aras.abbasi@gmail.com>
 *               2010 Aaron Spike, https://github.com/acspike
 *               2012 Willow Systems Corporation, https://github.com/willowsystems
 *               2012 Pablo Hess, https://github.com/pablohess
 *               2012 Florian Jenett, https://github.com/fjenett
 *               2013 Warren Weckesser, https://github.com/warrenweckesser
 *               2013 Youssef Beddad, https://github.com/lifof
 *               2013 Lee Driscoll, https://github.com/lsdriscoll
 *               2013 Stefan Slonevskiy, https://github.com/stefslon
 *               2013 Jeremy Morel, https://github.com/jmorel
 *               2013 Christoph Hartmann, https://github.com/chris-rock
 *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
 *               2014 James Makes, https://github.com/dollaruw
 *               2014 Diego Casorran, https://github.com/diegocr
 *               2014 Steven Spungin, https://github.com/Flamenco
 *               2014 Kenneth Glassey, https://github.com/Gavvers
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 * Contributor(s):
 *    siefkenj, ahwolf, rickygu, Midnith, saintclair, eaparango,
 *    kim3er, mfo, alnorth, Flamenco
 */
var VA = /* @__PURE__ */ function() {
  return typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : this;
}();
function Xu() {
  VA.console && typeof VA.console.log == "function" && VA.console.log.apply(VA.console, arguments);
}
var Qe = { log: Xu, warn: function(t) {
  VA.console && (typeof VA.console.warn == "function" ? VA.console.warn.apply(VA.console, arguments) : Xu.call(null, arguments));
}, error: function(t) {
  VA.console && (typeof VA.console.error == "function" ? VA.console.error.apply(VA.console, arguments) : Xu(t));
} };
function Ju(t, A, e) {
  var r = new XMLHttpRequest();
  r.open("GET", t), r.responseType = "blob", r.onload = function() {
    _n(r.response, A, e);
  }, r.onerror = function() {
    Qe.error("could not download file");
  }, r.send();
}
function mf(t) {
  var A = new XMLHttpRequest();
  A.open("HEAD", t, !1);
  try {
    A.send();
  } catch {
  }
  return A.status >= 200 && A.status <= 299;
}
function Zs(t) {
  try {
    t.dispatchEvent(new MouseEvent("click"));
  } catch {
    var A = document.createEvent("MouseEvents");
    A.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), t.dispatchEvent(A);
  }
}
var Sa, Ec, _n = VA.saveAs || ((typeof window > "u" ? "undefined" : de(window)) !== "object" || window !== VA ? function() {
} : typeof HTMLAnchorElement < "u" && "download" in HTMLAnchorElement.prototype ? function(t, A, e) {
  var r = VA.URL || VA.webkitURL, n = document.createElement("a");
  A = A || t.name || "download", n.download = A, n.rel = "noopener", typeof t == "string" ? (n.href = t, n.origin !== location.origin ? mf(n.href) ? Ju(t, A, e) : Zs(n, n.target = "_blank") : Zs(n)) : (n.href = r.createObjectURL(t), setTimeout(function() {
    r.revokeObjectURL(n.href);
  }, 4e4), setTimeout(function() {
    Zs(n);
  }, 0));
} : "msSaveOrOpenBlob" in navigator ? function(t, A, e) {
  if (A = A || t.name || "download", typeof t == "string") if (mf(t)) Ju(t, A, e);
  else {
    var r = document.createElement("a");
    r.href = t, r.target = "_blank", setTimeout(function() {
      Zs(r);
    });
  }
  else navigator.msSaveOrOpenBlob(function(n, i) {
    return i === void 0 ? i = { autoBom: !1 } : de(i) !== "object" && (Qe.warn("Deprecated: Expected third argument to be a object"), i = { autoBom: !i }), i.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(n.type) ? new Blob(["\uFEFF", n], { type: n.type }) : n;
  }(t, e), A);
} : function(t, A, e, r) {
  if ((r = r || open("", "_blank")) && (r.document.title = r.document.body.innerText = "downloading..."), typeof t == "string") return Ju(t, A, e);
  var n = t.type === "application/octet-stream", i = /constructor/i.test(VA.HTMLElement) || VA.safari, s = /CriOS\/[\d]+/.test(navigator.userAgent);
  if ((s || n && i) && (typeof FileReader > "u" ? "undefined" : de(FileReader)) === "object") {
    var u = new FileReader();
    u.onloadend = function() {
      var g = u.result;
      g = s ? g : g.replace(/^data:[^;]*;/, "data:attachment/file;"), r ? r.location.href = g : location = g, r = null;
    }, u.readAsDataURL(t);
  } else {
    var c = VA.URL || VA.webkitURL, h = c.createObjectURL(t);
    r ? r.location = h : location.href = h, r = null, setTimeout(function() {
      c.revokeObjectURL(h);
    }, 4e4);
  }
});
/**
 * A class to parse color values
 * @author Stoyan Stefanov <sstoo@gmail.com>
 * {@link   http://www.phpied.com/rgb-color-parser-in-javascript/}
 * @license Use it if you like it
 */
function zh(t) {
  var A;
  t = t || "", this.ok = !1, t.charAt(0) == "#" && (t = t.substr(1, 6)), t = { aliceblue: "f0f8ff", antiquewhite: "faebd7", aqua: "00ffff", aquamarine: "7fffd4", azure: "f0ffff", beige: "f5f5dc", bisque: "ffe4c4", black: "000000", blanchedalmond: "ffebcd", blue: "0000ff", blueviolet: "8a2be2", brown: "a52a2a", burlywood: "deb887", cadetblue: "5f9ea0", chartreuse: "7fff00", chocolate: "d2691e", coral: "ff7f50", cornflowerblue: "6495ed", cornsilk: "fff8dc", crimson: "dc143c", cyan: "00ffff", darkblue: "00008b", darkcyan: "008b8b", darkgoldenrod: "b8860b", darkgray: "a9a9a9", darkgreen: "006400", darkkhaki: "bdb76b", darkmagenta: "8b008b", darkolivegreen: "556b2f", darkorange: "ff8c00", darkorchid: "9932cc", darkred: "8b0000", darksalmon: "e9967a", darkseagreen: "8fbc8f", darkslateblue: "483d8b", darkslategray: "2f4f4f", darkturquoise: "00ced1", darkviolet: "9400d3", deeppink: "ff1493", deepskyblue: "00bfff", dimgray: "696969", dodgerblue: "1e90ff", feldspar: "d19275", firebrick: "b22222", floralwhite: "fffaf0", forestgreen: "228b22", fuchsia: "ff00ff", gainsboro: "dcdcdc", ghostwhite: "f8f8ff", gold: "ffd700", goldenrod: "daa520", gray: "808080", green: "008000", greenyellow: "adff2f", honeydew: "f0fff0", hotpink: "ff69b4", indianred: "cd5c5c", indigo: "4b0082", ivory: "fffff0", khaki: "f0e68c", lavender: "e6e6fa", lavenderblush: "fff0f5", lawngreen: "7cfc00", lemonchiffon: "fffacd", lightblue: "add8e6", lightcoral: "f08080", lightcyan: "e0ffff", lightgoldenrodyellow: "fafad2", lightgrey: "d3d3d3", lightgreen: "90ee90", lightpink: "ffb6c1", lightsalmon: "ffa07a", lightseagreen: "20b2aa", lightskyblue: "87cefa", lightslateblue: "8470ff", lightslategray: "778899", lightsteelblue: "b0c4de", lightyellow: "ffffe0", lime: "00ff00", limegreen: "32cd32", linen: "faf0e6", magenta: "ff00ff", maroon: "800000", mediumaquamarine: "66cdaa", mediumblue: "0000cd", mediumorchid: "ba55d3", mediumpurple: "9370d8", mediumseagreen: "3cb371", mediumslateblue: "7b68ee", mediumspringgreen: "00fa9a", mediumturquoise: "48d1cc", mediumvioletred: "c71585", midnightblue: "191970", mintcream: "f5fffa", mistyrose: "ffe4e1", moccasin: "ffe4b5", navajowhite: "ffdead", navy: "000080", oldlace: "fdf5e6", olive: "808000", olivedrab: "6b8e23", orange: "ffa500", orangered: "ff4500", orchid: "da70d6", palegoldenrod: "eee8aa", palegreen: "98fb98", paleturquoise: "afeeee", palevioletred: "d87093", papayawhip: "ffefd5", peachpuff: "ffdab9", peru: "cd853f", pink: "ffc0cb", plum: "dda0dd", powderblue: "b0e0e6", purple: "800080", red: "ff0000", rosybrown: "bc8f8f", royalblue: "4169e1", saddlebrown: "8b4513", salmon: "fa8072", sandybrown: "f4a460", seagreen: "2e8b57", seashell: "fff5ee", sienna: "a0522d", silver: "c0c0c0", skyblue: "87ceeb", slateblue: "6a5acd", slategray: "708090", snow: "fffafa", springgreen: "00ff7f", steelblue: "4682b4", tan: "d2b48c", teal: "008080", thistle: "d8bfd8", tomato: "ff6347", turquoise: "40e0d0", violet: "ee82ee", violetred: "d02090", wheat: "f5deb3", white: "ffffff", whitesmoke: "f5f5f5", yellow: "ffff00", yellowgreen: "9acd32" }[t = (t = t.replace(/ /g, "")).toLowerCase()] || t;
  for (var e = [{ re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/, example: ["rgb(123, 234, 45)", "rgb(255,234,245)"], process: function(u) {
    return [parseInt(u[1]), parseInt(u[2]), parseInt(u[3])];
  } }, { re: /^(\w{2})(\w{2})(\w{2})$/, example: ["#00ff00", "336699"], process: function(u) {
    return [parseInt(u[1], 16), parseInt(u[2], 16), parseInt(u[3], 16)];
  } }, { re: /^(\w{1})(\w{1})(\w{1})$/, example: ["#fb0", "f0f"], process: function(u) {
    return [parseInt(u[1] + u[1], 16), parseInt(u[2] + u[2], 16), parseInt(u[3] + u[3], 16)];
  } }], r = 0; r < e.length; r++) {
    var n = e[r].re, i = e[r].process, s = n.exec(t);
    s && (A = i(s), this.r = A[0], this.g = A[1], this.b = A[2], this.ok = !0);
  }
  this.r = this.r < 0 || isNaN(this.r) ? 0 : this.r > 255 ? 255 : this.r, this.g = this.g < 0 || isNaN(this.g) ? 0 : this.g > 255 ? 255 : this.g, this.b = this.b < 0 || isNaN(this.b) ? 0 : this.b > 255 ? 255 : this.b, this.toRGB = function() {
    return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
  }, this.toHex = function() {
    var u = this.r.toString(16), c = this.g.toString(16), h = this.b.toString(16);
    return u.length == 1 && (u = "0" + u), c.length == 1 && (c = "0" + c), h.length == 1 && (h = "0" + h), "#" + u + c + h;
  };
}
/**
 * @license
 * Joseph Myers does not specify a particular license for his work.
 *
 * Author: Joseph Myers
 * Accessed from: http://www.myersdaily.org/joseph/javascript/md5.js
 *
 * Modified by: Owen Leong
 */
function zu(t, A) {
  var e = t[0], r = t[1], n = t[2], i = t[3];
  e = ct(e, r, n, i, A[0], 7, -680876936), i = ct(i, e, r, n, A[1], 12, -389564586), n = ct(n, i, e, r, A[2], 17, 606105819), r = ct(r, n, i, e, A[3], 22, -1044525330), e = ct(e, r, n, i, A[4], 7, -176418897), i = ct(i, e, r, n, A[5], 12, 1200080426), n = ct(n, i, e, r, A[6], 17, -1473231341), r = ct(r, n, i, e, A[7], 22, -45705983), e = ct(e, r, n, i, A[8], 7, 1770035416), i = ct(i, e, r, n, A[9], 12, -1958414417), n = ct(n, i, e, r, A[10], 17, -42063), r = ct(r, n, i, e, A[11], 22, -1990404162), e = ct(e, r, n, i, A[12], 7, 1804603682), i = ct(i, e, r, n, A[13], 12, -40341101), n = ct(n, i, e, r, A[14], 17, -1502002290), e = lt(e, r = ct(r, n, i, e, A[15], 22, 1236535329), n, i, A[1], 5, -165796510), i = lt(i, e, r, n, A[6], 9, -1069501632), n = lt(n, i, e, r, A[11], 14, 643717713), r = lt(r, n, i, e, A[0], 20, -373897302), e = lt(e, r, n, i, A[5], 5, -701558691), i = lt(i, e, r, n, A[10], 9, 38016083), n = lt(n, i, e, r, A[15], 14, -660478335), r = lt(r, n, i, e, A[4], 20, -405537848), e = lt(e, r, n, i, A[9], 5, 568446438), i = lt(i, e, r, n, A[14], 9, -1019803690), n = lt(n, i, e, r, A[3], 14, -187363961), r = lt(r, n, i, e, A[8], 20, 1163531501), e = lt(e, r, n, i, A[13], 5, -1444681467), i = lt(i, e, r, n, A[2], 9, -51403784), n = lt(n, i, e, r, A[7], 14, 1735328473), e = ft(e, r = lt(r, n, i, e, A[12], 20, -1926607734), n, i, A[5], 4, -378558), i = ft(i, e, r, n, A[8], 11, -2022574463), n = ft(n, i, e, r, A[11], 16, 1839030562), r = ft(r, n, i, e, A[14], 23, -35309556), e = ft(e, r, n, i, A[1], 4, -1530992060), i = ft(i, e, r, n, A[4], 11, 1272893353), n = ft(n, i, e, r, A[7], 16, -155497632), r = ft(r, n, i, e, A[10], 23, -1094730640), e = ft(e, r, n, i, A[13], 4, 681279174), i = ft(i, e, r, n, A[0], 11, -358537222), n = ft(n, i, e, r, A[3], 16, -722521979), r = ft(r, n, i, e, A[6], 23, 76029189), e = ft(e, r, n, i, A[9], 4, -640364487), i = ft(i, e, r, n, A[12], 11, -421815835), n = ft(n, i, e, r, A[15], 16, 530742520), e = ht(e, r = ft(r, n, i, e, A[2], 23, -995338651), n, i, A[0], 6, -198630844), i = ht(i, e, r, n, A[7], 10, 1126891415), n = ht(n, i, e, r, A[14], 15, -1416354905), r = ht(r, n, i, e, A[5], 21, -57434055), e = ht(e, r, n, i, A[12], 6, 1700485571), i = ht(i, e, r, n, A[3], 10, -1894986606), n = ht(n, i, e, r, A[10], 15, -1051523), r = ht(r, n, i, e, A[1], 21, -2054922799), e = ht(e, r, n, i, A[8], 6, 1873313359), i = ht(i, e, r, n, A[15], 10, -30611744), n = ht(n, i, e, r, A[6], 15, -1560198380), r = ht(r, n, i, e, A[13], 21, 1309151649), e = ht(e, r, n, i, A[4], 6, -145523070), i = ht(i, e, r, n, A[11], 10, -1120210379), n = ht(n, i, e, r, A[2], 15, 718787259), r = ht(r, n, i, e, A[9], 21, -343485551), t[0] = Bn(e, t[0]), t[1] = Bn(r, t[1]), t[2] = Bn(n, t[2]), t[3] = Bn(i, t[3]);
}
function Do(t, A, e, r, n, i) {
  return A = Bn(Bn(A, t), Bn(r, i)), Bn(A << n | A >>> 32 - n, e);
}
function ct(t, A, e, r, n, i, s) {
  return Do(A & e | ~A & r, t, A, n, i, s);
}
function lt(t, A, e, r, n, i, s) {
  return Do(A & r | e & ~r, t, A, n, i, s);
}
function ft(t, A, e, r, n, i, s) {
  return Do(A ^ e ^ r, t, A, n, i, s);
}
function ht(t, A, e, r, n, i, s) {
  return Do(e ^ (A | ~r), t, A, n, i, s);
}
function Yh(t) {
  var A, e = t.length, r = [1732584193, -271733879, -1732584194, 271733878];
  for (A = 64; A <= t.length; A += 64) zu(r, Hp(t.substring(A - 64, A)));
  t = t.substring(A - 64);
  var n = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  for (A = 0; A < t.length; A++) n[A >> 2] |= t.charCodeAt(A) << (A % 4 << 3);
  if (n[A >> 2] |= 128 << (A % 4 << 3), A > 55) for (zu(r, n), A = 0; A < 16; A++) n[A] = 0;
  return n[14] = 8 * e, zu(r, n), r;
}
function Hp(t) {
  var A, e = [];
  for (A = 0; A < 64; A += 4) e[A >> 2] = t.charCodeAt(A) + (t.charCodeAt(A + 1) << 8) + (t.charCodeAt(A + 2) << 16) + (t.charCodeAt(A + 3) << 24);
  return e;
}
Sa = VA.atob.bind(VA), Ec = VA.btoa.bind(VA);
var Cf = "0123456789abcdef".split("");
function Sp(t) {
  for (var A = "", e = 0; e < 4; e++) A += Cf[t >> 8 * e + 4 & 15] + Cf[t >> 8 * e & 15];
  return A;
}
function Np(t) {
  return String.fromCharCode((255 & t) >> 0, (65280 & t) >> 8, (16711680 & t) >> 16, (4278190080 & t) >> 24);
}
function Ic(t) {
  return Yh(t).map(Np).join("");
}
var _p = function(t) {
  for (var A = 0; A < t.length; A++) t[A] = Sp(t[A]);
  return t.join("");
}(Yh("hello")) != "5d41402abc4b2a76b9719d911017c592";
function Bn(t, A) {
  if (_p) {
    var e = (65535 & t) + (65535 & A);
    return (t >> 16) + (A >> 16) + (e >> 16) << 16 | 65535 & e;
  }
  return t + A & 4294967295;
}
/**
 * @license
 * FPDF is released under a permissive license: there is no usage restriction.
 * You may embed it freely in your application (commercial or not), with or
 * without modifications.
 *
 * Reference: http://www.fpdf.org/en/script/script37.php
 */
function xc(t, A) {
  var e, r, n, i;
  if (t !== e) {
    for (var s = (n = t, i = 1 + (256 / t.length >> 0), new Array(i + 1).join(n)), u = [], c = 0; c < 256; c++) u[c] = c;
    var h = 0;
    for (c = 0; c < 256; c++) {
      var g = u[c];
      h = (h + g + s.charCodeAt(c)) % 256, u[c] = u[h], u[h] = g;
    }
    e = t, r = u;
  } else u = r;
  var p = A.length, w = 0, B = 0, L = "";
  for (c = 0; c < p; c++) B = (B + (g = u[w = (w + 1) % 256])) % 256, u[w] = u[B], u[B] = g, s = u[(u[w] + u[B]) % 256], L += String.fromCharCode(A.charCodeAt(c) ^ s);
  return L;
}
/**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 * Author: Owen Leong (@owenl131)
 * Date: 15 Oct 2020
 * References:
 * https://www.cs.cmu.edu/~dst/Adobe/Gallery/anon21jul01-pdf-encryption.txt
 * https://github.com/foliojs/pdfkit/blob/master/lib/security.js
 * http://www.fpdf.org/en/script/script37.php
 */
var Qf = { print: 4, modify: 8, copy: 16, "annot-forms": 32 };
function Li(t, A, e, r) {
  this.v = 1, this.r = 2;
  var n = 192;
  t.forEach(function(u) {
    if (Qf.perm !== void 0) throw new Error("Invalid permission: " + u);
    n += Qf[u];
  }), this.padding = "(¿N^NuAd\0NVÿú\b..\0¶Ðh>/\f©þdSiz";
  var i = (A + this.padding).substr(0, 32), s = (e + this.padding).substr(0, 32);
  this.O = this.processOwnerPassword(i, s), this.P = -(1 + (255 ^ n)), this.encryptionKey = Ic(i + this.O + this.lsbFirstWord(this.P) + this.hexToBytes(r)).substr(0, 5), this.U = xc(this.encryptionKey, this.padding);
}
function Ei(t) {
  if (/[^\u0000-\u00ff]/.test(t)) throw new Error("Invalid PDF Name Object: " + t + ", Only accept ASCII characters.");
  for (var A = "", e = t.length, r = 0; r < e; r++) {
    var n = t.charCodeAt(r);
    n < 33 || n === 35 || n === 37 || n === 40 || n === 41 || n === 47 || n === 60 || n === 62 || n === 91 || n === 93 || n === 123 || n === 125 || n > 126 ? A += "#" + ("0" + n.toString(16)).slice(-2) : A += t[r];
  }
  return A;
}
function Ff(t) {
  if (de(t) !== "object") throw new Error("Invalid Context passed to initialize PubSub (jsPDF-module)");
  var A = {};
  this.subscribe = function(e, r, n) {
    if (n = n || !1, typeof e != "string" || typeof r != "function" || typeof n != "boolean") throw new Error("Invalid arguments passed to PubSub.subscribe (jsPDF-module)");
    A.hasOwnProperty(e) || (A[e] = {});
    var i = Math.random().toString(35);
    return A[e][i] = [r, !!n], i;
  }, this.unsubscribe = function(e) {
    for (var r in A) if (A[r][e]) return delete A[r][e], Object.keys(A[r]).length === 0 && delete A[r], !0;
    return !1;
  }, this.publish = function(e) {
    if (A.hasOwnProperty(e)) {
      var r = Array.prototype.slice.call(arguments, 1), n = [];
      for (var i in A[e]) {
        var s = A[e][i];
        try {
          s[0].apply(t, r);
        } catch (u) {
          VA.console && Qe.error("jsPDF PubSub Error", u.message, u);
        }
        s[1] && n.push(i);
      }
      n.length && n.forEach(this.unsubscribe);
    }
  }, this.getTopics = function() {
    return A;
  };
}
function Co(t) {
  if (!(this instanceof Co)) return new Co(t);
  var A = "opacity,stroke-opacity".split(",");
  for (var e in t) t.hasOwnProperty(e) && A.indexOf(e) >= 0 && (this[e] = t[e]);
  this.id = "", this.objectNumber = -1;
}
function Zh(t, A) {
  this.gState = t, this.matrix = A, this.id = "", this.objectNumber = -1;
}
function Tn(t, A, e, r, n) {
  if (!(this instanceof Tn)) return new Tn(t, A, e, r, n);
  this.type = t === "axial" ? 2 : 3, this.coords = A, this.colors = e, Zh.call(this, r, n);
}
function xi(t, A, e, r, n) {
  if (!(this instanceof xi)) return new xi(t, A, e, r, n);
  this.boundingBox = t, this.xStep = A, this.yStep = e, this.stream = "", this.cloneIndex = 0, Zh.call(this, r, n);
}
function GA(t) {
  var A, e = typeof arguments[0] == "string" ? arguments[0] : "p", r = arguments[1], n = arguments[2], i = arguments[3], s = [], u = 1, c = 16, h = "S", g = null;
  de(t = t || {}) === "object" && (e = t.orientation, r = t.unit || r, n = t.format || n, i = t.compress || t.compressPdf || i, (g = t.encryption || null) !== null && (g.userPassword = g.userPassword || "", g.ownerPassword = g.ownerPassword || "", g.userPermissions = g.userPermissions || []), u = typeof t.userUnit == "number" ? Math.abs(t.userUnit) : 1, t.precision !== void 0 && (A = t.precision), t.floatPrecision !== void 0 && (c = t.floatPrecision), h = t.defaultPathOperation || "S"), s = t.filters || (i === !0 ? ["FlateEncode"] : s), r = r || "mm", e = ("" + (e || "P")).toLowerCase();
  var p = t.putOnlyUsedFonts || !1, w = {}, B = { internal: {}, __private__: {} };
  B.__private__.PubSub = Ff;
  var L = "1.3", y = B.__private__.getPdfVersion = function() {
    return L;
  };
  B.__private__.setPdfVersion = function(l) {
    L = l;
  };
  var N = { a0: [2383.94, 3370.39], a1: [1683.78, 2383.94], a2: [1190.55, 1683.78], a3: [841.89, 1190.55], a4: [595.28, 841.89], a5: [419.53, 595.28], a6: [297.64, 419.53], a7: [209.76, 297.64], a8: [147.4, 209.76], a9: [104.88, 147.4], a10: [73.7, 104.88], b0: [2834.65, 4008.19], b1: [2004.09, 2834.65], b2: [1417.32, 2004.09], b3: [1000.63, 1417.32], b4: [708.66, 1000.63], b5: [498.9, 708.66], b6: [354.33, 498.9], b7: [249.45, 354.33], b8: [175.75, 249.45], b9: [124.72, 175.75], b10: [87.87, 124.72], c0: [2599.37, 3676.54], c1: [1836.85, 2599.37], c2: [1298.27, 1836.85], c3: [918.43, 1298.27], c4: [649.13, 918.43], c5: [459.21, 649.13], c6: [323.15, 459.21], c7: [229.61, 323.15], c8: [161.57, 229.61], c9: [113.39, 161.57], c10: [79.37, 113.39], dl: [311.81, 623.62], letter: [612, 792], "government-letter": [576, 756], legal: [612, 1008], "junior-legal": [576, 360], ledger: [1224, 792], tabloid: [792, 1224], "credit-card": [153, 243] };
  B.__private__.getPageFormats = function() {
    return N;
  };
  var F = B.__private__.getPageFormat = function(l) {
    return N[l];
  };
  n = n || "a4";
  var x = { COMPAT: "compat", ADVANCED: "advanced" }, R = x.COMPAT;
  function Y() {
    this.saveGraphicsState(), P(new RA(SA, 0, 0, -SA, 0, Wr() * SA).toString() + " cm"), this.setFontSize(this.getFontSize() / SA), h = "n", R = x.ADVANCED;
  }
  function Z() {
    this.restoreGraphicsState(), h = "S", R = x.COMPAT;
  }
  var $ = B.__private__.combineFontStyleAndFontWeight = function(l, m) {
    if (l == "bold" && m == "normal" || l == "bold" && m == 400 || l == "normal" && m == "italic" || l == "bold" && m == "italic") throw new Error("Invalid Combination of fontweight and fontstyle");
    return m && (l = m == 400 || m === "normal" ? l === "italic" ? "italic" : "normal" : m != 700 && m !== "bold" || l !== "normal" ? (m == 700 ? "bold" : m) + "" + l : "bold"), l;
  };
  B.advancedAPI = function(l) {
    var m = R === x.COMPAT;
    return m && Y.call(this), typeof l != "function" || (l(this), m && Z.call(this)), this;
  }, B.compatAPI = function(l) {
    var m = R === x.ADVANCED;
    return m && Z.call(this), typeof l != "function" || (l(this), m && Y.call(this)), this;
  }, B.isAdvancedAPI = function() {
    return R === x.ADVANCED;
  };
  var J, O = function(l) {
    if (R !== x.ADVANCED) throw new Error(l + " is only available in 'advanced' API mode. You need to call advancedAPI() first.");
  }, W = B.roundToPrecision = B.__private__.roundToPrecision = function(l, m) {
    var D = A || m;
    if (isNaN(l) || isNaN(D)) throw new Error("Invalid argument passed to jsPDF.roundToPrecision");
    return l.toFixed(D).replace(/0+$/, "");
  };
  J = B.hpf = B.__private__.hpf = typeof c == "number" ? function(l) {
    if (isNaN(l)) throw new Error("Invalid argument passed to jsPDF.hpf");
    return W(l, c);
  } : c === "smart" ? function(l) {
    if (isNaN(l)) throw new Error("Invalid argument passed to jsPDF.hpf");
    return W(l, l > -1 && l < 1 ? 16 : 5);
  } : function(l) {
    if (isNaN(l)) throw new Error("Invalid argument passed to jsPDF.hpf");
    return W(l, 16);
  };
  var cA = B.f2 = B.__private__.f2 = function(l) {
    if (isNaN(l)) throw new Error("Invalid argument passed to jsPDF.f2");
    return W(l, 2);
  }, I = B.__private__.f3 = function(l) {
    if (isNaN(l)) throw new Error("Invalid argument passed to jsPDF.f3");
    return W(l, 3);
  }, H = B.scale = B.__private__.scale = function(l) {
    if (isNaN(l)) throw new Error("Invalid argument passed to jsPDF.scale");
    return R === x.COMPAT ? l * SA : R === x.ADVANCED ? l : void 0;
  }, K = function(l) {
    return R === x.COMPAT ? Wr() - l : R === x.ADVANCED ? l : void 0;
  }, M = function(l) {
    return H(K(l));
  };
  B.__private__.setPrecision = B.setPrecision = function(l) {
    typeof parseInt(l, 10) == "number" && (A = parseInt(l, 10));
  };
  var oA, iA = "00000000000000000000000000000000", uA = B.__private__.getFileId = function() {
    return iA;
  }, eA = B.__private__.setFileId = function(l) {
    return iA = l !== void 0 && /^[a-fA-F0-9]{32}$/.test(l) ? l.toUpperCase() : iA.split("").map(function() {
      return "ABCDEF0123456789".charAt(Math.floor(16 * Math.random()));
    }).join(""), g !== null && (ot = new Li(g.userPermissions, g.userPassword, g.ownerPassword, iA)), iA;
  };
  B.setFileId = function(l) {
    return eA(l), this;
  }, B.getFileId = function() {
    return uA();
  };
  var lA = B.__private__.convertDateToPDFDate = function(l) {
    var m = l.getTimezoneOffset(), D = m < 0 ? "+" : "-", G = Math.floor(Math.abs(m / 60)), AA = Math.abs(m % 60), BA = [D, T(G), "'", T(AA), "'"].join("");
    return ["D:", l.getFullYear(), T(l.getMonth() + 1), T(l.getDate()), T(l.getHours()), T(l.getMinutes()), T(l.getSeconds()), BA].join("");
  }, hA = B.__private__.convertPDFDateToDate = function(l) {
    var m = parseInt(l.substr(2, 4), 10), D = parseInt(l.substr(6, 2), 10) - 1, G = parseInt(l.substr(8, 2), 10), AA = parseInt(l.substr(10, 2), 10), BA = parseInt(l.substr(12, 2), 10), mA = parseInt(l.substr(14, 2), 10);
    return new Date(m, D, G, AA, BA, mA, 0);
  }, UA = B.__private__.setCreationDate = function(l) {
    var m;
    if (l === void 0 && (l = /* @__PURE__ */ new Date()), l instanceof Date) m = lA(l);
    else {
      if (!/^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|-0[0-9]|-1[0-1])'(0[0-9]|[1-5][0-9])'?$/.test(l)) throw new Error("Invalid argument passed to jsPDF.setCreationDate");
      m = l;
    }
    return oA = m;
  }, U = B.__private__.getCreationDate = function(l) {
    var m = oA;
    return l === "jsDate" && (m = hA(oA)), m;
  };
  B.setCreationDate = function(l) {
    return UA(l), this;
  }, B.getCreationDate = function(l) {
    return U(l);
  };
  var _, T = B.__private__.padd2 = function(l) {
    return ("0" + parseInt(l)).slice(-2);
  }, k = B.__private__.padd2Hex = function(l) {
    return ("00" + (l = l.toString())).substr(l.length);
  }, X = 0, nA = [], aA = [], sA = 0, FA = [], QA = [], xA = !1, LA = aA, jA = function() {
    X = 0, sA = 0, aA = [], nA = [], FA = [], xr = Ge(), Yt = Ge();
  };
  B.__private__.setCustomOutputDestination = function(l) {
    xA = !0, LA = l;
  };
  var gA = function(l) {
    xA || (LA = l);
  };
  B.__private__.resetCustomOutputDestination = function() {
    xA = !1, LA = aA;
  };
  var P = B.__private__.out = function(l) {
    return l = l.toString(), sA += l.length + 1, LA.push(l), LA;
  }, ZA = B.__private__.write = function(l) {
    return P(arguments.length === 1 ? l.toString() : Array.prototype.join.call(arguments, " "));
  }, PA = B.__private__.getArrayBuffer = function(l) {
    for (var m = l.length, D = new ArrayBuffer(m), G = new Uint8Array(D); m--; ) G[m] = l.charCodeAt(m);
    return D;
  }, CA = [["Helvetica", "helvetica", "normal", "WinAnsiEncoding"], ["Helvetica-Bold", "helvetica", "bold", "WinAnsiEncoding"], ["Helvetica-Oblique", "helvetica", "italic", "WinAnsiEncoding"], ["Helvetica-BoldOblique", "helvetica", "bolditalic", "WinAnsiEncoding"], ["Courier", "courier", "normal", "WinAnsiEncoding"], ["Courier-Bold", "courier", "bold", "WinAnsiEncoding"], ["Courier-Oblique", "courier", "italic", "WinAnsiEncoding"], ["Courier-BoldOblique", "courier", "bolditalic", "WinAnsiEncoding"], ["Times-Roman", "times", "normal", "WinAnsiEncoding"], ["Times-Bold", "times", "bold", "WinAnsiEncoding"], ["Times-Italic", "times", "italic", "WinAnsiEncoding"], ["Times-BoldItalic", "times", "bolditalic", "WinAnsiEncoding"], ["ZapfDingbats", "zapfdingbats", "normal", null], ["Symbol", "symbol", "normal", null]];
  B.__private__.getStandardFonts = function() {
    return CA;
  };
  var yA = t.fontSize || 16;
  B.__private__.setFontSize = B.setFontSize = function(l) {
    return yA = R === x.ADVANCED ? l / SA : l, this;
  };
  var HA, IA = B.__private__.getFontSize = B.getFontSize = function() {
    return R === x.COMPAT ? yA : yA * SA;
  }, MA = t.R2L || !1;
  B.__private__.setR2L = B.setR2L = function(l) {
    return MA = l, this;
  }, B.__private__.getR2L = B.getR2L = function() {
    return MA;
  };
  var XA, ee = B.__private__.setZoomMode = function(l) {
    var m = [void 0, null, "fullwidth", "fullheight", "fullpage", "original"];
    if (/^(?:\d+\.\d*|\d*\.\d+|\d+)%$/.test(l)) HA = l;
    else if (isNaN(l)) {
      if (m.indexOf(l) === -1) throw new Error('zoom must be Integer (e.g. 2), a percentage Value (e.g. 300%) or fullwidth, fullheight, fullpage, original. "' + l + '" is not recognized.');
      HA = l;
    } else HA = parseInt(l, 10);
  };
  B.__private__.getZoomMode = function() {
    return HA;
  };
  var te, se = B.__private__.setPageMode = function(l) {
    if ([void 0, null, "UseNone", "UseOutlines", "UseThumbs", "FullScreen"].indexOf(l) == -1) throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "' + l + '" is not recognized.');
    XA = l;
  };
  B.__private__.getPageMode = function() {
    return XA;
  };
  var pe = B.__private__.setLayoutMode = function(l) {
    if ([void 0, null, "continuous", "single", "twoleft", "tworight", "two"].indexOf(l) == -1) throw new Error('Layout mode must be one of continuous, single, twoleft, tworight. "' + l + '" is not recognized.');
    te = l;
  };
  B.__private__.getLayoutMode = function() {
    return te;
  }, B.__private__.setDisplayMode = B.setDisplayMode = function(l, m, D) {
    return ee(l), pe(m), se(D), this;
  };
  var qA = { title: "", subject: "", author: "", keywords: "", creator: "" };
  B.__private__.getDocumentProperty = function(l) {
    if (Object.keys(qA).indexOf(l) === -1) throw new Error("Invalid argument passed to jsPDF.getDocumentProperty");
    return qA[l];
  }, B.__private__.getDocumentProperties = function() {
    return qA;
  }, B.__private__.setDocumentProperties = B.setProperties = B.setDocumentProperties = function(l) {
    for (var m in qA) qA.hasOwnProperty(m) && l[m] && (qA[m] = l[m]);
    return this;
  }, B.__private__.setDocumentProperty = function(l, m) {
    if (Object.keys(qA).indexOf(l) === -1) throw new Error("Invalid arguments passed to jsPDF.setDocumentProperty");
    return qA[l] = m;
  };
  var re, SA, st, ue, Xt, me = {}, Le = {}, fr = [], le = {}, mn = {}, xe = {}, Jt = {}, Ir = null, He = 0, JA = [], fe = new Ff(B), Cn = t.hotfixes || [], tt = {}, hr = {}, Br = [], RA = function l(m, D, G, AA, BA, mA) {
    if (!(this instanceof l)) return new l(m, D, G, AA, BA, mA);
    isNaN(m) && (m = 1), isNaN(D) && (D = 0), isNaN(G) && (G = 0), isNaN(AA) && (AA = 1), isNaN(BA) && (BA = 0), isNaN(mA) && (mA = 0), this._matrix = [m, D, G, AA, BA, mA];
  };
  Object.defineProperty(RA.prototype, "sx", { get: function() {
    return this._matrix[0];
  }, set: function(l) {
    this._matrix[0] = l;
  } }), Object.defineProperty(RA.prototype, "shy", { get: function() {
    return this._matrix[1];
  }, set: function(l) {
    this._matrix[1] = l;
  } }), Object.defineProperty(RA.prototype, "shx", { get: function() {
    return this._matrix[2];
  }, set: function(l) {
    this._matrix[2] = l;
  } }), Object.defineProperty(RA.prototype, "sy", { get: function() {
    return this._matrix[3];
  }, set: function(l) {
    this._matrix[3] = l;
  } }), Object.defineProperty(RA.prototype, "tx", { get: function() {
    return this._matrix[4];
  }, set: function(l) {
    this._matrix[4] = l;
  } }), Object.defineProperty(RA.prototype, "ty", { get: function() {
    return this._matrix[5];
  }, set: function(l) {
    this._matrix[5] = l;
  } }), Object.defineProperty(RA.prototype, "a", { get: function() {
    return this._matrix[0];
  }, set: function(l) {
    this._matrix[0] = l;
  } }), Object.defineProperty(RA.prototype, "b", { get: function() {
    return this._matrix[1];
  }, set: function(l) {
    this._matrix[1] = l;
  } }), Object.defineProperty(RA.prototype, "c", { get: function() {
    return this._matrix[2];
  }, set: function(l) {
    this._matrix[2] = l;
  } }), Object.defineProperty(RA.prototype, "d", { get: function() {
    return this._matrix[3];
  }, set: function(l) {
    this._matrix[3] = l;
  } }), Object.defineProperty(RA.prototype, "e", { get: function() {
    return this._matrix[4];
  }, set: function(l) {
    this._matrix[4] = l;
  } }), Object.defineProperty(RA.prototype, "f", { get: function() {
    return this._matrix[5];
  }, set: function(l) {
    this._matrix[5] = l;
  } }), Object.defineProperty(RA.prototype, "rotation", { get: function() {
    return Math.atan2(this.shx, this.sx);
  } }), Object.defineProperty(RA.prototype, "scaleX", { get: function() {
    return this.decompose().scale.sx;
  } }), Object.defineProperty(RA.prototype, "scaleY", { get: function() {
    return this.decompose().scale.sy;
  } }), Object.defineProperty(RA.prototype, "isIdentity", { get: function() {
    return this.sx === 1 && this.shy === 0 && this.shx === 0 && this.sy === 1 && this.tx === 0 && this.ty === 0;
  } }), RA.prototype.join = function(l) {
    return [this.sx, this.shy, this.shx, this.sy, this.tx, this.ty].map(J).join(l);
  }, RA.prototype.multiply = function(l) {
    var m = l.sx * this.sx + l.shy * this.shx, D = l.sx * this.shy + l.shy * this.sy, G = l.shx * this.sx + l.sy * this.shx, AA = l.shx * this.shy + l.sy * this.sy, BA = l.tx * this.sx + l.ty * this.shx + this.tx, mA = l.tx * this.shy + l.ty * this.sy + this.ty;
    return new RA(m, D, G, AA, BA, mA);
  }, RA.prototype.decompose = function() {
    var l = this.sx, m = this.shy, D = this.shx, G = this.sy, AA = this.tx, BA = this.ty, mA = Math.sqrt(l * l + m * m), _A = (l /= mA) * D + (m /= mA) * G;
    D -= l * _A, G -= m * _A;
    var KA = Math.sqrt(D * D + G * G);
    return _A /= KA, l * (G /= KA) < m * (D /= KA) && (l = -l, m = -m, _A = -_A, mA = -mA), { scale: new RA(mA, 0, 0, KA, 0, 0), translate: new RA(1, 0, 0, 1, AA, BA), rotate: new RA(l, m, -m, l, 0, 0), skew: new RA(1, 0, _A, 1, 0, 0) };
  }, RA.prototype.toString = function(l) {
    return this.join(" ");
  }, RA.prototype.inversed = function() {
    var l = this.sx, m = this.shy, D = this.shx, G = this.sy, AA = this.tx, BA = this.ty, mA = 1 / (l * G - m * D), _A = G * mA, KA = -m * mA, $A = -D * mA, zA = l * mA;
    return new RA(_A, KA, $A, zA, -_A * AA - $A * BA, -KA * AA - zA * BA);
  }, RA.prototype.applyToPoint = function(l) {
    var m = l.x * this.sx + l.y * this.shx + this.tx, D = l.x * this.shy + l.y * this.sy + this.ty;
    return new ei(m, D);
  }, RA.prototype.applyToRectangle = function(l) {
    var m = this.applyToPoint(l), D = this.applyToPoint(new ei(l.x + l.w, l.y + l.h));
    return new Xi(m.x, m.y, D.x - m.x, D.y - m.y);
  }, RA.prototype.clone = function() {
    var l = this.sx, m = this.shy, D = this.shx, G = this.sy, AA = this.tx, BA = this.ty;
    return new RA(l, m, D, G, AA, BA);
  }, B.Matrix = RA;
  var zt = B.matrixMult = function(l, m) {
    return m.multiply(l);
  }, gr = new RA(1, 0, 0, 1, 0, 0);
  B.unitMatrix = B.identityMatrix = gr;
  var Ct = function(l, m) {
    if (!mn[l]) {
      var D = (m instanceof Tn ? "Sh" : "P") + (Object.keys(le).length + 1).toString(10);
      m.id = D, mn[l] = D, le[D] = m, fe.publish("addPattern", m);
    }
  };
  B.ShadingPattern = Tn, B.TilingPattern = xi, B.addShadingPattern = function(l, m) {
    return O("addShadingPattern()"), Ct(l, m), this;
  }, B.beginTilingPattern = function(l) {
    O("beginTilingPattern()"), rs(l.boundingBox[0], l.boundingBox[1], l.boundingBox[2] - l.boundingBox[0], l.boundingBox[3] - l.boundingBox[1], l.matrix);
  }, B.endTilingPattern = function(l, m) {
    O("endTilingPattern()"), m.stream = QA[_].join(`
`), Ct(l, m), fe.publish("endTilingPattern", m), Br.pop().restore();
  };
  var Xe = B.__private__.newObject = function() {
    var l = Ge();
    return It(l, !0), l;
  }, Ge = B.__private__.newObjectDeferred = function() {
    return X++, nA[X] = function() {
      return sA;
    }, X;
  }, It = function(l, m) {
    return m = typeof m == "boolean" && m, nA[l] = sA, m && P(l + " 0 obj"), l;
  }, Rn = B.__private__.newAdditionalObject = function() {
    var l = { objId: Ge(), content: "" };
    return FA.push(l), l;
  }, xr = Ge(), Yt = Ge(), Zt = B.__private__.decodeColorString = function(l) {
    var m = l.split(" ");
    if (m.length !== 2 || m[1] !== "g" && m[1] !== "G")
      m.length === 5 && (m[4] === "k" || m[4] === "K") && (m = [(1 - m[0]) * (1 - m[3]), (1 - m[1]) * (1 - m[3]), (1 - m[2]) * (1 - m[3]), "r"]);
    else {
      var D = parseFloat(m[0]);
      m = [D, D, D, "r"];
    }
    for (var G = "#", AA = 0; AA < 3; AA++) G += ("0" + Math.floor(255 * parseFloat(m[AA])).toString(16)).slice(-2);
    return G;
  }, $t = B.__private__.encodeColorString = function(l) {
    var m;
    typeof l == "string" && (l = { ch1: l });
    var D = l.ch1, G = l.ch2, AA = l.ch3, BA = l.ch4, mA = l.pdfColorType === "draw" ? ["G", "RG", "K"] : ["g", "rg", "k"];
    if (typeof D == "string" && D.charAt(0) !== "#") {
      var _A = new zh(D);
      if (_A.ok) D = _A.toHex();
      else if (!/^\d*\.?\d*$/.test(D)) throw new Error('Invalid color "' + D + '" passed to jsPDF.encodeColorString.');
    }
    if (typeof D == "string" && /^#[0-9A-Fa-f]{3}$/.test(D) && (D = "#" + D[1] + D[1] + D[2] + D[2] + D[3] + D[3]), typeof D == "string" && /^#[0-9A-Fa-f]{6}$/.test(D)) {
      var KA = parseInt(D.substr(1), 16);
      D = KA >> 16 & 255, G = KA >> 8 & 255, AA = 255 & KA;
    }
    if (G === void 0 || BA === void 0 && D === G && G === AA) if (typeof D == "string") m = D + " " + mA[0];
    else switch (l.precision) {
      case 2:
        m = cA(D / 255) + " " + mA[0];
        break;
      case 3:
      default:
        m = I(D / 255) + " " + mA[0];
    }
    else if (BA === void 0 || de(BA) === "object") {
      if (BA && !isNaN(BA.a) && BA.a === 0) return m = ["1.", "1.", "1.", mA[1]].join(" ");
      if (typeof D == "string") m = [D, G, AA, mA[1]].join(" ");
      else switch (l.precision) {
        case 2:
          m = [cA(D / 255), cA(G / 255), cA(AA / 255), mA[1]].join(" ");
          break;
        default:
        case 3:
          m = [I(D / 255), I(G / 255), I(AA / 255), mA[1]].join(" ");
      }
    } else if (typeof D == "string") m = [D, G, AA, BA, mA[2]].join(" ");
    else switch (l.precision) {
      case 2:
        m = [cA(D), cA(G), cA(AA), cA(BA), mA[2]].join(" ");
        break;
      case 3:
      default:
        m = [I(D), I(G), I(AA), I(BA), mA[2]].join(" ");
    }
    return m;
  }, dr = B.__private__.getFilters = function() {
    return s;
  }, Tt = B.__private__.putStream = function(l) {
    var m = (l = l || {}).data || "", D = l.filters || dr(), G = l.alreadyAppliedFilters || [], AA = l.addLength1 || !1, BA = m.length, mA = l.objectId, _A = function(ut) {
      return ut;
    };
    if (g !== null && mA === void 0) throw new Error("ObjectId must be passed to putStream for file encryption");
    g !== null && (_A = ot.encryptor(mA, 0));
    var KA = {};
    D === !0 && (D = ["FlateEncode"]);
    var $A = l.additionalKeyValues || [], zA = (KA = GA.API.processDataByFilters !== void 0 ? GA.API.processDataByFilters(m, D) : { data: m, reverseChain: [] }).reverseChain + (Array.isArray(G) ? G.join(" ") : G.toString());
    if (KA.data.length !== 0 && ($A.push({ key: "Length", value: KA.data.length }), AA === !0 && $A.push({ key: "Length1", value: BA })), zA.length != 0) if (zA.split("/").length - 1 == 1) $A.push({ key: "Filter", value: zA });
    else {
      $A.push({ key: "Filter", value: "[" + zA + "]" });
      for (var ae = 0; ae < $A.length; ae += 1) if ($A[ae].key === "DecodeParms") {
        for (var Ie = [], Se = 0; Se < KA.reverseChain.split("/").length - 1; Se += 1) Ie.push("null");
        Ie.push($A[ae].value), $A[ae].value = "[" + Ie.join(" ") + "]";
      }
    }
    P("<<");
    for (var je = 0; je < $A.length; je++) P("/" + $A[je].key + " " + $A[je].value);
    P(">>"), KA.data.length !== 0 && (P("stream"), P(_A(KA.data)), P("endstream"));
  }, pr = B.__private__.putPage = function(l) {
    var m = l.number, D = l.data, G = l.objId, AA = l.contentsObjId;
    It(G, !0), P("<</Type /Page"), P("/Parent " + l.rootDictionaryObjId + " 0 R"), P("/Resources " + l.resourceDictionaryObjId + " 0 R"), P("/MediaBox [" + parseFloat(J(l.mediaBox.bottomLeftX)) + " " + parseFloat(J(l.mediaBox.bottomLeftY)) + " " + J(l.mediaBox.topRightX) + " " + J(l.mediaBox.topRightY) + "]"), l.cropBox !== null && P("/CropBox [" + J(l.cropBox.bottomLeftX) + " " + J(l.cropBox.bottomLeftY) + " " + J(l.cropBox.topRightX) + " " + J(l.cropBox.topRightY) + "]"), l.bleedBox !== null && P("/BleedBox [" + J(l.bleedBox.bottomLeftX) + " " + J(l.bleedBox.bottomLeftY) + " " + J(l.bleedBox.topRightX) + " " + J(l.bleedBox.topRightY) + "]"), l.trimBox !== null && P("/TrimBox [" + J(l.trimBox.bottomLeftX) + " " + J(l.trimBox.bottomLeftY) + " " + J(l.trimBox.topRightX) + " " + J(l.trimBox.topRightY) + "]"), l.artBox !== null && P("/ArtBox [" + J(l.artBox.bottomLeftX) + " " + J(l.artBox.bottomLeftY) + " " + J(l.artBox.topRightX) + " " + J(l.artBox.topRightY) + "]"), typeof l.userUnit == "number" && l.userUnit !== 1 && P("/UserUnit " + l.userUnit), fe.publish("putPage", { objId: G, pageContext: JA[m], pageNumber: m, page: D }), P("/Contents " + AA + " 0 R"), P(">>"), P("endobj");
    var BA = D.join(`
`);
    return R === x.ADVANCED && (BA += `
Q`), It(AA, !0), Tt({ data: BA, filters: dr(), objectId: AA }), P("endobj"), G;
  }, Qn = B.__private__.putPages = function() {
    var l, m, D = [];
    for (l = 1; l <= He; l++) JA[l].objId = Ge(), JA[l].contentsObjId = Ge();
    for (l = 1; l <= He; l++) D.push(pr({ number: l, data: QA[l], objId: JA[l].objId, contentsObjId: JA[l].contentsObjId, mediaBox: JA[l].mediaBox, cropBox: JA[l].cropBox, bleedBox: JA[l].bleedBox, trimBox: JA[l].trimBox, artBox: JA[l].artBox, userUnit: JA[l].userUnit, rootDictionaryObjId: xr, resourceDictionaryObjId: Yt }));
    It(xr, !0), P("<</Type /Pages");
    var G = "/Kids [";
    for (m = 0; m < He; m++) G += D[m] + " 0 R ";
    P(G + "]"), P("/Count " + He), P(">>"), P("endobj"), fe.publish("postPutPages");
  }, Gn = function(l) {
    fe.publish("putFont", { font: l, out: P, newObject: Xe, putStream: Tt }), l.isAlreadyPutted !== !0 && (l.objectNumber = Xe(), P("<<"), P("/Type /Font"), P("/BaseFont /" + Ei(l.postScriptName)), P("/Subtype /Type1"), typeof l.encoding == "string" && P("/Encoding /" + l.encoding), P("/FirstChar 32"), P("/LastChar 255"), P(">>"), P("endobj"));
  }, jn = function() {
    for (var l in me) me.hasOwnProperty(l) && (p === !1 || p === !0 && w.hasOwnProperty(l)) && Gn(me[l]);
  }, Vn = function(l) {
    l.objectNumber = Xe();
    var m = [];
    m.push({ key: "Type", value: "/XObject" }), m.push({ key: "Subtype", value: "/Form" }), m.push({ key: "BBox", value: "[" + [J(l.x), J(l.y), J(l.x + l.width), J(l.y + l.height)].join(" ") + "]" }), m.push({ key: "Matrix", value: "[" + l.matrix.toString() + "]" });
    var D = l.pages[1].join(`
`);
    Tt({ data: D, additionalKeyValues: m, objectId: l.objectNumber }), P("endobj");
  }, qn = function() {
    for (var l in tt) tt.hasOwnProperty(l) && Vn(tt[l]);
  }, Ma = function(l, m) {
    var D, G = [], AA = 1 / (m - 1);
    for (D = 0; D < 1; D += AA) G.push(D);
    if (G.push(1), l[0].offset != 0) {
      var BA = { offset: 0, color: l[0].color };
      l.unshift(BA);
    }
    if (l[l.length - 1].offset != 1) {
      var mA = { offset: 1, color: l[l.length - 1].color };
      l.push(mA);
    }
    for (var _A = "", KA = 0, $A = 0; $A < G.length; $A++) {
      for (D = G[$A]; D > l[KA + 1].offset; ) KA++;
      var zA = l[KA].offset, ae = (D - zA) / (l[KA + 1].offset - zA), Ie = l[KA].color, Se = l[KA + 1].color;
      _A += k(Math.round((1 - ae) * Ie[0] + ae * Se[0]).toString(16)) + k(Math.round((1 - ae) * Ie[1] + ae * Se[1]).toString(16)) + k(Math.round((1 - ae) * Ie[2] + ae * Se[2]).toString(16));
    }
    return _A.trim();
  }, To = function(l, m) {
    m || (m = 21);
    var D = Xe(), G = Ma(l.colors, m), AA = [];
    AA.push({ key: "FunctionType", value: "0" }), AA.push({ key: "Domain", value: "[0.0 1.0]" }), AA.push({ key: "Size", value: "[" + m + "]" }), AA.push({ key: "BitsPerSample", value: "8" }), AA.push({ key: "Range", value: "[0.0 1.0 0.0 1.0 0.0 1.0]" }), AA.push({ key: "Decode", value: "[0.0 1.0 0.0 1.0 0.0 1.0]" }), Tt({ data: G, additionalKeyValues: AA, alreadyAppliedFilters: ["/ASCIIHexDecode"], objectId: D }), P("endobj"), l.objectNumber = Xe(), P("<< /ShadingType " + l.type), P("/ColorSpace /DeviceRGB");
    var BA = "/Coords [" + J(parseFloat(l.coords[0])) + " " + J(parseFloat(l.coords[1])) + " ";
    l.type === 2 ? BA += J(parseFloat(l.coords[2])) + " " + J(parseFloat(l.coords[3])) : BA += J(parseFloat(l.coords[2])) + " " + J(parseFloat(l.coords[3])) + " " + J(parseFloat(l.coords[4])) + " " + J(parseFloat(l.coords[5])), P(BA += "]"), l.matrix && P("/Matrix [" + l.matrix.toString() + "]"), P("/Function " + D + " 0 R"), P("/Extend [true true]"), P(">>"), P("endobj");
  }, Oo = function(l, m) {
    var D = Ge(), G = Xe();
    m.push({ resourcesOid: D, objectOid: G }), l.objectNumber = G;
    var AA = [];
    AA.push({ key: "Type", value: "/Pattern" }), AA.push({ key: "PatternType", value: "1" }), AA.push({ key: "PaintType", value: "1" }), AA.push({ key: "TilingType", value: "1" }), AA.push({ key: "BBox", value: "[" + l.boundingBox.map(J).join(" ") + "]" }), AA.push({ key: "XStep", value: J(l.xStep) }), AA.push({ key: "YStep", value: J(l.yStep) }), AA.push({ key: "Resources", value: D + " 0 R" }), l.matrix && AA.push({ key: "Matrix", value: "[" + l.matrix.toString() + "]" }), Tt({ data: l.stream, additionalKeyValues: AA, objectId: l.objectNumber }), P("endobj");
  }, Wn = function(l) {
    var m;
    for (m in le) le.hasOwnProperty(m) && (le[m] instanceof Tn ? To(le[m]) : le[m] instanceof xi && Oo(le[m], l));
  }, Ka = function(l) {
    for (var m in l.objectNumber = Xe(), P("<<"), l) switch (m) {
      case "opacity":
        P("/ca " + cA(l[m]));
        break;
      case "stroke-opacity":
        P("/CA " + cA(l[m]));
    }
    P(">>"), P("endobj");
  }, Po = function() {
    var l;
    for (l in xe) xe.hasOwnProperty(l) && Ka(xe[l]);
  }, Pi = function() {
    for (var l in P("/XObject <<"), tt) tt.hasOwnProperty(l) && tt[l].objectNumber >= 0 && P("/" + l + " " + tt[l].objectNumber + " 0 R");
    fe.publish("putXobjectDict"), P(">>");
  }, Mo = function() {
    ot.oid = Xe(), P("<<"), P("/Filter /Standard"), P("/V " + ot.v), P("/R " + ot.r), P("/U <" + ot.toHexString(ot.U) + ">"), P("/O <" + ot.toHexString(ot.O) + ">"), P("/P " + ot.P), P(">>"), P("endobj");
  }, ka = function() {
    for (var l in P("/Font <<"), me) me.hasOwnProperty(l) && (p === !1 || p === !0 && w.hasOwnProperty(l)) && P("/" + l + " " + me[l].objectNumber + " 0 R");
    P(">>");
  }, Ko = function() {
    if (Object.keys(le).length > 0) {
      for (var l in P("/Shading <<"), le) le.hasOwnProperty(l) && le[l] instanceof Tn && le[l].objectNumber >= 0 && P("/" + l + " " + le[l].objectNumber + " 0 R");
      fe.publish("putShadingPatternDict"), P(">>");
    }
  }, Xn = function(l) {
    if (Object.keys(le).length > 0) {
      for (var m in P("/Pattern <<"), le) le.hasOwnProperty(m) && le[m] instanceof B.TilingPattern && le[m].objectNumber >= 0 && le[m].objectNumber < l && P("/" + m + " " + le[m].objectNumber + " 0 R");
      fe.publish("putTilingPatternDict"), P(">>");
    }
  }, ko = function() {
    if (Object.keys(xe).length > 0) {
      var l;
      for (l in P("/ExtGState <<"), xe) xe.hasOwnProperty(l) && xe[l].objectNumber >= 0 && P("/" + l + " " + xe[l].objectNumber + " 0 R");
      fe.publish("putGStateDict"), P(">>");
    }
  }, De = function(l) {
    It(l.resourcesOid, !0), P("<<"), P("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"), ka(), Ko(), Xn(l.objectOid), ko(), Pi(), P(">>"), P("endobj");
  }, Ra = function() {
    var l = [];
    jn(), Po(), qn(), Wn(l), fe.publish("putResources"), l.forEach(De), De({ resourcesOid: Yt, objectOid: Number.MAX_SAFE_INTEGER }), fe.publish("postPutResources");
  }, Ga = function() {
    fe.publish("putAdditionalObjects");
    for (var l = 0; l < FA.length; l++) {
      var m = FA[l];
      It(m.objId, !0), P(m.content), P("endobj");
    }
    fe.publish("postPutAdditionalObjects");
  }, ja = function(l) {
    Le[l.fontName] = Le[l.fontName] || {}, Le[l.fontName][l.fontStyle] = l.id;
  }, Mi = function(l, m, D, G, AA) {
    var BA = { id: "F" + (Object.keys(me).length + 1).toString(10), postScriptName: l, fontName: m, fontStyle: D, encoding: G, isStandardFont: AA || !1, metadata: {} };
    return fe.publish("addFont", { font: BA, instance: this }), me[BA.id] = BA, ja(BA), BA.id;
  }, Ro = function(l) {
    for (var m = 0, D = CA.length; m < D; m++) {
      var G = Mi.call(this, l[m][0], l[m][1], l[m][2], CA[m][3], !0);
      p === !1 && (w[G] = !0);
      var AA = l[m][0].split("-");
      ja({ id: G, fontName: AA[0], fontStyle: AA[1] || "" });
    }
    fe.publish("addFonts", { fonts: me, dictionary: Le });
  }, Ar = function(l) {
    return l.foo = function() {
      try {
        return l.apply(this, arguments);
      } catch (G) {
        var m = G.stack || "";
        ~m.indexOf(" at ") && (m = m.split(" at ")[1]);
        var D = "Error in function " + m.split(`
`)[0].split("<")[0] + ": " + G.message;
        if (!VA.console) throw new Error(D);
        VA.console.error(D, G), VA.alert && alert(D);
      }
    }, l.foo.bar = l, l.foo;
  }, Jn = function(l, m) {
    var D, G, AA, BA, mA, _A, KA, $A, zA;
    if (AA = (m = m || {}).sourceEncoding || "Unicode", mA = m.outputEncoding, (m.autoencode || mA) && me[re].metadata && me[re].metadata[AA] && me[re].metadata[AA].encoding && (BA = me[re].metadata[AA].encoding, !mA && me[re].encoding && (mA = me[re].encoding), !mA && BA.codePages && (mA = BA.codePages[0]), typeof mA == "string" && (mA = BA[mA]), mA)) {
      for (KA = !1, _A = [], D = 0, G = l.length; D < G; D++) ($A = mA[l.charCodeAt(D)]) ? _A.push(String.fromCharCode($A)) : _A.push(l[D]), _A[D].charCodeAt(0) >> 8 && (KA = !0);
      l = _A.join("");
    }
    for (D = l.length; KA === void 0 && D !== 0; ) l.charCodeAt(D - 1) >> 8 && (KA = !0), D--;
    if (!KA) return l;
    for (_A = m.noBOM ? [] : [254, 255], D = 0, G = l.length; D < G; D++) {
      if ((zA = ($A = l.charCodeAt(D)) >> 8) >> 8) throw new Error("Character at position " + D + " of string '" + l + "' exceeds 16bits. Cannot be encoded into UCS-2 BE");
      _A.push(zA), _A.push($A - (zA << 8));
    }
    return String.fromCharCode.apply(void 0, _A);
  }, Qt = B.__private__.pdfEscape = B.pdfEscape = function(l, m) {
    return Jn(l, m).replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
  }, Ki = B.__private__.beginPage = function(l) {
    QA[++He] = [], JA[He] = { objId: 0, contentsObjId: 0, userUnit: Number(u), artBox: null, bleedBox: null, cropBox: null, trimBox: null, mediaBox: { bottomLeftX: 0, bottomLeftY: 0, topRightX: Number(l[0]), topRightY: Number(l[1]) } }, qa(He), gA(QA[_]);
  }, Va = function(l, m) {
    var D, G, AA;
    switch (e = m || e, typeof l == "string" && (D = F(l.toLowerCase()), Array.isArray(D) && (G = D[0], AA = D[1])), Array.isArray(l) && (G = l[0] * SA, AA = l[1] * SA), isNaN(G) && (G = n[0], AA = n[1]), (G > 14400 || AA > 14400) && (Qe.warn("A page in a PDF can not be wider or taller than 14400 userUnit. jsPDF limits the width/height to 14400"), G = Math.min(14400, G), AA = Math.min(14400, AA)), n = [G, AA], e.substr(0, 1)) {
      case "l":
        AA > G && (n = [AA, G]);
        break;
      case "p":
        G > AA && (n = [AA, G]);
    }
    Ki(n), Za(ji), P(er), qi !== 0 && P(qi + " J"), Wi !== 0 && P(Wi + " j"), fe.publish("addPage", { pageNumber: He });
  }, Go = function(l) {
    l > 0 && l <= He && (QA.splice(l, 1), JA.splice(l, 1), He--, _ > He && (_ = He), this.setPage(_));
  }, qa = function(l) {
    l > 0 && l <= He && (_ = l);
  }, jo = B.__private__.getNumberOfPages = B.getNumberOfPages = function() {
    return QA.length - 1;
  }, Wa = function(l, m, D) {
    var G, AA = void 0;
    return D = D || {}, l = l !== void 0 ? l : me[re].fontName, m = m !== void 0 ? m : me[re].fontStyle, G = l.toLowerCase(), Le[G] !== void 0 && Le[G][m] !== void 0 ? AA = Le[G][m] : Le[l] !== void 0 && Le[l][m] !== void 0 ? AA = Le[l][m] : D.disableWarning === !1 && Qe.warn("Unable to look up font label for font '" + l + "', '" + m + "'. Refer to getFontList() for available fonts."), AA || D.noFallback || (AA = Le.times[m]) == null && (AA = Le.times.normal), AA;
  }, Vo = B.__private__.putInfo = function() {
    var l = Xe(), m = function(G) {
      return G;
    };
    for (var D in g !== null && (m = ot.encryptor(l, 0)), P("<<"), P("/Producer (" + Qt(m("jsPDF " + GA.version)) + ")"), qA) qA.hasOwnProperty(D) && qA[D] && P("/" + D.substr(0, 1).toUpperCase() + D.substr(1) + " (" + Qt(m(qA[D])) + ")");
    P("/CreationDate (" + Qt(m(oA)) + ")"), P(">>"), P("endobj");
  }, ki = B.__private__.putCatalog = function(l) {
    var m = (l = l || {}).rootDictionaryObjId || xr;
    switch (Xe(), P("<<"), P("/Type /Catalog"), P("/Pages " + m + " 0 R"), HA || (HA = "fullwidth"), HA) {
      case "fullwidth":
        P("/OpenAction [3 0 R /FitH null]");
        break;
      case "fullheight":
        P("/OpenAction [3 0 R /FitV null]");
        break;
      case "fullpage":
        P("/OpenAction [3 0 R /Fit]");
        break;
      case "original":
        P("/OpenAction [3 0 R /XYZ null null 1]");
        break;
      default:
        var D = "" + HA;
        D.substr(D.length - 1) === "%" && (HA = parseInt(HA) / 100), typeof HA == "number" && P("/OpenAction [3 0 R /XYZ null null " + cA(HA) + "]");
    }
    switch (te || (te = "continuous"), te) {
      case "continuous":
        P("/PageLayout /OneColumn");
        break;
      case "single":
        P("/PageLayout /SinglePage");
        break;
      case "two":
      case "twoleft":
        P("/PageLayout /TwoColumnLeft");
        break;
      case "tworight":
        P("/PageLayout /TwoColumnRight");
    }
    XA && P("/PageMode /" + XA), fe.publish("putCatalog"), P(">>"), P("endobj");
  }, qo = B.__private__.putTrailer = function() {
    P("trailer"), P("<<"), P("/Size " + (X + 1)), P("/Root " + X + " 0 R"), P("/Info " + (X - 1) + " 0 R"), g !== null && P("/Encrypt " + ot.oid + " 0 R"), P("/ID [ <" + iA + "> <" + iA + "> ]"), P(">>");
  }, Wo = B.__private__.putHeader = function() {
    P("%PDF-" + L), P("%ºß¬à");
  }, Xo = B.__private__.putXRef = function() {
    var l = "0000000000";
    P("xref"), P("0 " + (X + 1)), P("0000000000 65535 f ");
    for (var m = 1; m <= X; m++)
      typeof nA[m] == "function" ? P((l + nA[m]()).slice(-10) + " 00000 n ") : nA[m] !== void 0 ? P((l + nA[m]).slice(-10) + " 00000 n ") : P("0000000000 00000 n ");
  }, Hr = B.__private__.buildDocument = function() {
    jA(), gA(aA), fe.publish("buildDocument"), Wo(), Qn(), Ga(), Ra(), g !== null && Mo(), Vo(), ki();
    var l = sA;
    return Xo(), qo(), P("startxref"), P("" + l), P("%%EOF"), gA(QA[_]), aA.join(`
`);
  }, zn = B.__private__.getBlob = function(l) {
    return new Blob([PA(l)], { type: "application/pdf" });
  }, Yn = B.output = B.__private__.output = Ar(function(l, m) {
    switch (typeof (m = m || {}) == "string" ? m = { filename: m } : m.filename = m.filename || "generated.pdf", l) {
      case void 0:
        return Hr();
      case "save":
        B.save(m.filename);
        break;
      case "arraybuffer":
        return PA(Hr());
      case "blob":
        return zn(Hr());
      case "bloburi":
      case "bloburl":
        if (VA.URL !== void 0 && typeof VA.URL.createObjectURL == "function") return VA.URL && VA.URL.createObjectURL(zn(Hr())) || void 0;
        Qe.warn("bloburl is not supported by your system, because URL.createObjectURL is not supported by your browser.");
        break;
      case "datauristring":
      case "dataurlstring":
        var D = "", G = Hr();
        try {
          D = Ec(G);
        } catch {
          D = Ec(unescape(encodeURIComponent(G)));
        }
        return "data:application/pdf;filename=" + m.filename + ";base64," + D;
      case "pdfobjectnewwindow":
        if (Object.prototype.toString.call(VA) === "[object Window]") {
          var AA = "https://cdnjs.cloudflare.com/ajax/libs/pdfobject/2.1.1/pdfobject.min.js", BA = ' integrity="sha512-4ze/a9/4jqu+tX9dfOqJYSvyYd5M6qum/3HpCLr+/Jqf0whc37VUbkpNGHR7/8pSnCFw47T1fmIpwBV7UySh3g==" crossorigin="anonymous"';
          m.pdfObjectUrl && (AA = m.pdfObjectUrl, BA = "");
          var mA = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><script src="' + AA + '"' + BA + '><\/script><script >PDFObject.embed("' + this.output("dataurlstring") + '", ' + JSON.stringify(m) + ");<\/script></body></html>", _A = VA.open();
          return _A !== null && _A.document.write(mA), _A;
        }
        throw new Error("The option pdfobjectnewwindow just works in a browser-environment.");
      case "pdfjsnewwindow":
        if (Object.prototype.toString.call(VA) === "[object Window]") {
          var KA = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe id="pdfViewer" src="' + (m.pdfJsUrl || "examples/PDF.js/web/viewer.html") + "?file=&downloadName=" + m.filename + '" width="500px" height="400px" /></body></html>', $A = VA.open();
          if ($A !== null) {
            $A.document.write(KA);
            var zA = this;
            $A.document.documentElement.querySelector("#pdfViewer").onload = function() {
              $A.document.title = m.filename, $A.document.documentElement.querySelector("#pdfViewer").contentWindow.PDFViewerApplication.open(zA.output("bloburl"));
            };
          }
          return $A;
        }
        throw new Error("The option pdfjsnewwindow just works in a browser-environment.");
      case "dataurlnewwindow":
        if (Object.prototype.toString.call(VA) !== "[object Window]") throw new Error("The option dataurlnewwindow just works in a browser-environment.");
        var ae = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe src="' + this.output("datauristring", m) + '"></iframe></body></html>', Ie = VA.open();
        if (Ie !== null && (Ie.document.write(ae), Ie.document.title = m.filename), Ie || typeof safari > "u") return Ie;
        break;
      case "datauri":
      case "dataurl":
        return VA.document.location.href = this.output("datauristring", m);
      default:
        return null;
    }
  }), Xa = function(l) {
    return Array.isArray(Cn) === !0 && Cn.indexOf(l) > -1;
  };
  switch (r) {
    case "pt":
      SA = 1;
      break;
    case "mm":
      SA = 72 / 25.4;
      break;
    case "cm":
      SA = 72 / 2.54;
      break;
    case "in":
      SA = 72;
      break;
    case "px":
      SA = Xa("px_scaling") == 1 ? 0.75 : 96 / 72;
      break;
    case "pc":
    case "em":
      SA = 12;
      break;
    case "ex":
      SA = 6;
      break;
    default:
      if (typeof r != "number") throw new Error("Invalid unit: " + r);
      SA = r;
  }
  var ot = null;
  UA(), eA();
  var Jo = function(l) {
    return g !== null ? ot.encryptor(l, 0) : function(m) {
      return m;
    };
  }, Ja = B.__private__.getPageInfo = B.getPageInfo = function(l) {
    if (isNaN(l) || l % 1 != 0) throw new Error("Invalid argument passed to jsPDF.getPageInfo");
    return { objId: JA[l].objId, pageNumber: l, pageContext: JA[l] };
  }, WA = B.__private__.getPageInfoByObjId = function(l) {
    if (isNaN(l) || l % 1 != 0) throw new Error("Invalid argument passed to jsPDF.getPageInfoByObjId");
    for (var m in JA) if (JA[m].objId === l) break;
    return Ja(m);
  }, zo = B.__private__.getCurrentPageInfo = B.getCurrentPageInfo = function() {
    return { objId: JA[_].objId, pageNumber: _, pageContext: JA[_] };
  };
  B.addPage = function() {
    return Va.apply(this, arguments), this;
  }, B.setPage = function() {
    return qa.apply(this, arguments), gA.call(this, QA[_]), this;
  }, B.insertPage = function(l) {
    return this.addPage(), this.movePage(_, l), this;
  }, B.movePage = function(l, m) {
    var D, G;
    if (l > m) {
      D = QA[l], G = JA[l];
      for (var AA = l; AA > m; AA--) QA[AA] = QA[AA - 1], JA[AA] = JA[AA - 1];
      QA[m] = D, JA[m] = G, this.setPage(m);
    } else if (l < m) {
      D = QA[l], G = JA[l];
      for (var BA = l; BA < m; BA++) QA[BA] = QA[BA + 1], JA[BA] = JA[BA + 1];
      QA[m] = D, JA[m] = G, this.setPage(m);
    }
    return this;
  }, B.deletePage = function() {
    return Go.apply(this, arguments), this;
  }, B.__private__.text = B.text = function(l, m, D, G, AA) {
    var BA, mA, _A, KA, $A, zA, ae, Ie, Se, je = (G = G || {}).scope || this;
    if (typeof l == "number" && typeof m == "number" && (typeof D == "string" || Array.isArray(D))) {
      var ut = D;
      D = m, m = l, l = ut;
    }
    if (arguments[3] instanceof RA ? (O("The transform parameter of text() with a Matrix value"), Se = AA) : (_A = arguments[4], KA = arguments[5], de(ae = arguments[3]) === "object" && ae !== null || (typeof _A == "string" && (KA = _A, _A = null), typeof ae == "string" && (KA = ae, ae = null), typeof ae == "number" && (_A = ae, ae = null), G = { flags: ae, angle: _A, align: KA })), isNaN(m) || isNaN(D) || l == null) throw new Error("Invalid arguments passed to jsPDF.text");
    if (l.length === 0) return je;
    var Ye = "", tr = !1, xt = typeof G.lineHeightFactor == "number" ? G.lineHeightFactor : Un, mr = je.internal.scaleFactor;
    function ns(Fe) {
      return Fe = Fe.split("	").join(Array(G.TabLen || 9).join(" ")), Qt(Fe, ae);
    }
    function Zi(Fe) {
      for (var Ue, Oe = Fe.concat(), Je = [], Tr = Oe.length; Tr--; ) typeof (Ue = Oe.shift()) == "string" ? Je.push(Ue) : Array.isArray(Fe) && (Ue.length === 1 || Ue[1] === void 0 && Ue[2] === void 0) ? Je.push(Ue[0]) : Je.push([Ue[0], Ue[1], Ue[2]]);
      return Je;
    }
    function $i(Fe, Ue) {
      var Oe;
      if (typeof Fe == "string") Oe = Ue(Fe)[0];
      else if (Array.isArray(Fe)) {
        for (var Je, Tr, sa = Fe.concat(), fi = [], us = sa.length; us--; ) typeof (Je = sa.shift()) == "string" ? fi.push(Ue(Je)[0]) : Array.isArray(Je) && typeof Je[0] == "string" && (Tr = Ue(Je[0], Je[1], Je[2]), fi.push([Tr[0], Tr[1], Tr[2]]));
        Oe = fi;
      }
      return Oe;
    }
    var ri = !1, Aa = !0;
    if (typeof l == "string") ri = !0;
    else if (Array.isArray(l)) {
      var ea = l.concat();
      mA = [];
      for (var ni, rt = ea.length; rt--; ) (typeof (ni = ea.shift()) != "string" || Array.isArray(ni) && typeof ni[0] != "string") && (Aa = !1);
      ri = Aa;
    }
    if (ri === !1) throw new Error('Type of text must be string or Array. "' + l + '" is not recognized.');
    typeof l == "string" && (l = l.match(/[\r?\n]/) ? l.split(/\r\n|\r|\n/g) : [l]);
    var ii = yA / je.internal.scaleFactor, ai = ii * (xt - 1);
    switch (G.baseline) {
      case "bottom":
        D -= ai;
        break;
      case "top":
        D += ii - ai;
        break;
      case "hanging":
        D += ii - 2 * ai;
        break;
      case "middle":
        D += ii / 2 - ai;
    }
    if ((zA = G.maxWidth || 0) > 0 && (typeof l == "string" ? l = je.splitTextToSize(l, zA) : Object.prototype.toString.call(l) === "[object Array]" && (l = l.reduce(function(Fe, Ue) {
      return Fe.concat(je.splitTextToSize(Ue, zA));
    }, []))), BA = { text: l, x: m, y: D, options: G, mutex: { pdfEscape: Qt, activeFontKey: re, fonts: me, activeFontSize: yA } }, fe.publish("preProcessText", BA), l = BA.text, _A = (G = BA.options).angle, !(Se instanceof RA) && _A && typeof _A == "number") {
      _A *= Math.PI / 180, G.rotationDirection === 0 && (_A = -_A), R === x.ADVANCED && (_A = -_A);
      var si = Math.cos(_A), ta = Math.sin(_A);
      Se = new RA(si, ta, -ta, si, 0, 0);
    } else _A && _A instanceof RA && (Se = _A);
    R !== x.ADVANCED || Se || (Se = gr), ($A = G.charSpace || Ai) !== void 0 && (Ye += J(H($A)) + ` Tc
`, this.setCharSpace(this.getCharSpace() || 0)), (Ie = G.horizontalScale) !== void 0 && (Ye += J(100 * Ie) + ` Tz
`), G.lang;
    var Ft = -1, au = G.renderingMode !== void 0 ? G.renderingMode : G.stroke, ra = je.internal.getCurrentPageInfo().pageContext;
    switch (au) {
      case 0:
      case !1:
      case "fill":
        Ft = 0;
        break;
      case 1:
      case !0:
      case "stroke":
        Ft = 1;
        break;
      case 2:
      case "fillThenStroke":
        Ft = 2;
        break;
      case 3:
      case "invisible":
        Ft = 3;
        break;
      case 4:
      case "fillAndAddForClipping":
        Ft = 4;
        break;
      case 5:
      case "strokeAndAddPathForClipping":
        Ft = 5;
        break;
      case 6:
      case "fillThenStrokeAndAddToPathForClipping":
        Ft = 6;
        break;
      case 7:
      case "addToPathForClipping":
        Ft = 7;
    }
    var is = ra.usedRenderingMode !== void 0 ? ra.usedRenderingMode : -1;
    Ft !== -1 ? Ye += Ft + ` Tr
` : is !== -1 && (Ye += `0 Tr
`), Ft !== -1 && (ra.usedRenderingMode = Ft), KA = G.align || "left";
    var Ot, oi = yA * xt, as = je.internal.pageSize.getWidth(), ss = me[re];
    $A = G.charSpace || Ai, zA = G.maxWidth || 0, ae = Object.assign({ autoencode: !0, noBOM: !0 }, G.flags);
    var Xr = [], Ln = function(Fe) {
      return je.getStringUnitWidth(Fe, { font: ss, charSpace: $A, fontSize: yA, doKerning: !1 }) * yA / mr;
    };
    if (Object.prototype.toString.call(l) === "[object Array]") {
      var Ut;
      mA = Zi(l), KA !== "left" && (Ot = mA.map(Ln));
      var pt, Jr = 0;
      if (KA === "right") {
        m -= Ot[0], l = [], rt = mA.length;
        for (var Nr = 0; Nr < rt; Nr++) Nr === 0 ? (pt = vr(m), Ut = Sr(D)) : (pt = H(Jr - Ot[Nr]), Ut = -oi), l.push([mA[Nr], pt, Ut]), Jr = Ot[Nr];
      } else if (KA === "center") {
        m -= Ot[0] / 2, l = [], rt = mA.length;
        for (var _r = 0; _r < rt; _r++) _r === 0 ? (pt = vr(m), Ut = Sr(D)) : (pt = H((Jr - Ot[_r]) / 2), Ut = -oi), l.push([mA[_r], pt, Ut]), Jr = Ot[_r];
      } else if (KA === "left") {
        l = [], rt = mA.length;
        for (var ui = 0; ui < rt; ui++) l.push(mA[ui]);
      } else if (KA === "justify" && ss.encoding === "Identity-H") {
        l = [], rt = mA.length, zA = zA !== 0 ? zA : as;
        for (var Dr = 0, Te = 0; Te < rt; Te++) if (Ut = Te === 0 ? Sr(D) : -oi, pt = Te === 0 ? vr(m) : Dr, Te < rt - 1) {
          var na = H((zA - Ot[Te]) / (mA[Te].split(" ").length - 1)), wt = mA[Te].split(" ");
          l.push([wt[0] + " ", pt, Ut]), Dr = 0;
          for (var Pt = 1; Pt < wt.length; Pt++) {
            var ci = (Ln(wt[Pt - 1] + " " + wt[Pt]) - Ln(wt[Pt])) * mr + na;
            Pt == wt.length - 1 ? l.push([wt[Pt], ci, 0]) : l.push([wt[Pt] + " ", ci, 0]), Dr -= ci;
          }
        } else l.push([mA[Te], pt, Ut]);
        l.push(["", Dr, 0]);
      } else {
        if (KA !== "justify") throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');
        for (l = [], rt = mA.length, zA = zA !== 0 ? zA : as, Te = 0; Te < rt; Te++) Ut = Te === 0 ? Sr(D) : -oi, pt = Te === 0 ? vr(m) : 0, Te < rt - 1 ? Xr.push(J(H((zA - Ot[Te]) / (mA[Te].split(" ").length - 1)))) : Xr.push(0), l.push([mA[Te], pt, Ut]);
      }
    }
    var os = typeof G.R2L == "boolean" ? G.R2L : MA;
    os === !0 && (l = $i(l, function(Fe, Ue, Oe) {
      return [Fe.split("").reverse().join(""), Ue, Oe];
    })), BA = { text: l, x: m, y: D, options: G, mutex: { pdfEscape: Qt, activeFontKey: re, fonts: me, activeFontSize: yA } }, fe.publish("postProcessText", BA), l = BA.text, tr = BA.mutex.isHex || !1;
    var ia = me[re].encoding;
    ia !== "WinAnsiEncoding" && ia !== "StandardEncoding" || (l = $i(l, function(Fe, Ue, Oe) {
      return [ns(Fe), Ue, Oe];
    })), mA = Zi(l), l = [];
    for (var En, In, zr, xn = 0, li = 1, Hn = Array.isArray(mA[0]) ? li : xn, Yr = "", aa = function(Fe, Ue, Oe) {
      var Je = "";
      return Oe instanceof RA ? (Oe = typeof G.angle == "number" ? zt(Oe, new RA(1, 0, 0, 1, Fe, Ue)) : zt(new RA(1, 0, 0, 1, Fe, Ue), Oe), R === x.ADVANCED && (Oe = zt(new RA(1, 0, 0, -1, 0, 0), Oe)), Je = Oe.join(" ") + ` Tm
`) : Je = J(Fe) + " " + J(Ue) + ` Td
`, Je;
    }, Mt = 0; Mt < mA.length; Mt++) {
      switch (Yr = "", Hn) {
        case li:
          zr = (tr ? "<" : "(") + mA[Mt][0] + (tr ? ">" : ")"), En = parseFloat(mA[Mt][1]), In = parseFloat(mA[Mt][2]);
          break;
        case xn:
          zr = (tr ? "<" : "(") + mA[Mt] + (tr ? ">" : ")"), En = vr(m), In = Sr(D);
      }
      Xr !== void 0 && Xr[Mt] !== void 0 && (Yr = Xr[Mt] + ` Tw
`), Mt === 0 ? l.push(Yr + aa(En, In, Se) + zr) : Hn === xn ? l.push(Yr + zr) : Hn === li && l.push(Yr + aa(En, In, Se) + zr);
    }
    l = Hn === xn ? l.join(` Tj
T* `) : l.join(` Tj
`), l += ` Tj
`;
    var Kt = `BT
/`;
    return Kt += re + " " + yA + ` Tf
`, Kt += J(yA * xt) + ` TL
`, Kt += yn + `
`, Kt += Ye, Kt += l, P(Kt += "ET"), w[re] = !0, je;
  };
  var Yo = B.__private__.clip = B.clip = function(l) {
    return P(l === "evenodd" ? "W*" : "W"), this;
  };
  B.clipEvenOdd = function() {
    return Yo("evenodd");
  }, B.__private__.discardPath = B.discardPath = function() {
    return P("n"), this;
  };
  var wr = B.__private__.isValidStyle = function(l) {
    var m = !1;
    return [void 0, null, "S", "D", "F", "DF", "FD", "f", "f*", "B", "B*", "n"].indexOf(l) !== -1 && (m = !0), m;
  };
  B.__private__.setDefaultPathOperation = B.setDefaultPathOperation = function(l) {
    return wr(l) && (h = l), this;
  };
  var za = B.__private__.getStyle = B.getStyle = function(l) {
    var m = h;
    switch (l) {
      case "D":
      case "S":
        m = "S";
        break;
      case "F":
        m = "f";
        break;
      case "FD":
      case "DF":
        m = "B";
        break;
      case "f":
      case "f*":
      case "B":
      case "B*":
        m = l;
    }
    return m;
  }, Ya = B.close = function() {
    return P("h"), this;
  };
  B.stroke = function() {
    return P("S"), this;
  }, B.fill = function(l) {
    return Zn("f", l), this;
  }, B.fillEvenOdd = function(l) {
    return Zn("f*", l), this;
  }, B.fillStroke = function(l) {
    return Zn("B", l), this;
  }, B.fillStrokeEvenOdd = function(l) {
    return Zn("B*", l), this;
  };
  var Zn = function(l, m) {
    de(m) === "object" ? $o(m, l) : P(l);
  }, Ri = function(l) {
    l === null || R === x.ADVANCED && l === void 0 || (l = za(l), P(l));
  };
  function Zo(l, m, D, G, AA) {
    var BA = new xi(m || this.boundingBox, D || this.xStep, G || this.yStep, this.gState, AA || this.matrix);
    BA.stream = this.stream;
    var mA = l + "$$" + this.cloneIndex++ + "$$";
    return Ct(mA, BA), BA;
  }
  var $o = function(l, m) {
    var D = mn[l.key], G = le[D];
    if (G instanceof Tn) P("q"), P(Au(m)), G.gState && B.setGState(G.gState), P(l.matrix.toString() + " cm"), P("/" + D + " sh"), P("Q");
    else if (G instanceof xi) {
      var AA = new RA(1, 0, 0, -1, 0, Wr());
      l.matrix && (AA = AA.multiply(l.matrix || gr), D = Zo.call(G, l.key, l.boundingBox, l.xStep, l.yStep, AA).id), P("q"), P("/Pattern cs"), P("/" + D + " scn"), G.gState && B.setGState(G.gState), P(m), P("Q");
    }
  }, Au = function(l) {
    switch (l) {
      case "f":
      case "F":
        return "W n";
      case "f*":
        return "W* n";
      case "B":
        return "W S";
      case "B*":
        return "W* S";
      case "S":
        return "W S";
      case "n":
        return "W n";
    }
  }, Gi = B.moveTo = function(l, m) {
    return P(J(H(l)) + " " + J(M(m)) + " m"), this;
  }, Fn = B.lineTo = function(l, m) {
    return P(J(H(l)) + " " + J(M(m)) + " l"), this;
  }, Vr = B.curveTo = function(l, m, D, G, AA, BA) {
    return P([J(H(l)), J(M(m)), J(H(D)), J(M(G)), J(H(AA)), J(M(BA)), "c"].join(" ")), this;
  };
  B.__private__.line = B.line = function(l, m, D, G, AA) {
    if (isNaN(l) || isNaN(m) || isNaN(D) || isNaN(G) || !wr(AA)) throw new Error("Invalid arguments passed to jsPDF.line");
    return R === x.COMPAT ? this.lines([[D - l, G - m]], l, m, [1, 1], AA || "S") : this.lines([[D - l, G - m]], l, m, [1, 1]).stroke();
  }, B.__private__.lines = B.lines = function(l, m, D, G, AA, BA) {
    var mA, _A, KA, $A, zA, ae, Ie, Se, je, ut, Ye, tr;
    if (typeof l == "number" && (tr = D, D = m, m = l, l = tr), G = G || [1, 1], BA = BA || !1, isNaN(m) || isNaN(D) || !Array.isArray(l) || !Array.isArray(G) || !wr(AA) || typeof BA != "boolean") throw new Error("Invalid arguments passed to jsPDF.lines");
    for (Gi(m, D), mA = G[0], _A = G[1], $A = l.length, ut = m, Ye = D, KA = 0; KA < $A; KA++) (zA = l[KA]).length === 2 ? (ut = zA[0] * mA + ut, Ye = zA[1] * _A + Ye, Fn(ut, Ye)) : (ae = zA[0] * mA + ut, Ie = zA[1] * _A + Ye, Se = zA[2] * mA + ut, je = zA[3] * _A + Ye, ut = zA[4] * mA + ut, Ye = zA[5] * _A + Ye, Vr(ae, Ie, Se, je, ut, Ye));
    return BA && Ya(), Ri(AA), this;
  }, B.path = function(l) {
    for (var m = 0; m < l.length; m++) {
      var D = l[m], G = D.c;
      switch (D.op) {
        case "m":
          Gi(G[0], G[1]);
          break;
        case "l":
          Fn(G[0], G[1]);
          break;
        case "c":
          Vr.apply(this, G);
          break;
        case "h":
          Ya();
      }
    }
    return this;
  }, B.__private__.rect = B.rect = function(l, m, D, G, AA) {
    if (isNaN(l) || isNaN(m) || isNaN(D) || isNaN(G) || !wr(AA)) throw new Error("Invalid arguments passed to jsPDF.rect");
    return R === x.COMPAT && (G = -G), P([J(H(l)), J(M(m)), J(H(D)), J(H(G)), "re"].join(" ")), Ri(AA), this;
  }, B.__private__.triangle = B.triangle = function(l, m, D, G, AA, BA, mA) {
    if (isNaN(l) || isNaN(m) || isNaN(D) || isNaN(G) || isNaN(AA) || isNaN(BA) || !wr(mA)) throw new Error("Invalid arguments passed to jsPDF.triangle");
    return this.lines([[D - l, G - m], [AA - D, BA - G], [l - AA, m - BA]], l, m, [1, 1], mA, !0), this;
  }, B.__private__.roundedRect = B.roundedRect = function(l, m, D, G, AA, BA, mA) {
    if (isNaN(l) || isNaN(m) || isNaN(D) || isNaN(G) || isNaN(AA) || isNaN(BA) || !wr(mA)) throw new Error("Invalid arguments passed to jsPDF.roundedRect");
    var _A = 4 / 3 * (Math.SQRT2 - 1);
    return AA = Math.min(AA, 0.5 * D), BA = Math.min(BA, 0.5 * G), this.lines([[D - 2 * AA, 0], [AA * _A, 0, AA, BA - BA * _A, AA, BA], [0, G - 2 * BA], [0, BA * _A, -AA * _A, BA, -AA, BA], [2 * AA - D, 0], [-AA * _A, 0, -AA, -BA * _A, -AA, -BA], [0, 2 * BA - G], [0, -BA * _A, AA * _A, -BA, AA, -BA]], l + AA, m, [1, 1], mA, !0), this;
  }, B.__private__.ellipse = B.ellipse = function(l, m, D, G, AA) {
    if (isNaN(l) || isNaN(m) || isNaN(D) || isNaN(G) || !wr(AA)) throw new Error("Invalid arguments passed to jsPDF.ellipse");
    var BA = 4 / 3 * (Math.SQRT2 - 1) * D, mA = 4 / 3 * (Math.SQRT2 - 1) * G;
    return Gi(l + D, m), Vr(l + D, m - mA, l + BA, m - G, l, m - G), Vr(l - BA, m - G, l - D, m - mA, l - D, m), Vr(l - D, m + mA, l - BA, m + G, l, m + G), Vr(l + BA, m + G, l + D, m + mA, l + D, m), Ri(AA), this;
  }, B.__private__.circle = B.circle = function(l, m, D, G) {
    if (isNaN(l) || isNaN(m) || isNaN(D) || !wr(G)) throw new Error("Invalid arguments passed to jsPDF.circle");
    return this.ellipse(l, m, D, D, G);
  }, B.setFont = function(l, m, D) {
    return D && (m = $(m, D)), re = Wa(l, m, { disableWarning: !1 }), this;
  };
  var eu = B.__private__.getFont = B.getFont = function() {
    return me[Wa.apply(B, arguments)];
  };
  B.__private__.getFontList = B.getFontList = function() {
    var l, m, D = {};
    for (l in Le) if (Le.hasOwnProperty(l)) for (m in D[l] = [], Le[l]) Le[l].hasOwnProperty(m) && D[l].push(m);
    return D;
  }, B.addFont = function(l, m, D, G, AA) {
    var BA = ["StandardEncoding", "MacRomanEncoding", "Identity-H", "WinAnsiEncoding"];
    return arguments[3] && BA.indexOf(arguments[3]) !== -1 ? AA = arguments[3] : arguments[3] && BA.indexOf(arguments[3]) == -1 && (D = $(D, G)), AA = AA || "Identity-H", Mi.call(this, l, m, D, AA);
  };
  var Un, ji = t.lineWidth || 0.200025, $n = B.__private__.getLineWidth = B.getLineWidth = function() {
    return ji;
  }, Za = B.__private__.setLineWidth = B.setLineWidth = function(l) {
    return ji = l, P(J(H(l)) + " w"), this;
  };
  B.__private__.setLineDash = GA.API.setLineDash = GA.API.setLineDashPattern = function(l, m) {
    if (l = l || [], m = m || 0, isNaN(m) || !Array.isArray(l)) throw new Error("Invalid arguments passed to jsPDF.setLineDash");
    return l = l.map(function(D) {
      return J(H(D));
    }).join(" "), m = J(H(m)), P("[" + l + "] " + m + " d"), this;
  };
  var $a = B.__private__.getLineHeight = B.getLineHeight = function() {
    return yA * Un;
  };
  B.__private__.getLineHeight = B.getLineHeight = function() {
    return yA * Un;
  };
  var As = B.__private__.setLineHeightFactor = B.setLineHeightFactor = function(l) {
    return typeof (l = l || 1.15) == "number" && (Un = l), this;
  }, es = B.__private__.getLineHeightFactor = B.getLineHeightFactor = function() {
    return Un;
  };
  As(t.lineHeight);
  var vr = B.__private__.getHorizontalCoordinate = function(l) {
    return H(l);
  }, Sr = B.__private__.getVerticalCoordinate = function(l) {
    return R === x.ADVANCED ? l : JA[_].mediaBox.topRightY - JA[_].mediaBox.bottomLeftY - H(l);
  }, tu = B.__private__.getHorizontalCoordinateString = B.getHorizontalCoordinateString = function(l) {
    return J(vr(l));
  }, qr = B.__private__.getVerticalCoordinateString = B.getVerticalCoordinateString = function(l) {
    return J(Sr(l));
  }, er = t.strokeColor || "0 G";
  B.__private__.getStrokeColor = B.getDrawColor = function() {
    return Zt(er);
  }, B.__private__.setStrokeColor = B.setDrawColor = function(l, m, D, G) {
    return er = $t({ ch1: l, ch2: m, ch3: D, ch4: G, pdfColorType: "draw", precision: 2 }), P(er), this;
  };
  var Vi = t.fillColor || "0 g";
  B.__private__.getFillColor = B.getFillColor = function() {
    return Zt(Vi);
  }, B.__private__.setFillColor = B.setFillColor = function(l, m, D, G) {
    return Vi = $t({ ch1: l, ch2: m, ch3: D, ch4: G, pdfColorType: "fill", precision: 2 }), P(Vi), this;
  };
  var yn = t.textColor || "0 g", ru = B.__private__.getTextColor = B.getTextColor = function() {
    return Zt(yn);
  };
  B.__private__.setTextColor = B.setTextColor = function(l, m, D, G) {
    return yn = $t({ ch1: l, ch2: m, ch3: D, ch4: G, pdfColorType: "text", precision: 3 }), this;
  };
  var Ai = t.charSpace, nu = B.__private__.getCharSpace = B.getCharSpace = function() {
    return parseFloat(Ai || 0);
  };
  B.__private__.setCharSpace = B.setCharSpace = function(l) {
    if (isNaN(l)) throw new Error("Invalid argument passed to jsPDF.setCharSpace");
    return Ai = l, this;
  };
  var qi = 0;
  B.CapJoinStyles = { 0: 0, butt: 0, but: 0, miter: 0, 1: 1, round: 1, rounded: 1, circle: 1, 2: 2, projecting: 2, project: 2, square: 2, bevel: 2 }, B.__private__.setLineCap = B.setLineCap = function(l) {
    var m = B.CapJoinStyles[l];
    if (m === void 0) throw new Error("Line cap style of '" + l + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
    return qi = m, P(m + " J"), this;
  };
  var Wi = 0;
  B.__private__.setLineJoin = B.setLineJoin = function(l) {
    var m = B.CapJoinStyles[l];
    if (m === void 0) throw new Error("Line join style of '" + l + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
    return Wi = m, P(m + " j"), this;
  }, B.__private__.setLineMiterLimit = B.__private__.setMiterLimit = B.setLineMiterLimit = B.setMiterLimit = function(l) {
    if (l = l || 0, isNaN(l)) throw new Error("Invalid argument passed to jsPDF.setLineMiterLimit");
    return P(J(H(l)) + " M"), this;
  }, B.GState = Co, B.setGState = function(l) {
    (l = typeof l == "string" ? xe[Jt[l]] : ts(null, l)).equals(Ir) || (P("/" + l.id + " gs"), Ir = l);
  };
  var ts = function(l, m) {
    if (!l || !Jt[l]) {
      var D = !1;
      for (var G in xe) if (xe.hasOwnProperty(G) && xe[G].equals(m)) {
        D = !0;
        break;
      }
      if (D) m = xe[G];
      else {
        var AA = "GS" + (Object.keys(xe).length + 1).toString(10);
        xe[AA] = m, m.id = AA;
      }
      return l && (Jt[l] = m.id), fe.publish("addGState", m), m;
    }
  };
  B.addGState = function(l, m) {
    return ts(l, m), this;
  }, B.saveGraphicsState = function() {
    return P("q"), fr.push({ key: re, size: yA, color: yn }), this;
  }, B.restoreGraphicsState = function() {
    P("Q");
    var l = fr.pop();
    return re = l.key, yA = l.size, yn = l.color, Ir = null, this;
  }, B.setCurrentTransformationMatrix = function(l) {
    return P(l.toString() + " cm"), this;
  }, B.comment = function(l) {
    return P("#" + l), this;
  };
  var ei = function(l, m) {
    var D = l || 0;
    Object.defineProperty(this, "x", { enumerable: !0, get: function() {
      return D;
    }, set: function(BA) {
      isNaN(BA) || (D = parseFloat(BA));
    } });
    var G = m || 0;
    Object.defineProperty(this, "y", { enumerable: !0, get: function() {
      return G;
    }, set: function(BA) {
      isNaN(BA) || (G = parseFloat(BA));
    } });
    var AA = "pt";
    return Object.defineProperty(this, "type", { enumerable: !0, get: function() {
      return AA;
    }, set: function(BA) {
      AA = BA.toString();
    } }), this;
  }, Xi = function(l, m, D, G) {
    ei.call(this, l, m), this.type = "rect";
    var AA = D || 0;
    Object.defineProperty(this, "w", { enumerable: !0, get: function() {
      return AA;
    }, set: function(mA) {
      isNaN(mA) || (AA = parseFloat(mA));
    } });
    var BA = G || 0;
    return Object.defineProperty(this, "h", { enumerable: !0, get: function() {
      return BA;
    }, set: function(mA) {
      isNaN(mA) || (BA = parseFloat(mA));
    } }), this;
  }, Ji = function() {
    this.page = He, this.currentPage = _, this.pages = QA.slice(0), this.pagesContext = JA.slice(0), this.x = st, this.y = ue, this.matrix = Xt, this.width = bn(_), this.height = Wr(_), this.outputDestination = LA, this.id = "", this.objectNumber = -1;
  };
  Ji.prototype.restore = function() {
    He = this.page, _ = this.currentPage, JA = this.pagesContext, QA = this.pages, st = this.x, ue = this.y, Xt = this.matrix, zi(_, this.width), Yi(_, this.height), LA = this.outputDestination;
  };
  var rs = function(l, m, D, G, AA) {
    Br.push(new Ji()), He = _ = 0, QA = [], st = l, ue = m, Xt = AA, Ki([D, G]);
  }, iu = function(l) {
    if (hr[l]) Br.pop().restore();
    else {
      var m = new Ji(), D = "Xo" + (Object.keys(tt).length + 1).toString(10);
      m.id = D, hr[l] = D, tt[D] = m, fe.publish("addFormObject", m), Br.pop().restore();
    }
  };
  for (var ti in B.beginFormObject = function(l, m, D, G, AA) {
    return rs(l, m, D, G, AA), this;
  }, B.endFormObject = function(l) {
    return iu(l), this;
  }, B.doFormObject = function(l, m) {
    var D = tt[hr[l]];
    return P("q"), P(m.toString() + " cm"), P("/" + D.id + " Do"), P("Q"), this;
  }, B.getFormObject = function(l) {
    var m = tt[hr[l]];
    return { x: m.x, y: m.y, width: m.width, height: m.height, matrix: m.matrix };
  }, B.save = function(l, m) {
    return l = l || "generated.pdf", (m = m || {}).returnPromise = m.returnPromise || !1, m.returnPromise === !1 ? (_n(zn(Hr()), l), typeof _n.unload == "function" && VA.setTimeout && setTimeout(_n.unload, 911), this) : new Promise(function(D, G) {
      try {
        var AA = _n(zn(Hr()), l);
        typeof _n.unload == "function" && VA.setTimeout && setTimeout(_n.unload, 911), D(AA);
      } catch (BA) {
        G(BA.message);
      }
    });
  }, GA.API) GA.API.hasOwnProperty(ti) && (ti === "events" && GA.API.events.length ? function(l, m) {
    var D, G, AA;
    for (AA = m.length - 1; AA !== -1; AA--) D = m[AA][0], G = m[AA][1], l.subscribe.apply(l, [D].concat(typeof G == "function" ? [G] : G));
  }(fe, GA.API.events) : B[ti] = GA.API[ti]);
  var bn = B.getPageWidth = function(l) {
    return (JA[l = l || _].mediaBox.topRightX - JA[l].mediaBox.bottomLeftX) / SA;
  }, zi = B.setPageWidth = function(l, m) {
    JA[l].mediaBox.topRightX = m * SA + JA[l].mediaBox.bottomLeftX;
  }, Wr = B.getPageHeight = function(l) {
    return (JA[l = l || _].mediaBox.topRightY - JA[l].mediaBox.bottomLeftY) / SA;
  }, Yi = B.setPageHeight = function(l, m) {
    JA[l].mediaBox.topRightY = m * SA + JA[l].mediaBox.bottomLeftY;
  };
  return B.internal = { pdfEscape: Qt, getStyle: za, getFont: eu, getFontSize: IA, getCharSpace: nu, getTextColor: ru, getLineHeight: $a, getLineHeightFactor: es, getLineWidth: $n, write: ZA, getHorizontalCoordinate: vr, getVerticalCoordinate: Sr, getCoordinateString: tu, getVerticalCoordinateString: qr, collections: {}, newObject: Xe, newAdditionalObject: Rn, newObjectDeferred: Ge, newObjectDeferredBegin: It, getFilters: dr, putStream: Tt, events: fe, scaleFactor: SA, pageSize: { getWidth: function() {
    return bn(_);
  }, setWidth: function(l) {
    zi(_, l);
  }, getHeight: function() {
    return Wr(_);
  }, setHeight: function(l) {
    Yi(_, l);
  } }, encryptionOptions: g, encryption: ot, getEncryptor: Jo, output: Yn, getNumberOfPages: jo, pages: QA, out: P, f2: cA, f3: I, getPageInfo: Ja, getPageInfoByObjId: WA, getCurrentPageInfo: zo, getPDFVersion: y, Point: ei, Rectangle: Xi, Matrix: RA, hasHotfix: Xa }, Object.defineProperty(B.internal.pageSize, "width", { get: function() {
    return bn(_);
  }, set: function(l) {
    zi(_, l);
  }, enumerable: !0, configurable: !0 }), Object.defineProperty(B.internal.pageSize, "height", { get: function() {
    return Wr(_);
  }, set: function(l) {
    Yi(_, l);
  }, enumerable: !0, configurable: !0 }), Ro.call(B, CA), re = "F1", Va(n, e), fe.publish("initialized"), B;
}
Li.prototype.lsbFirstWord = function(t) {
  return String.fromCharCode(t >> 0 & 255, t >> 8 & 255, t >> 16 & 255, t >> 24 & 255);
}, Li.prototype.toHexString = function(t) {
  return t.split("").map(function(A) {
    return ("0" + (255 & A.charCodeAt(0)).toString(16)).slice(-2);
  }).join("");
}, Li.prototype.hexToBytes = function(t) {
  for (var A = [], e = 0; e < t.length; e += 2) A.push(String.fromCharCode(parseInt(t.substr(e, 2), 16)));
  return A.join("");
}, Li.prototype.processOwnerPassword = function(t, A) {
  return xc(Ic(A).substr(0, 5), t);
}, Li.prototype.encryptor = function(t, A) {
  var e = Ic(this.encryptionKey + String.fromCharCode(255 & t, t >> 8 & 255, t >> 16 & 255, 255 & A, A >> 8 & 255)).substr(0, 10);
  return function(r) {
    return xc(e, r);
  };
}, Co.prototype.equals = function(t) {
  var A, e = "id,objectNumber,equals";
  if (!t || de(t) !== de(this)) return !1;
  var r = 0;
  for (A in this) if (!(e.indexOf(A) >= 0)) {
    if (this.hasOwnProperty(A) && !t.hasOwnProperty(A) || this[A] !== t[A]) return !1;
    r++;
  }
  for (A in t) t.hasOwnProperty(A) && e.indexOf(A) < 0 && r--;
  return r === 0;
}, GA.API = { events: [] }, GA.version = "3.0.1";
var _e = GA.API, Gc = 1, kn = function(t) {
  return t.replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
}, Fi = function(t) {
  return t.replace(/\\\\/g, "\\").replace(/\\\(/g, "(").replace(/\\\)/g, ")");
}, YA = function(t) {
  return t.toFixed(2);
}, sn = function(t) {
  return t.toFixed(5);
};
_e.__acroform__ = {};
var Et = function(t, A) {
  t.prototype = Object.create(A.prototype), t.prototype.constructor = t;
}, Uf = function(t) {
  return t * Gc;
}, Fr = function(t) {
  var A = new AB(), e = OA.internal.getHeight(t) || 0, r = OA.internal.getWidth(t) || 0;
  return A.BBox = [0, 0, Number(YA(r)), Number(YA(e))], A;
}, Dp = _e.__acroform__.setBit = function(t, A) {
  if (t = t || 0, A = A || 0, isNaN(t) || isNaN(A)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBit");
  return t |= 1 << A;
}, Tp = _e.__acroform__.clearBit = function(t, A) {
  if (t = t || 0, A = A || 0, isNaN(t) || isNaN(A)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBit");
  return t &= ~(1 << A);
}, Op = _e.__acroform__.getBit = function(t, A) {
  if (isNaN(t) || isNaN(A)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBit");
  return (t & 1 << A) == 0 ? 0 : 1;
}, Ke = _e.__acroform__.getBitForPdf = function(t, A) {
  if (isNaN(t) || isNaN(A)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBitForPdf");
  return Op(t, A - 1);
}, ke = _e.__acroform__.setBitForPdf = function(t, A) {
  if (isNaN(t) || isNaN(A)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBitForPdf");
  return Dp(t, A - 1);
}, Re = _e.__acroform__.clearBitForPdf = function(t, A) {
  if (isNaN(t) || isNaN(A)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBitForPdf");
  return Tp(t, A - 1);
}, Pp = _e.__acroform__.calculateCoordinates = function(t, A) {
  var e = A.internal.getHorizontalCoordinate, r = A.internal.getVerticalCoordinate, n = t[0], i = t[1], s = t[2], u = t[3], c = {};
  return c.lowerLeft_X = e(n) || 0, c.lowerLeft_Y = r(i + u) || 0, c.upperRight_X = e(n + s) || 0, c.upperRight_Y = r(i) || 0, [Number(YA(c.lowerLeft_X)), Number(YA(c.lowerLeft_Y)), Number(YA(c.upperRight_X)), Number(YA(c.upperRight_Y))];
}, Mp = function(t) {
  if (t.appearanceStreamContent) return t.appearanceStreamContent;
  if (t.V || t.DV) {
    var A = [], e = t._V || t.DV, r = Hc(t, e), n = t.scope.internal.getFont(t.fontName, t.fontStyle).id;
    A.push("/Tx BMC"), A.push("q"), A.push("BT"), A.push(t.scope.__private__.encodeColorString(t.color)), A.push("/" + n + " " + YA(r.fontSize) + " Tf"), A.push("1 0 0 1 0 0 Tm"), A.push(r.text), A.push("ET"), A.push("Q"), A.push("EMC");
    var i = Fr(t);
    return i.scope = t.scope, i.stream = A.join(`
`), i;
  }
}, Hc = function(t, A) {
  var e = t.fontSize === 0 ? t.maxFontSize : t.fontSize, r = { text: "", fontSize: "" }, n = (A = (A = A.substr(0, 1) == "(" ? A.substr(1) : A).substr(A.length - 1) == ")" ? A.substr(0, A.length - 1) : A).split(" ");
  n = t.multiline ? n.map(function(I) {
    return I.split(`
`);
  }) : n.map(function(I) {
    return [I];
  });
  var i = e, s = OA.internal.getHeight(t) || 0;
  s = s < 0 ? -s : s;
  var u = OA.internal.getWidth(t) || 0;
  u = u < 0 ? -u : u;
  var c = function(I, H, K) {
    if (I + 1 < n.length) {
      var M = H + " " + n[I + 1][0];
      return $s(M, t, K).width <= u - 4;
    }
    return !1;
  };
  i++;
  A: for (; i > 0; ) {
    A = "", i--;
    var h, g, p = $s("3", t, i).height, w = t.multiline ? s - i : (s - p) / 2, B = w += 2, L = 0, y = 0, N = 0;
    if (i <= 0) {
      A = `(...) Tj
`, A += "% Width of Text: " + $s(A, t, i = 12).width + ", FieldWidth:" + u + `
`;
      break;
    }
    for (var F = "", x = 0, R = 0; R < n.length; R++) if (n.hasOwnProperty(R)) {
      var Y = !1;
      if (n[R].length !== 1 && N !== n[R].length - 1) {
        if ((p + 2) * (x + 2) + 2 > s) continue A;
        F += n[R][N], Y = !0, y = R, R--;
      } else {
        F = (F += n[R][N] + " ").substr(F.length - 1) == " " ? F.substr(0, F.length - 1) : F;
        var Z = parseInt(R), $ = c(Z, F, i), J = R >= n.length - 1;
        if ($ && !J) {
          F += " ", N = 0;
          continue;
        }
        if ($ || J) {
          if (J) y = Z;
          else if (t.multiline && (p + 2) * (x + 2) + 2 > s) continue A;
        } else {
          if (!t.multiline || (p + 2) * (x + 2) + 2 > s) continue A;
          y = Z;
        }
      }
      for (var O = "", W = L; W <= y; W++) {
        var cA = n[W];
        if (t.multiline) {
          if (W === y) {
            O += cA[N] + " ", N = (N + 1) % cA.length;
            continue;
          }
          if (W === L) {
            O += cA[cA.length - 1] + " ";
            continue;
          }
        }
        O += cA[0] + " ";
      }
      switch (O = O.substr(O.length - 1) == " " ? O.substr(0, O.length - 1) : O, g = $s(O, t, i).width, t.textAlign) {
        case "right":
          h = u - g - 2;
          break;
        case "center":
          h = (u - g) / 2;
          break;
        case "left":
        default:
          h = 2;
      }
      A += YA(h) + " " + YA(B) + ` Td
`, A += "(" + kn(O) + `) Tj
`, A += -YA(h) + ` 0 Td
`, B = -(i + 2), g = 0, L = Y ? y : y + 1, x++, F = "";
    }
    break;
  }
  return r.text = A, r.fontSize = i, r;
}, $s = function(t, A, e) {
  var r = A.scope.internal.getFont(A.fontName, A.fontStyle), n = A.scope.getStringUnitWidth(t, { font: r, fontSize: parseFloat(e), charSpace: 0 }) * parseFloat(e);
  return { height: A.scope.getStringUnitWidth("3", { font: r, fontSize: parseFloat(e), charSpace: 0 }) * parseFloat(e) * 1.5, width: n };
}, Kp = { fields: [], xForms: [], acroFormDictionaryRoot: null, printedOut: !1, internal: null, isInitialized: !1 }, kp = function(t, A) {
  var e = { type: "reference", object: t };
  A.internal.getPageInfo(t.page).pageContext.annotations.find(function(r) {
    return r.type === e.type && r.object === e.object;
  }) === void 0 && A.internal.getPageInfo(t.page).pageContext.annotations.push(e);
}, Rp = function(t, A) {
  for (var e in t) if (t.hasOwnProperty(e)) {
    var r = e, n = t[e];
    A.internal.newObjectDeferredBegin(n.objId, !0), de(n) === "object" && typeof n.putStream == "function" && n.putStream(), delete t[r];
  }
}, Gp = function(t, A) {
  if (A.scope = t, t.internal !== void 0 && (t.internal.acroformPlugin === void 0 || t.internal.acroformPlugin.isInitialized === !1)) {
    if (cr.FieldNum = 0, t.internal.acroformPlugin = JSON.parse(JSON.stringify(Kp)), t.internal.acroformPlugin.acroFormDictionaryRoot) throw new Error("Exception while creating AcroformDictionary");
    Gc = t.internal.scaleFactor, t.internal.acroformPlugin.acroFormDictionaryRoot = new eB(), t.internal.acroformPlugin.acroFormDictionaryRoot.scope = t, t.internal.acroformPlugin.acroFormDictionaryRoot._eventID = t.internal.events.subscribe("postPutResources", function() {
      (function(e) {
        e.internal.events.unsubscribe(e.internal.acroformPlugin.acroFormDictionaryRoot._eventID), delete e.internal.acroformPlugin.acroFormDictionaryRoot._eventID, e.internal.acroformPlugin.printedOut = !0;
      })(t);
    }), t.internal.events.subscribe("buildDocument", function() {
      (function(e) {
        e.internal.acroformPlugin.acroFormDictionaryRoot.objId = void 0;
        var r = e.internal.acroformPlugin.acroFormDictionaryRoot.Fields;
        for (var n in r) if (r.hasOwnProperty(n)) {
          var i = r[n];
          i.objId = void 0, i.hasAnnotation && kp(i, e);
        }
      })(t);
    }), t.internal.events.subscribe("putCatalog", function() {
      (function(e) {
        if (e.internal.acroformPlugin.acroFormDictionaryRoot === void 0) throw new Error("putCatalogCallback: Root missing.");
        e.internal.write("/AcroForm " + e.internal.acroformPlugin.acroFormDictionaryRoot.objId + " 0 R");
      })(t);
    }), t.internal.events.subscribe("postPutPages", function(e) {
      (function(r, n) {
        var i = !r;
        for (var s in r || (n.internal.newObjectDeferredBegin(n.internal.acroformPlugin.acroFormDictionaryRoot.objId, !0), n.internal.acroformPlugin.acroFormDictionaryRoot.putStream()), r = r || n.internal.acroformPlugin.acroFormDictionaryRoot.Kids) if (r.hasOwnProperty(s)) {
          var u = r[s], c = [], h = u.Rect;
          if (u.Rect && (u.Rect = Pp(u.Rect, n)), n.internal.newObjectDeferredBegin(u.objId, !0), u.DA = OA.createDefaultAppearanceStream(u), de(u) === "object" && typeof u.getKeyValueListForStream == "function" && (c = u.getKeyValueListForStream()), u.Rect = h, u.hasAppearanceStream && !u.appearanceStreamContent) {
            var g = Mp(u);
            c.push({ key: "AP", value: "<</N " + g + ">>" }), n.internal.acroformPlugin.xForms.push(g);
          }
          if (u.appearanceStreamContent) {
            var p = "";
            for (var w in u.appearanceStreamContent) if (u.appearanceStreamContent.hasOwnProperty(w)) {
              var B = u.appearanceStreamContent[w];
              if (p += "/" + w + " ", p += "<<", Object.keys(B).length >= 1 || Array.isArray(B)) {
                for (var s in B) if (B.hasOwnProperty(s)) {
                  var L = B[s];
                  typeof L == "function" && (L = L.call(n, u)), p += "/" + s + " " + L + " ", n.internal.acroformPlugin.xForms.indexOf(L) >= 0 || n.internal.acroformPlugin.xForms.push(L);
                }
              } else typeof (L = B) == "function" && (L = L.call(n, u)), p += "/" + s + " " + L, n.internal.acroformPlugin.xForms.indexOf(L) >= 0 || n.internal.acroformPlugin.xForms.push(L);
              p += ">>";
            }
            c.push({ key: "AP", value: `<<
` + p + ">>" });
          }
          n.internal.putStream({ additionalKeyValues: c, objectId: u.objId }), n.internal.out("endobj");
        }
        i && Rp(n.internal.acroformPlugin.xForms, n);
      })(e, t);
    }), t.internal.acroformPlugin.isInitialized = !0;
  }
}, $h = _e.__acroform__.arrayToPdfArray = function(t, A, e) {
  var r = function(s) {
    return s;
  };
  if (Array.isArray(t)) {
    for (var n = "[", i = 0; i < t.length; i++) switch (i !== 0 && (n += " "), de(t[i])) {
      case "boolean":
      case "number":
      case "object":
        n += t[i].toString();
        break;
      case "string":
        t[i].substr(0, 1) !== "/" ? (A !== void 0 && e && (r = e.internal.getEncryptor(A)), n += "(" + kn(r(t[i].toString())) + ")") : n += t[i].toString();
    }
    return n += "]";
  }
  throw new Error("Invalid argument passed to jsPDF.__acroform__.arrayToPdfArray");
}, Yu = function(t, A, e) {
  var r = function(n) {
    return n;
  };
  return A !== void 0 && e && (r = e.internal.getEncryptor(A)), (t = t || "").toString(), t = "(" + kn(r(t)) + ")";
}, Ur = function() {
  this._objId = void 0, this._scope = void 0, Object.defineProperty(this, "objId", { get: function() {
    if (this._objId === void 0) {
      if (this.scope === void 0) return;
      this._objId = this.scope.internal.newObjectDeferred();
    }
    return this._objId;
  }, set: function(t) {
    this._objId = t;
  } }), Object.defineProperty(this, "scope", { value: this._scope, writable: !0 });
};
Ur.prototype.toString = function() {
  return this.objId + " 0 R";
}, Ur.prototype.putStream = function() {
  var t = this.getKeyValueListForStream();
  this.scope.internal.putStream({ data: this.stream, additionalKeyValues: t, objectId: this.objId }), this.scope.internal.out("endobj");
}, Ur.prototype.getKeyValueListForStream = function() {
  var t = [], A = Object.getOwnPropertyNames(this).filter(function(i) {
    return i != "content" && i != "appearanceStreamContent" && i != "scope" && i != "objId" && i.substring(0, 1) != "_";
  });
  for (var e in A) if (Object.getOwnPropertyDescriptor(this, A[e]).configurable === !1) {
    var r = A[e], n = this[r];
    n && (Array.isArray(n) ? t.push({ key: r, value: $h(n, this.objId, this.scope) }) : n instanceof Ur ? (n.scope = this.scope, t.push({ key: r, value: n.objId + " 0 R" })) : typeof n != "function" && t.push({ key: r, value: n }));
  }
  return t;
};
var AB = function() {
  Ur.call(this), Object.defineProperty(this, "Type", { value: "/XObject", configurable: !1, writable: !0 }), Object.defineProperty(this, "Subtype", { value: "/Form", configurable: !1, writable: !0 }), Object.defineProperty(this, "FormType", { value: 1, configurable: !1, writable: !0 });
  var t, A = [];
  Object.defineProperty(this, "BBox", { configurable: !1, get: function() {
    return A;
  }, set: function(e) {
    A = e;
  } }), Object.defineProperty(this, "Resources", { value: "2 0 R", configurable: !1, writable: !0 }), Object.defineProperty(this, "stream", { enumerable: !1, configurable: !0, set: function(e) {
    t = e.trim();
  }, get: function() {
    return t || null;
  } });
};
Et(AB, Ur);
var eB = function() {
  Ur.call(this);
  var t, A = [];
  Object.defineProperty(this, "Kids", { enumerable: !1, configurable: !0, get: function() {
    return A.length > 0 ? A : void 0;
  } }), Object.defineProperty(this, "Fields", { enumerable: !1, configurable: !1, get: function() {
    return A;
  } }), Object.defineProperty(this, "DA", { enumerable: !1, configurable: !1, get: function() {
    if (t) {
      var e = function(r) {
        return r;
      };
      return this.scope && (e = this.scope.internal.getEncryptor(this.objId)), "(" + kn(e(t)) + ")";
    }
  }, set: function(e) {
    t = e;
  } });
};
Et(eB, Ur);
var cr = function t() {
  Ur.call(this);
  var A = 4;
  Object.defineProperty(this, "F", { enumerable: !1, configurable: !1, get: function() {
    return A;
  }, set: function(F) {
    if (isNaN(F)) throw new Error('Invalid value "' + F + '" for attribute F supplied.');
    A = F;
  } }), Object.defineProperty(this, "showWhenPrinted", { enumerable: !0, configurable: !0, get: function() {
    return !!Ke(A, 3);
  }, set: function(F) {
    F ? this.F = ke(A, 3) : this.F = Re(A, 3);
  } });
  var e = 0;
  Object.defineProperty(this, "Ff", { enumerable: !1, configurable: !1, get: function() {
    return e;
  }, set: function(F) {
    if (isNaN(F)) throw new Error('Invalid value "' + F + '" for attribute Ff supplied.');
    e = F;
  } });
  var r = [];
  Object.defineProperty(this, "Rect", { enumerable: !1, configurable: !1, get: function() {
    if (r.length !== 0) return r;
  }, set: function(F) {
    r = F !== void 0 ? F : [];
  } }), Object.defineProperty(this, "x", { enumerable: !0, configurable: !0, get: function() {
    return !r || isNaN(r[0]) ? 0 : r[0];
  }, set: function(F) {
    r[0] = F;
  } }), Object.defineProperty(this, "y", { enumerable: !0, configurable: !0, get: function() {
    return !r || isNaN(r[1]) ? 0 : r[1];
  }, set: function(F) {
    r[1] = F;
  } }), Object.defineProperty(this, "width", { enumerable: !0, configurable: !0, get: function() {
    return !r || isNaN(r[2]) ? 0 : r[2];
  }, set: function(F) {
    r[2] = F;
  } }), Object.defineProperty(this, "height", { enumerable: !0, configurable: !0, get: function() {
    return !r || isNaN(r[3]) ? 0 : r[3];
  }, set: function(F) {
    r[3] = F;
  } });
  var n = "";
  Object.defineProperty(this, "FT", { enumerable: !0, configurable: !1, get: function() {
    return n;
  }, set: function(F) {
    switch (F) {
      case "/Btn":
      case "/Tx":
      case "/Ch":
      case "/Sig":
        n = F;
        break;
      default:
        throw new Error('Invalid value "' + F + '" for attribute FT supplied.');
    }
  } });
  var i = null;
  Object.defineProperty(this, "T", { enumerable: !0, configurable: !1, get: function() {
    if (!i || i.length < 1) {
      if (this instanceof Qo) return;
      i = "FieldObject" + t.FieldNum++;
    }
    var F = function(x) {
      return x;
    };
    return this.scope && (F = this.scope.internal.getEncryptor(this.objId)), "(" + kn(F(i)) + ")";
  }, set: function(F) {
    i = F.toString();
  } }), Object.defineProperty(this, "fieldName", { configurable: !0, enumerable: !0, get: function() {
    return i;
  }, set: function(F) {
    i = F;
  } });
  var s = "helvetica";
  Object.defineProperty(this, "fontName", { enumerable: !0, configurable: !0, get: function() {
    return s;
  }, set: function(F) {
    s = F;
  } });
  var u = "normal";
  Object.defineProperty(this, "fontStyle", { enumerable: !0, configurable: !0, get: function() {
    return u;
  }, set: function(F) {
    u = F;
  } });
  var c = 0;
  Object.defineProperty(this, "fontSize", { enumerable: !0, configurable: !0, get: function() {
    return c;
  }, set: function(F) {
    c = F;
  } });
  var h = void 0;
  Object.defineProperty(this, "maxFontSize", { enumerable: !0, configurable: !0, get: function() {
    return h === void 0 ? 50 / Gc : h;
  }, set: function(F) {
    h = F;
  } });
  var g = "black";
  Object.defineProperty(this, "color", { enumerable: !0, configurable: !0, get: function() {
    return g;
  }, set: function(F) {
    g = F;
  } });
  var p = "/F1 0 Tf 0 g";
  Object.defineProperty(this, "DA", { enumerable: !0, configurable: !1, get: function() {
    if (!(!p || this instanceof Qo || this instanceof Kn)) return Yu(p, this.objId, this.scope);
  }, set: function(F) {
    F = F.toString(), p = F;
  } });
  var w = null;
  Object.defineProperty(this, "DV", { enumerable: !1, configurable: !1, get: function() {
    if (w) return this instanceof et ? w : Yu(w, this.objId, this.scope);
  }, set: function(F) {
    F = F.toString(), w = this instanceof et ? F : F.substr(0, 1) === "(" ? Fi(F.substr(1, F.length - 2)) : Fi(F);
  } }), Object.defineProperty(this, "defaultValue", { enumerable: !0, configurable: !0, get: function() {
    return this instanceof et ? Fi(w.substr(1, w.length - 1)) : w;
  }, set: function(F) {
    F = F.toString(), w = this instanceof et ? "/" + F : F;
  } });
  var B = null;
  Object.defineProperty(this, "_V", { enumerable: !1, configurable: !1, get: function() {
    if (B) return B;
  }, set: function(F) {
    this.V = F;
  } }), Object.defineProperty(this, "V", { enumerable: !1, configurable: !1, get: function() {
    if (B) return this instanceof et ? B : Yu(B, this.objId, this.scope);
  }, set: function(F) {
    F = F.toString(), B = this instanceof et ? F : F.substr(0, 1) === "(" ? Fi(F.substr(1, F.length - 2)) : Fi(F);
  } }), Object.defineProperty(this, "value", { enumerable: !0, configurable: !0, get: function() {
    return this instanceof et ? Fi(B.substr(1, B.length - 1)) : B;
  }, set: function(F) {
    F = F.toString(), B = this instanceof et ? "/" + F : F;
  } }), Object.defineProperty(this, "hasAnnotation", { enumerable: !0, configurable: !0, get: function() {
    return this.Rect;
  } }), Object.defineProperty(this, "Type", { enumerable: !0, configurable: !1, get: function() {
    return this.hasAnnotation ? "/Annot" : null;
  } }), Object.defineProperty(this, "Subtype", { enumerable: !0, configurable: !1, get: function() {
    return this.hasAnnotation ? "/Widget" : null;
  } });
  var L, y = !1;
  Object.defineProperty(this, "hasAppearanceStream", { enumerable: !0, configurable: !0, get: function() {
    return y;
  }, set: function(F) {
    F = !!F, y = F;
  } }), Object.defineProperty(this, "page", { enumerable: !0, configurable: !0, get: function() {
    if (L) return L;
  }, set: function(F) {
    L = F;
  } }), Object.defineProperty(this, "readOnly", { enumerable: !0, configurable: !0, get: function() {
    return !!Ke(this.Ff, 1);
  }, set: function(F) {
    F ? this.Ff = ke(this.Ff, 1) : this.Ff = Re(this.Ff, 1);
  } }), Object.defineProperty(this, "required", { enumerable: !0, configurable: !0, get: function() {
    return !!Ke(this.Ff, 2);
  }, set: function(F) {
    F ? this.Ff = ke(this.Ff, 2) : this.Ff = Re(this.Ff, 2);
  } }), Object.defineProperty(this, "noExport", { enumerable: !0, configurable: !0, get: function() {
    return !!Ke(this.Ff, 3);
  }, set: function(F) {
    F ? this.Ff = ke(this.Ff, 3) : this.Ff = Re(this.Ff, 3);
  } });
  var N = null;
  Object.defineProperty(this, "Q", { enumerable: !0, configurable: !1, get: function() {
    if (N !== null) return N;
  }, set: function(F) {
    if ([0, 1, 2].indexOf(F) === -1) throw new Error('Invalid value "' + F + '" for attribute Q supplied.');
    N = F;
  } }), Object.defineProperty(this, "textAlign", { get: function() {
    var F;
    switch (N) {
      case 0:
      default:
        F = "left";
        break;
      case 1:
        F = "center";
        break;
      case 2:
        F = "right";
    }
    return F;
  }, configurable: !0, enumerable: !0, set: function(F) {
    switch (F) {
      case "right":
      case 2:
        N = 2;
        break;
      case "center":
      case 1:
        N = 1;
        break;
      case "left":
      case 0:
      default:
        N = 0;
    }
  } });
};
Et(cr, Ur);
var Si = function() {
  cr.call(this), this.FT = "/Ch", this.V = "()", this.fontName = "zapfdingbats";
  var t = 0;
  Object.defineProperty(this, "TI", { enumerable: !0, configurable: !1, get: function() {
    return t;
  }, set: function(e) {
    t = e;
  } }), Object.defineProperty(this, "topIndex", { enumerable: !0, configurable: !0, get: function() {
    return t;
  }, set: function(e) {
    t = e;
  } });
  var A = [];
  Object.defineProperty(this, "Opt", { enumerable: !0, configurable: !1, get: function() {
    return $h(A, this.objId, this.scope);
  }, set: function(e) {
    var r, n;
    n = [], typeof (r = e) == "string" && (n = function(i, s, u) {
      u || (u = 1);
      for (var c, h = []; c = s.exec(i); ) h.push(c[u]);
      return h;
    }(r, /\((.*?)\)/g)), A = n;
  } }), this.getOptions = function() {
    return A;
  }, this.setOptions = function(e) {
    A = e, this.sort && A.sort();
  }, this.addOption = function(e) {
    e = (e = e || "").toString(), A.push(e), this.sort && A.sort();
  }, this.removeOption = function(e, r) {
    for (r = r || !1, e = (e = e || "").toString(); A.indexOf(e) !== -1 && (A.splice(A.indexOf(e), 1), r !== !1); ) ;
  }, Object.defineProperty(this, "combo", { enumerable: !0, configurable: !0, get: function() {
    return !!Ke(this.Ff, 18);
  }, set: function(e) {
    e ? this.Ff = ke(this.Ff, 18) : this.Ff = Re(this.Ff, 18);
  } }), Object.defineProperty(this, "edit", { enumerable: !0, configurable: !0, get: function() {
    return !!Ke(this.Ff, 19);
  }, set: function(e) {
    this.combo === !0 && (e ? this.Ff = ke(this.Ff, 19) : this.Ff = Re(this.Ff, 19));
  } }), Object.defineProperty(this, "sort", { enumerable: !0, configurable: !0, get: function() {
    return !!Ke(this.Ff, 20);
  }, set: function(e) {
    e ? (this.Ff = ke(this.Ff, 20), A.sort()) : this.Ff = Re(this.Ff, 20);
  } }), Object.defineProperty(this, "multiSelect", { enumerable: !0, configurable: !0, get: function() {
    return !!Ke(this.Ff, 22);
  }, set: function(e) {
    e ? this.Ff = ke(this.Ff, 22) : this.Ff = Re(this.Ff, 22);
  } }), Object.defineProperty(this, "doNotSpellCheck", { enumerable: !0, configurable: !0, get: function() {
    return !!Ke(this.Ff, 23);
  }, set: function(e) {
    e ? this.Ff = ke(this.Ff, 23) : this.Ff = Re(this.Ff, 23);
  } }), Object.defineProperty(this, "commitOnSelChange", { enumerable: !0, configurable: !0, get: function() {
    return !!Ke(this.Ff, 27);
  }, set: function(e) {
    e ? this.Ff = ke(this.Ff, 27) : this.Ff = Re(this.Ff, 27);
  } }), this.hasAppearanceStream = !1;
};
Et(Si, cr);
var Ni = function() {
  Si.call(this), this.fontName = "helvetica", this.combo = !1;
};
Et(Ni, Si);
var _i = function() {
  Ni.call(this), this.combo = !0;
};
Et(_i, Ni);
var ao = function() {
  _i.call(this), this.edit = !0;
};
Et(ao, _i);
var et = function() {
  cr.call(this), this.FT = "/Btn", Object.defineProperty(this, "noToggleToOff", { enumerable: !0, configurable: !0, get: function() {
    return !!Ke(this.Ff, 15);
  }, set: function(e) {
    e ? this.Ff = ke(this.Ff, 15) : this.Ff = Re(this.Ff, 15);
  } }), Object.defineProperty(this, "radio", { enumerable: !0, configurable: !0, get: function() {
    return !!Ke(this.Ff, 16);
  }, set: function(e) {
    e ? this.Ff = ke(this.Ff, 16) : this.Ff = Re(this.Ff, 16);
  } }), Object.defineProperty(this, "pushButton", { enumerable: !0, configurable: !0, get: function() {
    return !!Ke(this.Ff, 17);
  }, set: function(e) {
    e ? this.Ff = ke(this.Ff, 17) : this.Ff = Re(this.Ff, 17);
  } }), Object.defineProperty(this, "radioIsUnison", { enumerable: !0, configurable: !0, get: function() {
    return !!Ke(this.Ff, 26);
  }, set: function(e) {
    e ? this.Ff = ke(this.Ff, 26) : this.Ff = Re(this.Ff, 26);
  } });
  var t, A = {};
  Object.defineProperty(this, "MK", { enumerable: !1, configurable: !1, get: function() {
    var e = function(i) {
      return i;
    };
    if (this.scope && (e = this.scope.internal.getEncryptor(this.objId)), Object.keys(A).length !== 0) {
      var r, n = [];
      for (r in n.push("<<"), A) n.push("/" + r + " (" + kn(e(A[r])) + ")");
      return n.push(">>"), n.join(`
`);
    }
  }, set: function(e) {
    de(e) === "object" && (A = e);
  } }), Object.defineProperty(this, "caption", { enumerable: !0, configurable: !0, get: function() {
    return A.CA || "";
  }, set: function(e) {
    typeof e == "string" && (A.CA = e);
  } }), Object.defineProperty(this, "AS", { enumerable: !1, configurable: !1, get: function() {
    return t;
  }, set: function(e) {
    t = e;
  } }), Object.defineProperty(this, "appearanceState", { enumerable: !0, configurable: !0, get: function() {
    return t.substr(1, t.length - 1);
  }, set: function(e) {
    t = "/" + e;
  } });
};
Et(et, cr);
var so = function() {
  et.call(this), this.pushButton = !0;
};
Et(so, et);
var Di = function() {
  et.call(this), this.radio = !0, this.pushButton = !1;
  var t = [];
  Object.defineProperty(this, "Kids", { enumerable: !0, configurable: !1, get: function() {
    return t;
  }, set: function(A) {
    t = A !== void 0 ? A : [];
  } });
};
Et(Di, et);
var Qo = function() {
  var t, A;
  cr.call(this), Object.defineProperty(this, "Parent", { enumerable: !1, configurable: !1, get: function() {
    return t;
  }, set: function(n) {
    t = n;
  } }), Object.defineProperty(this, "optionName", { enumerable: !1, configurable: !0, get: function() {
    return A;
  }, set: function(n) {
    A = n;
  } });
  var e, r = {};
  Object.defineProperty(this, "MK", { enumerable: !1, configurable: !1, get: function() {
    var n = function(u) {
      return u;
    };
    this.scope && (n = this.scope.internal.getEncryptor(this.objId));
    var i, s = [];
    for (i in s.push("<<"), r) s.push("/" + i + " (" + kn(n(r[i])) + ")");
    return s.push(">>"), s.join(`
`);
  }, set: function(n) {
    de(n) === "object" && (r = n);
  } }), Object.defineProperty(this, "caption", { enumerable: !0, configurable: !0, get: function() {
    return r.CA || "";
  }, set: function(n) {
    typeof n == "string" && (r.CA = n);
  } }), Object.defineProperty(this, "AS", { enumerable: !1, configurable: !1, get: function() {
    return e;
  }, set: function(n) {
    e = n;
  } }), Object.defineProperty(this, "appearanceState", { enumerable: !0, configurable: !0, get: function() {
    return e.substr(1, e.length - 1);
  }, set: function(n) {
    e = "/" + n;
  } }), this.caption = "l", this.appearanceState = "Off", this._AppearanceType = OA.RadioButton.Circle, this.appearanceStreamContent = this._AppearanceType.createAppearanceStream(this.optionName);
};
Et(Qo, cr), Di.prototype.setAppearance = function(t) {
  if (!("createAppearanceStream" in t) || !("getCA" in t)) throw new Error("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");
  for (var A in this.Kids) if (this.Kids.hasOwnProperty(A)) {
    var e = this.Kids[A];
    e.appearanceStreamContent = t.createAppearanceStream(e.optionName), e.caption = t.getCA();
  }
}, Di.prototype.createOption = function(t) {
  var A = new Qo();
  return A.Parent = this, A.optionName = t, this.Kids.push(A), jp.call(this.scope, A), A;
};
var oo = function() {
  et.call(this), this.fontName = "zapfdingbats", this.caption = "3", this.appearanceState = "On", this.value = "On", this.textAlign = "center", this.appearanceStreamContent = OA.CheckBox.createAppearanceStream();
};
Et(oo, et);
var Kn = function() {
  cr.call(this), this.FT = "/Tx", Object.defineProperty(this, "multiline", { enumerable: !0, configurable: !0, get: function() {
    return !!Ke(this.Ff, 13);
  }, set: function(A) {
    A ? this.Ff = ke(this.Ff, 13) : this.Ff = Re(this.Ff, 13);
  } }), Object.defineProperty(this, "fileSelect", { enumerable: !0, configurable: !0, get: function() {
    return !!Ke(this.Ff, 21);
  }, set: function(A) {
    A ? this.Ff = ke(this.Ff, 21) : this.Ff = Re(this.Ff, 21);
  } }), Object.defineProperty(this, "doNotSpellCheck", { enumerable: !0, configurable: !0, get: function() {
    return !!Ke(this.Ff, 23);
  }, set: function(A) {
    A ? this.Ff = ke(this.Ff, 23) : this.Ff = Re(this.Ff, 23);
  } }), Object.defineProperty(this, "doNotScroll", { enumerable: !0, configurable: !0, get: function() {
    return !!Ke(this.Ff, 24);
  }, set: function(A) {
    A ? this.Ff = ke(this.Ff, 24) : this.Ff = Re(this.Ff, 24);
  } }), Object.defineProperty(this, "comb", { enumerable: !0, configurable: !0, get: function() {
    return !!Ke(this.Ff, 25);
  }, set: function(A) {
    A ? this.Ff = ke(this.Ff, 25) : this.Ff = Re(this.Ff, 25);
  } }), Object.defineProperty(this, "richText", { enumerable: !0, configurable: !0, get: function() {
    return !!Ke(this.Ff, 26);
  }, set: function(A) {
    A ? this.Ff = ke(this.Ff, 26) : this.Ff = Re(this.Ff, 26);
  } });
  var t = null;
  Object.defineProperty(this, "MaxLen", { enumerable: !0, configurable: !1, get: function() {
    return t;
  }, set: function(A) {
    t = A;
  } }), Object.defineProperty(this, "maxLength", { enumerable: !0, configurable: !0, get: function() {
    return t;
  }, set: function(A) {
    Number.isInteger(A) && (t = A);
  } }), Object.defineProperty(this, "hasAppearanceStream", { enumerable: !0, configurable: !0, get: function() {
    return this.V || this.DV;
  } });
};
Et(Kn, cr);
var uo = function() {
  Kn.call(this), Object.defineProperty(this, "password", { enumerable: !0, configurable: !0, get: function() {
    return !!Ke(this.Ff, 14);
  }, set: function(t) {
    t ? this.Ff = ke(this.Ff, 14) : this.Ff = Re(this.Ff, 14);
  } }), this.password = !0;
};
Et(uo, Kn);
var OA = { CheckBox: { createAppearanceStream: function() {
  return { N: { On: OA.CheckBox.YesNormal }, D: { On: OA.CheckBox.YesPushDown, Off: OA.CheckBox.OffPushDown } };
}, YesPushDown: function(t) {
  var A = Fr(t);
  A.scope = t.scope;
  var e = [], r = t.scope.internal.getFont(t.fontName, t.fontStyle).id, n = t.scope.__private__.encodeColorString(t.color), i = Hc(t, t.caption);
  return e.push("0.749023 g"), e.push("0 0 " + YA(OA.internal.getWidth(t)) + " " + YA(OA.internal.getHeight(t)) + " re"), e.push("f"), e.push("BMC"), e.push("q"), e.push("0 0 1 rg"), e.push("/" + r + " " + YA(i.fontSize) + " Tf " + n), e.push("BT"), e.push(i.text), e.push("ET"), e.push("Q"), e.push("EMC"), A.stream = e.join(`
`), A;
}, YesNormal: function(t) {
  var A = Fr(t);
  A.scope = t.scope;
  var e = t.scope.internal.getFont(t.fontName, t.fontStyle).id, r = t.scope.__private__.encodeColorString(t.color), n = [], i = OA.internal.getHeight(t), s = OA.internal.getWidth(t), u = Hc(t, t.caption);
  return n.push("1 g"), n.push("0 0 " + YA(s) + " " + YA(i) + " re"), n.push("f"), n.push("q"), n.push("0 0 1 rg"), n.push("0 0 " + YA(s - 1) + " " + YA(i - 1) + " re"), n.push("W"), n.push("n"), n.push("0 g"), n.push("BT"), n.push("/" + e + " " + YA(u.fontSize) + " Tf " + r), n.push(u.text), n.push("ET"), n.push("Q"), A.stream = n.join(`
`), A;
}, OffPushDown: function(t) {
  var A = Fr(t);
  A.scope = t.scope;
  var e = [];
  return e.push("0.749023 g"), e.push("0 0 " + YA(OA.internal.getWidth(t)) + " " + YA(OA.internal.getHeight(t)) + " re"), e.push("f"), A.stream = e.join(`
`), A;
} }, RadioButton: { Circle: { createAppearanceStream: function(t) {
  var A = { D: { Off: OA.RadioButton.Circle.OffPushDown }, N: {} };
  return A.N[t] = OA.RadioButton.Circle.YesNormal, A.D[t] = OA.RadioButton.Circle.YesPushDown, A;
}, getCA: function() {
  return "l";
}, YesNormal: function(t) {
  var A = Fr(t);
  A.scope = t.scope;
  var e = [], r = OA.internal.getWidth(t) <= OA.internal.getHeight(t) ? OA.internal.getWidth(t) / 4 : OA.internal.getHeight(t) / 4;
  r = Number((0.9 * r).toFixed(5));
  var n = OA.internal.Bezier_C, i = Number((r * n).toFixed(5));
  return e.push("q"), e.push("1 0 0 1 " + sn(OA.internal.getWidth(t) / 2) + " " + sn(OA.internal.getHeight(t) / 2) + " cm"), e.push(r + " 0 m"), e.push(r + " " + i + " " + i + " " + r + " 0 " + r + " c"), e.push("-" + i + " " + r + " -" + r + " " + i + " -" + r + " 0 c"), e.push("-" + r + " -" + i + " -" + i + " -" + r + " 0 -" + r + " c"), e.push(i + " -" + r + " " + r + " -" + i + " " + r + " 0 c"), e.push("f"), e.push("Q"), A.stream = e.join(`
`), A;
}, YesPushDown: function(t) {
  var A = Fr(t);
  A.scope = t.scope;
  var e = [], r = OA.internal.getWidth(t) <= OA.internal.getHeight(t) ? OA.internal.getWidth(t) / 4 : OA.internal.getHeight(t) / 4;
  r = Number((0.9 * r).toFixed(5));
  var n = Number((2 * r).toFixed(5)), i = Number((n * OA.internal.Bezier_C).toFixed(5)), s = Number((r * OA.internal.Bezier_C).toFixed(5));
  return e.push("0.749023 g"), e.push("q"), e.push("1 0 0 1 " + sn(OA.internal.getWidth(t) / 2) + " " + sn(OA.internal.getHeight(t) / 2) + " cm"), e.push(n + " 0 m"), e.push(n + " " + i + " " + i + " " + n + " 0 " + n + " c"), e.push("-" + i + " " + n + " -" + n + " " + i + " -" + n + " 0 c"), e.push("-" + n + " -" + i + " -" + i + " -" + n + " 0 -" + n + " c"), e.push(i + " -" + n + " " + n + " -" + i + " " + n + " 0 c"), e.push("f"), e.push("Q"), e.push("0 g"), e.push("q"), e.push("1 0 0 1 " + sn(OA.internal.getWidth(t) / 2) + " " + sn(OA.internal.getHeight(t) / 2) + " cm"), e.push(r + " 0 m"), e.push(r + " " + s + " " + s + " " + r + " 0 " + r + " c"), e.push("-" + s + " " + r + " -" + r + " " + s + " -" + r + " 0 c"), e.push("-" + r + " -" + s + " -" + s + " -" + r + " 0 -" + r + " c"), e.push(s + " -" + r + " " + r + " -" + s + " " + r + " 0 c"), e.push("f"), e.push("Q"), A.stream = e.join(`
`), A;
}, OffPushDown: function(t) {
  var A = Fr(t);
  A.scope = t.scope;
  var e = [], r = OA.internal.getWidth(t) <= OA.internal.getHeight(t) ? OA.internal.getWidth(t) / 4 : OA.internal.getHeight(t) / 4;
  r = Number((0.9 * r).toFixed(5));
  var n = Number((2 * r).toFixed(5)), i = Number((n * OA.internal.Bezier_C).toFixed(5));
  return e.push("0.749023 g"), e.push("q"), e.push("1 0 0 1 " + sn(OA.internal.getWidth(t) / 2) + " " + sn(OA.internal.getHeight(t) / 2) + " cm"), e.push(n + " 0 m"), e.push(n + " " + i + " " + i + " " + n + " 0 " + n + " c"), e.push("-" + i + " " + n + " -" + n + " " + i + " -" + n + " 0 c"), e.push("-" + n + " -" + i + " -" + i + " -" + n + " 0 -" + n + " c"), e.push(i + " -" + n + " " + n + " -" + i + " " + n + " 0 c"), e.push("f"), e.push("Q"), A.stream = e.join(`
`), A;
} }, Cross: { createAppearanceStream: function(t) {
  var A = { D: { Off: OA.RadioButton.Cross.OffPushDown }, N: {} };
  return A.N[t] = OA.RadioButton.Cross.YesNormal, A.D[t] = OA.RadioButton.Cross.YesPushDown, A;
}, getCA: function() {
  return "8";
}, YesNormal: function(t) {
  var A = Fr(t);
  A.scope = t.scope;
  var e = [], r = OA.internal.calculateCross(t);
  return e.push("q"), e.push("1 1 " + YA(OA.internal.getWidth(t) - 2) + " " + YA(OA.internal.getHeight(t) - 2) + " re"), e.push("W"), e.push("n"), e.push(YA(r.x1.x) + " " + YA(r.x1.y) + " m"), e.push(YA(r.x2.x) + " " + YA(r.x2.y) + " l"), e.push(YA(r.x4.x) + " " + YA(r.x4.y) + " m"), e.push(YA(r.x3.x) + " " + YA(r.x3.y) + " l"), e.push("s"), e.push("Q"), A.stream = e.join(`
`), A;
}, YesPushDown: function(t) {
  var A = Fr(t);
  A.scope = t.scope;
  var e = OA.internal.calculateCross(t), r = [];
  return r.push("0.749023 g"), r.push("0 0 " + YA(OA.internal.getWidth(t)) + " " + YA(OA.internal.getHeight(t)) + " re"), r.push("f"), r.push("q"), r.push("1 1 " + YA(OA.internal.getWidth(t) - 2) + " " + YA(OA.internal.getHeight(t) - 2) + " re"), r.push("W"), r.push("n"), r.push(YA(e.x1.x) + " " + YA(e.x1.y) + " m"), r.push(YA(e.x2.x) + " " + YA(e.x2.y) + " l"), r.push(YA(e.x4.x) + " " + YA(e.x4.y) + " m"), r.push(YA(e.x3.x) + " " + YA(e.x3.y) + " l"), r.push("s"), r.push("Q"), A.stream = r.join(`
`), A;
}, OffPushDown: function(t) {
  var A = Fr(t);
  A.scope = t.scope;
  var e = [];
  return e.push("0.749023 g"), e.push("0 0 " + YA(OA.internal.getWidth(t)) + " " + YA(OA.internal.getHeight(t)) + " re"), e.push("f"), A.stream = e.join(`
`), A;
} } }, createDefaultAppearanceStream: function(t) {
  var A = t.scope.internal.getFont(t.fontName, t.fontStyle).id, e = t.scope.__private__.encodeColorString(t.color);
  return "/" + A + " " + t.fontSize + " Tf " + e;
} };
OA.internal = { Bezier_C: 0.551915024494, calculateCross: function(t) {
  var A = OA.internal.getWidth(t), e = OA.internal.getHeight(t), r = Math.min(A, e);
  return { x1: { x: (A - r) / 2, y: (e - r) / 2 + r }, x2: { x: (A - r) / 2 + r, y: (e - r) / 2 }, x3: { x: (A - r) / 2, y: (e - r) / 2 }, x4: { x: (A - r) / 2 + r, y: (e - r) / 2 + r } };
} }, OA.internal.getWidth = function(t) {
  var A = 0;
  return de(t) === "object" && (A = Uf(t.Rect[2])), A;
}, OA.internal.getHeight = function(t) {
  var A = 0;
  return de(t) === "object" && (A = Uf(t.Rect[3])), A;
};
var jp = _e.addField = function(t) {
  if (Gp(this, t), !(t instanceof cr)) throw new Error("Invalid argument passed to jsPDF.addField.");
  var A;
  return (A = t).scope.internal.acroformPlugin.printedOut && (A.scope.internal.acroformPlugin.printedOut = !1, A.scope.internal.acroformPlugin.acroFormDictionaryRoot = null), A.scope.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(A), t.page = t.scope.internal.getCurrentPageInfo().pageNumber, this;
};
_e.AcroFormChoiceField = Si, _e.AcroFormListBox = Ni, _e.AcroFormComboBox = _i, _e.AcroFormEditBox = ao, _e.AcroFormButton = et, _e.AcroFormPushButton = so, _e.AcroFormRadioButton = Di, _e.AcroFormCheckBox = oo, _e.AcroFormTextField = Kn, _e.AcroFormPasswordField = uo, _e.AcroFormAppearance = OA, _e.AcroForm = { ChoiceField: Si, ListBox: Ni, ComboBox: _i, EditBox: ao, Button: et, PushButton: so, RadioButton: Di, CheckBox: oo, TextField: Kn, PasswordField: uo, Appearance: OA }, GA.AcroForm = { ChoiceField: Si, ListBox: Ni, ComboBox: _i, EditBox: ao, Button: et, PushButton: so, RadioButton: Di, CheckBox: oo, TextField: Kn, PasswordField: uo, Appearance: OA };
GA.AcroForm;
function tB(t) {
  return t.reduce(function(A, e, r) {
    return A[e] = r, A;
  }, {});
}
(function(t) {
  t.__addimage__ = {};
  var A = "UNKNOWN", e = { PNG: [[137, 80, 78, 71]], TIFF: [[77, 77, 0, 42], [73, 73, 42, 0]], JPEG: [[255, 216, 255, 224, void 0, void 0, 74, 70, 73, 70, 0], [255, 216, 255, 225, void 0, void 0, 69, 120, 105, 102, 0, 0], [255, 216, 255, 219], [255, 216, 255, 238]], JPEG2000: [[0, 0, 0, 12, 106, 80, 32, 32]], GIF87a: [[71, 73, 70, 56, 55, 97]], GIF89a: [[71, 73, 70, 56, 57, 97]], WEBP: [[82, 73, 70, 70, void 0, void 0, void 0, void 0, 87, 69, 66, 80]], BMP: [[66, 77], [66, 65], [67, 73], [67, 80], [73, 67], [80, 84]] }, r = t.__addimage__.getImageFileTypeByImageData = function(I, H) {
    var K, M, oA, iA, uA, eA = A;
    if ((H = H || A) === "RGBA" || I.data !== void 0 && I.data instanceof Uint8ClampedArray && "height" in I && "width" in I) return "RGBA";
    if ($(I)) for (uA in e) for (oA = e[uA], K = 0; K < oA.length; K += 1) {
      for (iA = !0, M = 0; M < oA[K].length; M += 1) if (oA[K][M] !== void 0 && oA[K][M] !== I[M]) {
        iA = !1;
        break;
      }
      if (iA === !0) {
        eA = uA;
        break;
      }
    }
    else for (uA in e) for (oA = e[uA], K = 0; K < oA.length; K += 1) {
      for (iA = !0, M = 0; M < oA[K].length; M += 1) if (oA[K][M] !== void 0 && oA[K][M] !== I.charCodeAt(M)) {
        iA = !1;
        break;
      }
      if (iA === !0) {
        eA = uA;
        break;
      }
    }
    return eA === A && H !== A && (eA = H), eA;
  }, n = function I(H) {
    for (var K = this.internal.write, M = this.internal.putStream, oA = (0, this.internal.getFilters)(); oA.indexOf("FlateEncode") !== -1; ) oA.splice(oA.indexOf("FlateEncode"), 1);
    H.objectId = this.internal.newObject();
    var iA = [];
    if (iA.push({ key: "Type", value: "/XObject" }), iA.push({ key: "Subtype", value: "/Image" }), iA.push({ key: "Width", value: H.width }), iA.push({ key: "Height", value: H.height }), H.colorSpace === N.INDEXED ? iA.push({ key: "ColorSpace", value: "[/Indexed /DeviceRGB " + (H.palette.length / 3 - 1) + " " + ("sMask" in H && H.sMask !== void 0 ? H.objectId + 2 : H.objectId + 1) + " 0 R]" }) : (iA.push({ key: "ColorSpace", value: "/" + H.colorSpace }), H.colorSpace === N.DEVICE_CMYK && iA.push({ key: "Decode", value: "[1 0 1 0 1 0 1 0]" })), iA.push({ key: "BitsPerComponent", value: H.bitsPerComponent }), "decodeParameters" in H && H.decodeParameters !== void 0 && iA.push({ key: "DecodeParms", value: "<<" + H.decodeParameters + ">>" }), "transparency" in H && Array.isArray(H.transparency)) {
      for (var uA = "", eA = 0, lA = H.transparency.length; eA < lA; eA++) uA += H.transparency[eA] + " " + H.transparency[eA] + " ";
      iA.push({ key: "Mask", value: "[" + uA + "]" });
    }
    H.sMask !== void 0 && iA.push({ key: "SMask", value: H.objectId + 1 + " 0 R" });
    var hA = H.filter !== void 0 ? ["/" + H.filter] : void 0;
    if (M({ data: H.data, additionalKeyValues: iA, alreadyAppliedFilters: hA, objectId: H.objectId }), K("endobj"), "sMask" in H && H.sMask !== void 0) {
      var UA = "/Predictor " + H.predictor + " /Colors 1 /BitsPerComponent " + H.bitsPerComponent + " /Columns " + H.width, U = { width: H.width, height: H.height, colorSpace: "DeviceGray", bitsPerComponent: H.bitsPerComponent, decodeParameters: UA, data: H.sMask };
      "filter" in H && (U.filter = H.filter), I.call(this, U);
    }
    if (H.colorSpace === N.INDEXED) {
      var _ = this.internal.newObject();
      M({ data: O(new Uint8Array(H.palette)), objectId: _ }), K("endobj");
    }
  }, i = function() {
    var I = this.internal.collections.addImage_images;
    for (var H in I) n.call(this, I[H]);
  }, s = function() {
    var I, H = this.internal.collections.addImage_images, K = this.internal.write;
    for (var M in H) K("/I" + (I = H[M]).index, I.objectId, "0", "R");
  }, u = function() {
    this.internal.collections.addImage_images || (this.internal.collections.addImage_images = {}, this.internal.events.subscribe("putResources", i), this.internal.events.subscribe("putXobjectDict", s));
  }, c = function() {
    var I = this.internal.collections.addImage_images;
    return u.call(this), I;
  }, h = function() {
    return Object.keys(this.internal.collections.addImage_images).length;
  }, g = function(I) {
    return typeof t["process" + I.toUpperCase()] == "function";
  }, p = function(I) {
    return de(I) === "object" && I.nodeType === 1;
  }, w = function(I, H) {
    if (I.nodeName === "IMG" && I.hasAttribute("src")) {
      var K = "" + I.getAttribute("src");
      if (K.indexOf("data:image/") === 0) return Sa(unescape(K).split("base64,").pop());
      var M = t.loadFile(K, !0);
      if (M !== void 0) return M;
    }
    if (I.nodeName === "CANVAS") {
      if (I.width === 0 || I.height === 0) throw new Error("Given canvas must have data. Canvas width: " + I.width + ", height: " + I.height);
      var oA;
      switch (H) {
        case "PNG":
          oA = "image/png";
          break;
        case "WEBP":
          oA = "image/webp";
          break;
        case "JPEG":
        case "JPG":
        default:
          oA = "image/jpeg";
      }
      return Sa(I.toDataURL(oA, 1).split("base64,").pop());
    }
  }, B = function(I) {
    var H = this.internal.collections.addImage_images;
    if (H) {
      for (var K in H) if (I === H[K].alias) return H[K];
    }
  }, L = function(I, H, K) {
    return I || H || (I = -96, H = -96), I < 0 && (I = -1 * K.width * 72 / I / this.internal.scaleFactor), H < 0 && (H = -1 * K.height * 72 / H / this.internal.scaleFactor), I === 0 && (I = H * K.width / K.height), H === 0 && (H = I * K.height / K.width), [I, H];
  }, y = function(I, H, K, M, oA, iA) {
    var uA = L.call(this, K, M, oA), eA = this.internal.getCoordinateString, lA = this.internal.getVerticalCoordinateString, hA = c.call(this);
    if (K = uA[0], M = uA[1], hA[oA.index] = oA, iA) {
      iA *= Math.PI / 180;
      var UA = Math.cos(iA), U = Math.sin(iA), _ = function(k) {
        return k.toFixed(4);
      }, T = [_(UA), _(U), _(-1 * U), _(UA), 0, 0, "cm"];
    }
    this.internal.write("q"), iA ? (this.internal.write([1, "0", "0", 1, eA(I), lA(H + M), "cm"].join(" ")), this.internal.write(T.join(" ")), this.internal.write([eA(K), "0", "0", eA(M), "0", "0", "cm"].join(" "))) : this.internal.write([eA(K), "0", "0", eA(M), eA(I), lA(H + M), "cm"].join(" ")), this.isAdvancedAPI() && this.internal.write([1, 0, 0, -1, 0, 0, "cm"].join(" ")), this.internal.write("/I" + oA.index + " Do"), this.internal.write("Q");
  }, N = t.color_spaces = { DEVICE_RGB: "DeviceRGB", DEVICE_GRAY: "DeviceGray", DEVICE_CMYK: "DeviceCMYK", CAL_GREY: "CalGray", CAL_RGB: "CalRGB", LAB: "Lab", ICC_BASED: "ICCBased", INDEXED: "Indexed", PATTERN: "Pattern", SEPARATION: "Separation", DEVICE_N: "DeviceN" };
  t.decode = { DCT_DECODE: "DCTDecode", FLATE_DECODE: "FlateDecode", LZW_DECODE: "LZWDecode", JPX_DECODE: "JPXDecode", JBIG2_DECODE: "JBIG2Decode", ASCII85_DECODE: "ASCII85Decode", ASCII_HEX_DECODE: "ASCIIHexDecode", RUN_LENGTH_DECODE: "RunLengthDecode", CCITT_FAX_DECODE: "CCITTFaxDecode" };
  var F = t.image_compression = { NONE: "NONE", FAST: "FAST", MEDIUM: "MEDIUM", SLOW: "SLOW" }, x = t.__addimage__.sHashCode = function(I) {
    var H, K, M = 0;
    if (typeof I == "string") for (K = I.length, H = 0; H < K; H++) M = (M << 5) - M + I.charCodeAt(H), M |= 0;
    else if ($(I)) for (K = I.byteLength / 2, H = 0; H < K; H++) M = (M << 5) - M + I[H], M |= 0;
    return M;
  }, R = t.__addimage__.validateStringAsBase64 = function(I) {
    (I = I || "").toString().trim();
    var H = !0;
    return I.length === 0 && (H = !1), I.length % 4 != 0 && (H = !1), /^[A-Za-z0-9+/]+$/.test(I.substr(0, I.length - 2)) === !1 && (H = !1), /^[A-Za-z0-9/][A-Za-z0-9+/]|[A-Za-z0-9+/]=|==$/.test(I.substr(-2)) === !1 && (H = !1), H;
  }, Y = t.__addimage__.extractImageFromDataUrl = function(I) {
    if (I == null || !(I = I.trim()).startsWith("data:")) return null;
    var H = I.indexOf(",");
    return H < 0 ? null : I.substring(0, H).trim().endsWith("base64") ? I.substring(H + 1) : null;
  }, Z = t.__addimage__.supportsArrayBuffer = function() {
    return typeof ArrayBuffer < "u" && typeof Uint8Array < "u";
  };
  t.__addimage__.isArrayBuffer = function(I) {
    return Z() && I instanceof ArrayBuffer;
  };
  var $ = t.__addimage__.isArrayBufferView = function(I) {
    return Z() && typeof Uint32Array < "u" && (I instanceof Int8Array || I instanceof Uint8Array || typeof Uint8ClampedArray < "u" && I instanceof Uint8ClampedArray || I instanceof Int16Array || I instanceof Uint16Array || I instanceof Int32Array || I instanceof Uint32Array || I instanceof Float32Array || I instanceof Float64Array);
  }, J = t.__addimage__.binaryStringToUint8Array = function(I) {
    for (var H = I.length, K = new Uint8Array(H), M = 0; M < H; M++) K[M] = I.charCodeAt(M);
    return K;
  }, O = t.__addimage__.arrayBufferToBinaryString = function(I) {
    for (var H = "", K = $(I) ? I : new Uint8Array(I), M = 0; M < K.length; M += 8192) H += String.fromCharCode.apply(null, K.subarray(M, M + 8192));
    return H;
  };
  t.addImage = function() {
    var I, H, K, M, oA, iA, uA, eA, lA;
    if (typeof arguments[1] == "number" ? (H = A, K = arguments[1], M = arguments[2], oA = arguments[3], iA = arguments[4], uA = arguments[5], eA = arguments[6], lA = arguments[7]) : (H = arguments[1], K = arguments[2], M = arguments[3], oA = arguments[4], iA = arguments[5], uA = arguments[6], eA = arguments[7], lA = arguments[8]), de(I = arguments[0]) === "object" && !p(I) && "imageData" in I) {
      var hA = I;
      I = hA.imageData, H = hA.format || H || A, K = hA.x || K || 0, M = hA.y || M || 0, oA = hA.w || hA.width || oA, iA = hA.h || hA.height || iA, uA = hA.alias || uA, eA = hA.compression || eA, lA = hA.rotation || hA.angle || lA;
    }
    var UA = this.internal.getFilters();
    if (eA === void 0 && UA.indexOf("FlateEncode") !== -1 && (eA = "SLOW"), isNaN(K) || isNaN(M)) throw new Error("Invalid coordinates passed to jsPDF.addImage");
    u.call(this);
    var U = W.call(this, I, H, uA, eA);
    return y.call(this, K, M, oA, iA, U, lA), this;
  };
  var W = function(I, H, K, M) {
    var oA, iA, uA;
    if (typeof I == "string" && r(I) === A) {
      I = unescape(I);
      var eA = cA(I, !1);
      (eA !== "" || (eA = t.loadFile(I, !0)) !== void 0) && (I = eA);
    }
    if (p(I) && (I = w(I, H)), H = r(I, H), !g(H)) throw new Error("addImage does not support files of type '" + H + "', please ensure that a plugin for '" + H + "' support is added.");
    if (((uA = K) == null || uA.length === 0) && (K = function(lA) {
      return typeof lA == "string" || $(lA) ? x(lA) : $(lA.data) ? x(lA.data) : null;
    }(I)), (oA = B.call(this, K)) || (Z() && (I instanceof Uint8Array || H === "RGBA" || (iA = I, I = J(I))), oA = this["process" + H.toUpperCase()](I, h.call(this), K, function(lA) {
      return lA && typeof lA == "string" && (lA = lA.toUpperCase()), lA in t.image_compression ? lA : F.NONE;
    }(M), iA)), !oA) throw new Error("An unknown error occurred whilst processing the image.");
    return oA;
  }, cA = t.__addimage__.convertBase64ToBinaryString = function(I, H) {
    H = typeof H != "boolean" || H;
    var K, M = "";
    if (typeof I == "string") {
      var oA;
      K = (oA = Y(I)) !== null && oA !== void 0 ? oA : I;
      try {
        M = Sa(K);
      } catch (iA) {
        if (H) throw R(K) ? new Error("atob-Error in jsPDF.convertBase64ToBinaryString " + iA.message) : new Error("Supplied Data is not a valid base64-String jsPDF.convertBase64ToBinaryString ");
      }
    }
    return M;
  };
  t.getImageProperties = function(I) {
    var H, K, M = "";
    if (p(I) && (I = w(I)), typeof I == "string" && r(I) === A && ((M = cA(I, !1)) === "" && (M = t.loadFile(I) || ""), I = M), K = r(I), !g(K)) throw new Error("addImage does not support files of type '" + K + "', please ensure that a plugin for '" + K + "' support is added.");
    if (!Z() || I instanceof Uint8Array || (I = J(I)), !(H = this["process" + K.toUpperCase()](I))) throw new Error("An unknown error occurred whilst processing the image");
    return H.fileType = K, H;
  };
})(GA.API), /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t) {
  var A = function(e) {
    if (e !== void 0 && e != "") return !0;
  };
  GA.API.events.push(["addPage", function(e) {
    this.internal.getPageInfo(e.pageNumber).pageContext.annotations = [];
  }]), t.events.push(["putPage", function(e) {
    for (var r, n, i, s = this.internal.getCoordinateString, u = this.internal.getVerticalCoordinateString, c = this.internal.getPageInfoByObjId(e.objId), h = e.pageContext.annotations, g = !1, p = 0; p < h.length && !g; p++) switch ((r = h[p]).type) {
      case "link":
        (A(r.options.url) || A(r.options.pageNumber)) && (g = !0);
        break;
      case "reference":
      case "text":
      case "freetext":
        g = !0;
    }
    if (g != 0) {
      this.internal.write("/Annots [");
      for (var w = 0; w < h.length; w++) {
        r = h[w];
        var B = this.internal.pdfEscape, L = this.internal.getEncryptor(e.objId);
        switch (r.type) {
          case "reference":
            this.internal.write(" " + r.object.objId + " 0 R ");
            break;
          case "text":
            var y = this.internal.newAdditionalObject(), N = this.internal.newAdditionalObject(), F = this.internal.getEncryptor(y.objId), x = r.title || "Note";
            i = "<</Type /Annot /Subtype /Text " + (n = "/Rect [" + s(r.bounds.x) + " " + u(r.bounds.y + r.bounds.h) + " " + s(r.bounds.x + r.bounds.w) + " " + u(r.bounds.y) + "] ") + "/Contents (" + B(F(r.contents)) + ")", i += " /Popup " + N.objId + " 0 R", i += " /P " + c.objId + " 0 R", i += " /T (" + B(F(x)) + ") >>", y.content = i;
            var R = y.objId + " 0 R";
            i = "<</Type /Annot /Subtype /Popup " + (n = "/Rect [" + s(r.bounds.x + 30) + " " + u(r.bounds.y + r.bounds.h) + " " + s(r.bounds.x + r.bounds.w + 30) + " " + u(r.bounds.y) + "] ") + " /Parent " + R, r.open && (i += " /Open true"), i += " >>", N.content = i, this.internal.write(y.objId, "0 R", N.objId, "0 R");
            break;
          case "freetext":
            n = "/Rect [" + s(r.bounds.x) + " " + u(r.bounds.y) + " " + s(r.bounds.x + r.bounds.w) + " " + u(r.bounds.y + r.bounds.h) + "] ";
            var Y = r.color || "#000000";
            i = "<</Type /Annot /Subtype /FreeText " + n + "/Contents (" + B(L(r.contents)) + ")", i += " /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#" + Y + ")", i += " /Border [0 0 0]", i += " >>", this.internal.write(i);
            break;
          case "link":
            if (r.options.name) {
              var Z = this.annotations._nameMap[r.options.name];
              r.options.pageNumber = Z.page, r.options.top = Z.y;
            } else r.options.top || (r.options.top = 0);
            if (n = "/Rect [" + r.finalBounds.x + " " + r.finalBounds.y + " " + r.finalBounds.w + " " + r.finalBounds.h + "] ", i = "", r.options.url) i = "<</Type /Annot /Subtype /Link " + n + "/Border [0 0 0] /A <</S /URI /URI (" + B(L(r.options.url)) + ") >>";
            else if (r.options.pageNumber)
              switch (i = "<</Type /Annot /Subtype /Link " + n + "/Border [0 0 0] /Dest [" + this.internal.getPageInfo(r.options.pageNumber).objId + " 0 R", r.options.magFactor = r.options.magFactor || "XYZ", r.options.magFactor) {
                case "Fit":
                  i += " /Fit]";
                  break;
                case "FitH":
                  i += " /FitH " + r.options.top + "]";
                  break;
                case "FitV":
                  r.options.left = r.options.left || 0, i += " /FitV " + r.options.left + "]";
                  break;
                case "XYZ":
                default:
                  var $ = u(r.options.top);
                  r.options.left = r.options.left || 0, r.options.zoom === void 0 && (r.options.zoom = 0), i += " /XYZ " + r.options.left + " " + $ + " " + r.options.zoom + "]";
              }
            i != "" && (i += " >>", this.internal.write(i));
        }
      }
      this.internal.write("]");
    }
  }]), t.createAnnotation = function(e) {
    var r = this.internal.getCurrentPageInfo();
    switch (e.type) {
      case "link":
        this.link(e.bounds.x, e.bounds.y, e.bounds.w, e.bounds.h, e);
        break;
      case "text":
      case "freetext":
        r.pageContext.annotations.push(e);
    }
  }, t.link = function(e, r, n, i, s) {
    var u = this.internal.getCurrentPageInfo(), c = this.internal.getCoordinateString, h = this.internal.getVerticalCoordinateString;
    u.pageContext.annotations.push({ finalBounds: { x: c(e), y: h(r), w: c(e + n), h: h(r + i) }, options: s, type: "link" });
  }, t.textWithLink = function(e, r, n, i) {
    var s, u, c = this.getTextWidth(e), h = this.internal.getLineHeight() / this.internal.scaleFactor;
    if (i.maxWidth !== void 0) {
      u = i.maxWidth;
      var g = this.splitTextToSize(e, u).length;
      s = Math.ceil(h * g);
    } else u = c, s = h;
    return this.text(e, r, n, i), n += 0.2 * h, i.align === "center" && (r -= c / 2), i.align === "right" && (r -= c), this.link(r, n - h, u, s, i), c;
  }, t.getTextWidth = function(e) {
    var r = this.internal.getFontSize();
    return this.getStringUnitWidth(e) * r / this.internal.scaleFactor;
  };
}(GA.API), /**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t) {
  var A = { 1569: [65152], 1570: [65153, 65154], 1571: [65155, 65156], 1572: [65157, 65158], 1573: [65159, 65160], 1574: [65161, 65162, 65163, 65164], 1575: [65165, 65166], 1576: [65167, 65168, 65169, 65170], 1577: [65171, 65172], 1578: [65173, 65174, 65175, 65176], 1579: [65177, 65178, 65179, 65180], 1580: [65181, 65182, 65183, 65184], 1581: [65185, 65186, 65187, 65188], 1582: [65189, 65190, 65191, 65192], 1583: [65193, 65194], 1584: [65195, 65196], 1585: [65197, 65198], 1586: [65199, 65200], 1587: [65201, 65202, 65203, 65204], 1588: [65205, 65206, 65207, 65208], 1589: [65209, 65210, 65211, 65212], 1590: [65213, 65214, 65215, 65216], 1591: [65217, 65218, 65219, 65220], 1592: [65221, 65222, 65223, 65224], 1593: [65225, 65226, 65227, 65228], 1594: [65229, 65230, 65231, 65232], 1601: [65233, 65234, 65235, 65236], 1602: [65237, 65238, 65239, 65240], 1603: [65241, 65242, 65243, 65244], 1604: [65245, 65246, 65247, 65248], 1605: [65249, 65250, 65251, 65252], 1606: [65253, 65254, 65255, 65256], 1607: [65257, 65258, 65259, 65260], 1608: [65261, 65262], 1609: [65263, 65264, 64488, 64489], 1610: [65265, 65266, 65267, 65268], 1649: [64336, 64337], 1655: [64477], 1657: [64358, 64359, 64360, 64361], 1658: [64350, 64351, 64352, 64353], 1659: [64338, 64339, 64340, 64341], 1662: [64342, 64343, 64344, 64345], 1663: [64354, 64355, 64356, 64357], 1664: [64346, 64347, 64348, 64349], 1667: [64374, 64375, 64376, 64377], 1668: [64370, 64371, 64372, 64373], 1670: [64378, 64379, 64380, 64381], 1671: [64382, 64383, 64384, 64385], 1672: [64392, 64393], 1676: [64388, 64389], 1677: [64386, 64387], 1678: [64390, 64391], 1681: [64396, 64397], 1688: [64394, 64395], 1700: [64362, 64363, 64364, 64365], 1702: [64366, 64367, 64368, 64369], 1705: [64398, 64399, 64400, 64401], 1709: [64467, 64468, 64469, 64470], 1711: [64402, 64403, 64404, 64405], 1713: [64410, 64411, 64412, 64413], 1715: [64406, 64407, 64408, 64409], 1722: [64414, 64415], 1723: [64416, 64417, 64418, 64419], 1726: [64426, 64427, 64428, 64429], 1728: [64420, 64421], 1729: [64422, 64423, 64424, 64425], 1733: [64480, 64481], 1734: [64473, 64474], 1735: [64471, 64472], 1736: [64475, 64476], 1737: [64482, 64483], 1739: [64478, 64479], 1740: [64508, 64509, 64510, 64511], 1744: [64484, 64485, 64486, 64487], 1746: [64430, 64431], 1747: [64432, 64433] }, e = { 65247: { 65154: 65269, 65156: 65271, 65160: 65273, 65166: 65275 }, 65248: { 65154: 65270, 65156: 65272, 65160: 65274, 65166: 65276 }, 65165: { 65247: { 65248: { 65258: 65010 } } }, 1617: { 1612: 64606, 1613: 64607, 1614: 64608, 1615: 64609, 1616: 64610 } }, r = { 1612: 64606, 1613: 64607, 1614: 64608, 1615: 64609, 1616: 64610 }, n = [1570, 1571, 1573, 1575];
  t.__arabicParser__ = {};
  var i = t.__arabicParser__.isInArabicSubstitutionA = function(y) {
    return A[y.charCodeAt(0)] !== void 0;
  }, s = t.__arabicParser__.isArabicLetter = function(y) {
    return typeof y == "string" && /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+$/.test(y);
  }, u = t.__arabicParser__.isArabicEndLetter = function(y) {
    return s(y) && i(y) && A[y.charCodeAt(0)].length <= 2;
  }, c = t.__arabicParser__.isArabicAlfLetter = function(y) {
    return s(y) && n.indexOf(y.charCodeAt(0)) >= 0;
  };
  t.__arabicParser__.arabicLetterHasIsolatedForm = function(y) {
    return s(y) && i(y) && A[y.charCodeAt(0)].length >= 1;
  };
  var h = t.__arabicParser__.arabicLetterHasFinalForm = function(y) {
    return s(y) && i(y) && A[y.charCodeAt(0)].length >= 2;
  };
  t.__arabicParser__.arabicLetterHasInitialForm = function(y) {
    return s(y) && i(y) && A[y.charCodeAt(0)].length >= 3;
  };
  var g = t.__arabicParser__.arabicLetterHasMedialForm = function(y) {
    return s(y) && i(y) && A[y.charCodeAt(0)].length == 4;
  }, p = t.__arabicParser__.resolveLigatures = function(y) {
    var N = 0, F = e, x = "", R = 0;
    for (N = 0; N < y.length; N += 1) F[y.charCodeAt(N)] !== void 0 ? (R++, typeof (F = F[y.charCodeAt(N)]) == "number" && (x += String.fromCharCode(F), F = e, R = 0), N === y.length - 1 && (F = e, x += y.charAt(N - (R - 1)), N -= R - 1, R = 0)) : (F = e, x += y.charAt(N - R), N -= R, R = 0);
    return x;
  };
  t.__arabicParser__.isArabicDiacritic = function(y) {
    return y !== void 0 && r[y.charCodeAt(0)] !== void 0;
  };
  var w = t.__arabicParser__.getCorrectForm = function(y, N, F) {
    return s(y) ? i(y) === !1 ? -1 : !h(y) || !s(N) && !s(F) || !s(F) && u(N) || u(y) && !s(N) || u(y) && c(N) || u(y) && u(N) ? 0 : g(y) && s(N) && !u(N) && s(F) && h(F) ? 3 : u(y) || !s(F) ? 1 : 2 : -1;
  }, B = function(y) {
    var N = 0, F = 0, x = 0, R = "", Y = "", Z = "", $ = (y = y || "").split("\\s+"), J = [];
    for (N = 0; N < $.length; N += 1) {
      for (J.push(""), F = 0; F < $[N].length; F += 1) R = $[N][F], Y = $[N][F - 1], Z = $[N][F + 1], s(R) ? (x = w(R, Y, Z), J[N] += x !== -1 ? String.fromCharCode(A[R.charCodeAt(0)][x]) : R) : J[N] += R;
      J[N] = p(J[N]);
    }
    return J.join(" ");
  }, L = t.__arabicParser__.processArabic = t.processArabic = function() {
    var y, N = typeof arguments[0] == "string" ? arguments[0] : arguments[0].text, F = [];
    if (Array.isArray(N)) {
      var x = 0;
      for (F = [], x = 0; x < N.length; x += 1) Array.isArray(N[x]) ? F.push([B(N[x][0]), N[x][1], N[x][2]]) : F.push([B(N[x])]);
      y = F;
    } else y = B(N);
    return typeof arguments[0] == "string" ? y : (arguments[0].text = y, arguments[0]);
  };
  t.events.push(["preProcessText", L]);
}(GA.API), GA.API.autoPrint = function(t) {
  var A;
  switch ((t = t || {}).variant = t.variant || "non-conform", t.variant) {
    case "javascript":
      this.addJS("print({});");
      break;
    case "non-conform":
    default:
      this.internal.events.subscribe("postPutResources", function() {
        A = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /Named"), this.internal.out("/Type /Action"), this.internal.out("/N /Print"), this.internal.out(">>"), this.internal.out("endobj");
      }), this.internal.events.subscribe("putCatalog", function() {
        this.internal.out("/OpenAction " + A + " 0 R");
      });
  }
  return this;
}, /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t) {
  var A = function() {
    var e = void 0;
    Object.defineProperty(this, "pdf", { get: function() {
      return e;
    }, set: function(u) {
      e = u;
    } });
    var r = 150;
    Object.defineProperty(this, "width", { get: function() {
      return r;
    }, set: function(u) {
      r = isNaN(u) || Number.isInteger(u) === !1 || u < 0 ? 150 : u, this.getContext("2d").pageWrapXEnabled && (this.getContext("2d").pageWrapX = r + 1);
    } });
    var n = 300;
    Object.defineProperty(this, "height", { get: function() {
      return n;
    }, set: function(u) {
      n = isNaN(u) || Number.isInteger(u) === !1 || u < 0 ? 300 : u, this.getContext("2d").pageWrapYEnabled && (this.getContext("2d").pageWrapY = n + 1);
    } });
    var i = [];
    Object.defineProperty(this, "childNodes", { get: function() {
      return i;
    }, set: function(u) {
      i = u;
    } });
    var s = {};
    Object.defineProperty(this, "style", { get: function() {
      return s;
    }, set: function(u) {
      s = u;
    } }), Object.defineProperty(this, "parentNode", {});
  };
  A.prototype.getContext = function(e, r) {
    var n;
    if ((e = e || "2d") !== "2d") return null;
    for (n in r) this.pdf.context2d.hasOwnProperty(n) && (this.pdf.context2d[n] = r[n]);
    return this.pdf.context2d._canvas = this, this.pdf.context2d;
  }, A.prototype.toDataURL = function() {
    throw new Error("toDataURL is not implemented.");
  }, t.events.push(["initialized", function() {
    this.canvas = new A(), this.canvas.pdf = this;
  }]);
}(GA.API), function(t) {
  var A = { left: 0, top: 0, bottom: 0, right: 0 }, e = !1, r = function() {
    this.internal.__cell__ === void 0 && (this.internal.__cell__ = {}, this.internal.__cell__.padding = 3, this.internal.__cell__.headerFunction = void 0, this.internal.__cell__.margins = Object.assign({}, A), this.internal.__cell__.margins.width = this.getPageWidth(), n.call(this));
  }, n = function() {
    this.internal.__cell__.lastCell = new i(), this.internal.__cell__.pages = 1;
  }, i = function() {
    var c = arguments[0];
    Object.defineProperty(this, "x", { enumerable: !0, get: function() {
      return c;
    }, set: function(y) {
      c = y;
    } });
    var h = arguments[1];
    Object.defineProperty(this, "y", { enumerable: !0, get: function() {
      return h;
    }, set: function(y) {
      h = y;
    } });
    var g = arguments[2];
    Object.defineProperty(this, "width", { enumerable: !0, get: function() {
      return g;
    }, set: function(y) {
      g = y;
    } });
    var p = arguments[3];
    Object.defineProperty(this, "height", { enumerable: !0, get: function() {
      return p;
    }, set: function(y) {
      p = y;
    } });
    var w = arguments[4];
    Object.defineProperty(this, "text", { enumerable: !0, get: function() {
      return w;
    }, set: function(y) {
      w = y;
    } });
    var B = arguments[5];
    Object.defineProperty(this, "lineNumber", { enumerable: !0, get: function() {
      return B;
    }, set: function(y) {
      B = y;
    } });
    var L = arguments[6];
    return Object.defineProperty(this, "align", { enumerable: !0, get: function() {
      return L;
    }, set: function(y) {
      L = y;
    } }), this;
  };
  i.prototype.clone = function() {
    return new i(this.x, this.y, this.width, this.height, this.text, this.lineNumber, this.align);
  }, i.prototype.toArray = function() {
    return [this.x, this.y, this.width, this.height, this.text, this.lineNumber, this.align];
  }, t.setHeaderFunction = function(c) {
    return r.call(this), this.internal.__cell__.headerFunction = typeof c == "function" ? c : void 0, this;
  }, t.getTextDimensions = function(c, h) {
    r.call(this);
    var g = (h = h || {}).fontSize || this.getFontSize(), p = h.font || this.getFont(), w = h.scaleFactor || this.internal.scaleFactor, B = 0, L = 0, y = 0, N = this;
    if (!Array.isArray(c) && typeof c != "string") {
      if (typeof c != "number") throw new Error("getTextDimensions expects text-parameter to be of type String or type Number or an Array of Strings.");
      c = String(c);
    }
    var F = h.maxWidth;
    F > 0 ? typeof c == "string" ? c = this.splitTextToSize(c, F) : Object.prototype.toString.call(c) === "[object Array]" && (c = c.reduce(function(R, Y) {
      return R.concat(N.splitTextToSize(Y, F));
    }, [])) : c = Array.isArray(c) ? c : [c];
    for (var x = 0; x < c.length; x++) B < (y = this.getStringUnitWidth(c[x], { font: p }) * g) && (B = y);
    return B !== 0 && (L = c.length), { w: B /= w, h: Math.max((L * g * this.getLineHeightFactor() - g * (this.getLineHeightFactor() - 1)) / w, 0) };
  }, t.cellAddPage = function() {
    r.call(this), this.addPage();
    var c = this.internal.__cell__.margins || A;
    return this.internal.__cell__.lastCell = new i(c.left, c.top, void 0, void 0), this.internal.__cell__.pages += 1, this;
  };
  var s = t.cell = function() {
    var c;
    c = arguments[0] instanceof i ? arguments[0] : new i(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]), r.call(this);
    var h = this.internal.__cell__.lastCell, g = this.internal.__cell__.padding, p = this.internal.__cell__.margins || A, w = this.internal.__cell__.tableHeaderRow, B = this.internal.__cell__.printHeaders;
    return h.lineNumber !== void 0 && (h.lineNumber === c.lineNumber ? (c.x = (h.x || 0) + (h.width || 0), c.y = h.y || 0) : h.y + h.height + c.height + p.bottom > this.getPageHeight() ? (this.cellAddPage(), c.y = p.top, B && w && (this.printHeaderRow(c.lineNumber, !0), c.y += w[0].height)) : c.y = h.y + h.height || c.y), c.text[0] !== void 0 && (this.rect(c.x, c.y, c.width, c.height, e === !0 ? "FD" : void 0), c.align === "right" ? this.text(c.text, c.x + c.width - g, c.y + g, { align: "right", baseline: "top" }) : c.align === "center" ? this.text(c.text, c.x + c.width / 2, c.y + g, { align: "center", baseline: "top", maxWidth: c.width - g - g }) : this.text(c.text, c.x + g, c.y + g, { align: "left", baseline: "top", maxWidth: c.width - g - g })), this.internal.__cell__.lastCell = c, this;
  };
  t.table = function(c, h, g, p, w) {
    if (r.call(this), !g) throw new Error("No data for PDF table.");
    var B, L, y, N, F = [], x = [], R = [], Y = {}, Z = {}, $ = [], J = [], O = (w = w || {}).autoSize || !1, W = w.printHeaders !== !1, cA = w.css && w.css["font-size"] !== void 0 ? 16 * w.css["font-size"] : w.fontSize || 12, I = w.margins || Object.assign({ width: this.getPageWidth() }, A), H = typeof w.padding == "number" ? w.padding : 3, K = w.headerBackgroundColor || "#c8c8c8", M = w.headerTextColor || "#000";
    if (n.call(this), this.internal.__cell__.printHeaders = W, this.internal.__cell__.margins = I, this.internal.__cell__.table_font_size = cA, this.internal.__cell__.padding = H, this.internal.__cell__.headerBackgroundColor = K, this.internal.__cell__.headerTextColor = M, this.setFontSize(cA), p == null) x = F = Object.keys(g[0]), R = F.map(function() {
      return "left";
    });
    else if (Array.isArray(p) && de(p[0]) === "object") for (F = p.map(function(hA) {
      return hA.name;
    }), x = p.map(function(hA) {
      return hA.prompt || hA.name || "";
    }), R = p.map(function(hA) {
      return hA.align || "left";
    }), B = 0; B < p.length; B += 1) Z[p[B].name] = p[B].width * (19.049976 / 25.4);
    else Array.isArray(p) && typeof p[0] == "string" && (x = F = p, R = F.map(function() {
      return "left";
    }));
    if (O || Array.isArray(p) && typeof p[0] == "string") for (B = 0; B < F.length; B += 1) {
      for (Y[N = F[B]] = g.map(function(hA) {
        return hA[N];
      }), this.setFont(void 0, "bold"), $.push(this.getTextDimensions(x[B], { fontSize: this.internal.__cell__.table_font_size, scaleFactor: this.internal.scaleFactor }).w), L = Y[N], this.setFont(void 0, "normal"), y = 0; y < L.length; y += 1) $.push(this.getTextDimensions(L[y], { fontSize: this.internal.__cell__.table_font_size, scaleFactor: this.internal.scaleFactor }).w);
      Z[N] = Math.max.apply(null, $) + H + H, $ = [];
    }
    if (W) {
      var oA = {};
      for (B = 0; B < F.length; B += 1) oA[F[B]] = {}, oA[F[B]].text = x[B], oA[F[B]].align = R[B];
      var iA = u.call(this, oA, Z);
      J = F.map(function(hA) {
        return new i(c, h, Z[hA], iA, oA[hA].text, void 0, oA[hA].align);
      }), this.setTableHeaderRow(J), this.printHeaderRow(1, !1);
    }
    var uA = p.reduce(function(hA, UA) {
      return hA[UA.name] = UA.align, hA;
    }, {});
    for (B = 0; B < g.length; B += 1) {
      "rowStart" in w && w.rowStart instanceof Function && w.rowStart({ row: B, data: g[B] }, this);
      var eA = u.call(this, g[B], Z);
      for (y = 0; y < F.length; y += 1) {
        var lA = g[B][F[y]];
        "cellStart" in w && w.cellStart instanceof Function && w.cellStart({ row: B, col: y, data: lA }, this), s.call(this, new i(c, h, Z[F[y]], eA, lA, B + 2, uA[F[y]]));
      }
    }
    return this.internal.__cell__.table_x = c, this.internal.__cell__.table_y = h, this;
  };
  var u = function(c, h) {
    var g = this.internal.__cell__.padding, p = this.internal.__cell__.table_font_size, w = this.internal.scaleFactor;
    return Object.keys(c).map(function(B) {
      var L = c[B];
      return this.splitTextToSize(L.hasOwnProperty("text") ? L.text : L, h[B] - g - g);
    }, this).map(function(B) {
      return this.getLineHeightFactor() * B.length * p / w + g + g;
    }, this).reduce(function(B, L) {
      return Math.max(B, L);
    }, 0);
  };
  t.setTableHeaderRow = function(c) {
    r.call(this), this.internal.__cell__.tableHeaderRow = c;
  }, t.printHeaderRow = function(c, h) {
    if (r.call(this), !this.internal.__cell__.tableHeaderRow) throw new Error("Property tableHeaderRow does not exist.");
    var g;
    if (e = !0, typeof this.internal.__cell__.headerFunction == "function") {
      var p = this.internal.__cell__.headerFunction(this, this.internal.__cell__.pages);
      this.internal.__cell__.lastCell = new i(p[0], p[1], p[2], p[3], void 0, -1);
    }
    this.setFont(void 0, "bold");
    for (var w = [], B = 0; B < this.internal.__cell__.tableHeaderRow.length; B += 1) {
      g = this.internal.__cell__.tableHeaderRow[B].clone(), h && (g.y = this.internal.__cell__.margins.top || 0, w.push(g)), g.lineNumber = c;
      var L = this.getTextColor();
      this.setTextColor(this.internal.__cell__.headerTextColor), this.setFillColor(this.internal.__cell__.headerBackgroundColor), s.call(this, g), this.setTextColor(L);
    }
    w.length > 0 && this.setTableHeaderRow(w), this.setFont(void 0, "normal"), e = !1;
  };
}(GA.API);
var rB = { italic: ["italic", "oblique", "normal"], oblique: ["oblique", "italic", "normal"], normal: ["normal", "oblique", "italic"] }, nB = ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded"], Sc = tB(nB), iB = [100, 200, 300, 400, 500, 600, 700, 800, 900], Vp = tB(iB);
function Nc(t) {
  var A = t.family.replace(/"|'/g, "").toLowerCase(), e = function(i) {
    return rB[i = i || "normal"] ? i : "normal";
  }(t.style), r = function(i) {
    if (!i) return 400;
    if (typeof i == "number") return i >= 100 && i <= 900 && i % 100 == 0 ? i : 400;
    if (/^\d00$/.test(i)) return parseInt(i);
    switch (i) {
      case "bold":
        return 700;
      case "normal":
      default:
        return 400;
    }
  }(t.weight), n = function(i) {
    return typeof Sc[i = i || "normal"] == "number" ? i : "normal";
  }(t.stretch);
  return { family: A, style: e, weight: r, stretch: n, src: t.src || [], ref: t.ref || { name: A, style: [n, e, r].join(" ") } };
}
function yf(t, A, e, r) {
  var n;
  for (n = e; n >= 0 && n < A.length; n += r) if (t[A[n]]) return t[A[n]];
  for (n = e; n >= 0 && n < A.length; n -= r) if (t[A[n]]) return t[A[n]];
}
var qp = { "sans-serif": "helvetica", fixed: "courier", monospace: "courier", terminal: "courier", cursive: "times", fantasy: "times", serif: "times" }, bf = { caption: "times", icon: "times", menu: "times", "message-box": "times", "small-caption": "times", "status-bar": "times" };
function Lf(t) {
  return [t.stretch, t.style, t.weight, t.family].join(" ");
}
function Wp(t, A, e) {
  for (var r = (e = e || {}).defaultFontFamily || "times", n = Object.assign({}, qp, e.genericFontFamilies || {}), i = null, s = null, u = 0; u < A.length; ++u) if (n[(i = Nc(A[u])).family] && (i.family = n[i.family]), t.hasOwnProperty(i.family)) {
    s = t[i.family];
    break;
  }
  if (!(s = s || t[r])) throw new Error("Could not find a font-family for the rule '" + Lf(i) + "' and default family '" + r + "'.");
  if (s = function(c, h) {
    if (h[c]) return h[c];
    var g = Sc[c], p = g <= Sc.normal ? -1 : 1, w = yf(h, nB, g, p);
    if (!w) throw new Error("Could not find a matching font-stretch value for " + c);
    return w;
  }(i.stretch, s), s = function(c, h) {
    if (h[c]) return h[c];
    for (var g = rB[c], p = 0; p < g.length; ++p) if (h[g[p]]) return h[g[p]];
    throw new Error("Could not find a matching font-style for " + c);
  }(i.style, s), !(s = function(c, h) {
    if (h[c]) return h[c];
    if (c === 400 && h[500]) return h[500];
    if (c === 500 && h[400]) return h[400];
    var g = Vp[c], p = yf(h, iB, g, c < 400 ? -1 : 1);
    if (!p) throw new Error("Could not find a matching font-weight for value " + c);
    return p;
  }(i.weight, s))) throw new Error("Failed to resolve a font for the rule '" + Lf(i) + "'.");
  return s;
}
function Ef(t) {
  return t.trimLeft();
}
function Xp(t, A) {
  for (var e = 0; e < t.length; ) {
    if (t.charAt(e) === A) return [t.substring(0, e), t.substring(e + 1)];
    e += 1;
  }
  return null;
}
function Jp(t) {
  var A = t.match(/^(-[a-z_]|[a-z_])[a-z0-9_-]*/i);
  return A === null ? null : [A[0], t.substring(A[0].length)];
}
var Ao, If, xf, Zu = ["times"];
(function(t) {
  var A, e, r, n, i, s, u, c, h, g = function(U) {
    return U = U || {}, this.isStrokeTransparent = U.isStrokeTransparent || !1, this.strokeOpacity = U.strokeOpacity || 1, this.strokeStyle = U.strokeStyle || "#000000", this.fillStyle = U.fillStyle || "#000000", this.isFillTransparent = U.isFillTransparent || !1, this.fillOpacity = U.fillOpacity || 1, this.font = U.font || "10px sans-serif", this.textBaseline = U.textBaseline || "alphabetic", this.textAlign = U.textAlign || "left", this.lineWidth = U.lineWidth || 1, this.lineJoin = U.lineJoin || "miter", this.lineCap = U.lineCap || "butt", this.path = U.path || [], this.transform = U.transform !== void 0 ? U.transform.clone() : new c(), this.globalCompositeOperation = U.globalCompositeOperation || "normal", this.globalAlpha = U.globalAlpha || 1, this.clip_path = U.clip_path || [], this.currentPoint = U.currentPoint || new s(), this.miterLimit = U.miterLimit || 10, this.lastPoint = U.lastPoint || new s(), this.lineDashOffset = U.lineDashOffset || 0, this.lineDash = U.lineDash || [], this.margin = U.margin || [0, 0, 0, 0], this.prevPageLastElemOffset = U.prevPageLastElemOffset || 0, this.ignoreClearRect = typeof U.ignoreClearRect != "boolean" || U.ignoreClearRect, this;
  };
  t.events.push(["initialized", function() {
    this.context2d = new p(this), A = this.internal.f2, e = this.internal.getCoordinateString, r = this.internal.getVerticalCoordinateString, n = this.internal.getHorizontalCoordinate, i = this.internal.getVerticalCoordinate, s = this.internal.Point, u = this.internal.Rectangle, c = this.internal.Matrix, h = new g();
  }]);
  var p = function(U) {
    Object.defineProperty(this, "canvas", { get: function() {
      return { parentNode: !1, style: !1 };
    } });
    var _ = U;
    Object.defineProperty(this, "pdf", { get: function() {
      return _;
    } });
    var T = !1;
    Object.defineProperty(this, "pageWrapXEnabled", { get: function() {
      return T;
    }, set: function(gA) {
      T = !!gA;
    } });
    var k = !1;
    Object.defineProperty(this, "pageWrapYEnabled", { get: function() {
      return k;
    }, set: function(gA) {
      k = !!gA;
    } });
    var X = 0;
    Object.defineProperty(this, "posX", { get: function() {
      return X;
    }, set: function(gA) {
      isNaN(gA) || (X = gA);
    } });
    var nA = 0;
    Object.defineProperty(this, "posY", { get: function() {
      return nA;
    }, set: function(gA) {
      isNaN(gA) || (nA = gA);
    } }), Object.defineProperty(this, "margin", { get: function() {
      return h.margin;
    }, set: function(gA) {
      var P;
      typeof gA == "number" ? P = [gA, gA, gA, gA] : ((P = new Array(4))[0] = gA[0], P[1] = gA.length >= 2 ? gA[1] : P[0], P[2] = gA.length >= 3 ? gA[2] : P[0], P[3] = gA.length >= 4 ? gA[3] : P[1]), h.margin = P;
    } });
    var aA = !1;
    Object.defineProperty(this, "autoPaging", { get: function() {
      return aA;
    }, set: function(gA) {
      aA = gA;
    } });
    var sA = 0;
    Object.defineProperty(this, "lastBreak", { get: function() {
      return sA;
    }, set: function(gA) {
      sA = gA;
    } });
    var FA = [];
    Object.defineProperty(this, "pageBreaks", { get: function() {
      return FA;
    }, set: function(gA) {
      FA = gA;
    } }), Object.defineProperty(this, "ctx", { get: function() {
      return h;
    }, set: function(gA) {
      gA instanceof g && (h = gA);
    } }), Object.defineProperty(this, "path", { get: function() {
      return h.path;
    }, set: function(gA) {
      h.path = gA;
    } });
    var QA = [];
    Object.defineProperty(this, "ctxStack", { get: function() {
      return QA;
    }, set: function(gA) {
      QA = gA;
    } }), Object.defineProperty(this, "fillStyle", { get: function() {
      return this.ctx.fillStyle;
    }, set: function(gA) {
      var P;
      P = w(gA), this.ctx.fillStyle = P.style, this.ctx.isFillTransparent = P.a === 0, this.ctx.fillOpacity = P.a, this.pdf.setFillColor(P.r, P.g, P.b, { a: P.a }), this.pdf.setTextColor(P.r, P.g, P.b, { a: P.a });
    } }), Object.defineProperty(this, "strokeStyle", { get: function() {
      return this.ctx.strokeStyle;
    }, set: function(gA) {
      var P = w(gA);
      this.ctx.strokeStyle = P.style, this.ctx.isStrokeTransparent = P.a === 0, this.ctx.strokeOpacity = P.a, P.a === 0 ? this.pdf.setDrawColor(255, 255, 255) : (P.a, this.pdf.setDrawColor(P.r, P.g, P.b));
    } }), Object.defineProperty(this, "lineCap", { get: function() {
      return this.ctx.lineCap;
    }, set: function(gA) {
      ["butt", "round", "square"].indexOf(gA) !== -1 && (this.ctx.lineCap = gA, this.pdf.setLineCap(gA));
    } }), Object.defineProperty(this, "lineWidth", { get: function() {
      return this.ctx.lineWidth;
    }, set: function(gA) {
      isNaN(gA) || (this.ctx.lineWidth = gA, this.pdf.setLineWidth(gA));
    } }), Object.defineProperty(this, "lineJoin", { get: function() {
      return this.ctx.lineJoin;
    }, set: function(gA) {
      ["bevel", "round", "miter"].indexOf(gA) !== -1 && (this.ctx.lineJoin = gA, this.pdf.setLineJoin(gA));
    } }), Object.defineProperty(this, "miterLimit", { get: function() {
      return this.ctx.miterLimit;
    }, set: function(gA) {
      isNaN(gA) || (this.ctx.miterLimit = gA, this.pdf.setMiterLimit(gA));
    } }), Object.defineProperty(this, "textBaseline", { get: function() {
      return this.ctx.textBaseline;
    }, set: function(gA) {
      this.ctx.textBaseline = gA;
    } }), Object.defineProperty(this, "textAlign", { get: function() {
      return this.ctx.textAlign;
    }, set: function(gA) {
      ["right", "end", "center", "left", "start"].indexOf(gA) !== -1 && (this.ctx.textAlign = gA);
    } });
    var xA = null;
    function LA(gA, P) {
      if (xA === null) {
        var ZA = function(PA) {
          var CA = [];
          return Object.keys(PA).forEach(function(yA) {
            PA[yA].forEach(function(HA) {
              var IA = null;
              switch (HA) {
                case "bold":
                  IA = { family: yA, weight: "bold" };
                  break;
                case "italic":
                  IA = { family: yA, style: "italic" };
                  break;
                case "bolditalic":
                  IA = { family: yA, weight: "bold", style: "italic" };
                  break;
                case "":
                case "normal":
                  IA = { family: yA };
              }
              IA !== null && (IA.ref = { name: yA, style: HA }, CA.push(IA));
            });
          }), CA;
        }(gA.getFontList());
        xA = function(PA) {
          for (var CA = {}, yA = 0; yA < PA.length; ++yA) {
            var HA = Nc(PA[yA]), IA = HA.family, MA = HA.stretch, XA = HA.style, ee = HA.weight;
            CA[IA] = CA[IA] || {}, CA[IA][MA] = CA[IA][MA] || {}, CA[IA][MA][XA] = CA[IA][MA][XA] || {}, CA[IA][MA][XA][ee] = HA;
          }
          return CA;
        }(ZA.concat(P));
      }
      return xA;
    }
    var jA = null;
    Object.defineProperty(this, "fontFaces", { get: function() {
      return jA;
    }, set: function(gA) {
      xA = null, jA = gA;
    } }), Object.defineProperty(this, "font", { get: function() {
      return this.ctx.font;
    }, set: function(gA) {
      var P;
      if (this.ctx.font = gA, (P = /^\s*(?=(?:(?:[-a-z]+\s*){0,2}(italic|oblique))?)(?=(?:(?:[-a-z]+\s*){0,2}(small-caps))?)(?=(?:(?:[-a-z]+\s*){0,2}(bold(?:er)?|lighter|[1-9]00))?)(?:(?:normal|\1|\2|\3)\s*){0,3}((?:xx?-)?(?:small|large)|medium|smaller|larger|[.\d]+(?:\%|in|[cem]m|ex|p[ctx]))(?:\s*\/\s*(normal|[.\d]+(?:\%|in|[cem]m|ex|p[ctx])))?\s*([-_,\"\'\sa-z]+?)\s*$/i.exec(gA)) !== null) {
        var ZA = P[1];
        P[2];
        var PA = P[3], CA = P[4];
        P[5];
        var yA = P[6], HA = /^([.\d]+)((?:%|in|[cem]m|ex|p[ctx]))$/i.exec(CA)[2];
        CA = Math.floor(HA === "px" ? parseFloat(CA) * this.pdf.internal.scaleFactor : HA === "em" ? parseFloat(CA) * this.pdf.getFontSize() : parseFloat(CA) * this.pdf.internal.scaleFactor), this.pdf.setFontSize(CA);
        var IA = function(qA) {
          var re, SA, st = [], ue = qA.trim();
          if (ue === "") return Zu;
          if (ue in bf) return [bf[ue]];
          for (; ue !== ""; ) {
            switch (SA = null, re = (ue = Ef(ue)).charAt(0)) {
              case '"':
              case "'":
                SA = Xp(ue.substring(1), re);
                break;
              default:
                SA = Jp(ue);
            }
            if (SA === null || (st.push(SA[0]), (ue = Ef(SA[1])) !== "" && ue.charAt(0) !== ",")) return Zu;
            ue = ue.replace(/^,/, "");
          }
          return st;
        }(yA);
        if (this.fontFaces) {
          var MA = Wp(LA(this.pdf, this.fontFaces), IA.map(function(qA) {
            return { family: qA, stretch: "normal", weight: PA, style: ZA };
          }));
          this.pdf.setFont(MA.ref.name, MA.ref.style);
        } else {
          var XA = "";
          (PA === "bold" || parseInt(PA, 10) >= 700 || ZA === "bold") && (XA = "bold"), ZA === "italic" && (XA += "italic"), XA.length === 0 && (XA = "normal");
          for (var ee = "", te = { arial: "Helvetica", Arial: "Helvetica", verdana: "Helvetica", Verdana: "Helvetica", helvetica: "Helvetica", Helvetica: "Helvetica", "sans-serif": "Helvetica", fixed: "Courier", monospace: "Courier", terminal: "Courier", cursive: "Times", fantasy: "Times", serif: "Times" }, se = 0; se < IA.length; se++) {
            if (this.pdf.internal.getFont(IA[se], XA, { noFallback: !0, disableWarning: !0 }) !== void 0) {
              ee = IA[se];
              break;
            }
            if (XA === "bolditalic" && this.pdf.internal.getFont(IA[se], "bold", { noFallback: !0, disableWarning: !0 }) !== void 0) ee = IA[se], XA = "bold";
            else if (this.pdf.internal.getFont(IA[se], "normal", { noFallback: !0, disableWarning: !0 }) !== void 0) {
              ee = IA[se], XA = "normal";
              break;
            }
          }
          if (ee === "") {
            for (var pe = 0; pe < IA.length; pe++) if (te[IA[pe]]) {
              ee = te[IA[pe]];
              break;
            }
          }
          ee = ee === "" ? "Times" : ee, this.pdf.setFont(ee, XA);
        }
      }
    } }), Object.defineProperty(this, "globalCompositeOperation", { get: function() {
      return this.ctx.globalCompositeOperation;
    }, set: function(gA) {
      this.ctx.globalCompositeOperation = gA;
    } }), Object.defineProperty(this, "globalAlpha", { get: function() {
      return this.ctx.globalAlpha;
    }, set: function(gA) {
      this.ctx.globalAlpha = gA;
    } }), Object.defineProperty(this, "lineDashOffset", { get: function() {
      return this.ctx.lineDashOffset;
    }, set: function(gA) {
      this.ctx.lineDashOffset = gA, UA.call(this);
    } }), Object.defineProperty(this, "lineDash", { get: function() {
      return this.ctx.lineDash;
    }, set: function(gA) {
      this.ctx.lineDash = gA, UA.call(this);
    } }), Object.defineProperty(this, "ignoreClearRect", { get: function() {
      return this.ctx.ignoreClearRect;
    }, set: function(gA) {
      this.ctx.ignoreClearRect = !!gA;
    } });
  };
  p.prototype.setLineDash = function(U) {
    this.lineDash = U;
  }, p.prototype.getLineDash = function() {
    return this.lineDash.length % 2 ? this.lineDash.concat(this.lineDash) : this.lineDash.slice();
  }, p.prototype.fill = function() {
    Y.call(this, "fill", !1);
  }, p.prototype.stroke = function() {
    Y.call(this, "stroke", !1);
  }, p.prototype.beginPath = function() {
    this.path = [{ type: "begin" }];
  }, p.prototype.moveTo = function(U, _) {
    if (isNaN(U) || isNaN(_)) throw Qe.error("jsPDF.context2d.moveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.moveTo");
    var T = this.ctx.transform.applyToPoint(new s(U, _));
    this.path.push({ type: "mt", x: T.x, y: T.y }), this.ctx.lastPoint = new s(U, _);
  }, p.prototype.closePath = function() {
    var U = new s(0, 0), _ = 0;
    for (_ = this.path.length - 1; _ !== -1; _--) if (this.path[_].type === "begin" && de(this.path[_ + 1]) === "object" && typeof this.path[_ + 1].x == "number") {
      U = new s(this.path[_ + 1].x, this.path[_ + 1].y);
      break;
    }
    this.path.push({ type: "close" }), this.ctx.lastPoint = new s(U.x, U.y);
  }, p.prototype.lineTo = function(U, _) {
    if (isNaN(U) || isNaN(_)) throw Qe.error("jsPDF.context2d.lineTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.lineTo");
    var T = this.ctx.transform.applyToPoint(new s(U, _));
    this.path.push({ type: "lt", x: T.x, y: T.y }), this.ctx.lastPoint = new s(T.x, T.y);
  }, p.prototype.clip = function() {
    this.ctx.clip_path = JSON.parse(JSON.stringify(this.path)), Y.call(this, null, !0);
  }, p.prototype.quadraticCurveTo = function(U, _, T, k) {
    if (isNaN(T) || isNaN(k) || isNaN(U) || isNaN(_)) throw Qe.error("jsPDF.context2d.quadraticCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.quadraticCurveTo");
    var X = this.ctx.transform.applyToPoint(new s(T, k)), nA = this.ctx.transform.applyToPoint(new s(U, _));
    this.path.push({ type: "qct", x1: nA.x, y1: nA.y, x: X.x, y: X.y }), this.ctx.lastPoint = new s(X.x, X.y);
  }, p.prototype.bezierCurveTo = function(U, _, T, k, X, nA) {
    if (isNaN(X) || isNaN(nA) || isNaN(U) || isNaN(_) || isNaN(T) || isNaN(k)) throw Qe.error("jsPDF.context2d.bezierCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.bezierCurveTo");
    var aA = this.ctx.transform.applyToPoint(new s(X, nA)), sA = this.ctx.transform.applyToPoint(new s(U, _)), FA = this.ctx.transform.applyToPoint(new s(T, k));
    this.path.push({ type: "bct", x1: sA.x, y1: sA.y, x2: FA.x, y2: FA.y, x: aA.x, y: aA.y }), this.ctx.lastPoint = new s(aA.x, aA.y);
  }, p.prototype.arc = function(U, _, T, k, X, nA) {
    if (isNaN(U) || isNaN(_) || isNaN(T) || isNaN(k) || isNaN(X)) throw Qe.error("jsPDF.context2d.arc: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.arc");
    if (nA = !!nA, !this.ctx.transform.isIdentity) {
      var aA = this.ctx.transform.applyToPoint(new s(U, _));
      U = aA.x, _ = aA.y;
      var sA = this.ctx.transform.applyToPoint(new s(0, T)), FA = this.ctx.transform.applyToPoint(new s(0, 0));
      T = Math.sqrt(Math.pow(sA.x - FA.x, 2) + Math.pow(sA.y - FA.y, 2));
    }
    Math.abs(X - k) >= 2 * Math.PI && (k = 0, X = 2 * Math.PI), this.path.push({ type: "arc", x: U, y: _, radius: T, startAngle: k, endAngle: X, counterclockwise: nA });
  }, p.prototype.arcTo = function(U, _, T, k, X) {
    throw new Error("arcTo not implemented.");
  }, p.prototype.rect = function(U, _, T, k) {
    if (isNaN(U) || isNaN(_) || isNaN(T) || isNaN(k)) throw Qe.error("jsPDF.context2d.rect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rect");
    this.moveTo(U, _), this.lineTo(U + T, _), this.lineTo(U + T, _ + k), this.lineTo(U, _ + k), this.lineTo(U, _), this.lineTo(U + T, _), this.lineTo(U, _);
  }, p.prototype.fillRect = function(U, _, T, k) {
    if (isNaN(U) || isNaN(_) || isNaN(T) || isNaN(k)) throw Qe.error("jsPDF.context2d.fillRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillRect");
    if (!B.call(this)) {
      var X = {};
      this.lineCap !== "butt" && (X.lineCap = this.lineCap, this.lineCap = "butt"), this.lineJoin !== "miter" && (X.lineJoin = this.lineJoin, this.lineJoin = "miter"), this.beginPath(), this.rect(U, _, T, k), this.fill(), X.hasOwnProperty("lineCap") && (this.lineCap = X.lineCap), X.hasOwnProperty("lineJoin") && (this.lineJoin = X.lineJoin);
    }
  }, p.prototype.strokeRect = function(U, _, T, k) {
    if (isNaN(U) || isNaN(_) || isNaN(T) || isNaN(k)) throw Qe.error("jsPDF.context2d.strokeRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeRect");
    L.call(this) || (this.beginPath(), this.rect(U, _, T, k), this.stroke());
  }, p.prototype.clearRect = function(U, _, T, k) {
    if (isNaN(U) || isNaN(_) || isNaN(T) || isNaN(k)) throw Qe.error("jsPDF.context2d.clearRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.clearRect");
    this.ignoreClearRect || (this.fillStyle = "#ffffff", this.fillRect(U, _, T, k));
  }, p.prototype.save = function(U) {
    U = typeof U != "boolean" || U;
    for (var _ = this.pdf.internal.getCurrentPageInfo().pageNumber, T = 0; T < this.pdf.internal.getNumberOfPages(); T++) this.pdf.setPage(T + 1), this.pdf.internal.out("q");
    if (this.pdf.setPage(_), U) {
      this.ctx.fontSize = this.pdf.internal.getFontSize();
      var k = new g(this.ctx);
      this.ctxStack.push(this.ctx), this.ctx = k;
    }
  }, p.prototype.restore = function(U) {
    U = typeof U != "boolean" || U;
    for (var _ = this.pdf.internal.getCurrentPageInfo().pageNumber, T = 0; T < this.pdf.internal.getNumberOfPages(); T++) this.pdf.setPage(T + 1), this.pdf.internal.out("Q");
    this.pdf.setPage(_), U && this.ctxStack.length !== 0 && (this.ctx = this.ctxStack.pop(), this.fillStyle = this.ctx.fillStyle, this.strokeStyle = this.ctx.strokeStyle, this.font = this.ctx.font, this.lineCap = this.ctx.lineCap, this.lineWidth = this.ctx.lineWidth, this.lineJoin = this.ctx.lineJoin, this.lineDash = this.ctx.lineDash, this.lineDashOffset = this.ctx.lineDashOffset);
  }, p.prototype.toDataURL = function() {
    throw new Error("toDataUrl not implemented.");
  };
  var w = function(U) {
    var _, T, k, X;
    if (U.isCanvasGradient === !0 && (U = U.getColor()), !U) return { r: 0, g: 0, b: 0, a: 0, style: U };
    if (/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/.test(U)) _ = 0, T = 0, k = 0, X = 0;
    else {
      var nA = /rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/.exec(U);
      if (nA !== null) _ = parseInt(nA[1]), T = parseInt(nA[2]), k = parseInt(nA[3]), X = 1;
      else if ((nA = /rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d.]+)\s*\)/.exec(U)) !== null) _ = parseInt(nA[1]), T = parseInt(nA[2]), k = parseInt(nA[3]), X = parseFloat(nA[4]);
      else {
        if (X = 1, typeof U == "string" && U.charAt(0) !== "#") {
          var aA = new zh(U);
          U = aA.ok ? aA.toHex() : "#000000";
        }
        U.length === 4 ? (_ = U.substring(1, 2), _ += _, T = U.substring(2, 3), T += T, k = U.substring(3, 4), k += k) : (_ = U.substring(1, 3), T = U.substring(3, 5), k = U.substring(5, 7)), _ = parseInt(_, 16), T = parseInt(T, 16), k = parseInt(k, 16);
      }
    }
    return { r: _, g: T, b: k, a: X, style: U };
  }, B = function() {
    return this.ctx.isFillTransparent || this.globalAlpha == 0;
  }, L = function() {
    return !!(this.ctx.isStrokeTransparent || this.globalAlpha == 0);
  };
  p.prototype.fillText = function(U, _, T, k) {
    if (isNaN(_) || isNaN(T) || typeof U != "string") throw Qe.error("jsPDF.context2d.fillText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillText");
    if (k = isNaN(k) ? void 0 : k, !B.call(this)) {
      var X = eA(this.ctx.transform.rotation), nA = this.ctx.transform.scaleX;
      H.call(this, { text: U, x: _, y: T, scale: nA, angle: X, align: this.textAlign, maxWidth: k });
    }
  }, p.prototype.strokeText = function(U, _, T, k) {
    if (isNaN(_) || isNaN(T) || typeof U != "string") throw Qe.error("jsPDF.context2d.strokeText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeText");
    if (!L.call(this)) {
      k = isNaN(k) ? void 0 : k;
      var X = eA(this.ctx.transform.rotation), nA = this.ctx.transform.scaleX;
      H.call(this, { text: U, x: _, y: T, scale: nA, renderingMode: "stroke", angle: X, align: this.textAlign, maxWidth: k });
    }
  }, p.prototype.measureText = function(U) {
    if (typeof U != "string") throw Qe.error("jsPDF.context2d.measureText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.measureText");
    var _ = this.pdf, T = this.pdf.internal.scaleFactor, k = _.internal.getFontSize(), X = _.getStringUnitWidth(U) * k / _.internal.scaleFactor, nA = function(aA) {
      var sA = (aA = aA || {}).width || 0;
      return Object.defineProperty(this, "width", { get: function() {
        return sA;
      } }), this;
    };
    return new nA({ width: X *= Math.round(96 * T / 72 * 1e4) / 1e4 });
  }, p.prototype.scale = function(U, _) {
    if (isNaN(U) || isNaN(_)) throw Qe.error("jsPDF.context2d.scale: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.scale");
    var T = new c(U, 0, 0, _, 0, 0);
    this.ctx.transform = this.ctx.transform.multiply(T);
  }, p.prototype.rotate = function(U) {
    if (isNaN(U)) throw Qe.error("jsPDF.context2d.rotate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rotate");
    var _ = new c(Math.cos(U), Math.sin(U), -Math.sin(U), Math.cos(U), 0, 0);
    this.ctx.transform = this.ctx.transform.multiply(_);
  }, p.prototype.translate = function(U, _) {
    if (isNaN(U) || isNaN(_)) throw Qe.error("jsPDF.context2d.translate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.translate");
    var T = new c(1, 0, 0, 1, U, _);
    this.ctx.transform = this.ctx.transform.multiply(T);
  }, p.prototype.transform = function(U, _, T, k, X, nA) {
    if (isNaN(U) || isNaN(_) || isNaN(T) || isNaN(k) || isNaN(X) || isNaN(nA)) throw Qe.error("jsPDF.context2d.transform: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.transform");
    var aA = new c(U, _, T, k, X, nA);
    this.ctx.transform = this.ctx.transform.multiply(aA);
  }, p.prototype.setTransform = function(U, _, T, k, X, nA) {
    U = isNaN(U) ? 1 : U, _ = isNaN(_) ? 0 : _, T = isNaN(T) ? 0 : T, k = isNaN(k) ? 1 : k, X = isNaN(X) ? 0 : X, nA = isNaN(nA) ? 0 : nA, this.ctx.transform = new c(U, _, T, k, X, nA);
  };
  var y = function() {
    return this.margin[0] > 0 || this.margin[1] > 0 || this.margin[2] > 0 || this.margin[3] > 0;
  };
  p.prototype.drawImage = function(U, _, T, k, X, nA, aA, sA, FA) {
    var QA = this.pdf.getImageProperties(U), xA = 1, LA = 1, jA = 1, gA = 1;
    k !== void 0 && sA !== void 0 && (jA = sA / k, gA = FA / X, xA = QA.width / k * sA / k, LA = QA.height / X * FA / X), nA === void 0 && (nA = _, aA = T, _ = 0, T = 0), k !== void 0 && sA === void 0 && (sA = k, FA = X), k === void 0 && sA === void 0 && (sA = QA.width, FA = QA.height);
    for (var P, ZA = this.ctx.transform.decompose(), PA = eA(ZA.rotate.shx), CA = new c(), yA = (CA = (CA = (CA = CA.multiply(ZA.translate)).multiply(ZA.skew)).multiply(ZA.scale)).applyToRectangle(new u(nA - _ * jA, aA - T * gA, k * xA, X * LA)), HA = N.call(this, yA), IA = [], MA = 0; MA < HA.length; MA += 1) IA.indexOf(HA[MA]) === -1 && IA.push(HA[MA]);
    if (R(IA), this.autoPaging) for (var XA = IA[0], ee = IA[IA.length - 1], te = XA; te < ee + 1; te++) {
      this.pdf.setPage(te);
      var se = this.pdf.internal.pageSize.width - this.margin[3] - this.margin[1], pe = te === 1 ? this.posY + this.margin[0] : this.margin[0], qA = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], re = this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2], SA = te === 1 ? 0 : qA + (te - 2) * re;
      if (this.ctx.clip_path.length !== 0) {
        var st = this.path;
        P = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = x(P, this.posX + this.margin[3], -SA + pe + this.ctx.prevPageLastElemOffset), Z.call(this, "fill", !0), this.path = st;
      }
      var ue = JSON.parse(JSON.stringify(yA));
      ue = x([ue], this.posX + this.margin[3], -SA + pe + this.ctx.prevPageLastElemOffset)[0];
      var Xt = (te > XA || te < ee) && y.call(this);
      Xt && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], se, re, null).clip().discardPath()), this.pdf.addImage(U, "JPEG", ue.x, ue.y, ue.w, ue.h, null, null, PA), Xt && this.pdf.restoreGraphicsState();
    }
    else this.pdf.addImage(U, "JPEG", yA.x, yA.y, yA.w, yA.h, null, null, PA);
  };
  var N = function(U, _, T) {
    var k = [];
    _ = _ || this.pdf.internal.pageSize.width, T = T || this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2];
    var X = this.posY + this.ctx.prevPageLastElemOffset;
    switch (U.type) {
      default:
      case "mt":
      case "lt":
        k.push(Math.floor((U.y + X) / T) + 1);
        break;
      case "arc":
        k.push(Math.floor((U.y + X - U.radius) / T) + 1), k.push(Math.floor((U.y + X + U.radius) / T) + 1);
        break;
      case "qct":
        var nA = lA(this.ctx.lastPoint.x, this.ctx.lastPoint.y, U.x1, U.y1, U.x, U.y);
        k.push(Math.floor((nA.y + X) / T) + 1), k.push(Math.floor((nA.y + nA.h + X) / T) + 1);
        break;
      case "bct":
        var aA = hA(this.ctx.lastPoint.x, this.ctx.lastPoint.y, U.x1, U.y1, U.x2, U.y2, U.x, U.y);
        k.push(Math.floor((aA.y + X) / T) + 1), k.push(Math.floor((aA.y + aA.h + X) / T) + 1);
        break;
      case "rect":
        k.push(Math.floor((U.y + X) / T) + 1), k.push(Math.floor((U.y + U.h + X) / T) + 1);
    }
    for (var sA = 0; sA < k.length; sA += 1) for (; this.pdf.internal.getNumberOfPages() < k[sA]; ) F.call(this);
    return k;
  }, F = function() {
    var U = this.fillStyle, _ = this.strokeStyle, T = this.font, k = this.lineCap, X = this.lineWidth, nA = this.lineJoin;
    this.pdf.addPage(), this.fillStyle = U, this.strokeStyle = _, this.font = T, this.lineCap = k, this.lineWidth = X, this.lineJoin = nA;
  }, x = function(U, _, T) {
    for (var k = 0; k < U.length; k++) switch (U[k].type) {
      case "bct":
        U[k].x2 += _, U[k].y2 += T;
      case "qct":
        U[k].x1 += _, U[k].y1 += T;
      case "mt":
      case "lt":
      case "arc":
      default:
        U[k].x += _, U[k].y += T;
    }
    return U;
  }, R = function(U) {
    return U.sort(function(_, T) {
      return _ - T;
    });
  }, Y = function(U, _) {
    for (var T, k, X = this.fillStyle, nA = this.strokeStyle, aA = this.lineCap, sA = this.lineWidth, FA = Math.abs(sA * this.ctx.transform.scaleX), QA = this.lineJoin, xA = JSON.parse(JSON.stringify(this.path)), LA = JSON.parse(JSON.stringify(this.path)), jA = [], gA = 0; gA < LA.length; gA++) if (LA[gA].x !== void 0) for (var P = N.call(this, LA[gA]), ZA = 0; ZA < P.length; ZA += 1) jA.indexOf(P[ZA]) === -1 && jA.push(P[ZA]);
    for (var PA = 0; PA < jA.length; PA++) for (; this.pdf.internal.getNumberOfPages() < jA[PA]; ) F.call(this);
    if (R(jA), this.autoPaging) for (var CA = jA[0], yA = jA[jA.length - 1], HA = CA; HA < yA + 1; HA++) {
      this.pdf.setPage(HA), this.fillStyle = X, this.strokeStyle = nA, this.lineCap = aA, this.lineWidth = FA, this.lineJoin = QA;
      var IA = this.pdf.internal.pageSize.width - this.margin[3] - this.margin[1], MA = HA === 1 ? this.posY + this.margin[0] : this.margin[0], XA = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], ee = this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2], te = HA === 1 ? 0 : XA + (HA - 2) * ee;
      if (this.ctx.clip_path.length !== 0) {
        var se = this.path;
        T = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = x(T, this.posX + this.margin[3], -te + MA + this.ctx.prevPageLastElemOffset), Z.call(this, U, !0), this.path = se;
      }
      if (k = JSON.parse(JSON.stringify(xA)), this.path = x(k, this.posX + this.margin[3], -te + MA + this.ctx.prevPageLastElemOffset), _ === !1 || HA === 0) {
        var pe = (HA > CA || HA < yA) && y.call(this);
        pe && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], IA, ee, null).clip().discardPath()), Z.call(this, U, _), pe && this.pdf.restoreGraphicsState();
      }
      this.lineWidth = sA;
    }
    else this.lineWidth = FA, Z.call(this, U, _), this.lineWidth = sA;
    this.path = xA;
  }, Z = function(U, _) {
    if ((U !== "stroke" || _ || !L.call(this)) && (U === "stroke" || _ || !B.call(this))) {
      for (var T, k, X = [], nA = this.path, aA = 0; aA < nA.length; aA++) {
        var sA = nA[aA];
        switch (sA.type) {
          case "begin":
            X.push({ begin: !0 });
            break;
          case "close":
            X.push({ close: !0 });
            break;
          case "mt":
            X.push({ start: sA, deltas: [], abs: [] });
            break;
          case "lt":
            var FA = X.length;
            if (nA[aA - 1] && !isNaN(nA[aA - 1].x) && (T = [sA.x - nA[aA - 1].x, sA.y - nA[aA - 1].y], FA > 0)) {
              for (; FA >= 0; FA--) if (X[FA - 1].close !== !0 && X[FA - 1].begin !== !0) {
                X[FA - 1].deltas.push(T), X[FA - 1].abs.push(sA);
                break;
              }
            }
            break;
          case "bct":
            T = [sA.x1 - nA[aA - 1].x, sA.y1 - nA[aA - 1].y, sA.x2 - nA[aA - 1].x, sA.y2 - nA[aA - 1].y, sA.x - nA[aA - 1].x, sA.y - nA[aA - 1].y], X[X.length - 1].deltas.push(T);
            break;
          case "qct":
            var QA = nA[aA - 1].x + 2 / 3 * (sA.x1 - nA[aA - 1].x), xA = nA[aA - 1].y + 2 / 3 * (sA.y1 - nA[aA - 1].y), LA = sA.x + 2 / 3 * (sA.x1 - sA.x), jA = sA.y + 2 / 3 * (sA.y1 - sA.y), gA = sA.x, P = sA.y;
            T = [QA - nA[aA - 1].x, xA - nA[aA - 1].y, LA - nA[aA - 1].x, jA - nA[aA - 1].y, gA - nA[aA - 1].x, P - nA[aA - 1].y], X[X.length - 1].deltas.push(T);
            break;
          case "arc":
            X.push({ deltas: [], abs: [], arc: !0 }), Array.isArray(X[X.length - 1].abs) && X[X.length - 1].abs.push(sA);
        }
      }
      k = _ ? null : U === "stroke" ? "stroke" : "fill";
      for (var ZA = !1, PA = 0; PA < X.length; PA++) if (X[PA].arc) for (var CA = X[PA].abs, yA = 0; yA < CA.length; yA++) {
        var HA = CA[yA];
        HA.type === "arc" ? O.call(this, HA.x, HA.y, HA.radius, HA.startAngle, HA.endAngle, HA.counterclockwise, void 0, _, !ZA) : K.call(this, HA.x, HA.y), ZA = !0;
      }
      else if (X[PA].close === !0) this.pdf.internal.out("h"), ZA = !1;
      else if (X[PA].begin !== !0) {
        var IA = X[PA].start.x, MA = X[PA].start.y;
        M.call(this, X[PA].deltas, IA, MA), ZA = !0;
      }
      k && W.call(this, k), _ && cA.call(this);
    }
  }, $ = function(U) {
    var _ = this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor, T = _ * (this.pdf.internal.getLineHeightFactor() - 1);
    switch (this.ctx.textBaseline) {
      case "bottom":
        return U - T;
      case "top":
        return U + _ - T;
      case "hanging":
        return U + _ - 2 * T;
      case "middle":
        return U + _ / 2 - T;
      case "ideographic":
        return U;
      case "alphabetic":
      default:
        return U;
    }
  }, J = function(U) {
    return U + this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor * (this.pdf.internal.getLineHeightFactor() - 1);
  };
  p.prototype.createLinearGradient = function() {
    var U = function() {
    };
    return U.colorStops = [], U.addColorStop = function(_, T) {
      this.colorStops.push([_, T]);
    }, U.getColor = function() {
      return this.colorStops.length === 0 ? "#000000" : this.colorStops[0][1];
    }, U.isCanvasGradient = !0, U;
  }, p.prototype.createPattern = function() {
    return this.createLinearGradient();
  }, p.prototype.createRadialGradient = function() {
    return this.createLinearGradient();
  };
  var O = function(U, _, T, k, X, nA, aA, sA, FA) {
    for (var QA = iA.call(this, T, k, X, nA), xA = 0; xA < QA.length; xA++) {
      var LA = QA[xA];
      xA === 0 && (FA ? I.call(this, LA.x1 + U, LA.y1 + _) : K.call(this, LA.x1 + U, LA.y1 + _)), oA.call(this, U, _, LA.x2, LA.y2, LA.x3, LA.y3, LA.x4, LA.y4);
    }
    sA ? cA.call(this) : W.call(this, aA);
  }, W = function(U) {
    switch (U) {
      case "stroke":
        this.pdf.internal.out("S");
        break;
      case "fill":
        this.pdf.internal.out("f");
    }
  }, cA = function() {
    this.pdf.clip(), this.pdf.discardPath();
  }, I = function(U, _) {
    this.pdf.internal.out(e(U) + " " + r(_) + " m");
  }, H = function(U) {
    var _;
    switch (U.align) {
      case "right":
      case "end":
        _ = "right";
        break;
      case "center":
        _ = "center";
        break;
      case "left":
      case "start":
      default:
        _ = "left";
    }
    var T = this.pdf.getTextDimensions(U.text), k = $.call(this, U.y), X = J.call(this, k) - T.h, nA = this.ctx.transform.applyToPoint(new s(U.x, k)), aA = this.ctx.transform.decompose(), sA = new c();
    sA = (sA = (sA = sA.multiply(aA.translate)).multiply(aA.skew)).multiply(aA.scale);
    for (var FA, QA, xA, LA = this.ctx.transform.applyToRectangle(new u(U.x, k, T.w, T.h)), jA = sA.applyToRectangle(new u(U.x, X, T.w, T.h)), gA = N.call(this, jA), P = [], ZA = 0; ZA < gA.length; ZA += 1) P.indexOf(gA[ZA]) === -1 && P.push(gA[ZA]);
    if (R(P), this.autoPaging) for (var PA = P[0], CA = P[P.length - 1], yA = PA; yA < CA + 1; yA++) {
      this.pdf.setPage(yA);
      var HA = yA === 1 ? this.posY + this.margin[0] : this.margin[0], IA = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], MA = this.pdf.internal.pageSize.height - this.margin[2], XA = MA - this.margin[0], ee = this.pdf.internal.pageSize.width - this.margin[1], te = ee - this.margin[3], se = yA === 1 ? 0 : IA + (yA - 2) * XA;
      if (this.ctx.clip_path.length !== 0) {
        var pe = this.path;
        FA = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = x(FA, this.posX + this.margin[3], -1 * se + HA), Z.call(this, "fill", !0), this.path = pe;
      }
      var qA = x([JSON.parse(JSON.stringify(jA))], this.posX + this.margin[3], -se + HA + this.ctx.prevPageLastElemOffset)[0];
      U.scale >= 0.01 && (QA = this.pdf.internal.getFontSize(), this.pdf.setFontSize(QA * U.scale), xA = this.lineWidth, this.lineWidth = xA * U.scale);
      var re = this.autoPaging !== "text";
      if (re || qA.y + qA.h <= MA) {
        if (re || qA.y >= HA && qA.x <= ee) {
          var SA = re ? U.text : this.pdf.splitTextToSize(U.text, U.maxWidth || ee - qA.x)[0], st = x([JSON.parse(JSON.stringify(LA))], this.posX + this.margin[3], -se + HA + this.ctx.prevPageLastElemOffset)[0], ue = re && (yA > PA || yA < CA) && y.call(this);
          ue && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], te, XA, null).clip().discardPath()), this.pdf.text(SA, st.x, st.y, { angle: U.angle, align: _, renderingMode: U.renderingMode }), ue && this.pdf.restoreGraphicsState();
        }
      } else qA.y < MA && (this.ctx.prevPageLastElemOffset += MA - qA.y);
      U.scale >= 0.01 && (this.pdf.setFontSize(QA), this.lineWidth = xA);
    }
    else U.scale >= 0.01 && (QA = this.pdf.internal.getFontSize(), this.pdf.setFontSize(QA * U.scale), xA = this.lineWidth, this.lineWidth = xA * U.scale), this.pdf.text(U.text, nA.x + this.posX, nA.y + this.posY, { angle: U.angle, align: _, renderingMode: U.renderingMode, maxWidth: U.maxWidth }), U.scale >= 0.01 && (this.pdf.setFontSize(QA), this.lineWidth = xA);
  }, K = function(U, _, T, k) {
    T = T || 0, k = k || 0, this.pdf.internal.out(e(U + T) + " " + r(_ + k) + " l");
  }, M = function(U, _, T) {
    return this.pdf.lines(U, _, T, null, null);
  }, oA = function(U, _, T, k, X, nA, aA, sA) {
    this.pdf.internal.out([A(n(T + U)), A(i(k + _)), A(n(X + U)), A(i(nA + _)), A(n(aA + U)), A(i(sA + _)), "c"].join(" "));
  }, iA = function(U, _, T, k) {
    for (var X = 2 * Math.PI, nA = Math.PI / 2; _ > T; ) _ -= X;
    var aA = Math.abs(T - _);
    aA < X && k && (aA = X - aA);
    for (var sA = [], FA = k ? -1 : 1, QA = _; aA > 1e-5; ) {
      var xA = QA + FA * Math.min(aA, nA);
      sA.push(uA.call(this, U, QA, xA)), aA -= Math.abs(xA - QA), QA = xA;
    }
    return sA;
  }, uA = function(U, _, T) {
    var k = (T - _) / 2, X = U * Math.cos(k), nA = U * Math.sin(k), aA = X, sA = -nA, FA = aA * aA + sA * sA, QA = FA + aA * X + sA * nA, xA = 4 / 3 * (Math.sqrt(2 * FA * QA) - QA) / (aA * nA - sA * X), LA = aA - xA * sA, jA = sA + xA * aA, gA = LA, P = -jA, ZA = k + _, PA = Math.cos(ZA), CA = Math.sin(ZA);
    return { x1: U * Math.cos(_), y1: U * Math.sin(_), x2: LA * PA - jA * CA, y2: LA * CA + jA * PA, x3: gA * PA - P * CA, y3: gA * CA + P * PA, x4: U * Math.cos(T), y4: U * Math.sin(T) };
  }, eA = function(U) {
    return 180 * U / Math.PI;
  }, lA = function(U, _, T, k, X, nA) {
    var aA = U + 0.5 * (T - U), sA = _ + 0.5 * (k - _), FA = X + 0.5 * (T - X), QA = nA + 0.5 * (k - nA), xA = Math.min(U, X, aA, FA), LA = Math.max(U, X, aA, FA), jA = Math.min(_, nA, sA, QA), gA = Math.max(_, nA, sA, QA);
    return new u(xA, jA, LA - xA, gA - jA);
  }, hA = function(U, _, T, k, X, nA, aA, sA) {
    var FA, QA, xA, LA, jA, gA, P, ZA, PA, CA, yA, HA, IA, MA, XA = T - U, ee = k - _, te = X - T, se = nA - k, pe = aA - X, qA = sA - nA;
    for (QA = 0; QA < 41; QA++) PA = (P = (xA = U + (FA = QA / 40) * XA) + FA * ((jA = T + FA * te) - xA)) + FA * (jA + FA * (X + FA * pe - jA) - P), CA = (ZA = (LA = _ + FA * ee) + FA * ((gA = k + FA * se) - LA)) + FA * (gA + FA * (nA + FA * qA - gA) - ZA), QA == 0 ? (yA = PA, HA = CA, IA = PA, MA = CA) : (yA = Math.min(yA, PA), HA = Math.min(HA, CA), IA = Math.max(IA, PA), MA = Math.max(MA, CA));
    return new u(Math.round(yA), Math.round(HA), Math.round(IA - yA), Math.round(MA - HA));
  }, UA = function() {
    if (this.prevLineDash || this.ctx.lineDash.length || this.ctx.lineDashOffset) {
      var U, _, T = (U = this.ctx.lineDash, _ = this.ctx.lineDashOffset, JSON.stringify({ lineDash: U, lineDashOffset: _ }));
      this.prevLineDash !== T && (this.pdf.setLineDash(this.ctx.lineDash, this.ctx.lineDashOffset), this.prevLineDash = T);
    }
  };
})(GA.API), /**
 * @license
 * jsPDF filters PlugIn
 * Copyright (c) 2014 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t) {
  var A = function(i) {
    var s, u, c, h, g, p, w, B, L, y;
    for (u = [], c = 0, h = (i += s = "\0\0\0\0".slice(i.length % 4 || 4)).length; h > c; c += 4) (g = (i.charCodeAt(c) << 24) + (i.charCodeAt(c + 1) << 16) + (i.charCodeAt(c + 2) << 8) + i.charCodeAt(c + 3)) !== 0 ? (p = (g = ((g = ((g = ((g = (g - (y = g % 85)) / 85) - (L = g % 85)) / 85) - (B = g % 85)) / 85) - (w = g % 85)) / 85) % 85, u.push(p + 33, w + 33, B + 33, L + 33, y + 33)) : u.push(122);
    return function(N, F) {
      for (var x = F; x > 0; x--) N.pop();
    }(u, s.length), String.fromCharCode.apply(String, u) + "~>";
  }, e = function(i) {
    var s, u, c, h, g, p = String, w = "length", B = 255, L = "charCodeAt", y = "slice", N = "replace";
    for (i[y](-2), i = i[y](0, -2)[N](/\s/g, "")[N]("z", "!!!!!"), c = [], h = 0, g = (i += s = "uuuuu"[y](i[w] % 5 || 5))[w]; g > h; h += 5) u = 52200625 * (i[L](h) - 33) + 614125 * (i[L](h + 1) - 33) + 7225 * (i[L](h + 2) - 33) + 85 * (i[L](h + 3) - 33) + (i[L](h + 4) - 33), c.push(B & u >> 24, B & u >> 16, B & u >> 8, B & u);
    return function(F, x) {
      for (var R = x; R > 0; R--) F.pop();
    }(c, s[w]), p.fromCharCode.apply(p, c);
  }, r = function(i) {
    var s = new RegExp(/^([0-9A-Fa-f]{2})+$/);
    if ((i = i.replace(/\s/g, "")).indexOf(">") !== -1 && (i = i.substr(0, i.indexOf(">"))), i.length % 2 && (i += "0"), s.test(i) === !1) return "";
    for (var u = "", c = 0; c < i.length; c += 2) u += String.fromCharCode("0x" + (i[c] + i[c + 1]));
    return u;
  }, n = function(i) {
    for (var s = new Uint8Array(i.length), u = i.length; u--; ) s[u] = i.charCodeAt(u);
    return i = (s = Lc(s)).reduce(function(c, h) {
      return c + String.fromCharCode(h);
    }, "");
  };
  t.processDataByFilters = function(i, s) {
    var u = 0, c = i || "", h = [];
    for (typeof (s = s || []) == "string" && (s = [s]), u = 0; u < s.length; u += 1) switch (s[u]) {
      case "ASCII85Decode":
      case "/ASCII85Decode":
        c = e(c), h.push("/ASCII85Encode");
        break;
      case "ASCII85Encode":
      case "/ASCII85Encode":
        c = A(c), h.push("/ASCII85Decode");
        break;
      case "ASCIIHexDecode":
      case "/ASCIIHexDecode":
        c = r(c), h.push("/ASCIIHexEncode");
        break;
      case "ASCIIHexEncode":
      case "/ASCIIHexEncode":
        c = c.split("").map(function(g) {
          return ("0" + g.charCodeAt().toString(16)).slice(-2);
        }).join("") + ">", h.push("/ASCIIHexDecode");
        break;
      case "FlateEncode":
      case "/FlateEncode":
        c = n(c), h.push("/FlateDecode");
        break;
      default:
        throw new Error('The filter: "' + s[u] + '" is not implemented');
    }
    return { data: c, reverseChain: h.reverse().join(" ") };
  };
}(GA.API), /**
 * @license
 * jsPDF fileloading PlugIn
 * Copyright (c) 2018 Aras Abbasi (aras.abbasi@gmail.com)
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t) {
  t.loadFile = function(A, e, r) {
    return function(n, i, s) {
      i = i !== !1, s = typeof s == "function" ? s : function() {
      };
      var u = void 0;
      try {
        u = function(c, h, g) {
          var p = new XMLHttpRequest(), w = 0, B = function(L) {
            var y = L.length, N = [], F = String.fromCharCode;
            for (w = 0; w < y; w += 1) N.push(F(255 & L.charCodeAt(w)));
            return N.join("");
          };
          if (p.open("GET", c, !h), p.overrideMimeType("text/plain; charset=x-user-defined"), h === !1 && (p.onload = function() {
            p.status === 200 ? g(B(this.responseText)) : g(void 0);
          }), p.send(null), h && p.status === 200) return B(p.responseText);
        }(n, i, s);
      } catch {
      }
      return u;
    }(A, e, r);
  }, t.loadImageFile = t.loadFile;
}(GA.API), function(t) {
  function A() {
    return (VA.html2canvas ? Promise.resolve(VA.html2canvas) : Promise.resolve().then(() => gp)).catch(function(s) {
      return Promise.reject(new Error("Could not load html2canvas: " + s));
    }).then(function(s) {
      return s.default ? s.default : s;
    });
  }
  function e() {
    return (VA.DOMPurify ? Promise.resolve(VA.DOMPurify) : import("dompurify")).catch(function(s) {
      return Promise.reject(new Error("Could not load dompurify: " + s));
    }).then(function(s) {
      return s.default ? s.default : s;
    });
  }
  var r = function(s) {
    var u = de(s);
    return u === "undefined" ? "undefined" : u === "string" || s instanceof String ? "string" : u === "number" || s instanceof Number ? "number" : u === "function" || s instanceof Function ? "function" : s && s.constructor === Array ? "array" : s && s.nodeType === 1 ? "element" : u === "object" ? "object" : "unknown";
  }, n = function(s, u) {
    var c = document.createElement(s);
    for (var h in u.className && (c.className = u.className), u.innerHTML && u.dompurify && (c.innerHTML = u.dompurify.sanitize(u.innerHTML)), u.style) c.style[h] = u.style[h];
    return c;
  }, i = function s(u) {
    var c = Object.assign(s.convert(Promise.resolve()), JSON.parse(JSON.stringify(s.template))), h = s.convert(Promise.resolve(), c);
    return h = (h = h.setProgress(1, s, 1, [s])).set(u);
  };
  (i.prototype = Object.create(Promise.prototype)).constructor = i, i.convert = function(s, u) {
    return s.__proto__ = u || i.prototype, s;
  }, i.template = { prop: { src: null, container: null, overlay: null, canvas: null, img: null, pdf: null, pageSize: null, callback: function() {
  } }, progress: { val: 0, state: null, n: 0, stack: [] }, opt: { filename: "file.pdf", margin: [0, 0, 0, 0], enableLinks: !0, x: 0, y: 0, html2canvas: {}, jsPDF: {}, backgroundColor: "transparent" } }, i.prototype.from = function(s, u) {
    return this.then(function() {
      switch (u = u || function(c) {
        switch (r(c)) {
          case "string":
            return "string";
          case "element":
            return c.nodeName.toLowerCase() === "canvas" ? "canvas" : "element";
          default:
            return "unknown";
        }
      }(s)) {
        case "string":
          return this.then(e).then(function(c) {
            return this.set({ src: n("div", { innerHTML: s, dompurify: c }) });
          });
        case "element":
          return this.set({ src: s });
        case "canvas":
          return this.set({ canvas: s });
        case "img":
          return this.set({ img: s });
        default:
          return this.error("Unknown source type.");
      }
    });
  }, i.prototype.to = function(s) {
    switch (s) {
      case "container":
        return this.toContainer();
      case "canvas":
        return this.toCanvas();
      case "img":
        return this.toImg();
      case "pdf":
        return this.toPdf();
      default:
        return this.error("Invalid target.");
    }
  }, i.prototype.toContainer = function() {
    return this.thenList([function() {
      return this.prop.src || this.error("Cannot duplicate - no source HTML.");
    }, function() {
      return this.prop.pageSize || this.setPageSize();
    }]).then(function() {
      var s = { position: "relative", display: "inline-block", width: (typeof this.opt.width != "number" || isNaN(this.opt.width) || typeof this.opt.windowWidth != "number" || isNaN(this.opt.windowWidth) ? Math.max(this.prop.src.clientWidth, this.prop.src.scrollWidth, this.prop.src.offsetWidth) : this.opt.windowWidth) + "px", left: 0, right: 0, top: 0, margin: "auto", backgroundColor: this.opt.backgroundColor }, u = function c(h, g) {
        for (var p = h.nodeType === 3 ? document.createTextNode(h.nodeValue) : h.cloneNode(!1), w = h.firstChild; w; w = w.nextSibling) g !== !0 && w.nodeType === 1 && w.nodeName === "SCRIPT" || p.appendChild(c(w, g));
        return h.nodeType === 1 && (h.nodeName === "CANVAS" ? (p.width = h.width, p.height = h.height, p.getContext("2d").drawImage(h, 0, 0)) : h.nodeName !== "TEXTAREA" && h.nodeName !== "SELECT" || (p.value = h.value), p.addEventListener("load", function() {
          p.scrollTop = h.scrollTop, p.scrollLeft = h.scrollLeft;
        }, !0)), p;
      }(this.prop.src, this.opt.html2canvas.javascriptEnabled);
      u.tagName === "BODY" && (s.height = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) + "px"), this.prop.overlay = n("div", { className: "html2pdf__overlay", style: { position: "fixed", overflow: "hidden", zIndex: 1e3, left: "-100000px", right: 0, bottom: 0, top: 0 } }), this.prop.container = n("div", { className: "html2pdf__container", style: s }), this.prop.container.appendChild(u), this.prop.container.firstChild.appendChild(n("div", { style: { clear: "both", border: "0 none transparent", margin: 0, padding: 0, height: 0 } })), this.prop.container.style.float = "none", this.prop.overlay.appendChild(this.prop.container), document.body.appendChild(this.prop.overlay), this.prop.container.firstChild.style.position = "relative", this.prop.container.height = Math.max(this.prop.container.firstChild.clientHeight, this.prop.container.firstChild.scrollHeight, this.prop.container.firstChild.offsetHeight) + "px";
    });
  }, i.prototype.toCanvas = function() {
    var s = [function() {
      return document.body.contains(this.prop.container) || this.toContainer();
    }];
    return this.thenList(s).then(A).then(function(u) {
      var c = Object.assign({}, this.opt.html2canvas);
      return delete c.onrendered, u(this.prop.container, c);
    }).then(function(u) {
      (this.opt.html2canvas.onrendered || function() {
      })(u), this.prop.canvas = u, document.body.removeChild(this.prop.overlay);
    });
  }, i.prototype.toContext2d = function() {
    var s = [function() {
      return document.body.contains(this.prop.container) || this.toContainer();
    }];
    return this.thenList(s).then(A).then(function(u) {
      var c = this.opt.jsPDF, h = this.opt.fontFaces, g = typeof this.opt.width != "number" || isNaN(this.opt.width) || typeof this.opt.windowWidth != "number" || isNaN(this.opt.windowWidth) ? 1 : this.opt.width / this.opt.windowWidth, p = Object.assign({ async: !0, allowTaint: !0, scale: g, scrollX: this.opt.scrollX || 0, scrollY: this.opt.scrollY || 0, backgroundColor: "#ffffff", imageTimeout: 15e3, logging: !0, proxy: null, removeContainer: !0, foreignObjectRendering: !1, useCORS: !1 }, this.opt.html2canvas);
      if (delete p.onrendered, c.context2d.autoPaging = this.opt.autoPaging === void 0 || this.opt.autoPaging, c.context2d.posX = this.opt.x, c.context2d.posY = this.opt.y, c.context2d.margin = this.opt.margin, c.context2d.fontFaces = h, h) for (var w = 0; w < h.length; ++w) {
        var B = h[w], L = B.src.find(function(y) {
          return y.format === "truetype";
        });
        L && c.addFont(L.url, B.ref.name, B.ref.style);
      }
      return p.windowHeight = p.windowHeight || 0, p.windowHeight = p.windowHeight == 0 ? Math.max(this.prop.container.clientHeight, this.prop.container.scrollHeight, this.prop.container.offsetHeight) : p.windowHeight, c.context2d.save(!0), u(this.prop.container, p);
    }).then(function(u) {
      this.opt.jsPDF.context2d.restore(!0), (this.opt.html2canvas.onrendered || function() {
      })(u), this.prop.canvas = u, document.body.removeChild(this.prop.overlay);
    });
  }, i.prototype.toImg = function() {
    return this.thenList([function() {
      return this.prop.canvas || this.toCanvas();
    }]).then(function() {
      var s = this.prop.canvas.toDataURL("image/" + this.opt.image.type, this.opt.image.quality);
      this.prop.img = document.createElement("img"), this.prop.img.src = s;
    });
  }, i.prototype.toPdf = function() {
    return this.thenList([function() {
      return this.toContext2d();
    }]).then(function() {
      this.prop.pdf = this.prop.pdf || this.opt.jsPDF;
    });
  }, i.prototype.output = function(s, u, c) {
    return (c = c || "pdf").toLowerCase() === "img" || c.toLowerCase() === "image" ? this.outputImg(s, u) : this.outputPdf(s, u);
  }, i.prototype.outputPdf = function(s, u) {
    return this.thenList([function() {
      return this.prop.pdf || this.toPdf();
    }]).then(function() {
      return this.prop.pdf.output(s, u);
    });
  }, i.prototype.outputImg = function(s) {
    return this.thenList([function() {
      return this.prop.img || this.toImg();
    }]).then(function() {
      switch (s) {
        case void 0:
        case "img":
          return this.prop.img;
        case "datauristring":
        case "dataurlstring":
          return this.prop.img.src;
        case "datauri":
        case "dataurl":
          return document.location.href = this.prop.img.src;
        default:
          throw 'Image output type "' + s + '" is not supported.';
      }
    });
  }, i.prototype.save = function(s) {
    return this.thenList([function() {
      return this.prop.pdf || this.toPdf();
    }]).set(s ? { filename: s } : null).then(function() {
      this.prop.pdf.save(this.opt.filename);
    });
  }, i.prototype.doCallback = function() {
    return this.thenList([function() {
      return this.prop.pdf || this.toPdf();
    }]).then(function() {
      this.prop.callback(this.prop.pdf);
    });
  }, i.prototype.set = function(s) {
    if (r(s) !== "object") return this;
    var u = Object.keys(s || {}).map(function(c) {
      if (c in i.template.prop) return function() {
        this.prop[c] = s[c];
      };
      switch (c) {
        case "margin":
          return this.setMargin.bind(this, s.margin);
        case "jsPDF":
          return function() {
            return this.opt.jsPDF = s.jsPDF, this.setPageSize();
          };
        case "pageSize":
          return this.setPageSize.bind(this, s.pageSize);
        default:
          return function() {
            this.opt[c] = s[c];
          };
      }
    }, this);
    return this.then(function() {
      return this.thenList(u);
    });
  }, i.prototype.get = function(s, u) {
    return this.then(function() {
      var c = s in i.template.prop ? this.prop[s] : this.opt[s];
      return u ? u(c) : c;
    });
  }, i.prototype.setMargin = function(s) {
    return this.then(function() {
      switch (r(s)) {
        case "number":
          s = [s, s, s, s];
        case "array":
          if (s.length === 2 && (s = [s[0], s[1], s[0], s[1]]), s.length === 4) break;
        default:
          return this.error("Invalid margin array.");
      }
      this.opt.margin = s;
    }).then(this.setPageSize);
  }, i.prototype.setPageSize = function(s) {
    function u(c, h) {
      return Math.floor(c * h / 72 * 96);
    }
    return this.then(function() {
      (s = s || GA.getPageSize(this.opt.jsPDF)).hasOwnProperty("inner") || (s.inner = { width: s.width - this.opt.margin[1] - this.opt.margin[3], height: s.height - this.opt.margin[0] - this.opt.margin[2] }, s.inner.px = { width: u(s.inner.width, s.k), height: u(s.inner.height, s.k) }, s.inner.ratio = s.inner.height / s.inner.width), this.prop.pageSize = s;
    });
  }, i.prototype.setProgress = function(s, u, c, h) {
    return s != null && (this.progress.val = s), u != null && (this.progress.state = u), c != null && (this.progress.n = c), h != null && (this.progress.stack = h), this.progress.ratio = this.progress.val / this.progress.state, this;
  }, i.prototype.updateProgress = function(s, u, c, h) {
    return this.setProgress(s ? this.progress.val + s : null, u || null, c ? this.progress.n + c : null, h ? this.progress.stack.concat(h) : null);
  }, i.prototype.then = function(s, u) {
    var c = this;
    return this.thenCore(s, u, function(h, g) {
      return c.updateProgress(null, null, 1, [h]), Promise.prototype.then.call(this, function(p) {
        return c.updateProgress(null, h), p;
      }).then(h, g).then(function(p) {
        return c.updateProgress(1), p;
      });
    });
  }, i.prototype.thenCore = function(s, u, c) {
    c = c || Promise.prototype.then, s && (s = s.bind(this)), u && (u = u.bind(this));
    var h = Promise.toString().indexOf("[native code]") !== -1 && Promise.name === "Promise" ? this : i.convert(Object.assign({}, this), Promise.prototype), g = c.call(h, s, u);
    return i.convert(g, this.__proto__);
  }, i.prototype.thenExternal = function(s, u) {
    return Promise.prototype.then.call(this, s, u);
  }, i.prototype.thenList = function(s) {
    var u = this;
    return s.forEach(function(c) {
      u = u.thenCore(c);
    }), u;
  }, i.prototype.catch = function(s) {
    s && (s = s.bind(this));
    var u = Promise.prototype.catch.call(this, s);
    return i.convert(u, this);
  }, i.prototype.catchExternal = function(s) {
    return Promise.prototype.catch.call(this, s);
  }, i.prototype.error = function(s) {
    return this.then(function() {
      throw new Error(s);
    });
  }, i.prototype.using = i.prototype.set, i.prototype.saveAs = i.prototype.save, i.prototype.export = i.prototype.output, i.prototype.run = i.prototype.then, GA.getPageSize = function(s, u, c) {
    if (de(s) === "object") {
      var h = s;
      s = h.orientation, u = h.unit || u, c = h.format || c;
    }
    u = u || "mm", c = c || "a4", s = ("" + (s || "P")).toLowerCase();
    var g, p = ("" + c).toLowerCase(), w = { a0: [2383.94, 3370.39], a1: [1683.78, 2383.94], a2: [1190.55, 1683.78], a3: [841.89, 1190.55], a4: [595.28, 841.89], a5: [419.53, 595.28], a6: [297.64, 419.53], a7: [209.76, 297.64], a8: [147.4, 209.76], a9: [104.88, 147.4], a10: [73.7, 104.88], b0: [2834.65, 4008.19], b1: [2004.09, 2834.65], b2: [1417.32, 2004.09], b3: [1000.63, 1417.32], b4: [708.66, 1000.63], b5: [498.9, 708.66], b6: [354.33, 498.9], b7: [249.45, 354.33], b8: [175.75, 249.45], b9: [124.72, 175.75], b10: [87.87, 124.72], c0: [2599.37, 3676.54], c1: [1836.85, 2599.37], c2: [1298.27, 1836.85], c3: [918.43, 1298.27], c4: [649.13, 918.43], c5: [459.21, 649.13], c6: [323.15, 459.21], c7: [229.61, 323.15], c8: [161.57, 229.61], c9: [113.39, 161.57], c10: [79.37, 113.39], dl: [311.81, 623.62], letter: [612, 792], "government-letter": [576, 756], legal: [612, 1008], "junior-legal": [576, 360], ledger: [1224, 792], tabloid: [792, 1224], "credit-card": [153, 243] };
    switch (u) {
      case "pt":
        g = 1;
        break;
      case "mm":
        g = 72 / 25.4;
        break;
      case "cm":
        g = 72 / 2.54;
        break;
      case "in":
        g = 72;
        break;
      case "px":
        g = 0.75;
        break;
      case "pc":
      case "em":
        g = 12;
        break;
      case "ex":
        g = 6;
        break;
      default:
        throw "Invalid unit: " + u;
    }
    var B, L = 0, y = 0;
    if (w.hasOwnProperty(p)) L = w[p][1] / g, y = w[p][0] / g;
    else try {
      L = c[1], y = c[0];
    } catch {
      throw new Error("Invalid format: " + c);
    }
    if (s === "p" || s === "portrait") s = "p", y > L && (B = y, y = L, L = B);
    else {
      if (s !== "l" && s !== "landscape") throw "Invalid orientation: " + s;
      s = "l", L > y && (B = y, y = L, L = B);
    }
    return { width: y, height: L, unit: u, k: g, orientation: s };
  }, t.html = function(s, u) {
    (u = u || {}).callback = u.callback || function() {
    }, u.html2canvas = u.html2canvas || {}, u.html2canvas.canvas = u.html2canvas.canvas || this.canvas, u.jsPDF = u.jsPDF || this, u.fontFaces = u.fontFaces ? u.fontFaces.map(Nc) : null;
    var c = new i(u);
    return u.worker ? c : c.from(s).doCallback();
  };
}(GA.API), GA.API.addJS = function(t) {
  return xf = t, this.internal.events.subscribe("postPutResources", function() {
    Ao = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/Names [(EmbeddedJS) " + (Ao + 1) + " 0 R]"), this.internal.out(">>"), this.internal.out("endobj"), If = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /JavaScript"), this.internal.out("/JS (" + xf + ")"), this.internal.out(">>"), this.internal.out("endobj");
  }), this.internal.events.subscribe("putCatalog", function() {
    Ao !== void 0 && If !== void 0 && this.internal.out("/Names <</JavaScript " + Ao + " 0 R>>");
  }), this;
}, /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t) {
  var A;
  t.events.push(["postPutResources", function() {
    var e = this, r = /^(\d+) 0 obj$/;
    if (this.outline.root.children.length > 0) for (var n = e.outline.render().split(/\r\n/), i = 0; i < n.length; i++) {
      var s = n[i], u = r.exec(s);
      if (u != null) {
        var c = u[1];
        e.internal.newObjectDeferredBegin(c, !1);
      }
      e.internal.write(s);
    }
    if (this.outline.createNamedDestinations) {
      var h = this.internal.pages.length, g = [];
      for (i = 0; i < h; i++) {
        var p = e.internal.newObject();
        g.push(p);
        var w = e.internal.getPageInfo(i + 1);
        e.internal.write("<< /D[" + w.objId + " 0 R /XYZ null null null]>> endobj");
      }
      var B = e.internal.newObject();
      for (e.internal.write("<< /Names [ "), i = 0; i < g.length; i++) e.internal.write("(page_" + (i + 1) + ")" + g[i] + " 0 R");
      e.internal.write(" ] >>", "endobj"), A = e.internal.newObject(), e.internal.write("<< /Dests " + B + " 0 R"), e.internal.write(">>", "endobj");
    }
  }]), t.events.push(["putCatalog", function() {
    this.outline.root.children.length > 0 && (this.internal.write("/Outlines", this.outline.makeRef(this.outline.root)), this.outline.createNamedDestinations && this.internal.write("/Names " + A + " 0 R"));
  }]), t.events.push(["initialized", function() {
    var e = this;
    e.outline = { createNamedDestinations: !1, root: { children: [] } }, e.outline.add = function(r, n, i) {
      var s = { title: n, options: i, children: [] };
      return r == null && (r = this.root), r.children.push(s), s;
    }, e.outline.render = function() {
      return this.ctx = {}, this.ctx.val = "", this.ctx.pdf = e, this.genIds_r(this.root), this.renderRoot(this.root), this.renderItems(this.root), this.ctx.val;
    }, e.outline.genIds_r = function(r) {
      r.id = e.internal.newObjectDeferred();
      for (var n = 0; n < r.children.length; n++) this.genIds_r(r.children[n]);
    }, e.outline.renderRoot = function(r) {
      this.objStart(r), this.line("/Type /Outlines"), r.children.length > 0 && (this.line("/First " + this.makeRef(r.children[0])), this.line("/Last " + this.makeRef(r.children[r.children.length - 1]))), this.line("/Count " + this.count_r({ count: 0 }, r)), this.objEnd();
    }, e.outline.renderItems = function(r) {
      for (var n = this.ctx.pdf.internal.getVerticalCoordinateString, i = 0; i < r.children.length; i++) {
        var s = r.children[i];
        this.objStart(s), this.line("/Title " + this.makeString(s.title)), this.line("/Parent " + this.makeRef(r)), i > 0 && this.line("/Prev " + this.makeRef(r.children[i - 1])), i < r.children.length - 1 && this.line("/Next " + this.makeRef(r.children[i + 1])), s.children.length > 0 && (this.line("/First " + this.makeRef(s.children[0])), this.line("/Last " + this.makeRef(s.children[s.children.length - 1])));
        var u = this.count = this.count_r({ count: 0 }, s);
        if (u > 0 && this.line("/Count " + u), s.options && s.options.pageNumber) {
          var c = e.internal.getPageInfo(s.options.pageNumber);
          this.line("/Dest [" + c.objId + " 0 R /XYZ 0 " + n(0) + " 0]");
        }
        this.objEnd();
      }
      for (var h = 0; h < r.children.length; h++) this.renderItems(r.children[h]);
    }, e.outline.line = function(r) {
      this.ctx.val += r + `\r
`;
    }, e.outline.makeRef = function(r) {
      return r.id + " 0 R";
    }, e.outline.makeString = function(r) {
      return "(" + e.internal.pdfEscape(r) + ")";
    }, e.outline.objStart = function(r) {
      this.ctx.val += `\r
` + r.id + ` 0 obj\r
<<\r
`;
    }, e.outline.objEnd = function() {
      this.ctx.val += `>> \r
endobj\r
`;
    }, e.outline.count_r = function(r, n) {
      for (var i = 0; i < n.children.length; i++) r.count++, this.count_r(r, n.children[i]);
      return r.count;
    };
  }]);
}(GA.API), /**
 * @license
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t) {
  var A = [192, 193, 194, 195, 196, 197, 198, 199];
  t.processJPEG = function(e, r, n, i, s, u) {
    var c, h = this.decode.DCT_DECODE, g = null;
    if (typeof e == "string" || this.__addimage__.isArrayBuffer(e) || this.__addimage__.isArrayBufferView(e)) {
      switch (e = s || e, e = this.__addimage__.isArrayBuffer(e) ? new Uint8Array(e) : e, (c = function(p) {
        for (var w, B = 256 * p.charCodeAt(4) + p.charCodeAt(5), L = p.length, y = { width: 0, height: 0, numcomponents: 1 }, N = 4; N < L; N += 2) {
          if (N += B, A.indexOf(p.charCodeAt(N + 1)) !== -1) {
            w = 256 * p.charCodeAt(N + 5) + p.charCodeAt(N + 6), y = { width: 256 * p.charCodeAt(N + 7) + p.charCodeAt(N + 8), height: w, numcomponents: p.charCodeAt(N + 9) };
            break;
          }
          B = 256 * p.charCodeAt(N + 2) + p.charCodeAt(N + 3);
        }
        return y;
      }(e = this.__addimage__.isArrayBufferView(e) ? this.__addimage__.arrayBufferToBinaryString(e) : e)).numcomponents) {
        case 1:
          u = this.color_spaces.DEVICE_GRAY;
          break;
        case 4:
          u = this.color_spaces.DEVICE_CMYK;
          break;
        case 3:
          u = this.color_spaces.DEVICE_RGB;
      }
      g = { data: e, width: c.width, height: c.height, colorSpace: u, bitsPerComponent: 8, filter: h, index: r, alias: n };
    }
    return g;
  };
}(GA.API);
var Ui, eo, Hf, Sf, Nf, zp = function() {
  var t, A, e;
  function r(i) {
    var s, u, c, h, g, p, w, B, L, y, N, F, x, R;
    for (this.data = i, this.pos = 8, this.palette = [], this.imgData = [], this.transparency = {}, this.animation = null, this.text = {}, p = null; ; ) {
      switch (s = this.readUInt32(), L = (function() {
        var Y, Z;
        for (Z = [], Y = 0; Y < 4; ++Y) Z.push(String.fromCharCode(this.data[this.pos++]));
        return Z;
      }).call(this).join("")) {
        case "IHDR":
          this.width = this.readUInt32(), this.height = this.readUInt32(), this.bits = this.data[this.pos++], this.colorType = this.data[this.pos++], this.compressionMethod = this.data[this.pos++], this.filterMethod = this.data[this.pos++], this.interlaceMethod = this.data[this.pos++];
          break;
        case "acTL":
          this.animation = { numFrames: this.readUInt32(), numPlays: this.readUInt32() || 1 / 0, frames: [] };
          break;
        case "PLTE":
          this.palette = this.read(s);
          break;
        case "fcTL":
          p && this.animation.frames.push(p), this.pos += 4, p = { width: this.readUInt32(), height: this.readUInt32(), xOffset: this.readUInt32(), yOffset: this.readUInt32() }, g = this.readUInt16(), h = this.readUInt16() || 100, p.delay = 1e3 * g / h, p.disposeOp = this.data[this.pos++], p.blendOp = this.data[this.pos++], p.data = [];
          break;
        case "IDAT":
        case "fdAT":
          for (L === "fdAT" && (this.pos += 4, s -= 4), i = (p != null ? p.data : void 0) || this.imgData, F = 0; 0 <= s ? F < s : F > s; 0 <= s ? ++F : --F) i.push(this.data[this.pos++]);
          break;
        case "tRNS":
          switch (this.transparency = {}, this.colorType) {
            case 3:
              if (c = this.palette.length / 3, this.transparency.indexed = this.read(s), this.transparency.indexed.length > c) throw new Error("More transparent colors than palette size");
              if ((y = c - this.transparency.indexed.length) > 0) for (x = 0; 0 <= y ? x < y : x > y; 0 <= y ? ++x : --x) this.transparency.indexed.push(255);
              break;
            case 0:
              this.transparency.grayscale = this.read(s)[0];
              break;
            case 2:
              this.transparency.rgb = this.read(s);
          }
          break;
        case "tEXt":
          w = (N = this.read(s)).indexOf(0), B = String.fromCharCode.apply(String, N.slice(0, w)), this.text[B] = String.fromCharCode.apply(String, N.slice(w + 1));
          break;
        case "IEND":
          return p && this.animation.frames.push(p), this.colors = (function() {
            switch (this.colorType) {
              case 0:
              case 3:
              case 4:
                return 1;
              case 2:
              case 6:
                return 3;
            }
          }).call(this), this.hasAlphaChannel = (R = this.colorType) === 4 || R === 6, u = this.colors + (this.hasAlphaChannel ? 1 : 0), this.pixelBitlength = this.bits * u, this.colorSpace = (function() {
            switch (this.colors) {
              case 1:
                return "DeviceGray";
              case 3:
                return "DeviceRGB";
            }
          }).call(this), void (this.imgData = new Uint8Array(this.imgData));
        default:
          this.pos += s;
      }
      if (this.pos += 4, this.pos > this.data.length) throw new Error("Incomplete or corrupt PNG file");
    }
  }
  r.prototype.read = function(i) {
    var s, u;
    for (u = [], s = 0; 0 <= i ? s < i : s > i; 0 <= i ? ++s : --s) u.push(this.data[this.pos++]);
    return u;
  }, r.prototype.readUInt32 = function() {
    return this.data[this.pos++] << 24 | this.data[this.pos++] << 16 | this.data[this.pos++] << 8 | this.data[this.pos++];
  }, r.prototype.readUInt16 = function() {
    return this.data[this.pos++] << 8 | this.data[this.pos++];
  }, r.prototype.decodePixels = function(i) {
    var s = this.pixelBitlength / 8, u = new Uint8Array(this.width * this.height * s), c = 0, h = this;
    if (i == null && (i = this.imgData), i.length === 0) return new Uint8Array(0);
    function g(p, w, B, L) {
      var y, N, F, x, R, Y, Z, $, J, O, W, cA, I, H, K, M, oA, iA, uA, eA, lA, hA = Math.ceil((h.width - p) / B), UA = Math.ceil((h.height - w) / L), U = h.width == hA && h.height == UA;
      for (H = s * hA, cA = U ? u : new Uint8Array(H * UA), Y = i.length, I = 0, N = 0; I < UA && c < Y; ) {
        switch (i[c++]) {
          case 0:
            for (x = oA = 0; oA < H; x = oA += 1) cA[N++] = i[c++];
            break;
          case 1:
            for (x = iA = 0; iA < H; x = iA += 1) y = i[c++], R = x < s ? 0 : cA[N - s], cA[N++] = (y + R) % 256;
            break;
          case 2:
            for (x = uA = 0; uA < H; x = uA += 1) y = i[c++], F = (x - x % s) / s, K = I && cA[(I - 1) * H + F * s + x % s], cA[N++] = (K + y) % 256;
            break;
          case 3:
            for (x = eA = 0; eA < H; x = eA += 1) y = i[c++], F = (x - x % s) / s, R = x < s ? 0 : cA[N - s], K = I && cA[(I - 1) * H + F * s + x % s], cA[N++] = (y + Math.floor((R + K) / 2)) % 256;
            break;
          case 4:
            for (x = lA = 0; lA < H; x = lA += 1) y = i[c++], F = (x - x % s) / s, R = x < s ? 0 : cA[N - s], I === 0 ? K = M = 0 : (K = cA[(I - 1) * H + F * s + x % s], M = F && cA[(I - 1) * H + (F - 1) * s + x % s]), Z = R + K - M, $ = Math.abs(Z - R), O = Math.abs(Z - K), W = Math.abs(Z - M), J = $ <= O && $ <= W ? R : O <= W ? K : M, cA[N++] = (y + J) % 256;
            break;
          default:
            throw new Error("Invalid filter algorithm: " + i[c - 1]);
        }
        if (!U) {
          var _ = ((w + I * L) * h.width + p) * s, T = I * H;
          for (x = 0; x < hA; x += 1) {
            for (var k = 0; k < s; k += 1) u[_++] = cA[T++];
            _ += (B - 1) * s;
          }
        }
        I++;
      }
    }
    return i = Ep(i), h.interlaceMethod == 1 ? (g(0, 0, 8, 8), g(4, 0, 8, 8), g(0, 4, 4, 8), g(2, 0, 4, 4), g(0, 2, 2, 4), g(1, 0, 2, 2), g(0, 1, 1, 2)) : g(0, 0, 1, 1), u;
  }, r.prototype.decodePalette = function() {
    var i, s, u, c, h, g, p, w, B;
    for (u = this.palette, g = this.transparency.indexed || [], h = new Uint8Array((g.length || 0) + u.length), c = 0, i = 0, s = p = 0, w = u.length; p < w; s = p += 3) h[c++] = u[s], h[c++] = u[s + 1], h[c++] = u[s + 2], h[c++] = (B = g[i++]) != null ? B : 255;
    return h;
  }, r.prototype.copyToImageData = function(i, s) {
    var u, c, h, g, p, w, B, L, y, N, F;
    if (c = this.colors, y = null, u = this.hasAlphaChannel, this.palette.length && (y = (F = this._decodedPalette) != null ? F : this._decodedPalette = this.decodePalette(), c = 4, u = !0), L = (h = i.data || i).length, p = y || s, g = w = 0, c === 1) for (; g < L; ) B = y ? 4 * s[g / 4] : w, N = p[B++], h[g++] = N, h[g++] = N, h[g++] = N, h[g++] = u ? p[B++] : 255, w = B;
    else for (; g < L; ) B = y ? 4 * s[g / 4] : w, h[g++] = p[B++], h[g++] = p[B++], h[g++] = p[B++], h[g++] = u ? p[B++] : 255, w = B;
  }, r.prototype.decode = function() {
    var i;
    return i = new Uint8Array(this.width * this.height * 4), this.copyToImageData(i, this.decodePixels()), i;
  };
  var n = function() {
    if (Object.prototype.toString.call(VA) === "[object Window]") {
      try {
        A = VA.document.createElement("canvas"), e = A.getContext("2d");
      } catch {
        return !1;
      }
      return !0;
    }
    return !1;
  };
  return n(), t = function(i) {
    var s;
    if (n() === !0) return e.width = i.width, e.height = i.height, e.clearRect(0, 0, i.width, i.height), e.putImageData(i, 0, 0), (s = new Image()).src = A.toDataURL(), s;
    throw new Error("This method requires a Browser with Canvas-capability.");
  }, r.prototype.decodeFrames = function(i) {
    var s, u, c, h, g, p, w, B;
    if (this.animation) {
      for (B = [], u = g = 0, p = (w = this.animation.frames).length; g < p; u = ++g) s = w[u], c = i.createImageData(s.width, s.height), h = this.decodePixels(new Uint8Array(s.data)), this.copyToImageData(c, h), s.imageData = c, B.push(s.image = t(c));
      return B;
    }
  }, r.prototype.renderFrame = function(i, s) {
    var u, c, h;
    return u = (c = this.animation.frames)[s], h = c[s - 1], s === 0 && i.clearRect(0, 0, this.width, this.height), (h != null ? h.disposeOp : void 0) === 1 ? i.clearRect(h.xOffset, h.yOffset, h.width, h.height) : (h != null ? h.disposeOp : void 0) === 2 && i.putImageData(h.imageData, h.xOffset, h.yOffset), u.blendOp === 0 && i.clearRect(u.xOffset, u.yOffset, u.width, u.height), i.drawImage(u.image, u.xOffset, u.yOffset);
  }, r.prototype.animate = function(i) {
    var s, u, c, h, g, p, w = this;
    return u = 0, p = this.animation, h = p.numFrames, c = p.frames, g = p.numPlays, (s = function() {
      var B, L;
      if (B = u++ % h, L = c[B], w.renderFrame(i, B), h > 1 && u / h < g) return w.animation._timeout = setTimeout(s, L.delay);
    })();
  }, r.prototype.stopAnimation = function() {
    var i;
    return clearTimeout((i = this.animation) != null ? i._timeout : void 0);
  }, r.prototype.render = function(i) {
    var s, u;
    return i._png && i._png.stopAnimation(), i._png = this, i.width = this.width, i.height = this.height, s = i.getContext("2d"), this.animation ? (this.decodeFrames(s), this.animate(s)) : (u = s.createImageData(this.width, this.height), this.copyToImageData(u, this.decodePixels()), s.putImageData(u, 0, 0));
  }, r;
}();
/**
 * @license
 *
 * Copyright (c) 2014 James Robb, https://github.com/jamesbrobb
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */
/**
 * @license
 * (c) Dean McNamee <dean@gmail.com>, 2013.
 *
 * https://github.com/deanm/omggif
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to
 * deal in the Software without restriction, including without limitation the
 * rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
 * sell copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 *
 * omggif is a JavaScript implementation of a GIF 89a encoder and decoder,
 * including animation and compression.  It does not rely on any specific
 * underlying system, so should run in the browser, Node, or Plask.
 */
function Yp(t) {
  var A = 0;
  if (t[A++] !== 71 || t[A++] !== 73 || t[A++] !== 70 || t[A++] !== 56 || (t[A++] + 1 & 253) != 56 || t[A++] !== 97) throw new Error("Invalid GIF 87a/89a header.");
  var e = t[A++] | t[A++] << 8, r = t[A++] | t[A++] << 8, n = t[A++], i = n >> 7, s = 1 << (7 & n) + 1;
  t[A++], t[A++];
  var u = null, c = null;
  i && (u = A, c = s, A += 3 * s);
  var h = !0, g = [], p = 0, w = null, B = 0, L = null;
  for (this.width = e, this.height = r; h && A < t.length; ) switch (t[A++]) {
    case 33:
      switch (t[A++]) {
        case 255:
          if (t[A] !== 11 || t[A + 1] == 78 && t[A + 2] == 69 && t[A + 3] == 84 && t[A + 4] == 83 && t[A + 5] == 67 && t[A + 6] == 65 && t[A + 7] == 80 && t[A + 8] == 69 && t[A + 9] == 50 && t[A + 10] == 46 && t[A + 11] == 48 && t[A + 12] == 3 && t[A + 13] == 1 && t[A + 16] == 0) A += 14, L = t[A++] | t[A++] << 8, A++;
          else for (A += 12; ; ) {
            if (!((I = t[A++]) >= 0)) throw Error("Invalid block size");
            if (I === 0) break;
            A += I;
          }
          break;
        case 249:
          if (t[A++] !== 4 || t[A + 4] !== 0) throw new Error("Invalid graphics extension block.");
          var y = t[A++];
          p = t[A++] | t[A++] << 8, w = t[A++], (1 & y) == 0 && (w = null), B = y >> 2 & 7, A++;
          break;
        case 254:
          for (; ; ) {
            if (!((I = t[A++]) >= 0)) throw Error("Invalid block size");
            if (I === 0) break;
            A += I;
          }
          break;
        default:
          throw new Error("Unknown graphic control label: 0x" + t[A - 1].toString(16));
      }
      break;
    case 44:
      var N = t[A++] | t[A++] << 8, F = t[A++] | t[A++] << 8, x = t[A++] | t[A++] << 8, R = t[A++] | t[A++] << 8, Y = t[A++], Z = Y >> 6 & 1, $ = 1 << (7 & Y) + 1, J = u, O = c, W = !1;
      Y >> 7 && (W = !0, J = A, O = $, A += 3 * $);
      var cA = A;
      for (A++; ; ) {
        var I;
        if (!((I = t[A++]) >= 0)) throw Error("Invalid block size");
        if (I === 0) break;
        A += I;
      }
      g.push({ x: N, y: F, width: x, height: R, has_local_palette: W, palette_offset: J, palette_size: O, data_offset: cA, data_length: A - cA, transparent_index: w, interlaced: !!Z, delay: p, disposal: B });
      break;
    case 59:
      h = !1;
      break;
    default:
      throw new Error("Unknown gif block: 0x" + t[A - 1].toString(16));
  }
  this.numFrames = function() {
    return g.length;
  }, this.loopCount = function() {
    return L;
  }, this.frameInfo = function(H) {
    if (H < 0 || H >= g.length) throw new Error("Frame index out of range.");
    return g[H];
  }, this.decodeAndBlitFrameBGRA = function(H, K) {
    var M = this.frameInfo(H), oA = M.width * M.height, iA = new Uint8Array(oA);
    _f(t, M.data_offset, iA, oA);
    var uA = M.palette_offset, eA = M.transparent_index;
    eA === null && (eA = 256);
    var lA = M.width, hA = e - lA, UA = lA, U = 4 * (M.y * e + M.x), _ = 4 * ((M.y + M.height) * e + M.x), T = U, k = 4 * hA;
    M.interlaced === !0 && (k += 4 * e * 7);
    for (var X = 8, nA = 0, aA = iA.length; nA < aA; ++nA) {
      var sA = iA[nA];
      if (UA === 0 && (UA = lA, (T += k) >= _ && (k = 4 * hA + 4 * e * (X - 1), T = U + (lA + hA) * (X << 1), X >>= 1)), sA === eA) T += 4;
      else {
        var FA = t[uA + 3 * sA], QA = t[uA + 3 * sA + 1], xA = t[uA + 3 * sA + 2];
        K[T++] = xA, K[T++] = QA, K[T++] = FA, K[T++] = 255;
      }
      --UA;
    }
  }, this.decodeAndBlitFrameRGBA = function(H, K) {
    var M = this.frameInfo(H), oA = M.width * M.height, iA = new Uint8Array(oA);
    _f(t, M.data_offset, iA, oA);
    var uA = M.palette_offset, eA = M.transparent_index;
    eA === null && (eA = 256);
    var lA = M.width, hA = e - lA, UA = lA, U = 4 * (M.y * e + M.x), _ = 4 * ((M.y + M.height) * e + M.x), T = U, k = 4 * hA;
    M.interlaced === !0 && (k += 4 * e * 7);
    for (var X = 8, nA = 0, aA = iA.length; nA < aA; ++nA) {
      var sA = iA[nA];
      if (UA === 0 && (UA = lA, (T += k) >= _ && (k = 4 * hA + 4 * e * (X - 1), T = U + (lA + hA) * (X << 1), X >>= 1)), sA === eA) T += 4;
      else {
        var FA = t[uA + 3 * sA], QA = t[uA + 3 * sA + 1], xA = t[uA + 3 * sA + 2];
        K[T++] = FA, K[T++] = QA, K[T++] = xA, K[T++] = 255;
      }
      --UA;
    }
  };
}
function _f(t, A, e, r) {
  for (var n = t[A++], i = 1 << n, s = i + 1, u = s + 1, c = n + 1, h = (1 << c) - 1, g = 0, p = 0, w = 0, B = t[A++], L = new Int32Array(4096), y = null; ; ) {
    for (; g < 16 && B !== 0; ) p |= t[A++] << g, g += 8, B === 1 ? B = t[A++] : --B;
    if (g < c) break;
    var N = p & h;
    if (p >>= c, g -= c, N !== i) {
      if (N === s) break;
      for (var F = N < u ? N : y, x = 0, R = F; R > i; ) R = L[R] >> 8, ++x;
      var Y = R;
      if (w + x + (F !== N ? 1 : 0) > r) return void Qe.log("Warning, gif stream longer than expected.");
      e[w++] = Y;
      var Z = w += x;
      for (F !== N && (e[w++] = Y), R = F; x--; ) R = L[R], e[--Z] = 255 & R, R >>= 8;
      y !== null && u < 4096 && (L[u++] = y << 8 | Y, u >= h + 1 && c < 12 && (++c, h = h << 1 | 1)), y = N;
    } else u = s + 1, h = (1 << (c = n + 1)) - 1, y = null;
  }
  return w !== r && Qe.log("Warning, gif stream shorter than expected."), e;
}
/**
 * @license
  Copyright (c) 2008, Adobe Systems Incorporated
  All rights reserved.

  Redistribution and use in source and binary forms, with or without 
  modification, are permitted provided that the following conditions are
  met:

  * Redistributions of source code must retain the above copyright notice, 
    this list of conditions and the following disclaimer.
  
  * Redistributions in binary form must reproduce the above copyright
    notice, this list of conditions and the following disclaimer in the 
    documentation and/or other materials provided with the distribution.
  
  * Neither the name of Adobe Systems Incorporated nor the names of its 
    contributors may be used to endorse or promote products derived from 
    this software without specific prior written permission.

  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
  IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
  THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
  PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR 
  CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
  PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
  LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
  SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/
function $u(t) {
  var A, e, r, n, i, s = Math.floor, u = new Array(64), c = new Array(64), h = new Array(64), g = new Array(64), p = new Array(65535), w = new Array(65535), B = new Array(64), L = new Array(64), y = [], N = 0, F = 7, x = new Array(64), R = new Array(64), Y = new Array(64), Z = new Array(256), $ = new Array(2048), J = [0, 1, 5, 6, 14, 15, 27, 28, 2, 4, 7, 13, 16, 26, 29, 42, 3, 8, 12, 17, 25, 30, 41, 43, 9, 11, 18, 24, 31, 40, 44, 53, 10, 19, 23, 32, 39, 45, 52, 54, 20, 22, 33, 38, 46, 51, 55, 60, 21, 34, 37, 47, 50, 56, 59, 61, 35, 36, 48, 49, 57, 58, 62, 63], O = [0, 0, 1, 5, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0], W = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], cA = [0, 0, 2, 1, 3, 3, 2, 4, 3, 5, 5, 4, 4, 0, 0, 1, 125], I = [1, 2, 3, 0, 4, 17, 5, 18, 33, 49, 65, 6, 19, 81, 97, 7, 34, 113, 20, 50, 129, 145, 161, 8, 35, 66, 177, 193, 21, 82, 209, 240, 36, 51, 98, 114, 130, 9, 10, 22, 23, 24, 25, 26, 37, 38, 39, 40, 41, 42, 52, 53, 54, 55, 56, 57, 58, 67, 68, 69, 70, 71, 72, 73, 74, 83, 84, 85, 86, 87, 88, 89, 90, 99, 100, 101, 102, 103, 104, 105, 106, 115, 116, 117, 118, 119, 120, 121, 122, 131, 132, 133, 134, 135, 136, 137, 138, 146, 147, 148, 149, 150, 151, 152, 153, 154, 162, 163, 164, 165, 166, 167, 168, 169, 170, 178, 179, 180, 181, 182, 183, 184, 185, 186, 194, 195, 196, 197, 198, 199, 200, 201, 202, 210, 211, 212, 213, 214, 215, 216, 217, 218, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250], H = [0, 0, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0], K = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], M = [0, 0, 2, 1, 2, 4, 4, 3, 4, 7, 5, 4, 4, 0, 1, 2, 119], oA = [0, 1, 2, 3, 17, 4, 5, 33, 49, 6, 18, 65, 81, 7, 97, 113, 19, 34, 50, 129, 8, 20, 66, 145, 161, 177, 193, 9, 35, 51, 82, 240, 21, 98, 114, 209, 10, 22, 36, 52, 225, 37, 241, 23, 24, 25, 26, 38, 39, 40, 41, 42, 53, 54, 55, 56, 57, 58, 67, 68, 69, 70, 71, 72, 73, 74, 83, 84, 85, 86, 87, 88, 89, 90, 99, 100, 101, 102, 103, 104, 105, 106, 115, 116, 117, 118, 119, 120, 121, 122, 130, 131, 132, 133, 134, 135, 136, 137, 138, 146, 147, 148, 149, 150, 151, 152, 153, 154, 162, 163, 164, 165, 166, 167, 168, 169, 170, 178, 179, 180, 181, 182, 183, 184, 185, 186, 194, 195, 196, 197, 198, 199, 200, 201, 202, 210, 211, 212, 213, 214, 215, 216, 217, 218, 226, 227, 228, 229, 230, 231, 232, 233, 234, 242, 243, 244, 245, 246, 247, 248, 249, 250];
  function iA(U, _) {
    for (var T = 0, k = 0, X = new Array(), nA = 1; nA <= 16; nA++) {
      for (var aA = 1; aA <= U[nA]; aA++) X[_[k]] = [], X[_[k]][0] = T, X[_[k]][1] = nA, k++, T++;
      T *= 2;
    }
    return X;
  }
  function uA(U) {
    for (var _ = U[0], T = U[1] - 1; T >= 0; ) _ & 1 << T && (N |= 1 << F), T--, --F < 0 && (N == 255 ? (eA(255), eA(0)) : eA(N), F = 7, N = 0);
  }
  function eA(U) {
    y.push(U);
  }
  function lA(U) {
    eA(U >> 8 & 255), eA(255 & U);
  }
  function hA(U, _, T, k, X) {
    for (var nA, aA = X[0], sA = X[240], FA = function(CA, yA) {
      var HA, IA, MA, XA, ee, te, se, pe, qA, re, SA = 0;
      for (qA = 0; qA < 8; ++qA) {
        HA = CA[SA], IA = CA[SA + 1], MA = CA[SA + 2], XA = CA[SA + 3], ee = CA[SA + 4], te = CA[SA + 5], se = CA[SA + 6];
        var st = HA + (pe = CA[SA + 7]), ue = HA - pe, Xt = IA + se, me = IA - se, Le = MA + te, fr = MA - te, le = XA + ee, mn = XA - ee, xe = st + le, Jt = st - le, Ir = Xt + Le, He = Xt - Le;
        CA[SA] = xe + Ir, CA[SA + 4] = xe - Ir;
        var JA = 0.707106781 * (He + Jt);
        CA[SA + 2] = Jt + JA, CA[SA + 6] = Jt - JA;
        var fe = 0.382683433 * ((xe = mn + fr) - (He = me + ue)), Cn = 0.5411961 * xe + fe, tt = 1.306562965 * He + fe, hr = 0.707106781 * (Ir = fr + me), Br = ue + hr, RA = ue - hr;
        CA[SA + 5] = RA + Cn, CA[SA + 3] = RA - Cn, CA[SA + 1] = Br + tt, CA[SA + 7] = Br - tt, SA += 8;
      }
      for (SA = 0, qA = 0; qA < 8; ++qA) {
        HA = CA[SA], IA = CA[SA + 8], MA = CA[SA + 16], XA = CA[SA + 24], ee = CA[SA + 32], te = CA[SA + 40], se = CA[SA + 48];
        var zt = HA + (pe = CA[SA + 56]), gr = HA - pe, Ct = IA + se, Xe = IA - se, Ge = MA + te, It = MA - te, Rn = XA + ee, xr = XA - ee, Yt = zt + Rn, Zt = zt - Rn, $t = Ct + Ge, dr = Ct - Ge;
        CA[SA] = Yt + $t, CA[SA + 32] = Yt - $t;
        var Tt = 0.707106781 * (dr + Zt);
        CA[SA + 16] = Zt + Tt, CA[SA + 48] = Zt - Tt;
        var pr = 0.382683433 * ((Yt = xr + It) - (dr = Xe + gr)), Qn = 0.5411961 * Yt + pr, Gn = 1.306562965 * dr + pr, jn = 0.707106781 * ($t = It + Xe), Vn = gr + jn, qn = gr - jn;
        CA[SA + 40] = qn + Qn, CA[SA + 24] = qn - Qn, CA[SA + 8] = Vn + Gn, CA[SA + 56] = Vn - Gn, SA++;
      }
      for (qA = 0; qA < 64; ++qA) re = CA[qA] * yA[qA], B[qA] = re > 0 ? re + 0.5 | 0 : re - 0.5 | 0;
      return B;
    }(U, _), QA = 0; QA < 64; ++QA) L[J[QA]] = FA[QA];
    var xA = L[0] - T;
    T = L[0], xA == 0 ? uA(k[0]) : (uA(k[w[nA = 32767 + xA]]), uA(p[nA]));
    for (var LA = 63; LA > 0 && L[LA] == 0; ) LA--;
    if (LA == 0) return uA(aA), T;
    for (var jA, gA = 1; gA <= LA; ) {
      for (var P = gA; L[gA] == 0 && gA <= LA; ) ++gA;
      var ZA = gA - P;
      if (ZA >= 16) {
        jA = ZA >> 4;
        for (var PA = 1; PA <= jA; ++PA) uA(sA);
        ZA &= 15;
      }
      nA = 32767 + L[gA], uA(X[(ZA << 4) + w[nA]]), uA(p[nA]), gA++;
    }
    return LA != 63 && uA(aA), T;
  }
  function UA(U) {
    U = Math.min(Math.max(U, 1), 100), i != U && (function(_) {
      for (var T = [16, 11, 10, 16, 24, 40, 51, 61, 12, 12, 14, 19, 26, 58, 60, 55, 14, 13, 16, 24, 40, 57, 69, 56, 14, 17, 22, 29, 51, 87, 80, 62, 18, 22, 37, 56, 68, 109, 103, 77, 24, 35, 55, 64, 81, 104, 113, 92, 49, 64, 78, 87, 103, 121, 120, 101, 72, 92, 95, 98, 112, 100, 103, 99], k = 0; k < 64; k++) {
        var X = s((T[k] * _ + 50) / 100);
        X = Math.min(Math.max(X, 1), 255), u[J[k]] = X;
      }
      for (var nA = [17, 18, 24, 47, 99, 99, 99, 99, 18, 21, 26, 66, 99, 99, 99, 99, 24, 26, 56, 99, 99, 99, 99, 99, 47, 66, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99], aA = 0; aA < 64; aA++) {
        var sA = s((nA[aA] * _ + 50) / 100);
        sA = Math.min(Math.max(sA, 1), 255), c[J[aA]] = sA;
      }
      for (var FA = [1, 1.387039845, 1.306562965, 1.175875602, 1, 0.785694958, 0.5411961, 0.275899379], QA = 0, xA = 0; xA < 8; xA++) for (var LA = 0; LA < 8; LA++) h[QA] = 1 / (u[J[QA]] * FA[xA] * FA[LA] * 8), g[QA] = 1 / (c[J[QA]] * FA[xA] * FA[LA] * 8), QA++;
    }(U < 50 ? Math.floor(5e3 / U) : Math.floor(200 - 2 * U)), i = U);
  }
  this.encode = function(U, _) {
    _ && UA(_), y = new Array(), N = 0, F = 7, lA(65496), lA(65504), lA(16), eA(74), eA(70), eA(73), eA(70), eA(0), eA(1), eA(1), eA(0), lA(1), lA(1), eA(0), eA(0), function() {
      lA(65499), lA(132), eA(0);
      for (var IA = 0; IA < 64; IA++) eA(u[IA]);
      eA(1);
      for (var MA = 0; MA < 64; MA++) eA(c[MA]);
    }(), function(IA, MA) {
      lA(65472), lA(17), eA(8), lA(MA), lA(IA), eA(3), eA(1), eA(17), eA(0), eA(2), eA(17), eA(1), eA(3), eA(17), eA(1);
    }(U.width, U.height), function() {
      lA(65476), lA(418), eA(0);
      for (var IA = 0; IA < 16; IA++) eA(O[IA + 1]);
      for (var MA = 0; MA <= 11; MA++) eA(W[MA]);
      eA(16);
      for (var XA = 0; XA < 16; XA++) eA(cA[XA + 1]);
      for (var ee = 0; ee <= 161; ee++) eA(I[ee]);
      eA(1);
      for (var te = 0; te < 16; te++) eA(H[te + 1]);
      for (var se = 0; se <= 11; se++) eA(K[se]);
      eA(17);
      for (var pe = 0; pe < 16; pe++) eA(M[pe + 1]);
      for (var qA = 0; qA <= 161; qA++) eA(oA[qA]);
    }(), lA(65498), lA(12), eA(3), eA(1), eA(0), eA(2), eA(17), eA(3), eA(17), eA(0), eA(63), eA(0);
    var T = 0, k = 0, X = 0;
    N = 0, F = 7, this.encode.displayName = "_encode_";
    for (var nA, aA, sA, FA, QA, xA, LA, jA, gA, P = U.data, ZA = U.width, PA = U.height, CA = 4 * ZA, yA = 0; yA < PA; ) {
      for (nA = 0; nA < CA; ) {
        for (QA = CA * yA + nA, LA = -1, jA = 0, gA = 0; gA < 64; gA++) xA = QA + (jA = gA >> 3) * CA + (LA = 4 * (7 & gA)), yA + jA >= PA && (xA -= CA * (yA + 1 + jA - PA)), nA + LA >= CA && (xA -= nA + LA - CA + 4), aA = P[xA++], sA = P[xA++], FA = P[xA++], x[gA] = ($[aA] + $[sA + 256 >> 0] + $[FA + 512 >> 0] >> 16) - 128, R[gA] = ($[aA + 768 >> 0] + $[sA + 1024 >> 0] + $[FA + 1280 >> 0] >> 16) - 128, Y[gA] = ($[aA + 1280 >> 0] + $[sA + 1536 >> 0] + $[FA + 1792 >> 0] >> 16) - 128;
        T = hA(x, h, T, A, r), k = hA(R, g, k, e, n), X = hA(Y, g, X, e, n), nA += 32;
      }
      yA += 8;
    }
    if (F >= 0) {
      var HA = [];
      HA[1] = F + 1, HA[0] = (1 << F + 1) - 1, uA(HA);
    }
    return lA(65497), new Uint8Array(y);
  }, t = t || 50, function() {
    for (var U = String.fromCharCode, _ = 0; _ < 256; _++) Z[_] = U(_);
  }(), A = iA(O, W), e = iA(H, K), r = iA(cA, I), n = iA(M, oA), function() {
    for (var U = 1, _ = 2, T = 1; T <= 15; T++) {
      for (var k = U; k < _; k++) w[32767 + k] = T, p[32767 + k] = [], p[32767 + k][1] = T, p[32767 + k][0] = k;
      for (var X = -(_ - 1); X <= -U; X++) w[32767 + X] = T, p[32767 + X] = [], p[32767 + X][1] = T, p[32767 + X][0] = _ - 1 + X;
      U <<= 1, _ <<= 1;
    }
  }(), function() {
    for (var U = 0; U < 256; U++) $[U] = 19595 * U, $[U + 256 >> 0] = 38470 * U, $[U + 512 >> 0] = 7471 * U + 32768, $[U + 768 >> 0] = -11059 * U, $[U + 1024 >> 0] = -21709 * U, $[U + 1280 >> 0] = 32768 * U + 8421375, $[U + 1536 >> 0] = -27439 * U, $[U + 1792 >> 0] = -5329 * U;
  }(), UA(t);
}
/**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function ar(t, A) {
  if (this.pos = 0, this.buffer = t, this.datav = new DataView(t.buffer), this.is_with_alpha = !!A, this.bottom_up = !0, this.flag = String.fromCharCode(this.buffer[0]) + String.fromCharCode(this.buffer[1]), this.pos += 2, ["BM", "BA", "CI", "CP", "IC", "PT"].indexOf(this.flag) === -1) throw new Error("Invalid BMP File");
  this.parseHeader(), this.parseBGR();
}
function Df(t) {
  function A(O) {
    if (!O) throw Error("assert :P");
  }
  function e(O, W, cA) {
    for (var I = 0; 4 > I; I++) if (O[W + I] != cA.charCodeAt(I)) return !0;
    return !1;
  }
  function r(O, W, cA, I, H) {
    for (var K = 0; K < H; K++) O[W + K] = cA[I + K];
  }
  function n(O, W, cA, I) {
    for (var H = 0; H < I; H++) O[W + H] = cA;
  }
  function i(O) {
    return new Int32Array(O);
  }
  function s(O, W) {
    for (var cA = [], I = 0; I < O; I++) cA.push(new W());
    return cA;
  }
  function u(O, W) {
    var cA = [];
    return function I(H, K, M) {
      for (var oA = M[K], iA = 0; iA < oA && (H.push(M.length > K + 1 ? [] : new W()), !(M.length < K + 1)); iA++) I(H[iA], K + 1, M);
    }(cA, 0, O), cA;
  }
  var c = function() {
    var O = this;
    function W(a, o) {
      for (var f = 1 << o - 1 >>> 0; a & f; ) f >>>= 1;
      return f ? (a & f - 1) + f : a;
    }
    function cA(a, o, f, d, v) {
      A(!(d % f));
      do
        a[o + (d -= f)] = v;
      while (0 < d);
    }
    function I(a, o, f, d, v) {
      if (A(2328 >= v), 512 >= v) var C = i(512);
      else if ((C = i(v)) == null) return 0;
      return function(Q, b, E, S, j, tA) {
        var rA, z, wA = b, fA = 1 << E, V = i(16), q = i(16);
        for (A(j != 0), A(S != null), A(Q != null), A(0 < E), z = 0; z < j; ++z) {
          if (15 < S[z]) return 0;
          ++V[S[z]];
        }
        if (V[0] == j) return 0;
        for (q[1] = 0, rA = 1; 15 > rA; ++rA) {
          if (V[rA] > 1 << rA) return 0;
          q[rA + 1] = q[rA] + V[rA];
        }
        for (z = 0; z < j; ++z) rA = S[z], 0 < S[z] && (tA[q[rA]++] = z);
        if (q[15] == 1) return (S = new H()).g = 0, S.value = tA[0], cA(Q, wA, 1, fA, S), fA;
        var dA, vA = -1, pA = fA - 1, DA = 0, bA = 1, kA = 1, EA = 1 << E;
        for (z = 0, rA = 1, j = 2; rA <= E; ++rA, j <<= 1) {
          if (bA += kA <<= 1, 0 > (kA -= V[rA])) return 0;
          for (; 0 < V[rA]; --V[rA]) (S = new H()).g = rA, S.value = tA[z++], cA(Q, wA + DA, j, EA, S), DA = W(DA, rA);
        }
        for (rA = E + 1, j = 2; 15 >= rA; ++rA, j <<= 1) {
          if (bA += kA <<= 1, 0 > (kA -= V[rA])) return 0;
          for (; 0 < V[rA]; --V[rA]) {
            if (S = new H(), (DA & pA) != vA) {
              for (wA += EA, dA = 1 << (vA = rA) - E; 15 > vA && !(0 >= (dA -= V[vA])); ) ++vA, dA <<= 1;
              fA += EA = 1 << (dA = vA - E), Q[b + (vA = DA & pA)].g = dA + E, Q[b + vA].value = wA - b - vA;
            }
            S.g = rA - E, S.value = tA[z++], cA(Q, wA + (DA >> E), j, EA, S), DA = W(DA, rA);
          }
        }
        return bA != 2 * q[15] - 1 ? 0 : fA;
      }(a, o, f, d, v, C);
    }
    function H() {
      this.value = this.g = 0;
    }
    function K() {
      this.value = this.g = 0;
    }
    function M() {
      this.G = s(5, H), this.H = i(5), this.jc = this.Qb = this.qb = this.nd = 0, this.pd = s(rt, K);
    }
    function oA(a, o, f, d) {
      A(a != null), A(o != null), A(2147483648 > d), a.Ca = 254, a.I = 0, a.b = -8, a.Ka = 0, a.oa = o, a.pa = f, a.Jd = o, a.Yc = f + d, a.Zc = 4 <= d ? f + d - 4 + 1 : f, nA(a);
    }
    function iA(a, o) {
      for (var f = 0; 0 < o--; ) f |= sA(a, 128) << o;
      return f;
    }
    function uA(a, o) {
      var f = iA(a, o);
      return aA(a) ? -f : f;
    }
    function eA(a, o, f, d) {
      var v, C = 0;
      for (A(a != null), A(o != null), A(4294967288 > d), a.Sb = d, a.Ra = 0, a.u = 0, a.h = 0, 4 < d && (d = 4), v = 0; v < d; ++v) C += o[f + v] << 8 * v;
      a.Ra = C, a.bb = d, a.oa = o, a.pa = f;
    }
    function lA(a) {
      for (; 8 <= a.u && a.bb < a.Sb; ) a.Ra >>>= 8, a.Ra += a.oa[a.pa + a.bb] << si - 8 >>> 0, ++a.bb, a.u -= 8;
      T(a) && (a.h = 1, a.u = 0);
    }
    function hA(a, o) {
      if (A(0 <= o), !a.h && o <= ai) {
        var f = _(a) & ii[o];
        return a.u += o, lA(a), f;
      }
      return a.h = 1, a.u = 0;
    }
    function UA() {
      this.b = this.Ca = this.I = 0, this.oa = [], this.pa = 0, this.Jd = [], this.Yc = 0, this.Zc = [], this.Ka = 0;
    }
    function U() {
      this.Ra = 0, this.oa = [], this.h = this.u = this.bb = this.Sb = this.pa = 0;
    }
    function _(a) {
      return a.Ra >>> (a.u & si - 1) >>> 0;
    }
    function T(a) {
      return A(a.bb <= a.Sb), a.h || a.bb == a.Sb && a.u > si;
    }
    function k(a, o) {
      a.u = o, a.h = T(a);
    }
    function X(a) {
      a.u >= ta && (A(a.u >= ta), lA(a));
    }
    function nA(a) {
      A(a != null && a.oa != null), a.pa < a.Zc ? (a.I = (a.oa[a.pa++] | a.I << 8) >>> 0, a.b += 8) : (A(a != null && a.oa != null), a.pa < a.Yc ? (a.b += 8, a.I = a.oa[a.pa++] | a.I << 8) : a.Ka ? a.b = 0 : (a.I <<= 8, a.b += 8, a.Ka = 1));
    }
    function aA(a) {
      return iA(a, 1);
    }
    function sA(a, o) {
      var f = a.Ca;
      0 > a.b && nA(a);
      var d = a.b, v = f * o >>> 8, C = (a.I >>> d > v) + 0;
      for (C ? (f -= v, a.I -= v + 1 << d >>> 0) : f = v + 1, d = f, v = 0; 256 <= d; ) v += 8, d >>= 8;
      return d = 7 ^ v + Ft[d], a.b -= d, a.Ca = (f << d) - 1, C;
    }
    function FA(a, o, f) {
      a[o + 0] = f >> 24 & 255, a[o + 1] = f >> 16 & 255, a[o + 2] = f >> 8 & 255, a[o + 3] = f >> 0 & 255;
    }
    function QA(a, o) {
      return a[o + 0] << 0 | a[o + 1] << 8;
    }
    function xA(a, o) {
      return QA(a, o) | a[o + 2] << 16;
    }
    function LA(a, o) {
      return QA(a, o) | QA(a, o + 2) << 16;
    }
    function jA(a, o) {
      var f = 1 << o;
      return A(a != null), A(0 < o), a.X = i(f), a.X == null ? 0 : (a.Mb = 32 - o, a.Xa = o, 1);
    }
    function gA(a, o) {
      A(a != null), A(o != null), A(a.Xa == o.Xa), r(o.X, 0, a.X, 0, 1 << o.Xa);
    }
    function P() {
      this.X = [], this.Xa = this.Mb = 0;
    }
    function ZA(a, o, f, d) {
      A(f != null), A(d != null);
      var v = f[0], C = d[0];
      return v == 0 && (v = (a * C + o / 2) / o), C == 0 && (C = (o * v + a / 2) / a), 0 >= v || 0 >= C ? 0 : (f[0] = v, d[0] = C, 1);
    }
    function PA(a, o) {
      return a + (1 << o) - 1 >>> o;
    }
    function CA(a, o) {
      return ((4278255360 & a) + (4278255360 & o) >>> 0 & 4278255360) + ((16711935 & a) + (16711935 & o) >>> 0 & 16711935) >>> 0;
    }
    function yA(a, o) {
      O[o] = function(f, d, v, C, Q, b, E) {
        var S;
        for (S = 0; S < Q; ++S) {
          var j = O[a](b[E + S - 1], v, C + S);
          b[E + S] = CA(f[d + S], j);
        }
      };
    }
    function HA() {
      this.ud = this.hd = this.jd = 0;
    }
    function IA(a, o) {
      return ((4278124286 & (a ^ o)) >>> 1) + (a & o) >>> 0;
    }
    function MA(a) {
      return 0 <= a && 256 > a ? a : 0 > a ? 0 : 255 < a ? 255 : void 0;
    }
    function XA(a, o) {
      return MA(a + (a - o + 0.5 >> 1));
    }
    function ee(a, o, f) {
      return Math.abs(o - f) - Math.abs(a - f);
    }
    function te(a, o, f, d, v, C, Q) {
      for (d = C[Q - 1], f = 0; f < v; ++f) C[Q + f] = d = CA(a[o + f], d);
    }
    function se(a, o, f, d, v) {
      var C;
      for (C = 0; C < f; ++C) {
        var Q = a[o + C], b = Q >> 8 & 255, E = 16711935 & (E = (E = 16711935 & Q) + ((b << 16) + b));
        d[v + C] = (4278255360 & Q) + E >>> 0;
      }
    }
    function pe(a, o) {
      o.jd = a >> 0 & 255, o.hd = a >> 8 & 255, o.ud = a >> 16 & 255;
    }
    function qA(a, o, f, d, v, C) {
      var Q;
      for (Q = 0; Q < d; ++Q) {
        var b = o[f + Q], E = b >>> 8, S = b, j = 255 & (j = (j = b >>> 16) + ((a.jd << 24 >> 24) * (E << 24 >> 24) >>> 5));
        S = 255 & (S = (S = S + ((a.hd << 24 >> 24) * (E << 24 >> 24) >>> 5)) + ((a.ud << 24 >> 24) * (j << 24 >> 24) >>> 5)), v[C + Q] = (4278255360 & b) + (j << 16) + S;
      }
    }
    function re(a, o, f, d, v) {
      O[o] = function(C, Q, b, E, S, j, tA, rA, z) {
        for (E = tA; E < rA; ++E) for (tA = 0; tA < z; ++tA) S[j++] = v(b[d(C[Q++])]);
      }, O[a] = function(C, Q, b, E, S, j, tA) {
        var rA = 8 >> C.b, z = C.Ea, wA = C.K[0], fA = C.w;
        if (8 > rA) for (C = (1 << C.b) - 1, fA = (1 << rA) - 1; Q < b; ++Q) {
          var V, q = 0;
          for (V = 0; V < z; ++V) V & C || (q = d(E[S++])), j[tA++] = v(wA[q & fA]), q >>= rA;
        }
        else O["VP8LMapColor" + f](E, S, wA, fA, j, tA, Q, b, z);
      };
    }
    function SA(a, o, f, d, v) {
      for (f = o + f; o < f; ) {
        var C = a[o++];
        d[v++] = C >> 16 & 255, d[v++] = C >> 8 & 255, d[v++] = C >> 0 & 255;
      }
    }
    function st(a, o, f, d, v) {
      for (f = o + f; o < f; ) {
        var C = a[o++];
        d[v++] = C >> 16 & 255, d[v++] = C >> 8 & 255, d[v++] = C >> 0 & 255, d[v++] = C >> 24 & 255;
      }
    }
    function ue(a, o, f, d, v) {
      for (f = o + f; o < f; ) {
        var C = (Q = a[o++]) >> 16 & 240 | Q >> 12 & 15, Q = Q >> 0 & 240 | Q >> 28 & 15;
        d[v++] = C, d[v++] = Q;
      }
    }
    function Xt(a, o, f, d, v) {
      for (f = o + f; o < f; ) {
        var C = (Q = a[o++]) >> 16 & 248 | Q >> 13 & 7, Q = Q >> 5 & 224 | Q >> 3 & 31;
        d[v++] = C, d[v++] = Q;
      }
    }
    function me(a, o, f, d, v) {
      for (f = o + f; o < f; ) {
        var C = a[o++];
        d[v++] = C >> 0 & 255, d[v++] = C >> 8 & 255, d[v++] = C >> 16 & 255;
      }
    }
    function Le(a, o, f, d, v, C) {
      if (C == 0) for (f = o + f; o < f; ) FA(d, ((C = a[o++])[0] >> 24 | C[1] >> 8 & 65280 | C[2] << 8 & 16711680 | C[3] << 24) >>> 0), v += 32;
      else r(d, v, a, o, f);
    }
    function fr(a, o) {
      O[o][0] = O[a + "0"], O[o][1] = O[a + "1"], O[o][2] = O[a + "2"], O[o][3] = O[a + "3"], O[o][4] = O[a + "4"], O[o][5] = O[a + "5"], O[o][6] = O[a + "6"], O[o][7] = O[a + "7"], O[o][8] = O[a + "8"], O[o][9] = O[a + "9"], O[o][10] = O[a + "10"], O[o][11] = O[a + "11"], O[o][12] = O[a + "12"], O[o][13] = O[a + "13"], O[o][14] = O[a + "0"], O[o][15] = O[a + "0"];
    }
    function le(a) {
      return a == uu || a == cu || a == gs || a == lu;
    }
    function mn() {
      this.eb = [], this.size = this.A = this.fb = 0;
    }
    function xe() {
      this.y = [], this.f = [], this.ea = [], this.F = [], this.Tc = this.Ed = this.Cd = this.Fd = this.lb = this.Db = this.Ab = this.fa = this.J = this.W = this.N = this.O = 0;
    }
    function Jt() {
      this.Rd = this.height = this.width = this.S = 0, this.f = {}, this.f.RGBA = new mn(), this.f.kb = new xe(), this.sd = null;
    }
    function Ir() {
      this.width = [0], this.height = [0], this.Pd = [0], this.Qd = [0], this.format = [0];
    }
    function He() {
      this.Id = this.fd = this.Md = this.hb = this.ib = this.da = this.bd = this.cd = this.j = this.v = this.Da = this.Sd = this.ob = 0;
    }
    function JA(a) {
      return alert("todo:WebPSamplerProcessPlane"), a.T;
    }
    function fe(a, o) {
      var f = a.T, d = o.ba.f.RGBA, v = d.eb, C = d.fb + a.ka * d.A, Q = Rt[o.ba.S], b = a.y, E = a.O, S = a.f, j = a.N, tA = a.ea, rA = a.W, z = o.cc, wA = o.dc, fA = o.Mc, V = o.Nc, q = a.ka, dA = a.ka + a.T, vA = a.U, pA = vA + 1 >> 1;
      for (q == 0 ? Q(b, E, null, null, S, j, tA, rA, S, j, tA, rA, v, C, null, null, vA) : (Q(o.ec, o.fc, b, E, z, wA, fA, V, S, j, tA, rA, v, C - d.A, v, C, vA), ++f); q + 2 < dA; q += 2) z = S, wA = j, fA = tA, V = rA, j += a.Rc, rA += a.Rc, C += 2 * d.A, Q(b, (E += 2 * a.fa) - a.fa, b, E, z, wA, fA, V, S, j, tA, rA, v, C - d.A, v, C, vA);
      return E += a.fa, a.j + dA < a.o ? (r(o.ec, o.fc, b, E, vA), r(o.cc, o.dc, S, j, pA), r(o.Mc, o.Nc, tA, rA, pA), f--) : 1 & dA || Q(b, E, null, null, S, j, tA, rA, S, j, tA, rA, v, C + d.A, null, null, vA), f;
    }
    function Cn(a, o, f) {
      var d = a.F, v = [a.J];
      if (d != null) {
        var C = a.U, Q = o.ba.S, b = Q == Bs || Q == gs;
        o = o.ba.f.RGBA;
        var E = [0], S = a.ka;
        E[0] = a.T, a.Kb && (S == 0 ? --E[0] : (--S, v[0] -= a.width), a.j + a.ka + a.T == a.o && (E[0] = a.o - a.j - S));
        var j = o.eb;
        S = o.fb + S * o.A, a = Ue(d, v[0], a.width, C, E, j, S + (b ? 0 : 3), o.A), A(f == E), a && le(Q) && Kt(j, S, b, C, E, o.A);
      }
      return 0;
    }
    function tt(a) {
      var o = a.ma, f = o.ba.S, d = 11 > f, v = f == fs || f == hs || f == Bs || f == ou || f == 12 || le(f);
      if (o.memory = null, o.Ib = null, o.Jb = null, o.Nd = null, !Aa(o.Oa, a, v ? 11 : 12)) return 0;
      if (v && le(f) && mA(), a.da) alert("todo:use_scaling");
      else {
        if (d) {
          if (o.Ib = JA, a.Kb) {
            if (f = a.U + 1 >> 1, o.memory = i(a.U + 2 * f), o.memory == null) return 0;
            o.ec = o.memory, o.fc = 0, o.cc = o.ec, o.dc = o.fc + a.U, o.Mc = o.cc, o.Nc = o.dc + f, o.Ib = fe, mA();
          }
        } else alert("todo:EmitYUV");
        v && (o.Jb = Cn, d && AA());
      }
      if (d && !$c) {
        for (a = 0; 256 > a; ++a) bB[a] = 89858 * (a - 128) + ps >> ds, IB[a] = -22014 * (a - 128) + ps, EB[a] = -45773 * (a - 128), LB[a] = 113618 * (a - 128) + ps >> ds;
        for (a = ua; a < Bu; ++a) o = 76283 * (a - 16) + ps >> ds, xB[a - ua] = xt(o, 255), HB[a - ua] = xt(o + 8 >> 4, 15);
        $c = 1;
      }
      return 1;
    }
    function hr(a) {
      var o = a.ma, f = a.U, d = a.T;
      return A(!(1 & a.ka)), 0 >= f || 0 >= d ? 0 : (f = o.Ib(a, o), o.Jb != null && o.Jb(a, o, f), o.Dc += f, 1);
    }
    function Br(a) {
      a.ma.memory = null;
    }
    function RA(a, o, f, d) {
      return hA(a, 8) != 47 ? 0 : (o[0] = hA(a, 14) + 1, f[0] = hA(a, 14) + 1, d[0] = hA(a, 1), hA(a, 3) != 0 ? 0 : !a.h);
    }
    function zt(a, o) {
      if (4 > a) return a + 1;
      var f = a - 2 >> 1;
      return (2 + (1 & a) << f) + hA(o, f) + 1;
    }
    function gr(a, o) {
      return 120 < o ? o - 120 : 1 <= (f = ((f = fB[o - 1]) >> 4) * a + (8 - (15 & f))) ? f : 1;
      var f;
    }
    function Ct(a, o, f) {
      var d = _(f), v = a[o += 255 & d].g - 8;
      return 0 < v && (k(f, f.u + 8), d = _(f), o += a[o].value, o += d & (1 << v) - 1), k(f, f.u + a[o].g), a[o].value;
    }
    function Xe(a, o, f) {
      return f.g += a.g, f.value += a.value << o >>> 0, A(8 >= f.g), a.g;
    }
    function Ge(a, o, f) {
      var d = a.xc;
      return A((o = d == 0 ? 0 : a.vc[a.md * (f >> d) + (o >> d)]) < a.Wb), a.Ya[o];
    }
    function It(a, o, f, d) {
      var v = a.ab, C = a.c * o, Q = a.C;
      o = Q + o;
      var b = f, E = d;
      for (d = a.Ta, f = a.Ua; 0 < v--; ) {
        var S = a.gc[v], j = Q, tA = o, rA = b, z = E, wA = (E = d, b = f, S.Ea);
        switch (A(j < tA), A(tA <= S.nc), S.hc) {
          case 2:
            is(rA, z, (tA - j) * wA, E, b);
            break;
          case 0:
            var fA = j, V = tA, q = E, dA = b, vA = (EA = S).Ea;
            fA == 0 && (au(rA, z, null, null, 1, q, dA), te(rA, z + 1, 0, 0, vA - 1, q, dA + 1), z += vA, dA += vA, ++fA);
            for (var pA = 1 << EA.b, DA = pA - 1, bA = PA(vA, EA.b), kA = EA.K, EA = EA.w + (fA >> EA.b) * bA; fA < V; ) {
              var ce = kA, Be = EA, oe = 1;
              for (ra(rA, z, q, dA - vA, 1, q, dA); oe < vA; ) {
                var ne = (oe & ~DA) + pA;
                ne > vA && (ne = vA), (0, Xr[ce[Be++] >> 8 & 15])(rA, z + +oe, q, dA + oe - vA, ne - oe, q, dA + oe), oe = ne;
              }
              z += vA, dA += vA, ++fA & DA || (EA += bA);
            }
            tA != S.nc && r(E, b - wA, E, b + (tA - j - 1) * wA, wA);
            break;
          case 1:
            for (wA = rA, V = z, vA = (rA = S.Ea) - (dA = rA & ~(q = (z = 1 << S.b) - 1)), fA = PA(rA, S.b), pA = S.K, S = S.w + (j >> S.b) * fA; j < tA; ) {
              for (DA = pA, bA = S, kA = new HA(), EA = V + dA, ce = V + rA; V < EA; ) pe(DA[bA++], kA), Ln(kA, wA, V, z, E, b), V += z, b += z;
              V < ce && (pe(DA[bA++], kA), Ln(kA, wA, V, vA, E, b), V += vA, b += vA), ++j & q || (S += fA);
            }
            break;
          case 3:
            if (rA == E && z == b && 0 < S.b) {
              for (V = E, rA = wA = b + (tA - j) * wA - (dA = (tA - j) * PA(S.Ea, S.b)), z = E, q = b, fA = [], dA = (vA = dA) - 1; 0 <= dA; --dA) fA[dA] = z[q + dA];
              for (dA = vA - 1; 0 <= dA; --dA) V[rA + dA] = fA[dA];
              Ot(S, j, tA, E, wA, E, b);
            } else Ot(S, j, tA, rA, z, E, b);
        }
        b = d, E = f;
      }
      E != f && r(d, f, b, E, C);
    }
    function Rn(a, o) {
      var f = a.V, d = a.Ba + a.c * a.C, v = o - a.C;
      if (A(o <= a.l.o), A(16 >= v), 0 < v) {
        var C = a.l, Q = a.Ta, b = a.Ua, E = C.width;
        if (It(a, v, f, d), v = b = [b], A((f = a.C) < (d = o)), A(C.v < C.va), d > C.o && (d = C.o), f < C.j) {
          var S = C.j - f;
          f = C.j, v[0] += S * E;
        }
        if (f >= d ? f = 0 : (v[0] += 4 * C.v, C.ka = f - C.j, C.U = C.va - C.v, C.T = d - f, f = 1), f) {
          if (b = b[0], 11 > (f = a.ca).S) {
            var j = f.f.RGBA, tA = (d = f.S, v = C.U, C = C.T, S = j.eb, j.A), rA = C;
            for (j = j.fb + a.Ma * j.A; 0 < rA--; ) {
              var z = Q, wA = b, fA = v, V = S, q = j;
              switch (d) {
                case ls:
                  Ut(z, wA, fA, V, q);
                  break;
                case fs:
                  pt(z, wA, fA, V, q);
                  break;
                case uu:
                  pt(z, wA, fA, V, q), Kt(V, q, 0, fA, 1, 0);
                  break;
                case jc:
                  _r(z, wA, fA, V, q);
                  break;
                case hs:
                  Le(z, wA, fA, V, q, 1);
                  break;
                case cu:
                  Le(z, wA, fA, V, q, 1), Kt(V, q, 0, fA, 1, 0);
                  break;
                case Bs:
                  Le(z, wA, fA, V, q, 0);
                  break;
                case gs:
                  Le(z, wA, fA, V, q, 0), Kt(V, q, 1, fA, 1, 0);
                  break;
                case ou:
                  Jr(z, wA, fA, V, q);
                  break;
                case lu:
                  Jr(z, wA, fA, V, q), Fe(V, q, fA, 1, 0);
                  break;
                case Vc:
                  Nr(z, wA, fA, V, q);
                  break;
                default:
                  A(0);
              }
              b += E, j += tA;
            }
            a.Ma += C;
          } else alert("todo:EmitRescaledRowsYUVA");
          A(a.Ma <= f.height);
        }
      }
      a.C = o, A(a.C <= a.i);
    }
    function xr(a) {
      var o;
      if (0 < a.ua) return 0;
      for (o = 0; o < a.Wb; ++o) {
        var f = a.Ya[o].G, d = a.Ya[o].H;
        if (0 < f[1][d[1] + 0].g || 0 < f[2][d[2] + 0].g || 0 < f[3][d[3] + 0].g) return 0;
      }
      return 1;
    }
    function Yt(a, o, f, d, v, C) {
      if (a.Z != 0) {
        var Q = a.qd, b = a.rd;
        for (A($r[a.Z] != null); o < f; ++o) $r[a.Z](Q, b, d, v, d, v, C), Q = d, b = v, v += C;
        a.qd = Q, a.rd = b;
      }
    }
    function Zt(a, o) {
      var f = a.l.ma, d = f.Z == 0 || f.Z == 1 ? a.l.j : a.C;
      if (d = a.C < d ? d : a.C, A(o <= a.l.o), o > d) {
        var v = a.l.width, C = f.ca, Q = f.tb + v * d, b = a.V, E = a.Ba + a.c * d, S = a.gc;
        A(a.ab == 1), A(S[0].hc == 3), as(S[0], d, o, b, E, C, Q), Yt(f, d, o, C, Q, v);
      }
      a.C = a.Ma = o;
    }
    function $t(a, o, f, d, v, C, Q) {
      var b = a.$ / d, E = a.$ % d, S = a.m, j = a.s, tA = f + a.$, rA = tA;
      v = f + d * v;
      var z = f + d * C, wA = 280 + j.ua, fA = a.Pb ? b : 16777216, V = 0 < j.ua ? j.Wa : null, q = j.wc, dA = tA < z ? Ge(j, E, b) : null;
      A(a.C < C), A(z <= v);
      var vA = !1;
      A: for (; ; ) {
        for (; vA || tA < z; ) {
          var pA = 0;
          if (b >= fA) {
            var DA = tA - f;
            A((fA = a).Pb), fA.wd = fA.m, fA.xd = DA, 0 < fA.s.ua && gA(fA.s.Wa, fA.s.vb), fA = b + BB;
          }
          if (E & q || (dA = Ge(j, E, b)), A(dA != null), dA.Qb && (o[tA] = dA.qb, vA = !0), !vA) if (X(S), dA.jc) {
            pA = S, DA = o;
            var bA = tA, kA = dA.pd[_(pA) & rt - 1];
            A(dA.jc), 256 > kA.g ? (k(pA, pA.u + kA.g), DA[bA] = kA.value, pA = 0) : (k(pA, pA.u + kA.g - 256), A(256 <= kA.value), pA = kA.value), pA == 0 && (vA = !0);
          } else pA = Ct(dA.G[0], dA.H[0], S);
          if (S.h) break;
          if (vA || 256 > pA) {
            if (!vA) if (dA.nd) o[tA] = (dA.qb | pA << 8) >>> 0;
            else {
              if (X(S), vA = Ct(dA.G[1], dA.H[1], S), X(S), DA = Ct(dA.G[2], dA.H[2], S), bA = Ct(dA.G[3], dA.H[3], S), S.h) break;
              o[tA] = (bA << 24 | vA << 16 | pA << 8 | DA) >>> 0;
            }
            if (vA = !1, ++tA, ++E >= d && (E = 0, ++b, Q != null && b <= C && !(b % 16) && Q(a, b), V != null)) for (; rA < tA; ) pA = o[rA++], V.X[(506832829 * pA & 4294967295) >>> V.Mb] = pA;
          } else if (280 > pA) {
            if (pA = zt(pA - 256, S), DA = Ct(dA.G[4], dA.H[4], S), X(S), DA = gr(d, DA = zt(DA, S)), S.h) break;
            if (tA - f < DA || v - tA < pA) break A;
            for (bA = 0; bA < pA; ++bA) o[tA + bA] = o[tA + bA - DA];
            for (tA += pA, E += pA; E >= d; ) E -= d, ++b, Q != null && b <= C && !(b % 16) && Q(a, b);
            if (A(tA <= v), E & q && (dA = Ge(j, E, b)), V != null) for (; rA < tA; ) pA = o[rA++], V.X[(506832829 * pA & 4294967295) >>> V.Mb] = pA;
          } else {
            if (!(pA < wA)) break A;
            for (vA = pA - 280, A(V != null); rA < tA; ) pA = o[rA++], V.X[(506832829 * pA & 4294967295) >>> V.Mb] = pA;
            pA = tA, A(!(vA >>> (DA = V).Xa)), o[pA] = DA.X[vA], vA = !0;
          }
          vA || A(S.h == T(S));
        }
        if (a.Pb && S.h && tA < v) A(a.m.h), a.a = 5, a.m = a.wd, a.$ = a.xd, 0 < a.s.ua && gA(a.s.vb, a.s.Wa);
        else {
          if (S.h) break A;
          Q != null && Q(a, b > C ? C : b), a.a = 0, a.$ = tA - f;
        }
        return 1;
      }
      return a.a = 3, 0;
    }
    function dr(a) {
      A(a != null), a.vc = null, a.yc = null, a.Ya = null;
      var o = a.Wa;
      o != null && (o.X = null), a.vb = null, A(a != null);
    }
    function Tt() {
      var a = new iu();
      return a == null ? null : (a.a = 0, a.xb = Xc, fr("Predictor", "VP8LPredictors"), fr("Predictor", "VP8LPredictors_C"), fr("PredictorAdd", "VP8LPredictorsAdd"), fr("PredictorAdd", "VP8LPredictorsAdd_C"), is = se, Ln = qA, Ut = SA, pt = st, Jr = ue, Nr = Xt, _r = me, O.VP8LMapColor32b = oi, O.VP8LMapColor8b = ss, a);
    }
    function pr(a, o, f, d, v) {
      var C = 1, Q = [a], b = [o], E = d.m, S = d.s, j = null, tA = 0;
      A: for (; ; ) {
        if (f) for (; C && hA(E, 1); ) {
          var rA = Q, z = b, wA = d, fA = 1, V = wA.m, q = wA.gc[wA.ab], dA = hA(V, 2);
          if (wA.Oc & 1 << dA) C = 0;
          else {
            switch (wA.Oc |= 1 << dA, q.hc = dA, q.Ea = rA[0], q.nc = z[0], q.K = [null], ++wA.ab, A(4 >= wA.ab), dA) {
              case 0:
              case 1:
                q.b = hA(V, 3) + 2, fA = pr(PA(q.Ea, q.b), PA(q.nc, q.b), 0, wA, q.K), q.K = q.K[0];
                break;
              case 3:
                var vA, pA = hA(V, 8) + 1, DA = 16 < pA ? 0 : 4 < pA ? 1 : 2 < pA ? 2 : 3;
                if (rA[0] = PA(q.Ea, DA), q.b = DA, vA = fA = pr(pA, 1, 0, wA, q.K)) {
                  var bA, kA = pA, EA = q, ce = 1 << (8 >> EA.b), Be = i(ce);
                  if (Be == null) vA = 0;
                  else {
                    var oe = EA.K[0], ne = EA.w;
                    for (Be[0] = EA.K[0][0], bA = 1; bA < 1 * kA; ++bA) Be[bA] = CA(oe[ne + bA], Be[bA - 1]);
                    for (; bA < 4 * ce; ++bA) Be[bA] = 0;
                    EA.K[0] = null, EA.K[0] = Be, vA = 1;
                  }
                }
                fA = vA;
                break;
              case 2:
                break;
              default:
                A(0);
            }
            C = fA;
          }
        }
        if (Q = Q[0], b = b[0], C && hA(E, 1) && !(C = 1 <= (tA = hA(E, 4)) && 11 >= tA)) {
          d.a = 3;
          break A;
        }
        var Ce;
        if (Ce = C) e: {
          var we, Ae, Ve, yt = d, qe = Q, bt = b, ge = tA, St = f, Nt = yt.m, Ze = yt.s, nt = [null], vt = 1, Gt = 0, Cr = hB[ge];
          t: for (; ; ) {
            if (St && hA(Nt, 1)) {
              var $e = hA(Nt, 3) + 2, Pr = PA(qe, $e), Sn = PA(bt, $e), hi = Pr * Sn;
              if (!pr(Pr, Sn, 0, yt, nt)) break t;
              for (nt = nt[0], Ze.xc = $e, we = 0; we < hi; ++we) {
                var An = nt[we] >> 8 & 65535;
                nt[we] = An, An >= vt && (vt = An + 1);
              }
            }
            if (Nt.h) break t;
            for (Ae = 0; 5 > Ae; ++Ae) {
              var Ne = qc[Ae];
              !Ae && 0 < ge && (Ne += 1 << ge), Gt < Ne && (Gt = Ne);
            }
            var gu = s(vt * Cr, H), tl = vt, rl = s(tl, M);
            if (rl == null) var vs = null;
            else A(65536 >= tl), vs = rl;
            var ca = i(Gt);
            if (vs == null || ca == null || gu == null) {
              yt.a = 1;
              break t;
            }
            var ms = gu;
            for (we = Ve = 0; we < vt; ++we) {
              var nr = vs[we], Bi = nr.G, gi = nr.H, nl = 0, Cs = 1, il = 0;
              for (Ae = 0; 5 > Ae; ++Ae) {
                Ne = qc[Ae], Bi[Ae] = ms, gi[Ae] = Ve, !Ae && 0 < ge && (Ne += 1 << ge);
                n: {
                  var Qs, du = Ne, Fs = yt, la = ca, _B = ms, DB = Ve, pu = 0, en = Fs.m, TB = hA(en, 1);
                  if (n(la, 0, 0, du), TB) {
                    var OB = hA(en, 1) + 1, PB = hA(en, 1), al = hA(en, PB == 0 ? 1 : 8);
                    la[al] = 1, OB == 2 && (la[al = hA(en, 8)] = 1);
                    var Us = 1;
                  } else {
                    var sl = i(19), ol = hA(en, 4) + 4;
                    if (19 < ol) {
                      Fs.a = 3;
                      var ys = 0;
                      break n;
                    }
                    for (Qs = 0; Qs < ol; ++Qs) sl[lB[Qs]] = hA(en, 3);
                    var wu = void 0, fa = void 0, ul = Fs, MB = sl, bs = du, cl = la, vu = 0, tn = ul.m, ll = 8, fl = s(128, H);
                    r: for (; I(fl, 0, 7, MB, 19); ) {
                      if (hA(tn, 1)) {
                        var KB = 2 + 2 * hA(tn, 3);
                        if ((wu = 2 + hA(tn, KB)) > bs) break r;
                      } else wu = bs;
                      for (fa = 0; fa < bs && wu--; ) {
                        X(tn);
                        var hl = fl[0 + (127 & _(tn))];
                        k(tn, tn.u + hl.g);
                        var di = hl.value;
                        if (16 > di) cl[fa++] = di, di != 0 && (ll = di);
                        else {
                          var kB = di == 16, Bl = di - 16, RB = uB[Bl], gl = hA(tn, oB[Bl]) + RB;
                          if (fa + gl > bs) break r;
                          for (var GB = kB ? ll : 0; 0 < gl--; ) cl[fa++] = GB;
                        }
                      }
                      vu = 1;
                      break r;
                    }
                    vu || (ul.a = 3), Us = vu;
                  }
                  (Us = Us && !en.h) && (pu = I(_B, DB, 8, la, du)), Us && pu != 0 ? ys = pu : (Fs.a = 3, ys = 0);
                }
                if (ys == 0) break t;
                if (Cs && cB[Ae] == 1 && (Cs = ms[Ve].g == 0), nl += ms[Ve].g, Ve += ys, 3 >= Ae) {
                  var ha, mu = ca[0];
                  for (ha = 1; ha < Ne; ++ha) ca[ha] > mu && (mu = ca[ha]);
                  il += mu;
                }
              }
              if (nr.nd = Cs, nr.Qb = 0, Cs && (nr.qb = (Bi[3][gi[3] + 0].value << 24 | Bi[1][gi[1] + 0].value << 16 | Bi[2][gi[2] + 0].value) >>> 0, nl == 0 && 256 > Bi[0][gi[0] + 0].value && (nr.Qb = 1, nr.qb += Bi[0][gi[0] + 0].value << 8)), nr.jc = !nr.Qb && 6 > il, nr.jc) {
                var Ls, Mr = nr;
                for (Ls = 0; Ls < rt; ++Ls) {
                  var rn = Ls, nn = Mr.pd[rn], Es = Mr.G[0][Mr.H[0] + rn];
                  256 <= Es.value ? (nn.g = Es.g + 256, nn.value = Es.value) : (nn.g = 0, nn.value = 0, rn >>= Xe(Es, 8, nn), rn >>= Xe(Mr.G[1][Mr.H[1] + rn], 16, nn), rn >>= Xe(Mr.G[2][Mr.H[2] + rn], 0, nn), Xe(Mr.G[3][Mr.H[3] + rn], 24, nn));
                }
              }
            }
            Ze.vc = nt, Ze.Wb = vt, Ze.Ya = vs, Ze.yc = gu, Ce = 1;
            break e;
          }
          Ce = 0;
        }
        if (!(C = Ce)) {
          d.a = 3;
          break A;
        }
        if (0 < tA) {
          if (S.ua = 1 << tA, !jA(S.Wa, tA)) {
            d.a = 1, C = 0;
            break A;
          }
        } else S.ua = 0;
        var Cu = d, dl = Q, jB = b, Qu = Cu.s, Fu = Qu.xc;
        if (Cu.c = dl, Cu.i = jB, Qu.md = PA(dl, Fu), Qu.wc = Fu == 0 ? -1 : (1 << Fu) - 1, f) {
          d.xb = CB;
          break A;
        }
        if ((j = i(Q * b)) == null) {
          d.a = 1, C = 0;
          break A;
        }
        C = (C = $t(d, j, 0, Q, b, b, null)) && !E.h;
        break A;
      }
      return C ? (v != null ? v[0] = j : (A(j == null), A(f)), d.$ = 0, f || dr(S)) : dr(S), C;
    }
    function Qn(a, o) {
      var f = a.c * a.i, d = f + o + 16 * o;
      return A(a.c <= o), a.V = i(d), a.V == null ? (a.Ta = null, a.Ua = 0, a.a = 1, 0) : (a.Ta = a.V, a.Ua = a.Ba + f + o, 1);
    }
    function Gn(a, o) {
      var f = a.C, d = o - f, v = a.V, C = a.Ba + a.c * f;
      for (A(o <= a.l.o); 0 < d; ) {
        var Q = 16 < d ? 16 : d, b = a.l.ma, E = a.l.width, S = E * Q, j = b.ca, tA = b.tb + E * f, rA = a.Ta, z = a.Ua;
        It(a, Q, v, C), Oe(rA, z, j, tA, S), Yt(b, f, f + Q, j, tA, E), d -= Q, v += Q * a.c, f += Q;
      }
      A(f == o), a.C = a.Ma = o;
    }
    function jn() {
      this.ub = this.yd = this.td = this.Rb = 0;
    }
    function Vn() {
      this.Kd = this.Ld = this.Ud = this.Td = this.i = this.c = 0;
    }
    function qn() {
      this.Fb = this.Bb = this.Cb = 0, this.Zb = i(4), this.Lb = i(4);
    }
    function Ma() {
      this.Yb = function() {
        var a = [];
        return function o(f, d, v) {
          for (var C = v[d], Q = 0; Q < C && (f.push(v.length > d + 1 ? [] : 0), !(v.length < d + 1)); Q++) o(f[Q], d + 1, v);
        }(a, 0, [3, 11]), a;
      }();
    }
    function To() {
      this.jb = i(3), this.Wc = u([4, 8], Ma), this.Xc = u([4, 17], Ma);
    }
    function Oo() {
      this.Pc = this.wb = this.Tb = this.zd = 0, this.vd = new i(4), this.od = new i(4);
    }
    function Wn() {
      this.ld = this.La = this.dd = this.tc = 0;
    }
    function Ka() {
      this.Na = this.la = 0;
    }
    function Po() {
      this.Sc = [0, 0], this.Eb = [0, 0], this.Qc = [0, 0], this.ia = this.lc = 0;
    }
    function Pi() {
      this.ad = i(384), this.Za = 0, this.Ob = i(16), this.$b = this.Ad = this.ia = this.Gc = this.Hc = this.Dd = 0;
    }
    function Mo() {
      this.uc = this.M = this.Nb = 0, this.wa = Array(new Wn()), this.Y = 0, this.ya = Array(new Pi()), this.aa = 0, this.l = new Xn();
    }
    function ka() {
      this.y = i(16), this.f = i(8), this.ea = i(8);
    }
    function Ko() {
      this.cb = this.a = 0, this.sc = "", this.m = new UA(), this.Od = new jn(), this.Kc = new Vn(), this.ed = new Oo(), this.Qa = new qn(), this.Ic = this.$c = this.Aa = 0, this.D = new Mo(), this.Xb = this.Va = this.Hb = this.zb = this.yb = this.Ub = this.za = 0, this.Jc = s(8, UA), this.ia = 0, this.pb = s(4, Po), this.Pa = new To(), this.Bd = this.kc = 0, this.Ac = [], this.Bc = 0, this.zc = [0, 0, 0, 0], this.Gd = Array(new ka()), this.Hd = 0, this.rb = Array(new Ka()), this.sb = 0, this.wa = Array(new Wn()), this.Y = 0, this.oc = [], this.pc = 0, this.sa = [], this.ta = 0, this.qa = [], this.ra = 0, this.Ha = [], this.B = this.R = this.Ia = 0, this.Ec = [], this.M = this.ja = this.Vb = this.Fc = 0, this.ya = Array(new Pi()), this.L = this.aa = 0, this.gd = u([4, 2], Wn), this.ga = null, this.Fa = [], this.Cc = this.qc = this.P = 0, this.Gb = [], this.Uc = 0, this.mb = [], this.nb = 0, this.rc = [], this.Ga = this.Vc = 0;
    }
    function Xn() {
      this.T = this.U = this.ka = this.height = this.width = 0, this.y = [], this.f = [], this.ea = [], this.Rc = this.fa = this.W = this.N = this.O = 0, this.ma = "void", this.put = "VP8IoPutHook", this.ac = "VP8IoSetupHook", this.bc = "VP8IoTeardownHook", this.ha = this.Kb = 0, this.data = [], this.hb = this.ib = this.da = this.o = this.j = this.va = this.v = this.Da = this.ob = this.w = 0, this.F = [], this.J = 0;
    }
    function ko() {
      var a = new Ko();
      return a != null && (a.a = 0, a.sc = "OK", a.cb = 0, a.Xb = 0, oa || (oa = ja)), a;
    }
    function De(a, o, f) {
      return a.a == 0 && (a.a = o, a.sc = f, a.cb = 0), 0;
    }
    function Ra(a, o, f) {
      return 3 <= f && a[o + 0] == 157 && a[o + 1] == 1 && a[o + 2] == 42;
    }
    function Ga(a, o) {
      if (a == null) return 0;
      if (a.a = 0, a.sc = "OK", o == null) return De(a, 2, "null VP8Io passed to VP8GetHeaders()");
      var f = o.data, d = o.w, v = o.ha;
      if (4 > v) return De(a, 7, "Truncated header.");
      var C = f[d + 0] | f[d + 1] << 8 | f[d + 2] << 16, Q = a.Od;
      if (Q.Rb = !(1 & C), Q.td = C >> 1 & 7, Q.yd = C >> 4 & 1, Q.ub = C >> 5, 3 < Q.td) return De(a, 3, "Incorrect keyframe parameters.");
      if (!Q.yd) return De(a, 4, "Frame not displayable.");
      d += 3, v -= 3;
      var b = a.Kc;
      if (Q.Rb) {
        if (7 > v) return De(a, 7, "cannot parse picture header");
        if (!Ra(f, d, v)) return De(a, 3, "Bad code word");
        b.c = 16383 & (f[d + 4] << 8 | f[d + 3]), b.Td = f[d + 4] >> 6, b.i = 16383 & (f[d + 6] << 8 | f[d + 5]), b.Ud = f[d + 6] >> 6, d += 7, v -= 7, a.za = b.c + 15 >> 4, a.Ub = b.i + 15 >> 4, o.width = b.c, o.height = b.i, o.Da = 0, o.j = 0, o.v = 0, o.va = o.width, o.o = o.height, o.da = 0, o.ib = o.width, o.hb = o.height, o.U = o.width, o.T = o.height, n((C = a.Pa).jb, 0, 255, C.jb.length), A((C = a.Qa) != null), C.Cb = 0, C.Bb = 0, C.Fb = 1, n(C.Zb, 0, 0, C.Zb.length), n(C.Lb, 0, 0, C.Lb);
      }
      if (Q.ub > v) return De(a, 7, "bad partition length");
      oA(C = a.m, f, d, Q.ub), d += Q.ub, v -= Q.ub, Q.Rb && (b.Ld = aA(C), b.Kd = aA(C)), b = a.Qa;
      var E, S = a.Pa;
      if (A(C != null), A(b != null), b.Cb = aA(C), b.Cb) {
        if (b.Bb = aA(C), aA(C)) {
          for (b.Fb = aA(C), E = 0; 4 > E; ++E) b.Zb[E] = aA(C) ? uA(C, 7) : 0;
          for (E = 0; 4 > E; ++E) b.Lb[E] = aA(C) ? uA(C, 6) : 0;
        }
        if (b.Bb) for (E = 0; 3 > E; ++E) S.jb[E] = aA(C) ? iA(C, 8) : 255;
      } else b.Bb = 0;
      if (C.Ka) return De(a, 3, "cannot parse segment header");
      if ((b = a.ed).zd = aA(C), b.Tb = iA(C, 6), b.wb = iA(C, 3), b.Pc = aA(C), b.Pc && aA(C)) {
        for (S = 0; 4 > S; ++S) aA(C) && (b.vd[S] = uA(C, 6));
        for (S = 0; 4 > S; ++S) aA(C) && (b.od[S] = uA(C, 6));
      }
      if (a.L = b.Tb == 0 ? 0 : b.zd ? 1 : 2, C.Ka) return De(a, 3, "cannot parse filter header");
      var j = v;
      if (v = E = d, d = E + j, b = j, a.Xb = (1 << iA(a.m, 2)) - 1, j < 3 * (S = a.Xb)) f = 7;
      else {
        for (E += 3 * S, b -= 3 * S, j = 0; j < S; ++j) {
          var tA = f[v + 0] | f[v + 1] << 8 | f[v + 2] << 16;
          tA > b && (tA = b), oA(a.Jc[+j], f, E, tA), E += tA, b -= tA, v += 3;
        }
        oA(a.Jc[+S], f, E, b), f = E < d ? 0 : 5;
      }
      if (f != 0) return De(a, f, "cannot parse partitions");
      for (f = iA(E = a.m, 7), v = aA(E) ? uA(E, 4) : 0, d = aA(E) ? uA(E, 4) : 0, b = aA(E) ? uA(E, 4) : 0, S = aA(E) ? uA(E, 4) : 0, E = aA(E) ? uA(E, 4) : 0, j = a.Qa, tA = 0; 4 > tA; ++tA) {
        if (j.Cb) {
          var rA = j.Zb[tA];
          j.Fb || (rA += f);
        } else {
          if (0 < tA) {
            a.pb[tA] = a.pb[0];
            continue;
          }
          rA = f;
        }
        var z = a.pb[tA];
        z.Sc[0] = fu[xt(rA + v, 127)], z.Sc[1] = hu[xt(rA + 0, 127)], z.Eb[0] = 2 * fu[xt(rA + d, 127)], z.Eb[1] = 101581 * hu[xt(rA + b, 127)] >> 16, 8 > z.Eb[1] && (z.Eb[1] = 8), z.Qc[0] = fu[xt(rA + S, 117)], z.Qc[1] = hu[xt(rA + E, 127)], z.lc = rA + E;
      }
      if (!Q.Rb) return De(a, 4, "Not a key frame.");
      for (aA(C), Q = a.Pa, f = 0; 4 > f; ++f) {
        for (v = 0; 8 > v; ++v) for (d = 0; 3 > d; ++d) for (b = 0; 11 > b; ++b) S = sA(C, vB[f][v][d][b]) ? iA(C, 8) : pB[f][v][d][b], Q.Wc[f][v].Yb[d][b] = S;
        for (v = 0; 17 > v; ++v) Q.Xc[f][v] = Q.Wc[f][mB[v]];
      }
      return a.kc = aA(C), a.kc && (a.Bd = iA(C, 8)), a.cb = 1;
    }
    function ja(a, o, f, d, v, C, Q) {
      var b = o[v].Yb[f];
      for (f = 0; 16 > v; ++v) {
        if (!sA(a, b[f + 0])) return v;
        for (; !sA(a, b[f + 1]); ) if (b = o[++v].Yb[0], f = 0, v == 16) return 16;
        var E = o[v + 1].Yb;
        if (sA(a, b[f + 2])) {
          var S = a, j = 0;
          if (sA(S, (rA = b)[(tA = f) + 3])) if (sA(S, rA[tA + 6])) {
            for (b = 0, tA = 2 * (j = sA(S, rA[tA + 8])) + (rA = sA(S, rA[tA + 9 + j])), j = 0, rA = gB[tA]; rA[b]; ++b) j += j + sA(S, rA[b]);
            j += 3 + (8 << tA);
          } else sA(S, rA[tA + 7]) ? (j = 7 + 2 * sA(S, 165), j += sA(S, 145)) : j = 5 + sA(S, 159);
          else j = sA(S, rA[tA + 4]) ? 3 + sA(S, rA[tA + 5]) : 2;
          b = E[2];
        } else j = 1, b = E[1];
        E = Q + dB[v], 0 > (S = a).b && nA(S);
        var tA, rA = S.b, z = (tA = S.Ca >> 1) - (S.I >> rA) >> 31;
        --S.b, S.Ca += z, S.Ca |= 1, S.I -= (tA + 1 & z) << rA, C[E] = ((j ^ z) - z) * d[(0 < v) + 0];
      }
      return 16;
    }
    function Mi(a) {
      var o = a.rb[a.sb - 1];
      o.la = 0, o.Na = 0, n(a.zc, 0, 0, a.zc.length), a.ja = 0;
    }
    function Ro(a, o) {
      if (a == null) return 0;
      if (o == null) return De(a, 2, "NULL VP8Io parameter in VP8Decode().");
      if (!a.cb && !Ga(a, o)) return 0;
      if (A(a.cb), o.ac == null || o.ac(o)) {
        o.ob && (a.L = 0);
        var f = ws[a.L];
        if (a.L == 2 ? (a.yb = 0, a.zb = 0) : (a.yb = o.v - f >> 4, a.zb = o.j - f >> 4, 0 > a.yb && (a.yb = 0), 0 > a.zb && (a.zb = 0)), a.Va = o.o + 15 + f >> 4, a.Hb = o.va + 15 + f >> 4, a.Hb > a.za && (a.Hb = a.za), a.Va > a.Ub && (a.Va = a.Ub), 0 < a.L) {
          var d = a.ed;
          for (f = 0; 4 > f; ++f) {
            var v;
            if (a.Qa.Cb) {
              var C = a.Qa.Lb[f];
              a.Qa.Fb || (C += d.Tb);
            } else C = d.Tb;
            for (v = 0; 1 >= v; ++v) {
              var Q = a.gd[f][v], b = C;
              if (d.Pc && (b += d.vd[0], v && (b += d.od[0])), 0 < (b = 0 > b ? 0 : 63 < b ? 63 : b)) {
                var E = b;
                0 < d.wb && (E = 4 < d.wb ? E >> 2 : E >> 1) > 9 - d.wb && (E = 9 - d.wb), 1 > E && (E = 1), Q.dd = E, Q.tc = 2 * b + E, Q.ld = 40 <= b ? 2 : 15 <= b ? 1 : 0;
              } else Q.tc = 0;
              Q.La = v;
            }
          }
        }
        f = 0;
      } else De(a, 6, "Frame setup failed"), f = a.a;
      if (f = f == 0) {
        if (f) {
          a.$c = 0, 0 < a.Aa || (a.Ic = NB);
          A: {
            f = a.Ic, d = 4 * (E = a.za);
            var S = 32 * E, j = E + 1, tA = 0 < a.L ? E * (0 < a.Aa ? 2 : 1) : 0, rA = (a.Aa == 2 ? 2 : 1) * E;
            if ((Q = d + 832 + (v = 3 * (16 * f + ws[a.L]) / 2 * S) + (C = a.Fa != null && 0 < a.Fa.length ? a.Kc.c * a.Kc.i : 0)) != Q) f = 0;
            else {
              if (Q > a.Vb) {
                if (a.Vb = 0, a.Ec = i(Q), a.Fc = 0, a.Ec == null) {
                  f = De(a, 1, "no memory during frame initialization.");
                  break A;
                }
                a.Vb = Q;
              }
              Q = a.Ec, b = a.Fc, a.Ac = Q, a.Bc = b, b += d, a.Gd = s(S, ka), a.Hd = 0, a.rb = s(j + 1, Ka), a.sb = 1, a.wa = tA ? s(tA, Wn) : null, a.Y = 0, a.D.Nb = 0, a.D.wa = a.wa, a.D.Y = a.Y, 0 < a.Aa && (a.D.Y += E), A(!0), a.oc = Q, a.pc = b, b += 832, a.ya = s(rA, Pi), a.aa = 0, a.D.ya = a.ya, a.D.aa = a.aa, a.Aa == 2 && (a.D.aa += E), a.R = 16 * E, a.B = 8 * E, E = (S = ws[a.L]) * a.R, S = S / 2 * a.B, a.sa = Q, a.ta = b + E, a.qa = a.sa, a.ra = a.ta + 16 * f * a.R + S, a.Ha = a.qa, a.Ia = a.ra + 8 * f * a.B + S, a.$c = 0, b += v, a.mb = C ? Q : null, a.nb = C ? b : null, A(b + C <= a.Fc + a.Vb), Mi(a), n(a.Ac, a.Bc, 0, d), f = 1;
            }
          }
          if (f) {
            if (o.ka = 0, o.y = a.sa, o.O = a.ta, o.f = a.qa, o.N = a.ra, o.ea = a.Ha, o.Vd = a.Ia, o.fa = a.R, o.Rc = a.B, o.F = null, o.J = 0, !us) {
              for (f = -255; 255 >= f; ++f) Je[255 + f] = 0 > f ? -f : f;
              for (f = -1020; 1020 >= f; ++f) Tr[1020 + f] = -128 > f ? -128 : 127 < f ? 127 : f;
              for (f = -112; 112 >= f; ++f) sa[112 + f] = -16 > f ? -16 : 15 < f ? 15 : f;
              for (f = -255; 510 >= f; ++f) fi[255 + f] = 0 > f ? 0 : 255 < f ? 255 : f;
              us = 1;
            }
            ui = Vo, Dr = Go, na = qa, wt = jo, Pt = Wa, Te = Va, ci = Vi, os = yn, ia = nu, En = qi, In = ru, zr = Ai, xn = Wi, li = ts, Hn = es, Yr = vr, aa = Sr, Mt = tu, rr[0] = wr, rr[1] = qo, rr[2] = zo, rr[3] = Yo, rr[4] = za, rr[5] = Zn, rr[6] = Ya, rr[7] = Ri, rr[8] = $o, rr[9] = Zo, Zr[0] = Xa, Zr[1] = Xo, Zr[2] = Hr, Zr[3] = zn, Zr[4] = ot, Zr[5] = Jo, Zr[6] = Ja, Or[0] = Vr, Or[1] = Wo, Or[2] = Au, Or[3] = Gi, Or[4] = Un, Or[5] = eu, Or[6] = ji, f = 1;
          } else f = 0;
        }
        f && (f = function(z, wA) {
          for (z.M = 0; z.M < z.Va; ++z.M) {
            var fA, V = z.Jc[z.M & z.Xb], q = z.m, dA = z;
            for (fA = 0; fA < dA.za; ++fA) {
              var vA = q, pA = dA, DA = pA.Ac, bA = pA.Bc + 4 * fA, kA = pA.zc, EA = pA.ya[pA.aa + fA];
              if (pA.Qa.Bb ? EA.$b = sA(vA, pA.Pa.jb[0]) ? 2 + sA(vA, pA.Pa.jb[2]) : sA(vA, pA.Pa.jb[1]) : EA.$b = 0, pA.kc && (EA.Ad = sA(vA, pA.Bd)), EA.Za = !sA(vA, 145) + 0, EA.Za) {
                var ce = EA.Ob, Be = 0;
                for (pA = 0; 4 > pA; ++pA) {
                  var oe, ne = kA[0 + pA];
                  for (oe = 0; 4 > oe; ++oe) {
                    ne = wB[DA[bA + oe]][ne];
                    for (var Ce = Wc[sA(vA, ne[0])]; 0 < Ce; ) Ce = Wc[2 * Ce + sA(vA, ne[Ce])];
                    ne = -Ce, DA[bA + oe] = ne;
                  }
                  r(ce, Be, DA, bA, 4), Be += 4, kA[0 + pA] = ne;
                }
              } else ne = sA(vA, 156) ? sA(vA, 128) ? 1 : 3 : sA(vA, 163) ? 2 : 0, EA.Ob[0] = ne, n(DA, bA, ne, 4), n(kA, 0, ne, 4);
              EA.Dd = sA(vA, 142) ? sA(vA, 114) ? sA(vA, 183) ? 1 : 3 : 2 : 0;
            }
            if (dA.m.Ka) return De(z, 7, "Premature end-of-partition0 encountered.");
            for (; z.ja < z.za; ++z.ja) {
              if (dA = V, vA = (q = z).rb[q.sb - 1], DA = q.rb[q.sb + q.ja], fA = q.ya[q.aa + q.ja], bA = q.kc ? fA.Ad : 0) vA.la = DA.la = 0, fA.Za || (vA.Na = DA.Na = 0), fA.Hc = 0, fA.Gc = 0, fA.ia = 0;
              else {
                var we, Ae;
                if (vA = DA, DA = dA, bA = q.Pa.Xc, kA = q.ya[q.aa + q.ja], EA = q.pb[kA.$b], pA = kA.ad, ce = 0, Be = q.rb[q.sb - 1], ne = oe = 0, n(pA, ce, 0, 384), kA.Za) var Ve = 0, yt = bA[3];
                else {
                  Ce = i(16);
                  var qe = vA.Na + Be.Na;
                  if (qe = oa(DA, bA[1], qe, EA.Eb, 0, Ce, 0), vA.Na = Be.Na = (0 < qe) + 0, 1 < qe) ui(Ce, 0, pA, ce);
                  else {
                    var bt = Ce[0] + 3 >> 3;
                    for (Ce = 0; 256 > Ce; Ce += 16) pA[ce + Ce] = bt;
                  }
                  Ve = 1, yt = bA[0];
                }
                var ge = 15 & vA.la, St = 15 & Be.la;
                for (Ce = 0; 4 > Ce; ++Ce) {
                  var Nt = 1 & St;
                  for (bt = Ae = 0; 4 > bt; ++bt) ge = ge >> 1 | (Nt = (qe = oa(DA, yt, qe = Nt + (1 & ge), EA.Sc, Ve, pA, ce)) > Ve) << 7, Ae = Ae << 2 | (3 < qe ? 3 : 1 < qe ? 2 : pA[ce + 0] != 0), ce += 16;
                  ge >>= 4, St = St >> 1 | Nt << 7, oe = (oe << 8 | Ae) >>> 0;
                }
                for (yt = ge, Ve = St >> 4, we = 0; 4 > we; we += 2) {
                  for (Ae = 0, ge = vA.la >> 4 + we, St = Be.la >> 4 + we, Ce = 0; 2 > Ce; ++Ce) {
                    for (Nt = 1 & St, bt = 0; 2 > bt; ++bt) qe = Nt + (1 & ge), ge = ge >> 1 | (Nt = 0 < (qe = oa(DA, bA[2], qe, EA.Qc, 0, pA, ce))) << 3, Ae = Ae << 2 | (3 < qe ? 3 : 1 < qe ? 2 : pA[ce + 0] != 0), ce += 16;
                    ge >>= 2, St = St >> 1 | Nt << 5;
                  }
                  ne |= Ae << 4 * we, yt |= ge << 4 << we, Ve |= (240 & St) << we;
                }
                vA.la = yt, Be.la = Ve, kA.Hc = oe, kA.Gc = ne, kA.ia = 43690 & ne ? 0 : EA.ia, bA = !(oe | ne);
              }
              if (0 < q.L && (q.wa[q.Y + q.ja] = q.gd[fA.$b][fA.Za], q.wa[q.Y + q.ja].La |= !bA), dA.Ka) return De(z, 7, "Premature end-of-file encountered.");
            }
            if (Mi(z), q = wA, dA = 1, fA = (V = z).D, vA = 0 < V.L && V.M >= V.zb && V.M <= V.Va, V.Aa == 0) A: {
              if (fA.M = V.M, fA.uc = vA, $i(V, fA), dA = 1, fA = (Ae = V.D).Nb, vA = (ne = ws[V.L]) * V.R, DA = ne / 2 * V.B, Ce = 16 * fA * V.R, bt = 8 * fA * V.B, bA = V.sa, kA = V.ta - vA + Ce, EA = V.qa, pA = V.ra - DA + bt, ce = V.Ha, Be = V.Ia - DA + bt, St = (ge = Ae.M) == 0, oe = ge >= V.Va - 1, V.Aa == 2 && $i(V, Ae), Ae.uc) for (Nt = (qe = V).D.M, A(qe.D.uc), Ae = qe.yb; Ae < qe.Hb; ++Ae) {
                Ve = Ae, yt = Nt;
                var Ze = (nt = (Ne = qe).D).Nb;
                we = Ne.R;
                var nt = nt.wa[nt.Y + Ve], vt = Ne.sa, Gt = Ne.ta + 16 * Ze * we + 16 * Ve, Cr = nt.dd, $e = nt.tc;
                if ($e != 0) if (A(3 <= $e), Ne.L == 1) 0 < Ve && Yr(vt, Gt, we, $e + 4), nt.La && Mt(vt, Gt, we, $e), 0 < yt && Hn(vt, Gt, we, $e + 4), nt.La && aa(vt, Gt, we, $e);
                else {
                  var Pr = Ne.B, Sn = Ne.qa, hi = Ne.ra + 8 * Ze * Pr + 8 * Ve, An = Ne.Ha, Ne = Ne.Ia + 8 * Ze * Pr + 8 * Ve;
                  Ze = nt.ld, 0 < Ve && (os(vt, Gt, we, $e + 4, Cr, Ze), En(Sn, hi, An, Ne, Pr, $e + 4, Cr, Ze)), nt.La && (zr(vt, Gt, we, $e, Cr, Ze), li(Sn, hi, An, Ne, Pr, $e, Cr, Ze)), 0 < yt && (ci(vt, Gt, we, $e + 4, Cr, Ze), ia(Sn, hi, An, Ne, Pr, $e + 4, Cr, Ze)), nt.La && (In(vt, Gt, we, $e, Cr, Ze), xn(Sn, hi, An, Ne, Pr, $e, Cr, Ze));
                }
              }
              if (V.ia && alert("todo:DitherRow"), q.put != null) {
                if (Ae = 16 * ge, ge = 16 * (ge + 1), St ? (q.y = V.sa, q.O = V.ta + Ce, q.f = V.qa, q.N = V.ra + bt, q.ea = V.Ha, q.W = V.Ia + bt) : (Ae -= ne, q.y = bA, q.O = kA, q.f = EA, q.N = pA, q.ea = ce, q.W = Be), oe || (ge -= ne), ge > q.o && (ge = q.o), q.F = null, q.J = null, V.Fa != null && 0 < V.Fa.length && Ae < ge && (q.J = Yi(V, q, Ae, ge - Ae), q.F = V.mb, q.F == null && q.F.length == 0)) {
                  dA = De(V, 3, "Could not decode alpha data.");
                  break A;
                }
                Ae < q.j && (ne = q.j - Ae, Ae = q.j, A(!(1 & ne)), q.O += V.R * ne, q.N += V.B * (ne >> 1), q.W += V.B * (ne >> 1), q.F != null && (q.J += q.width * ne)), Ae < ge && (q.O += q.v, q.N += q.v >> 1, q.W += q.v >> 1, q.F != null && (q.J += q.v), q.ka = Ae - q.j, q.U = q.va - q.v, q.T = ge - Ae, dA = q.put(q));
              }
              fA + 1 != V.Ic || oe || (r(V.sa, V.ta - vA, bA, kA + 16 * V.R, vA), r(V.qa, V.ra - DA, EA, pA + 8 * V.B, DA), r(V.Ha, V.Ia - DA, ce, Be + 8 * V.B, DA));
            }
            if (!dA) return De(z, 6, "Output aborted.");
          }
          return 1;
        }(a, o)), o.bc != null && o.bc(o), f &= 1;
      }
      return f ? (a.cb = 0, f) : 0;
    }
    function Ar(a, o, f, d, v) {
      v = a[o + f + 32 * d] + (v >> 3), a[o + f + 32 * d] = -256 & v ? 0 > v ? 0 : 255 : v;
    }
    function Jn(a, o, f, d, v, C) {
      Ar(a, o, 0, f, d + v), Ar(a, o, 1, f, d + C), Ar(a, o, 2, f, d - C), Ar(a, o, 3, f, d - v);
    }
    function Qt(a) {
      return (20091 * a >> 16) + a;
    }
    function Ki(a, o, f, d) {
      var v, C = 0, Q = i(16);
      for (v = 0; 4 > v; ++v) {
        var b = a[o + 0] + a[o + 8], E = a[o + 0] - a[o + 8], S = (35468 * a[o + 4] >> 16) - Qt(a[o + 12]), j = Qt(a[o + 4]) + (35468 * a[o + 12] >> 16);
        Q[C + 0] = b + j, Q[C + 1] = E + S, Q[C + 2] = E - S, Q[C + 3] = b - j, C += 4, o++;
      }
      for (v = C = 0; 4 > v; ++v) b = (a = Q[C + 0] + 4) + Q[C + 8], E = a - Q[C + 8], S = (35468 * Q[C + 4] >> 16) - Qt(Q[C + 12]), Ar(f, d, 0, 0, b + (j = Qt(Q[C + 4]) + (35468 * Q[C + 12] >> 16))), Ar(f, d, 1, 0, E + S), Ar(f, d, 2, 0, E - S), Ar(f, d, 3, 0, b - j), C++, d += 32;
    }
    function Va(a, o, f, d) {
      var v = a[o + 0] + 4, C = 35468 * a[o + 4] >> 16, Q = Qt(a[o + 4]), b = 35468 * a[o + 1] >> 16;
      Jn(f, d, 0, v + Q, a = Qt(a[o + 1]), b), Jn(f, d, 1, v + C, a, b), Jn(f, d, 2, v - C, a, b), Jn(f, d, 3, v - Q, a, b);
    }
    function Go(a, o, f, d, v) {
      Ki(a, o, f, d), v && Ki(a, o + 16, f, d + 4);
    }
    function qa(a, o, f, d) {
      Dr(a, o + 0, f, d, 1), Dr(a, o + 32, f, d + 128, 1);
    }
    function jo(a, o, f, d) {
      var v;
      for (a = a[o + 0] + 4, v = 0; 4 > v; ++v) for (o = 0; 4 > o; ++o) Ar(f, d, o, v, a);
    }
    function Wa(a, o, f, d) {
      a[o + 0] && wt(a, o + 0, f, d), a[o + 16] && wt(a, o + 16, f, d + 4), a[o + 32] && wt(a, o + 32, f, d + 128), a[o + 48] && wt(a, o + 48, f, d + 128 + 4);
    }
    function Vo(a, o, f, d) {
      var v, C = i(16);
      for (v = 0; 4 > v; ++v) {
        var Q = a[o + 0 + v] + a[o + 12 + v], b = a[o + 4 + v] + a[o + 8 + v], E = a[o + 4 + v] - a[o + 8 + v], S = a[o + 0 + v] - a[o + 12 + v];
        C[0 + v] = Q + b, C[8 + v] = Q - b, C[4 + v] = S + E, C[12 + v] = S - E;
      }
      for (v = 0; 4 > v; ++v) Q = (a = C[0 + 4 * v] + 3) + C[3 + 4 * v], b = C[1 + 4 * v] + C[2 + 4 * v], E = C[1 + 4 * v] - C[2 + 4 * v], S = a - C[3 + 4 * v], f[d + 0] = Q + b >> 3, f[d + 16] = S + E >> 3, f[d + 32] = Q - b >> 3, f[d + 48] = S - E >> 3, d += 64;
    }
    function ki(a, o, f) {
      var d, v = o - 32, C = Ht, Q = 255 - a[v - 1];
      for (d = 0; d < f; ++d) {
        var b, E = C, S = Q + a[o - 1];
        for (b = 0; b < f; ++b) a[o + b] = E[S + a[v + b]];
        o += 32;
      }
    }
    function qo(a, o) {
      ki(a, o, 4);
    }
    function Wo(a, o) {
      ki(a, o, 8);
    }
    function Xo(a, o) {
      ki(a, o, 16);
    }
    function Hr(a, o) {
      var f;
      for (f = 0; 16 > f; ++f) r(a, o + 32 * f, a, o - 32, 16);
    }
    function zn(a, o) {
      var f;
      for (f = 16; 0 < f; --f) n(a, o, a[o - 1], 16), o += 32;
    }
    function Yn(a, o, f) {
      var d;
      for (d = 0; 16 > d; ++d) n(o, f + 32 * d, a, 16);
    }
    function Xa(a, o) {
      var f, d = 16;
      for (f = 0; 16 > f; ++f) d += a[o - 1 + 32 * f] + a[o + f - 32];
      Yn(d >> 5, a, o);
    }
    function ot(a, o) {
      var f, d = 8;
      for (f = 0; 16 > f; ++f) d += a[o - 1 + 32 * f];
      Yn(d >> 4, a, o);
    }
    function Jo(a, o) {
      var f, d = 8;
      for (f = 0; 16 > f; ++f) d += a[o + f - 32];
      Yn(d >> 4, a, o);
    }
    function Ja(a, o) {
      Yn(128, a, o);
    }
    function WA(a, o, f) {
      return a + 2 * o + f + 2 >> 2;
    }
    function zo(a, o) {
      var f, d = o - 32;
      for (d = new Uint8Array([WA(a[d - 1], a[d + 0], a[d + 1]), WA(a[d + 0], a[d + 1], a[d + 2]), WA(a[d + 1], a[d + 2], a[d + 3]), WA(a[d + 2], a[d + 3], a[d + 4])]), f = 0; 4 > f; ++f) r(a, o + 32 * f, d, 0, d.length);
    }
    function Yo(a, o) {
      var f = a[o - 1], d = a[o - 1 + 32], v = a[o - 1 + 64], C = a[o - 1 + 96];
      FA(a, o + 0, 16843009 * WA(a[o - 1 - 32], f, d)), FA(a, o + 32, 16843009 * WA(f, d, v)), FA(a, o + 64, 16843009 * WA(d, v, C)), FA(a, o + 96, 16843009 * WA(v, C, C));
    }
    function wr(a, o) {
      var f, d = 4;
      for (f = 0; 4 > f; ++f) d += a[o + f - 32] + a[o - 1 + 32 * f];
      for (d >>= 3, f = 0; 4 > f; ++f) n(a, o + 32 * f, d, 4);
    }
    function za(a, o) {
      var f = a[o - 1 + 0], d = a[o - 1 + 32], v = a[o - 1 + 64], C = a[o - 1 - 32], Q = a[o + 0 - 32], b = a[o + 1 - 32], E = a[o + 2 - 32], S = a[o + 3 - 32];
      a[o + 0 + 96] = WA(d, v, a[o - 1 + 96]), a[o + 1 + 96] = a[o + 0 + 64] = WA(f, d, v), a[o + 2 + 96] = a[o + 1 + 64] = a[o + 0 + 32] = WA(C, f, d), a[o + 3 + 96] = a[o + 2 + 64] = a[o + 1 + 32] = a[o + 0 + 0] = WA(Q, C, f), a[o + 3 + 64] = a[o + 2 + 32] = a[o + 1 + 0] = WA(b, Q, C), a[o + 3 + 32] = a[o + 2 + 0] = WA(E, b, Q), a[o + 3 + 0] = WA(S, E, b);
    }
    function Ya(a, o) {
      var f = a[o + 1 - 32], d = a[o + 2 - 32], v = a[o + 3 - 32], C = a[o + 4 - 32], Q = a[o + 5 - 32], b = a[o + 6 - 32], E = a[o + 7 - 32];
      a[o + 0 + 0] = WA(a[o + 0 - 32], f, d), a[o + 1 + 0] = a[o + 0 + 32] = WA(f, d, v), a[o + 2 + 0] = a[o + 1 + 32] = a[o + 0 + 64] = WA(d, v, C), a[o + 3 + 0] = a[o + 2 + 32] = a[o + 1 + 64] = a[o + 0 + 96] = WA(v, C, Q), a[o + 3 + 32] = a[o + 2 + 64] = a[o + 1 + 96] = WA(C, Q, b), a[o + 3 + 64] = a[o + 2 + 96] = WA(Q, b, E), a[o + 3 + 96] = WA(b, E, E);
    }
    function Zn(a, o) {
      var f = a[o - 1 + 0], d = a[o - 1 + 32], v = a[o - 1 + 64], C = a[o - 1 - 32], Q = a[o + 0 - 32], b = a[o + 1 - 32], E = a[o + 2 - 32], S = a[o + 3 - 32];
      a[o + 0 + 0] = a[o + 1 + 64] = C + Q + 1 >> 1, a[o + 1 + 0] = a[o + 2 + 64] = Q + b + 1 >> 1, a[o + 2 + 0] = a[o + 3 + 64] = b + E + 1 >> 1, a[o + 3 + 0] = E + S + 1 >> 1, a[o + 0 + 96] = WA(v, d, f), a[o + 0 + 64] = WA(d, f, C), a[o + 0 + 32] = a[o + 1 + 96] = WA(f, C, Q), a[o + 1 + 32] = a[o + 2 + 96] = WA(C, Q, b), a[o + 2 + 32] = a[o + 3 + 96] = WA(Q, b, E), a[o + 3 + 32] = WA(b, E, S);
    }
    function Ri(a, o) {
      var f = a[o + 0 - 32], d = a[o + 1 - 32], v = a[o + 2 - 32], C = a[o + 3 - 32], Q = a[o + 4 - 32], b = a[o + 5 - 32], E = a[o + 6 - 32], S = a[o + 7 - 32];
      a[o + 0 + 0] = f + d + 1 >> 1, a[o + 1 + 0] = a[o + 0 + 64] = d + v + 1 >> 1, a[o + 2 + 0] = a[o + 1 + 64] = v + C + 1 >> 1, a[o + 3 + 0] = a[o + 2 + 64] = C + Q + 1 >> 1, a[o + 0 + 32] = WA(f, d, v), a[o + 1 + 32] = a[o + 0 + 96] = WA(d, v, C), a[o + 2 + 32] = a[o + 1 + 96] = WA(v, C, Q), a[o + 3 + 32] = a[o + 2 + 96] = WA(C, Q, b), a[o + 3 + 64] = WA(Q, b, E), a[o + 3 + 96] = WA(b, E, S);
    }
    function Zo(a, o) {
      var f = a[o - 1 + 0], d = a[o - 1 + 32], v = a[o - 1 + 64], C = a[o - 1 + 96];
      a[o + 0 + 0] = f + d + 1 >> 1, a[o + 2 + 0] = a[o + 0 + 32] = d + v + 1 >> 1, a[o + 2 + 32] = a[o + 0 + 64] = v + C + 1 >> 1, a[o + 1 + 0] = WA(f, d, v), a[o + 3 + 0] = a[o + 1 + 32] = WA(d, v, C), a[o + 3 + 32] = a[o + 1 + 64] = WA(v, C, C), a[o + 3 + 64] = a[o + 2 + 64] = a[o + 0 + 96] = a[o + 1 + 96] = a[o + 2 + 96] = a[o + 3 + 96] = C;
    }
    function $o(a, o) {
      var f = a[o - 1 + 0], d = a[o - 1 + 32], v = a[o - 1 + 64], C = a[o - 1 + 96], Q = a[o - 1 - 32], b = a[o + 0 - 32], E = a[o + 1 - 32], S = a[o + 2 - 32];
      a[o + 0 + 0] = a[o + 2 + 32] = f + Q + 1 >> 1, a[o + 0 + 32] = a[o + 2 + 64] = d + f + 1 >> 1, a[o + 0 + 64] = a[o + 2 + 96] = v + d + 1 >> 1, a[o + 0 + 96] = C + v + 1 >> 1, a[o + 3 + 0] = WA(b, E, S), a[o + 2 + 0] = WA(Q, b, E), a[o + 1 + 0] = a[o + 3 + 32] = WA(f, Q, b), a[o + 1 + 32] = a[o + 3 + 64] = WA(d, f, Q), a[o + 1 + 64] = a[o + 3 + 96] = WA(v, d, f), a[o + 1 + 96] = WA(C, v, d);
    }
    function Au(a, o) {
      var f;
      for (f = 0; 8 > f; ++f) r(a, o + 32 * f, a, o - 32, 8);
    }
    function Gi(a, o) {
      var f;
      for (f = 0; 8 > f; ++f) n(a, o, a[o - 1], 8), o += 32;
    }
    function Fn(a, o, f) {
      var d;
      for (d = 0; 8 > d; ++d) n(o, f + 32 * d, a, 8);
    }
    function Vr(a, o) {
      var f, d = 8;
      for (f = 0; 8 > f; ++f) d += a[o + f - 32] + a[o - 1 + 32 * f];
      Fn(d >> 4, a, o);
    }
    function eu(a, o) {
      var f, d = 4;
      for (f = 0; 8 > f; ++f) d += a[o + f - 32];
      Fn(d >> 3, a, o);
    }
    function Un(a, o) {
      var f, d = 4;
      for (f = 0; 8 > f; ++f) d += a[o - 1 + 32 * f];
      Fn(d >> 3, a, o);
    }
    function ji(a, o) {
      Fn(128, a, o);
    }
    function $n(a, o, f) {
      var d = a[o - f], v = a[o + 0], C = 3 * (v - d) + su[1020 + a[o - 2 * f] - a[o + f]], Q = cs[112 + (C + 4 >> 3)];
      a[o - f] = Ht[255 + d + cs[112 + (C + 3 >> 3)]], a[o + 0] = Ht[255 + v - Q];
    }
    function Za(a, o, f, d) {
      var v = a[o + 0], C = a[o + f];
      return kt[255 + a[o - 2 * f] - a[o - f]] > d || kt[255 + C - v] > d;
    }
    function $a(a, o, f, d) {
      return 4 * kt[255 + a[o - f] - a[o + 0]] + kt[255 + a[o - 2 * f] - a[o + f]] <= d;
    }
    function As(a, o, f, d, v) {
      var C = a[o - 3 * f], Q = a[o - 2 * f], b = a[o - f], E = a[o + 0], S = a[o + f], j = a[o + 2 * f], tA = a[o + 3 * f];
      return 4 * kt[255 + b - E] + kt[255 + Q - S] > d ? 0 : kt[255 + a[o - 4 * f] - C] <= v && kt[255 + C - Q] <= v && kt[255 + Q - b] <= v && kt[255 + tA - j] <= v && kt[255 + j - S] <= v && kt[255 + S - E] <= v;
    }
    function es(a, o, f, d) {
      var v = 2 * d + 1;
      for (d = 0; 16 > d; ++d) $a(a, o + d, f, v) && $n(a, o + d, f);
    }
    function vr(a, o, f, d) {
      var v = 2 * d + 1;
      for (d = 0; 16 > d; ++d) $a(a, o + d * f, 1, v) && $n(a, o + d * f, 1);
    }
    function Sr(a, o, f, d) {
      var v;
      for (v = 3; 0 < v; --v) es(a, o += 4 * f, f, d);
    }
    function tu(a, o, f, d) {
      var v;
      for (v = 3; 0 < v; --v) vr(a, o += 4, f, d);
    }
    function qr(a, o, f, d, v, C, Q, b) {
      for (C = 2 * C + 1; 0 < v--; ) {
        if (As(a, o, f, C, Q)) if (Za(a, o, f, b)) $n(a, o, f);
        else {
          var E = a, S = o, j = f, tA = E[S - 2 * j], rA = E[S - j], z = E[S + 0], wA = E[S + j], fA = E[S + 2 * j], V = 27 * (dA = su[1020 + 3 * (z - rA) + su[1020 + tA - wA]]) + 63 >> 7, q = 18 * dA + 63 >> 7, dA = 9 * dA + 63 >> 7;
          E[S - 3 * j] = Ht[255 + E[S - 3 * j] + dA], E[S - 2 * j] = Ht[255 + tA + q], E[S - j] = Ht[255 + rA + V], E[S + 0] = Ht[255 + z - V], E[S + j] = Ht[255 + wA - q], E[S + 2 * j] = Ht[255 + fA - dA];
        }
        o += d;
      }
    }
    function er(a, o, f, d, v, C, Q, b) {
      for (C = 2 * C + 1; 0 < v--; ) {
        if (As(a, o, f, C, Q)) if (Za(a, o, f, b)) $n(a, o, f);
        else {
          var E = a, S = o, j = f, tA = E[S - j], rA = E[S + 0], z = E[S + j], wA = cs[112 + ((fA = 3 * (rA - tA)) + 4 >> 3)], fA = cs[112 + (fA + 3 >> 3)], V = wA + 1 >> 1;
          E[S - 2 * j] = Ht[255 + E[S - 2 * j] + V], E[S - j] = Ht[255 + tA + fA], E[S + 0] = Ht[255 + rA - wA], E[S + j] = Ht[255 + z - V];
        }
        o += d;
      }
    }
    function Vi(a, o, f, d, v, C) {
      qr(a, o, f, 1, 16, d, v, C);
    }
    function yn(a, o, f, d, v, C) {
      qr(a, o, 1, f, 16, d, v, C);
    }
    function ru(a, o, f, d, v, C) {
      var Q;
      for (Q = 3; 0 < Q; --Q) er(a, o += 4 * f, f, 1, 16, d, v, C);
    }
    function Ai(a, o, f, d, v, C) {
      var Q;
      for (Q = 3; 0 < Q; --Q) er(a, o += 4, 1, f, 16, d, v, C);
    }
    function nu(a, o, f, d, v, C, Q, b) {
      qr(a, o, v, 1, 8, C, Q, b), qr(f, d, v, 1, 8, C, Q, b);
    }
    function qi(a, o, f, d, v, C, Q, b) {
      qr(a, o, 1, v, 8, C, Q, b), qr(f, d, 1, v, 8, C, Q, b);
    }
    function Wi(a, o, f, d, v, C, Q, b) {
      er(a, o + 4 * v, v, 1, 8, C, Q, b), er(f, d + 4 * v, v, 1, 8, C, Q, b);
    }
    function ts(a, o, f, d, v, C, Q, b) {
      er(a, o + 4, 1, v, 8, C, Q, b), er(f, d + 4, 1, v, 8, C, Q, b);
    }
    function ei() {
      this.ba = new Jt(), this.ec = [], this.cc = [], this.Mc = [], this.Dc = this.Nc = this.dc = this.fc = 0, this.Oa = new He(), this.memory = 0, this.Ib = "OutputFunc", this.Jb = "OutputAlphaFunc", this.Nd = "OutputRowFunc";
    }
    function Xi() {
      this.data = [], this.offset = this.kd = this.ha = this.w = 0, this.na = [], this.xa = this.gb = this.Ja = this.Sa = this.P = 0;
    }
    function Ji() {
      this.nc = this.Ea = this.b = this.hc = 0, this.K = [], this.w = 0;
    }
    function rs() {
      this.ua = 0, this.Wa = new P(), this.vb = new P(), this.md = this.xc = this.wc = 0, this.vc = [], this.Wb = 0, this.Ya = new M(), this.yc = new H();
    }
    function iu() {
      this.xb = this.a = 0, this.l = new Xn(), this.ca = new Jt(), this.V = [], this.Ba = 0, this.Ta = [], this.Ua = 0, this.m = new U(), this.Pb = 0, this.wd = new U(), this.Ma = this.$ = this.C = this.i = this.c = this.xd = 0, this.s = new rs(), this.ab = 0, this.gc = s(4, Ji), this.Oc = 0;
    }
    function ti() {
      this.Lc = this.Z = this.$a = this.i = this.c = 0, this.l = new Xn(), this.ic = 0, this.ca = [], this.tb = 0, this.qd = null, this.rd = 0;
    }
    function bn(a, o, f, d, v, C, Q) {
      for (a = a == null ? 0 : a[o + 0], o = 0; o < Q; ++o) v[C + o] = a + f[d + o] & 255, a = v[C + o];
    }
    function zi(a, o, f, d, v, C, Q) {
      var b;
      if (a == null) bn(null, null, f, d, v, C, Q);
      else for (b = 0; b < Q; ++b) v[C + b] = a[o + b] + f[d + b] & 255;
    }
    function Wr(a, o, f, d, v, C, Q) {
      if (a == null) bn(null, null, f, d, v, C, Q);
      else {
        var b, E = a[o + 0], S = E, j = E;
        for (b = 0; b < Q; ++b) S = j + (E = a[o + b]) - S, j = f[d + b] + (-256 & S ? 0 > S ? 0 : 255 : S) & 255, S = E, v[C + b] = j;
      }
    }
    function Yi(a, o, f, d) {
      var v = o.width, C = o.o;
      if (A(a != null && o != null), 0 > f || 0 >= d || f + d > C) return null;
      if (!a.Cc) {
        if (a.ga == null) {
          var Q;
          if (a.ga = new ti(), (Q = a.ga == null) || (Q = o.width * o.o, A(a.Gb.length == 0), a.Gb = i(Q), a.Uc = 0, a.Gb == null ? Q = 0 : (a.mb = a.Gb, a.nb = a.Uc, a.rc = null, Q = 1), Q = !Q), !Q) {
            Q = a.ga;
            var b = a.Fa, E = a.P, S = a.qc, j = a.mb, tA = a.nb, rA = E + 1, z = S - 1, wA = Q.l;
            if (A(b != null && j != null && o != null), $r[0] = null, $r[1] = bn, $r[2] = zi, $r[3] = Wr, Q.ca = j, Q.tb = tA, Q.c = o.width, Q.i = o.height, A(0 < Q.c && 0 < Q.i), 1 >= S) o = 0;
            else if (Q.$a = b[E + 0] >> 0 & 3, Q.Z = b[E + 0] >> 2 & 3, Q.Lc = b[E + 0] >> 4 & 3, E = b[E + 0] >> 6 & 3, 0 > Q.$a || 1 < Q.$a || 4 <= Q.Z || 1 < Q.Lc || E) o = 0;
            else if (wA.put = hr, wA.ac = tt, wA.bc = Br, wA.ma = Q, wA.width = o.width, wA.height = o.height, wA.Da = o.Da, wA.v = o.v, wA.va = o.va, wA.j = o.j, wA.o = o.o, Q.$a) A: {
              A(Q.$a == 1), o = Tt();
              e: for (; ; ) {
                if (o == null) {
                  o = 0;
                  break A;
                }
                if (A(Q != null), Q.mc = o, o.c = Q.c, o.i = Q.i, o.l = Q.l, o.l.ma = Q, o.l.width = Q.c, o.l.height = Q.i, o.a = 0, eA(o.m, b, rA, z), !pr(Q.c, Q.i, 1, o, null) || (o.ab == 1 && o.gc[0].hc == 3 && xr(o.s) ? (Q.ic = 1, b = o.c * o.i, o.Ta = null, o.Ua = 0, o.V = i(b), o.Ba = 0, o.V == null ? (o.a = 1, o = 0) : o = 1) : (Q.ic = 0, o = Qn(o, Q.c)), !o)) break e;
                o = 1;
                break A;
              }
              Q.mc = null, o = 0;
            }
            else o = z >= Q.c * Q.i;
            Q = !o;
          }
          if (Q) return null;
          a.ga.Lc != 1 ? a.Ga = 0 : d = C - f;
        }
        A(a.ga != null), A(f + d <= C);
        A: {
          if (o = (b = a.ga).c, C = b.l.o, b.$a == 0) {
            if (rA = a.rc, z = a.Vc, wA = a.Fa, E = a.P + 1 + f * o, S = a.mb, j = a.nb + f * o, A(E <= a.P + a.qc), b.Z != 0) for (A($r[b.Z] != null), Q = 0; Q < d; ++Q) $r[b.Z](rA, z, wA, E, S, j, o), rA = S, z = j, j += o, E += o;
            else for (Q = 0; Q < d; ++Q) r(S, j, wA, E, o), rA = S, z = j, j += o, E += o;
            a.rc = rA, a.Vc = z;
          } else {
            if (A(b.mc != null), o = f + d, A((Q = b.mc) != null), A(o <= Q.i), Q.C >= o) o = 1;
            else if (b.ic || AA(), b.ic) {
              b = Q.V, rA = Q.Ba, z = Q.c;
              var fA = Q.i, V = (wA = 1, E = Q.$ / z, S = Q.$ % z, j = Q.m, tA = Q.s, Q.$), q = z * fA, dA = z * o, vA = tA.wc, pA = V < dA ? Ge(tA, S, E) : null;
              A(V <= q), A(o <= fA), A(xr(tA));
              e: for (; ; ) {
                for (; !j.h && V < dA; ) {
                  if (S & vA || (pA = Ge(tA, S, E)), A(pA != null), X(j), 256 > (fA = Ct(pA.G[0], pA.H[0], j))) b[rA + V] = fA, ++V, ++S >= z && (S = 0, ++E <= o && !(E % 16) && Zt(Q, E));
                  else {
                    if (!(280 > fA)) {
                      wA = 0;
                      break e;
                    }
                    fA = zt(fA - 256, j);
                    var DA, bA = Ct(pA.G[4], pA.H[4], j);
                    if (X(j), !(V >= (bA = gr(z, bA = zt(bA, j))) && q - V >= fA)) {
                      wA = 0;
                      break e;
                    }
                    for (DA = 0; DA < fA; ++DA) b[rA + V + DA] = b[rA + V + DA - bA];
                    for (V += fA, S += fA; S >= z; ) S -= z, ++E <= o && !(E % 16) && Zt(Q, E);
                    V < dA && S & vA && (pA = Ge(tA, S, E));
                  }
                  A(j.h == T(j));
                }
                Zt(Q, E > o ? o : E);
                break e;
              }
              !wA || j.h && V < q ? (wA = 0, Q.a = j.h ? 5 : 3) : Q.$ = V, o = wA;
            } else o = $t(Q, Q.V, Q.Ba, Q.c, Q.i, o, Gn);
            if (!o) {
              d = 0;
              break A;
            }
          }
          f + d >= C && (a.Cc = 1), d = 1;
        }
        if (!d) return null;
        if (a.Cc && ((d = a.ga) != null && (d.mc = null), a.ga = null, 0 < a.Ga)) return alert("todo:WebPDequantizeLevels"), null;
      }
      return a.nb + f * v;
    }
    function l(a, o, f, d, v, C) {
      for (; 0 < v--; ) {
        var Q, b = a, E = o + (f ? 1 : 0), S = a, j = o + (f ? 0 : 3);
        for (Q = 0; Q < d; ++Q) {
          var tA = S[j + 4 * Q];
          tA != 255 && (tA *= 32897, b[E + 4 * Q + 0] = b[E + 4 * Q + 0] * tA >> 23, b[E + 4 * Q + 1] = b[E + 4 * Q + 1] * tA >> 23, b[E + 4 * Q + 2] = b[E + 4 * Q + 2] * tA >> 23);
        }
        o += C;
      }
    }
    function m(a, o, f, d, v) {
      for (; 0 < d--; ) {
        var C;
        for (C = 0; C < f; ++C) {
          var Q = a[o + 2 * C + 0], b = 15 & (S = a[o + 2 * C + 1]), E = 4369 * b, S = (240 & S | S >> 4) * E >> 16;
          a[o + 2 * C + 0] = (240 & Q | Q >> 4) * E >> 16 & 240 | (15 & Q | Q << 4) * E >> 16 >> 4 & 15, a[o + 2 * C + 1] = 240 & S | b;
        }
        o += v;
      }
    }
    function D(a, o, f, d, v, C, Q, b) {
      var E, S, j = 255;
      for (S = 0; S < v; ++S) {
        for (E = 0; E < d; ++E) {
          var tA = a[o + E];
          C[Q + 4 * E] = tA, j &= tA;
        }
        o += f, Q += b;
      }
      return j != 255;
    }
    function G(a, o, f, d, v) {
      var C;
      for (C = 0; C < v; ++C) f[d + C] = a[o + C] >> 8;
    }
    function AA() {
      Kt = l, Fe = m, Ue = D, Oe = G;
    }
    function BA(a, o, f) {
      O[a] = function(d, v, C, Q, b, E, S, j, tA, rA, z, wA, fA, V, q, dA, vA) {
        var pA, DA = vA - 1 >> 1, bA = b[E + 0] | S[j + 0] << 16, kA = tA[rA + 0] | z[wA + 0] << 16;
        A(d != null);
        var EA = 3 * bA + kA + 131074 >> 2;
        for (o(d[v + 0], 255 & EA, EA >> 16, fA, V), C != null && (EA = 3 * kA + bA + 131074 >> 2, o(C[Q + 0], 255 & EA, EA >> 16, q, dA)), pA = 1; pA <= DA; ++pA) {
          var ce = b[E + pA] | S[j + pA] << 16, Be = tA[rA + pA] | z[wA + pA] << 16, oe = bA + ce + kA + Be + 524296, ne = oe + 2 * (ce + kA) >> 3;
          EA = ne + bA >> 1, bA = (oe = oe + 2 * (bA + Be) >> 3) + ce >> 1, o(d[v + 2 * pA - 1], 255 & EA, EA >> 16, fA, V + (2 * pA - 1) * f), o(d[v + 2 * pA - 0], 255 & bA, bA >> 16, fA, V + (2 * pA - 0) * f), C != null && (EA = oe + kA >> 1, bA = ne + Be >> 1, o(C[Q + 2 * pA - 1], 255 & EA, EA >> 16, q, dA + (2 * pA - 1) * f), o(C[Q + 2 * pA + 0], 255 & bA, bA >> 16, q, dA + (2 * pA + 0) * f)), bA = ce, kA = Be;
        }
        1 & vA || (EA = 3 * bA + kA + 131074 >> 2, o(d[v + vA - 1], 255 & EA, EA >> 16, fA, V + (vA - 1) * f), C != null && (EA = 3 * kA + bA + 131074 >> 2, o(C[Q + vA - 1], 255 & EA, EA >> 16, q, dA + (vA - 1) * f)));
      };
    }
    function mA() {
      Rt[ls] = QB, Rt[fs] = Jc, Rt[jc] = FB, Rt[hs] = zc, Rt[Bs] = Yc, Rt[ou] = Zc, Rt[Vc] = UB, Rt[uu] = Jc, Rt[cu] = zc, Rt[gs] = Yc, Rt[lu] = Zc;
    }
    function _A(a) {
      return a & -16384 ? 0 > a ? 0 : 255 : a >> yB;
    }
    function KA(a, o) {
      return _A((19077 * a >> 8) + (26149 * o >> 8) - 14234);
    }
    function $A(a, o, f) {
      return _A((19077 * a >> 8) - (6419 * o >> 8) - (13320 * f >> 8) + 8708);
    }
    function zA(a, o) {
      return _A((19077 * a >> 8) + (33050 * o >> 8) - 17685);
    }
    function ae(a, o, f, d, v) {
      d[v + 0] = KA(a, f), d[v + 1] = $A(a, o, f), d[v + 2] = zA(a, o);
    }
    function Ie(a, o, f, d, v) {
      d[v + 0] = zA(a, o), d[v + 1] = $A(a, o, f), d[v + 2] = KA(a, f);
    }
    function Se(a, o, f, d, v) {
      var C = $A(a, o, f);
      o = C << 3 & 224 | zA(a, o) >> 3, d[v + 0] = 248 & KA(a, f) | C >> 5, d[v + 1] = o;
    }
    function je(a, o, f, d, v) {
      var C = 240 & zA(a, o) | 15;
      d[v + 0] = 240 & KA(a, f) | $A(a, o, f) >> 4, d[v + 1] = C;
    }
    function ut(a, o, f, d, v) {
      d[v + 0] = 255, ae(a, o, f, d, v + 1);
    }
    function Ye(a, o, f, d, v) {
      Ie(a, o, f, d, v), d[v + 3] = 255;
    }
    function tr(a, o, f, d, v) {
      ae(a, o, f, d, v), d[v + 3] = 255;
    }
    function xt(a, o) {
      return 0 > a ? 0 : a > o ? o : a;
    }
    function mr(a, o, f) {
      O[a] = function(d, v, C, Q, b, E, S, j, tA) {
        for (var rA = j + (-2 & tA) * f; j != rA; ) o(d[v + 0], C[Q + 0], b[E + 0], S, j), o(d[v + 1], C[Q + 0], b[E + 0], S, j + f), v += 2, ++Q, ++E, j += 2 * f;
        1 & tA && o(d[v + 0], C[Q + 0], b[E + 0], S, j);
      };
    }
    function ns(a, o, f) {
      return f == 0 ? a == 0 ? o == 0 ? 6 : 5 : o == 0 ? 4 : 0 : f;
    }
    function Zi(a, o, f, d, v) {
      switch (a >>> 30) {
        case 3:
          Dr(o, f, d, v, 0);
          break;
        case 2:
          Te(o, f, d, v);
          break;
        case 1:
          wt(o, f, d, v);
      }
    }
    function $i(a, o) {
      var f, d, v = o.M, C = o.Nb, Q = a.oc, b = a.pc + 40, E = a.oc, S = a.pc + 584, j = a.oc, tA = a.pc + 600;
      for (f = 0; 16 > f; ++f) Q[b + 32 * f - 1] = 129;
      for (f = 0; 8 > f; ++f) E[S + 32 * f - 1] = 129, j[tA + 32 * f - 1] = 129;
      for (0 < v ? Q[b - 1 - 32] = E[S - 1 - 32] = j[tA - 1 - 32] = 129 : (n(Q, b - 32 - 1, 127, 21), n(E, S - 32 - 1, 127, 9), n(j, tA - 32 - 1, 127, 9)), d = 0; d < a.za; ++d) {
        var rA = o.ya[o.aa + d];
        if (0 < d) {
          for (f = -1; 16 > f; ++f) r(Q, b + 32 * f - 4, Q, b + 32 * f + 12, 4);
          for (f = -1; 8 > f; ++f) r(E, S + 32 * f - 4, E, S + 32 * f + 4, 4), r(j, tA + 32 * f - 4, j, tA + 32 * f + 4, 4);
        }
        var z = a.Gd, wA = a.Hd + d, fA = rA.ad, V = rA.Hc;
        if (0 < v && (r(Q, b - 32, z[wA].y, 0, 16), r(E, S - 32, z[wA].f, 0, 8), r(j, tA - 32, z[wA].ea, 0, 8)), rA.Za) {
          var q = Q, dA = b - 32 + 16;
          for (0 < v && (d >= a.za - 1 ? n(q, dA, z[wA].y[15], 4) : r(q, dA, z[wA + 1].y, 0, 4)), f = 0; 4 > f; f++) q[dA + 128 + f] = q[dA + 256 + f] = q[dA + 384 + f] = q[dA + 0 + f];
          for (f = 0; 16 > f; ++f, V <<= 2) q = Q, dA = b + Al[f], rr[rA.Ob[f]](q, dA), Zi(V, fA, 16 * +f, q, dA);
        } else if (q = ns(d, v, rA.Ob[0]), Zr[q](Q, b), V != 0) for (f = 0; 16 > f; ++f, V <<= 2) Zi(V, fA, 16 * +f, Q, b + Al[f]);
        for (f = rA.Gc, q = ns(d, v, rA.Dd), Or[q](E, S), Or[q](j, tA), V = fA, q = E, dA = S, 255 & (rA = f >> 0) && (170 & rA ? na(V, 256, q, dA) : Pt(V, 256, q, dA)), rA = j, V = tA, 255 & (f >>= 8) && (170 & f ? na(fA, 320, rA, V) : Pt(fA, 320, rA, V)), v < a.Ub - 1 && (r(z[wA].y, 0, Q, b + 480, 16), r(z[wA].f, 0, E, S + 224, 8), r(z[wA].ea, 0, j, tA + 224, 8)), f = 8 * C * a.B, z = a.sa, wA = a.ta + 16 * d + 16 * C * a.R, fA = a.qa, rA = a.ra + 8 * d + f, V = a.Ha, q = a.Ia + 8 * d + f, f = 0; 16 > f; ++f) r(z, wA + f * a.R, Q, b + 32 * f, 16);
        for (f = 0; 8 > f; ++f) r(fA, rA + f * a.B, E, S + 32 * f, 8), r(V, q + f * a.B, j, tA + 32 * f, 8);
      }
    }
    function ri(a, o, f, d, v, C, Q, b, E) {
      var S = [0], j = [0], tA = 0, rA = E != null ? E.kd : 0, z = E ?? new Xi();
      if (a == null || 12 > f) return 7;
      z.data = a, z.w = o, z.ha = f, o = [o], f = [f], z.gb = [z.gb];
      A: {
        var wA = o, fA = f, V = z.gb;
        if (A(a != null), A(fA != null), A(V != null), V[0] = 0, 12 <= fA[0] && !e(a, wA[0], "RIFF")) {
          if (e(a, wA[0] + 8, "WEBP")) {
            V = 3;
            break A;
          }
          var q = LA(a, wA[0] + 4);
          if (12 > q || 4294967286 < q) {
            V = 3;
            break A;
          }
          if (rA && q > fA[0] - 8) {
            V = 7;
            break A;
          }
          V[0] = q, wA[0] += 12, fA[0] -= 12;
        }
        V = 0;
      }
      if (V != 0) return V;
      for (q = 0 < z.gb[0], f = f[0]; ; ) {
        A: {
          var dA = a;
          fA = o, V = f;
          var vA = S, pA = j, DA = wA = [0];
          if ((EA = tA = [tA])[0] = 0, 8 > V[0]) V = 7;
          else {
            if (!e(dA, fA[0], "VP8X")) {
              if (LA(dA, fA[0] + 4) != 10) {
                V = 3;
                break A;
              }
              if (18 > V[0]) {
                V = 7;
                break A;
              }
              var bA = LA(dA, fA[0] + 8), kA = 1 + xA(dA, fA[0] + 12);
              if (2147483648 <= kA * (dA = 1 + xA(dA, fA[0] + 15))) {
                V = 3;
                break A;
              }
              DA != null && (DA[0] = bA), vA != null && (vA[0] = kA), pA != null && (pA[0] = dA), fA[0] += 18, V[0] -= 18, EA[0] = 1;
            }
            V = 0;
          }
        }
        if (tA = tA[0], wA = wA[0], V != 0) return V;
        if (fA = !!(2 & wA), !q && tA) return 3;
        if (C != null && (C[0] = !!(16 & wA)), Q != null && (Q[0] = fA), b != null && (b[0] = 0), Q = S[0], wA = j[0], tA && fA && E == null) {
          V = 0;
          break;
        }
        if (4 > f) {
          V = 7;
          break;
        }
        if (q && tA || !q && !tA && !e(a, o[0], "ALPH")) {
          f = [f], z.na = [z.na], z.P = [z.P], z.Sa = [z.Sa];
          A: {
            bA = a, V = o, q = f;
            var EA = z.gb;
            vA = z.na, pA = z.P, DA = z.Sa, kA = 22, A(bA != null), A(q != null), dA = V[0];
            var ce = q[0];
            for (A(vA != null), A(DA != null), vA[0] = null, pA[0] = null, DA[0] = 0; ; ) {
              if (V[0] = dA, q[0] = ce, 8 > ce) {
                V = 7;
                break A;
              }
              var Be = LA(bA, dA + 4);
              if (4294967286 < Be) {
                V = 3;
                break A;
              }
              var oe = 8 + Be + 1 & -2;
              if (kA += oe, 0 < EA && kA > EA) {
                V = 3;
                break A;
              }
              if (!e(bA, dA, "VP8 ") || !e(bA, dA, "VP8L")) {
                V = 0;
                break A;
              }
              if (ce[0] < oe) {
                V = 7;
                break A;
              }
              e(bA, dA, "ALPH") || (vA[0] = bA, pA[0] = dA + 8, DA[0] = Be), dA += oe, ce -= oe;
            }
          }
          if (f = f[0], z.na = z.na[0], z.P = z.P[0], z.Sa = z.Sa[0], V != 0) break;
        }
        f = [f], z.Ja = [z.Ja], z.xa = [z.xa];
        A: if (EA = a, V = o, q = f, vA = z.gb[0], pA = z.Ja, DA = z.xa, bA = V[0], dA = !e(EA, bA, "VP8 "), kA = !e(EA, bA, "VP8L"), A(EA != null), A(q != null), A(pA != null), A(DA != null), 8 > q[0]) V = 7;
        else {
          if (dA || kA) {
            if (EA = LA(EA, bA + 4), 12 <= vA && EA > vA - 12) {
              V = 3;
              break A;
            }
            if (rA && EA > q[0] - 8) {
              V = 7;
              break A;
            }
            pA[0] = EA, V[0] += 8, q[0] -= 8, DA[0] = kA;
          } else DA[0] = 5 <= q[0] && EA[bA + 0] == 47 && !(EA[bA + 4] >> 5), pA[0] = q[0];
          V = 0;
        }
        if (f = f[0], z.Ja = z.Ja[0], z.xa = z.xa[0], o = o[0], V != 0) break;
        if (4294967286 < z.Ja) return 3;
        if (b == null || fA || (b[0] = z.xa ? 2 : 1), Q = [Q], wA = [wA], z.xa) {
          if (5 > f) {
            V = 7;
            break;
          }
          b = Q, rA = wA, fA = C, a == null || 5 > f ? a = 0 : 5 <= f && a[o + 0] == 47 && !(a[o + 4] >> 5) ? (q = [0], EA = [0], vA = [0], eA(pA = new U(), a, o, f), RA(pA, q, EA, vA) ? (b != null && (b[0] = q[0]), rA != null && (rA[0] = EA[0]), fA != null && (fA[0] = vA[0]), a = 1) : a = 0) : a = 0;
        } else {
          if (10 > f) {
            V = 7;
            break;
          }
          b = wA, a == null || 10 > f || !Ra(a, o + 3, f - 3) ? a = 0 : (rA = a[o + 0] | a[o + 1] << 8 | a[o + 2] << 16, fA = 16383 & (a[o + 7] << 8 | a[o + 6]), a = 16383 & (a[o + 9] << 8 | a[o + 8]), 1 & rA || 3 < (rA >> 1 & 7) || !(rA >> 4 & 1) || rA >> 5 >= z.Ja || !fA || !a ? a = 0 : (Q && (Q[0] = fA), b && (b[0] = a), a = 1));
        }
        if (!a || (Q = Q[0], wA = wA[0], tA && (S[0] != Q || j[0] != wA))) return 3;
        E != null && (E[0] = z, E.offset = o - E.w, A(4294967286 > o - E.w), A(E.offset == E.ha - f));
        break;
      }
      return V == 0 || V == 7 && tA && E == null ? (C != null && (C[0] |= z.na != null && 0 < z.na.length), d != null && (d[0] = Q), v != null && (v[0] = wA), 0) : V;
    }
    function Aa(a, o, f) {
      var d = o.width, v = o.height, C = 0, Q = 0, b = d, E = v;
      if (o.Da = a != null && 0 < a.Da, o.Da && (b = a.cd, E = a.bd, C = a.v, Q = a.j, 11 > f || (C &= -2, Q &= -2), 0 > C || 0 > Q || 0 >= b || 0 >= E || C + b > d || Q + E > v)) return 0;
      if (o.v = C, o.j = Q, o.va = C + b, o.o = Q + E, o.U = b, o.T = E, o.da = a != null && 0 < a.da, o.da) {
        if (!ZA(b, E, f = [a.ib], C = [a.hb])) return 0;
        o.ib = f[0], o.hb = C[0];
      }
      return o.ob = a != null && a.ob, o.Kb = a == null || !a.Sd, o.da && (o.ob = o.ib < 3 * d / 4 && o.hb < 3 * v / 4, o.Kb = 0), 1;
    }
    function ea(a) {
      if (a == null) return 2;
      if (11 > a.S) {
        var o = a.f.RGBA;
        o.fb += (a.height - 1) * o.A, o.A = -o.A;
      } else o = a.f.kb, a = a.height, o.O += (a - 1) * o.fa, o.fa = -o.fa, o.N += (a - 1 >> 1) * o.Ab, o.Ab = -o.Ab, o.W += (a - 1 >> 1) * o.Db, o.Db = -o.Db, o.F != null && (o.J += (a - 1) * o.lb, o.lb = -o.lb);
      return 0;
    }
    function ni(a, o, f, d) {
      if (d == null || 0 >= a || 0 >= o) return 2;
      if (f != null) {
        if (f.Da) {
          var v = f.cd, C = f.bd, Q = -2 & f.v, b = -2 & f.j;
          if (0 > Q || 0 > b || 0 >= v || 0 >= C || Q + v > a || b + C > o) return 2;
          a = v, o = C;
        }
        if (f.da) {
          if (!ZA(a, o, v = [f.ib], C = [f.hb])) return 2;
          a = v[0], o = C[0];
        }
      }
      d.width = a, d.height = o;
      A: {
        var E = d.width, S = d.height;
        if (a = d.S, 0 >= E || 0 >= S || !(a >= ls && 13 > a)) a = 2;
        else {
          if (0 >= d.Rd && d.sd == null) {
            Q = C = v = o = 0;
            var j = (b = E * el[a]) * S;
            if (11 > a || (C = (S + 1) / 2 * (o = (E + 1) / 2), a == 12 && (Q = (v = E) * S)), (S = i(j + 2 * C + Q)) == null) {
              a = 1;
              break A;
            }
            d.sd = S, 11 > a ? ((E = d.f.RGBA).eb = S, E.fb = 0, E.A = b, E.size = j) : ((E = d.f.kb).y = S, E.O = 0, E.fa = b, E.Fd = j, E.f = S, E.N = 0 + j, E.Ab = o, E.Cd = C, E.ea = S, E.W = 0 + j + C, E.Db = o, E.Ed = C, a == 12 && (E.F = S, E.J = 0 + j + 2 * C), E.Tc = Q, E.lb = v);
          }
          if (o = 1, v = d.S, C = d.width, Q = d.height, v >= ls && 13 > v) if (11 > v) a = d.f.RGBA, o &= (b = Math.abs(a.A)) * (Q - 1) + C <= a.size, o &= b >= C * el[v], o &= a.eb != null;
          else {
            a = d.f.kb, b = (C + 1) / 2, j = (Q + 1) / 2, E = Math.abs(a.fa), S = Math.abs(a.Ab);
            var tA = Math.abs(a.Db), rA = Math.abs(a.lb), z = rA * (Q - 1) + C;
            o &= E * (Q - 1) + C <= a.Fd, o &= S * (j - 1) + b <= a.Cd, o = (o &= tA * (j - 1) + b <= a.Ed) & E >= C & S >= b & tA >= b, o &= a.y != null, o &= a.f != null, o &= a.ea != null, v == 12 && (o &= rA >= C, o &= z <= a.Tc, o &= a.F != null);
          }
          else o = 0;
          a = o ? 0 : 2;
        }
      }
      return a != 0 || f != null && f.fd && (a = ea(d)), a;
    }
    var rt = 64, ii = [0, 1, 3, 7, 15, 31, 63, 127, 255, 511, 1023, 2047, 4095, 8191, 16383, 32767, 65535, 131071, 262143, 524287, 1048575, 2097151, 4194303, 8388607, 16777215], ai = 24, si = 32, ta = 8, Ft = [0, 0, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7];
    yA("Predictor0", "PredictorAdd0"), O.Predictor0 = function() {
      return 4278190080;
    }, O.Predictor1 = function(a) {
      return a;
    }, O.Predictor2 = function(a, o, f) {
      return o[f + 0];
    }, O.Predictor3 = function(a, o, f) {
      return o[f + 1];
    }, O.Predictor4 = function(a, o, f) {
      return o[f - 1];
    }, O.Predictor5 = function(a, o, f) {
      return IA(IA(a, o[f + 1]), o[f + 0]);
    }, O.Predictor6 = function(a, o, f) {
      return IA(a, o[f - 1]);
    }, O.Predictor7 = function(a, o, f) {
      return IA(a, o[f + 0]);
    }, O.Predictor8 = function(a, o, f) {
      return IA(o[f - 1], o[f + 0]);
    }, O.Predictor9 = function(a, o, f) {
      return IA(o[f + 0], o[f + 1]);
    }, O.Predictor10 = function(a, o, f) {
      return IA(IA(a, o[f - 1]), IA(o[f + 0], o[f + 1]));
    }, O.Predictor11 = function(a, o, f) {
      var d = o[f + 0];
      return 0 >= ee(d >> 24 & 255, a >> 24 & 255, (o = o[f - 1]) >> 24 & 255) + ee(d >> 16 & 255, a >> 16 & 255, o >> 16 & 255) + ee(d >> 8 & 255, a >> 8 & 255, o >> 8 & 255) + ee(255 & d, 255 & a, 255 & o) ? d : a;
    }, O.Predictor12 = function(a, o, f) {
      var d = o[f + 0];
      return (MA((a >> 24 & 255) + (d >> 24 & 255) - ((o = o[f - 1]) >> 24 & 255)) << 24 | MA((a >> 16 & 255) + (d >> 16 & 255) - (o >> 16 & 255)) << 16 | MA((a >> 8 & 255) + (d >> 8 & 255) - (o >> 8 & 255)) << 8 | MA((255 & a) + (255 & d) - (255 & o))) >>> 0;
    }, O.Predictor13 = function(a, o, f) {
      var d = o[f - 1];
      return (XA((a = IA(a, o[f + 0])) >> 24 & 255, d >> 24 & 255) << 24 | XA(a >> 16 & 255, d >> 16 & 255) << 16 | XA(a >> 8 & 255, d >> 8 & 255) << 8 | XA(a >> 0 & 255, d >> 0 & 255)) >>> 0;
    };
    var au = O.PredictorAdd0;
    O.PredictorAdd1 = te, yA("Predictor2", "PredictorAdd2"), yA("Predictor3", "PredictorAdd3"), yA("Predictor4", "PredictorAdd4"), yA("Predictor5", "PredictorAdd5"), yA("Predictor6", "PredictorAdd6"), yA("Predictor7", "PredictorAdd7"), yA("Predictor8", "PredictorAdd8"), yA("Predictor9", "PredictorAdd9"), yA("Predictor10", "PredictorAdd10"), yA("Predictor11", "PredictorAdd11"), yA("Predictor12", "PredictorAdd12"), yA("Predictor13", "PredictorAdd13");
    var ra = O.PredictorAdd2;
    re("ColorIndexInverseTransform", "MapARGB", "32b", function(a) {
      return a >> 8 & 255;
    }, function(a) {
      return a;
    }), re("VP8LColorIndexInverseTransformAlpha", "MapAlpha", "8b", function(a) {
      return a;
    }, function(a) {
      return a >> 8 & 255;
    });
    var is, Ot = O.ColorIndexInverseTransform, oi = O.MapARGB, as = O.VP8LColorIndexInverseTransformAlpha, ss = O.MapAlpha, Xr = O.VP8LPredictorsAdd = [];
    Xr.length = 16, (O.VP8LPredictors = []).length = 16, (O.VP8LPredictorsAdd_C = []).length = 16, (O.VP8LPredictors_C = []).length = 16;
    var Ln, Ut, pt, Jr, Nr, _r, ui, Dr, Te, na, wt, Pt, ci, os, ia, En, In, zr, xn, li, Hn, Yr, aa, Mt, Kt, Fe, Ue, Oe, Je = i(511), Tr = i(2041), sa = i(225), fi = i(767), us = 0, su = Tr, cs = sa, Ht = fi, kt = Je, ls = 0, fs = 1, jc = 2, hs = 3, Bs = 4, ou = 5, Vc = 6, uu = 7, cu = 8, gs = 9, lu = 10, oB = [2, 3, 7], uB = [3, 3, 11], qc = [280, 256, 256, 256, 40], cB = [0, 1, 1, 1, 0], lB = [17, 18, 0, 1, 2, 3, 4, 5, 16, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], fB = [24, 7, 23, 25, 40, 6, 39, 41, 22, 26, 38, 42, 56, 5, 55, 57, 21, 27, 54, 58, 37, 43, 72, 4, 71, 73, 20, 28, 53, 59, 70, 74, 36, 44, 88, 69, 75, 52, 60, 3, 87, 89, 19, 29, 86, 90, 35, 45, 68, 76, 85, 91, 51, 61, 104, 2, 103, 105, 18, 30, 102, 106, 34, 46, 84, 92, 67, 77, 101, 107, 50, 62, 120, 1, 119, 121, 83, 93, 17, 31, 100, 108, 66, 78, 118, 122, 33, 47, 117, 123, 49, 63, 99, 109, 82, 94, 0, 116, 124, 65, 79, 16, 32, 98, 110, 48, 115, 125, 81, 95, 64, 114, 126, 97, 111, 80, 113, 127, 96, 112], hB = [2954, 2956, 2958, 2962, 2970, 2986, 3018, 3082, 3212, 3468, 3980, 5004], BB = 8, fu = [4, 5, 6, 7, 8, 9, 10, 10, 11, 12, 13, 14, 15, 16, 17, 17, 18, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 25, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 91, 93, 95, 96, 98, 100, 101, 102, 104, 106, 108, 110, 112, 114, 116, 118, 122, 124, 126, 128, 130, 132, 134, 136, 138, 140, 143, 145, 148, 151, 154, 157], hu = [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 60, 62, 64, 66, 68, 70, 72, 74, 76, 78, 80, 82, 84, 86, 88, 90, 92, 94, 96, 98, 100, 102, 104, 106, 108, 110, 112, 114, 116, 119, 122, 125, 128, 131, 134, 137, 140, 143, 146, 149, 152, 155, 158, 161, 164, 167, 170, 173, 177, 181, 185, 189, 193, 197, 201, 205, 209, 213, 217, 221, 225, 229, 234, 239, 245, 249, 254, 259, 264, 269, 274, 279, 284], oa = null, gB = [[173, 148, 140, 0], [176, 155, 140, 135, 0], [180, 157, 141, 134, 130, 0], [254, 254, 243, 230, 196, 177, 153, 140, 133, 130, 129, 0]], dB = [0, 1, 4, 8, 5, 2, 3, 6, 9, 12, 13, 10, 7, 11, 14, 15], Wc = [-0, 1, -1, 2, -2, 3, 4, 6, -3, 5, -4, -5, -6, 7, -7, 8, -8, -9], pB = [[[[128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128], [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128], [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128]], [[253, 136, 254, 255, 228, 219, 128, 128, 128, 128, 128], [189, 129, 242, 255, 227, 213, 255, 219, 128, 128, 128], [106, 126, 227, 252, 214, 209, 255, 255, 128, 128, 128]], [[1, 98, 248, 255, 236, 226, 255, 255, 128, 128, 128], [181, 133, 238, 254, 221, 234, 255, 154, 128, 128, 128], [78, 134, 202, 247, 198, 180, 255, 219, 128, 128, 128]], [[1, 185, 249, 255, 243, 255, 128, 128, 128, 128, 128], [184, 150, 247, 255, 236, 224, 128, 128, 128, 128, 128], [77, 110, 216, 255, 236, 230, 128, 128, 128, 128, 128]], [[1, 101, 251, 255, 241, 255, 128, 128, 128, 128, 128], [170, 139, 241, 252, 236, 209, 255, 255, 128, 128, 128], [37, 116, 196, 243, 228, 255, 255, 255, 128, 128, 128]], [[1, 204, 254, 255, 245, 255, 128, 128, 128, 128, 128], [207, 160, 250, 255, 238, 128, 128, 128, 128, 128, 128], [102, 103, 231, 255, 211, 171, 128, 128, 128, 128, 128]], [[1, 152, 252, 255, 240, 255, 128, 128, 128, 128, 128], [177, 135, 243, 255, 234, 225, 128, 128, 128, 128, 128], [80, 129, 211, 255, 194, 224, 128, 128, 128, 128, 128]], [[1, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128], [246, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128], [255, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128]]], [[[198, 35, 237, 223, 193, 187, 162, 160, 145, 155, 62], [131, 45, 198, 221, 172, 176, 220, 157, 252, 221, 1], [68, 47, 146, 208, 149, 167, 221, 162, 255, 223, 128]], [[1, 149, 241, 255, 221, 224, 255, 255, 128, 128, 128], [184, 141, 234, 253, 222, 220, 255, 199, 128, 128, 128], [81, 99, 181, 242, 176, 190, 249, 202, 255, 255, 128]], [[1, 129, 232, 253, 214, 197, 242, 196, 255, 255, 128], [99, 121, 210, 250, 201, 198, 255, 202, 128, 128, 128], [23, 91, 163, 242, 170, 187, 247, 210, 255, 255, 128]], [[1, 200, 246, 255, 234, 255, 128, 128, 128, 128, 128], [109, 178, 241, 255, 231, 245, 255, 255, 128, 128, 128], [44, 130, 201, 253, 205, 192, 255, 255, 128, 128, 128]], [[1, 132, 239, 251, 219, 209, 255, 165, 128, 128, 128], [94, 136, 225, 251, 218, 190, 255, 255, 128, 128, 128], [22, 100, 174, 245, 186, 161, 255, 199, 128, 128, 128]], [[1, 182, 249, 255, 232, 235, 128, 128, 128, 128, 128], [124, 143, 241, 255, 227, 234, 128, 128, 128, 128, 128], [35, 77, 181, 251, 193, 211, 255, 205, 128, 128, 128]], [[1, 157, 247, 255, 236, 231, 255, 255, 128, 128, 128], [121, 141, 235, 255, 225, 227, 255, 255, 128, 128, 128], [45, 99, 188, 251, 195, 217, 255, 224, 128, 128, 128]], [[1, 1, 251, 255, 213, 255, 128, 128, 128, 128, 128], [203, 1, 248, 255, 255, 128, 128, 128, 128, 128, 128], [137, 1, 177, 255, 224, 255, 128, 128, 128, 128, 128]]], [[[253, 9, 248, 251, 207, 208, 255, 192, 128, 128, 128], [175, 13, 224, 243, 193, 185, 249, 198, 255, 255, 128], [73, 17, 171, 221, 161, 179, 236, 167, 255, 234, 128]], [[1, 95, 247, 253, 212, 183, 255, 255, 128, 128, 128], [239, 90, 244, 250, 211, 209, 255, 255, 128, 128, 128], [155, 77, 195, 248, 188, 195, 255, 255, 128, 128, 128]], [[1, 24, 239, 251, 218, 219, 255, 205, 128, 128, 128], [201, 51, 219, 255, 196, 186, 128, 128, 128, 128, 128], [69, 46, 190, 239, 201, 218, 255, 228, 128, 128, 128]], [[1, 191, 251, 255, 255, 128, 128, 128, 128, 128, 128], [223, 165, 249, 255, 213, 255, 128, 128, 128, 128, 128], [141, 124, 248, 255, 255, 128, 128, 128, 128, 128, 128]], [[1, 16, 248, 255, 255, 128, 128, 128, 128, 128, 128], [190, 36, 230, 255, 236, 255, 128, 128, 128, 128, 128], [149, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128]], [[1, 226, 255, 128, 128, 128, 128, 128, 128, 128, 128], [247, 192, 255, 128, 128, 128, 128, 128, 128, 128, 128], [240, 128, 255, 128, 128, 128, 128, 128, 128, 128, 128]], [[1, 134, 252, 255, 255, 128, 128, 128, 128, 128, 128], [213, 62, 250, 255, 255, 128, 128, 128, 128, 128, 128], [55, 93, 255, 128, 128, 128, 128, 128, 128, 128, 128]], [[128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128], [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128], [128, 128, 128, 128, 128, 128, 128, 128, 128, 128, 128]]], [[[202, 24, 213, 235, 186, 191, 220, 160, 240, 175, 255], [126, 38, 182, 232, 169, 184, 228, 174, 255, 187, 128], [61, 46, 138, 219, 151, 178, 240, 170, 255, 216, 128]], [[1, 112, 230, 250, 199, 191, 247, 159, 255, 255, 128], [166, 109, 228, 252, 211, 215, 255, 174, 128, 128, 128], [39, 77, 162, 232, 172, 180, 245, 178, 255, 255, 128]], [[1, 52, 220, 246, 198, 199, 249, 220, 255, 255, 128], [124, 74, 191, 243, 183, 193, 250, 221, 255, 255, 128], [24, 71, 130, 219, 154, 170, 243, 182, 255, 255, 128]], [[1, 182, 225, 249, 219, 240, 255, 224, 128, 128, 128], [149, 150, 226, 252, 216, 205, 255, 171, 128, 128, 128], [28, 108, 170, 242, 183, 194, 254, 223, 255, 255, 128]], [[1, 81, 230, 252, 204, 203, 255, 192, 128, 128, 128], [123, 102, 209, 247, 188, 196, 255, 233, 128, 128, 128], [20, 95, 153, 243, 164, 173, 255, 203, 128, 128, 128]], [[1, 222, 248, 255, 216, 213, 128, 128, 128, 128, 128], [168, 175, 246, 252, 235, 205, 255, 255, 128, 128, 128], [47, 116, 215, 255, 211, 212, 255, 255, 128, 128, 128]], [[1, 121, 236, 253, 212, 214, 255, 255, 128, 128, 128], [141, 84, 213, 252, 201, 202, 255, 219, 128, 128, 128], [42, 80, 160, 240, 162, 185, 255, 205, 128, 128, 128]], [[1, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128], [244, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128], [238, 1, 255, 128, 128, 128, 128, 128, 128, 128, 128]]]], wB = [[[231, 120, 48, 89, 115, 113, 120, 152, 112], [152, 179, 64, 126, 170, 118, 46, 70, 95], [175, 69, 143, 80, 85, 82, 72, 155, 103], [56, 58, 10, 171, 218, 189, 17, 13, 152], [114, 26, 17, 163, 44, 195, 21, 10, 173], [121, 24, 80, 195, 26, 62, 44, 64, 85], [144, 71, 10, 38, 171, 213, 144, 34, 26], [170, 46, 55, 19, 136, 160, 33, 206, 71], [63, 20, 8, 114, 114, 208, 12, 9, 226], [81, 40, 11, 96, 182, 84, 29, 16, 36]], [[134, 183, 89, 137, 98, 101, 106, 165, 148], [72, 187, 100, 130, 157, 111, 32, 75, 80], [66, 102, 167, 99, 74, 62, 40, 234, 128], [41, 53, 9, 178, 241, 141, 26, 8, 107], [74, 43, 26, 146, 73, 166, 49, 23, 157], [65, 38, 105, 160, 51, 52, 31, 115, 128], [104, 79, 12, 27, 217, 255, 87, 17, 7], [87, 68, 71, 44, 114, 51, 15, 186, 23], [47, 41, 14, 110, 182, 183, 21, 17, 194], [66, 45, 25, 102, 197, 189, 23, 18, 22]], [[88, 88, 147, 150, 42, 46, 45, 196, 205], [43, 97, 183, 117, 85, 38, 35, 179, 61], [39, 53, 200, 87, 26, 21, 43, 232, 171], [56, 34, 51, 104, 114, 102, 29, 93, 77], [39, 28, 85, 171, 58, 165, 90, 98, 64], [34, 22, 116, 206, 23, 34, 43, 166, 73], [107, 54, 32, 26, 51, 1, 81, 43, 31], [68, 25, 106, 22, 64, 171, 36, 225, 114], [34, 19, 21, 102, 132, 188, 16, 76, 124], [62, 18, 78, 95, 85, 57, 50, 48, 51]], [[193, 101, 35, 159, 215, 111, 89, 46, 111], [60, 148, 31, 172, 219, 228, 21, 18, 111], [112, 113, 77, 85, 179, 255, 38, 120, 114], [40, 42, 1, 196, 245, 209, 10, 25, 109], [88, 43, 29, 140, 166, 213, 37, 43, 154], [61, 63, 30, 155, 67, 45, 68, 1, 209], [100, 80, 8, 43, 154, 1, 51, 26, 71], [142, 78, 78, 16, 255, 128, 34, 197, 171], [41, 40, 5, 102, 211, 183, 4, 1, 221], [51, 50, 17, 168, 209, 192, 23, 25, 82]], [[138, 31, 36, 171, 27, 166, 38, 44, 229], [67, 87, 58, 169, 82, 115, 26, 59, 179], [63, 59, 90, 180, 59, 166, 93, 73, 154], [40, 40, 21, 116, 143, 209, 34, 39, 175], [47, 15, 16, 183, 34, 223, 49, 45, 183], [46, 17, 33, 183, 6, 98, 15, 32, 183], [57, 46, 22, 24, 128, 1, 54, 17, 37], [65, 32, 73, 115, 28, 128, 23, 128, 205], [40, 3, 9, 115, 51, 192, 18, 6, 223], [87, 37, 9, 115, 59, 77, 64, 21, 47]], [[104, 55, 44, 218, 9, 54, 53, 130, 226], [64, 90, 70, 205, 40, 41, 23, 26, 57], [54, 57, 112, 184, 5, 41, 38, 166, 213], [30, 34, 26, 133, 152, 116, 10, 32, 134], [39, 19, 53, 221, 26, 114, 32, 73, 255], [31, 9, 65, 234, 2, 15, 1, 118, 73], [75, 32, 12, 51, 192, 255, 160, 43, 51], [88, 31, 35, 67, 102, 85, 55, 186, 85], [56, 21, 23, 111, 59, 205, 45, 37, 192], [55, 38, 70, 124, 73, 102, 1, 34, 98]], [[125, 98, 42, 88, 104, 85, 117, 175, 82], [95, 84, 53, 89, 128, 100, 113, 101, 45], [75, 79, 123, 47, 51, 128, 81, 171, 1], [57, 17, 5, 71, 102, 57, 53, 41, 49], [38, 33, 13, 121, 57, 73, 26, 1, 85], [41, 10, 67, 138, 77, 110, 90, 47, 114], [115, 21, 2, 10, 102, 255, 166, 23, 6], [101, 29, 16, 10, 85, 128, 101, 196, 26], [57, 18, 10, 102, 102, 213, 34, 20, 43], [117, 20, 15, 36, 163, 128, 68, 1, 26]], [[102, 61, 71, 37, 34, 53, 31, 243, 192], [69, 60, 71, 38, 73, 119, 28, 222, 37], [68, 45, 128, 34, 1, 47, 11, 245, 171], [62, 17, 19, 70, 146, 85, 55, 62, 70], [37, 43, 37, 154, 100, 163, 85, 160, 1], [63, 9, 92, 136, 28, 64, 32, 201, 85], [75, 15, 9, 9, 64, 255, 184, 119, 16], [86, 6, 28, 5, 64, 255, 25, 248, 1], [56, 8, 17, 132, 137, 255, 55, 116, 128], [58, 15, 20, 82, 135, 57, 26, 121, 40]], [[164, 50, 31, 137, 154, 133, 25, 35, 218], [51, 103, 44, 131, 131, 123, 31, 6, 158], [86, 40, 64, 135, 148, 224, 45, 183, 128], [22, 26, 17, 131, 240, 154, 14, 1, 209], [45, 16, 21, 91, 64, 222, 7, 1, 197], [56, 21, 39, 155, 60, 138, 23, 102, 213], [83, 12, 13, 54, 192, 255, 68, 47, 28], [85, 26, 85, 85, 128, 128, 32, 146, 171], [18, 11, 7, 63, 144, 171, 4, 4, 246], [35, 27, 10, 146, 174, 171, 12, 26, 128]], [[190, 80, 35, 99, 180, 80, 126, 54, 45], [85, 126, 47, 87, 176, 51, 41, 20, 32], [101, 75, 128, 139, 118, 146, 116, 128, 85], [56, 41, 15, 176, 236, 85, 37, 9, 62], [71, 30, 17, 119, 118, 255, 17, 18, 138], [101, 38, 60, 138, 55, 70, 43, 26, 142], [146, 36, 19, 30, 171, 255, 97, 27, 20], [138, 45, 61, 62, 219, 1, 81, 188, 64], [32, 41, 20, 117, 151, 142, 20, 21, 163], [112, 19, 12, 61, 195, 128, 48, 4, 24]]], vB = [[[[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[176, 246, 255, 255, 255, 255, 255, 255, 255, 255, 255], [223, 241, 252, 255, 255, 255, 255, 255, 255, 255, 255], [249, 253, 253, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 244, 252, 255, 255, 255, 255, 255, 255, 255, 255], [234, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [253, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 246, 254, 255, 255, 255, 255, 255, 255, 255, 255], [239, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 248, 254, 255, 255, 255, 255, 255, 255, 255, 255], [251, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [251, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 254, 253, 255, 254, 255, 255, 255, 255, 255, 255], [250, 255, 254, 255, 254, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]]], [[[217, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [225, 252, 241, 253, 255, 255, 254, 255, 255, 255, 255], [234, 250, 241, 250, 253, 255, 253, 254, 255, 255, 255]], [[255, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [223, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [238, 253, 254, 254, 255, 255, 255, 255, 255, 255, 255]], [[255, 248, 254, 255, 255, 255, 255, 255, 255, 255, 255], [249, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 253, 255, 255, 255, 255, 255, 255, 255, 255, 255], [247, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [252, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [253, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 254, 253, 255, 255, 255, 255, 255, 255, 255, 255], [250, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]]], [[[186, 251, 250, 255, 255, 255, 255, 255, 255, 255, 255], [234, 251, 244, 254, 255, 255, 255, 255, 255, 255, 255], [251, 251, 243, 253, 254, 255, 254, 255, 255, 255, 255]], [[255, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [236, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [251, 253, 253, 254, 254, 255, 255, 255, 255, 255, 255]], [[255, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [254, 254, 254, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]]], [[[248, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [250, 254, 252, 254, 255, 255, 255, 255, 255, 255, 255], [248, 254, 249, 253, 255, 255, 255, 255, 255, 255, 255]], [[255, 253, 253, 255, 255, 255, 255, 255, 255, 255, 255], [246, 253, 253, 255, 255, 255, 255, 255, 255, 255, 255], [252, 254, 251, 254, 254, 255, 255, 255, 255, 255, 255]], [[255, 254, 252, 255, 255, 255, 255, 255, 255, 255, 255], [248, 254, 253, 255, 255, 255, 255, 255, 255, 255, 255], [253, 255, 254, 254, 255, 255, 255, 255, 255, 255, 255]], [[255, 251, 254, 255, 255, 255, 255, 255, 255, 255, 255], [245, 251, 254, 255, 255, 255, 255, 255, 255, 255, 255], [253, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 251, 253, 255, 255, 255, 255, 255, 255, 255, 255], [252, 253, 254, 255, 255, 255, 255, 255, 255, 255, 255], [255, 254, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 252, 255, 255, 255, 255, 255, 255, 255, 255, 255], [249, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 254, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 253, 255, 255, 255, 255, 255, 255, 255, 255], [250, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]], [[255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [254, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255], [255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255]]]], mB = [0, 1, 2, 3, 6, 4, 5, 6, 6, 6, 6, 6, 6, 6, 6, 7, 0], Zr = [], rr = [], Or = [], CB = 1, Xc = 2, $r = [], Rt = [];
    BA("UpsampleRgbLinePair", ae, 3), BA("UpsampleBgrLinePair", Ie, 3), BA("UpsampleRgbaLinePair", tr, 4), BA("UpsampleBgraLinePair", Ye, 4), BA("UpsampleArgbLinePair", ut, 4), BA("UpsampleRgba4444LinePair", je, 2), BA("UpsampleRgb565LinePair", Se, 2);
    var QB = O.UpsampleRgbLinePair, FB = O.UpsampleBgrLinePair, Jc = O.UpsampleRgbaLinePair, zc = O.UpsampleBgraLinePair, Yc = O.UpsampleArgbLinePair, Zc = O.UpsampleRgba4444LinePair, UB = O.UpsampleRgb565LinePair, ds = 16, ps = 1 << ds - 1, ua = -227, Bu = 482, yB = 6, $c = 0, bB = i(256), LB = i(256), EB = i(256), IB = i(256), xB = i(Bu - ua), HB = i(Bu - ua);
    mr("YuvToRgbRow", ae, 3), mr("YuvToBgrRow", Ie, 3), mr("YuvToRgbaRow", tr, 4), mr("YuvToBgraRow", Ye, 4), mr("YuvToArgbRow", ut, 4), mr("YuvToRgba4444Row", je, 2), mr("YuvToRgb565Row", Se, 2);
    var Al = [0, 4, 8, 12, 128, 132, 136, 140, 256, 260, 264, 268, 384, 388, 392, 396], ws = [0, 2, 8], SB = [8, 7, 6, 4, 4, 2, 2, 2, 1, 1, 1, 1], NB = 1;
    this.WebPDecodeRGBA = function(a, o, f, d, v) {
      var C = fs, Q = new ei(), b = new Jt();
      Q.ba = b, b.S = C, b.width = [b.width], b.height = [b.height];
      var E = b.width, S = b.height, j = new Ir();
      if (j == null || a == null) var tA = 2;
      else A(j != null), tA = ri(a, o, f, j.width, j.height, j.Pd, j.Qd, j.format, null);
      if (tA != 0 ? E = 0 : (E != null && (E[0] = j.width[0]), S != null && (S[0] = j.height[0]), E = 1), E) {
        b.width = b.width[0], b.height = b.height[0], d != null && (d[0] = b.width), v != null && (v[0] = b.height);
        A: {
          if (d = new Xn(), (v = new Xi()).data = a, v.w = o, v.ha = f, v.kd = 1, o = [0], A(v != null), ((a = ri(v.data, v.w, v.ha, null, null, null, o, null, v)) == 0 || a == 7) && o[0] && (a = 4), (o = a) == 0) {
            if (A(Q != null), d.data = v.data, d.w = v.w + v.offset, d.ha = v.ha - v.offset, d.put = hr, d.ac = tt, d.bc = Br, d.ma = Q, v.xa) {
              if ((a = Tt()) == null) {
                Q = 1;
                break A;
              }
              if (function(rA, z) {
                var wA = [0], fA = [0], V = [0];
                e: for (; ; ) {
                  if (rA == null) return 0;
                  if (z == null) return rA.a = 2, 0;
                  if (rA.l = z, rA.a = 0, eA(rA.m, z.data, z.w, z.ha), !RA(rA.m, wA, fA, V)) {
                    rA.a = 3;
                    break e;
                  }
                  if (rA.xb = Xc, z.width = wA[0], z.height = fA[0], !pr(wA[0], fA[0], 1, rA, null)) break e;
                  return 1;
                }
                return A(rA.a != 0), 0;
              }(a, d)) {
                if (d = (o = ni(d.width, d.height, Q.Oa, Q.ba)) == 0) {
                  e: {
                    d = a;
                    t: for (; ; ) {
                      if (d == null) {
                        d = 0;
                        break e;
                      }
                      if (A(d.s.yc != null), A(d.s.Ya != null), A(0 < d.s.Wb), A((f = d.l) != null), A((v = f.ma) != null), d.xb != 0) {
                        if (d.ca = v.ba, d.tb = v.tb, A(d.ca != null), !Aa(v.Oa, f, hs)) {
                          d.a = 2;
                          break t;
                        }
                        if (!Qn(d, f.width) || f.da) break t;
                        if ((f.da || le(d.ca.S)) && AA(), 11 > d.ca.S || (alert("todo:WebPInitConvertARGBToYUV"), d.ca.f.kb.F != null && AA()), d.Pb && 0 < d.s.ua && d.s.vb.X == null && !jA(d.s.vb, d.s.Wa.Xa)) {
                          d.a = 1;
                          break t;
                        }
                        d.xb = 0;
                      }
                      if (!$t(d, d.V, d.Ba, d.c, d.i, f.o, Rn)) break t;
                      v.Dc = d.Ma, d = 1;
                      break e;
                    }
                    A(d.a != 0), d = 0;
                  }
                  d = !d;
                }
                d && (o = a.a);
              } else o = a.a;
            } else {
              if ((a = new ko()) == null) {
                Q = 1;
                break A;
              }
              if (a.Fa = v.na, a.P = v.P, a.qc = v.Sa, Ga(a, d)) {
                if ((o = ni(d.width, d.height, Q.Oa, Q.ba)) == 0) {
                  if (a.Aa = 0, f = Q.Oa, A((v = a) != null), f != null) {
                    if (0 < (E = 0 > (E = f.Md) ? 0 : 100 < E ? 255 : 255 * E / 100)) {
                      for (S = j = 0; 4 > S; ++S) 12 > (tA = v.pb[S]).lc && (tA.ia = E * SB[0 > tA.lc ? 0 : tA.lc] >> 3), j |= tA.ia;
                      j && (alert("todo:VP8InitRandom"), v.ia = 1);
                    }
                    v.Ga = f.Id, 100 < v.Ga ? v.Ga = 100 : 0 > v.Ga && (v.Ga = 0);
                  }
                  Ro(a, d) || (o = a.a);
                }
              } else o = a.a;
            }
            o == 0 && Q.Oa != null && Q.Oa.fd && (o = ea(Q.ba));
          }
          Q = o;
        }
        C = Q != 0 ? null : 11 > C ? b.f.RGBA.eb : b.f.kb.y;
      } else C = null;
      return C;
    };
    var el = [3, 4, 3, 4, 4, 2, 2, 4, 4, 4, 2, 1, 1];
  };
  function h(O, W) {
    for (var cA = "", I = 0; I < 4; I++) cA += String.fromCharCode(O[W++]);
    return cA;
  }
  function g(O, W) {
    return (O[W + 0] << 0 | O[W + 1] << 8 | O[W + 2] << 16) >>> 0;
  }
  function p(O, W) {
    return (O[W + 0] << 0 | O[W + 1] << 8 | O[W + 2] << 16 | O[W + 3] << 24) >>> 0;
  }
  new c();
  var w = [0], B = [0], L = [], y = new c(), N = t, F = function(O, W) {
    var cA = {}, I = 0, H = !1, K = 0, M = 0;
    if (cA.frames = [], !/** @license
       * Copyright (c) 2017 Dominik Homberger
      Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
      The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
      THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
      https://webpjs.appspot.com
      WebPRiffParser dominikhlbg@gmail.com
      */
    function(_, T, k, X) {
      for (var nA = 0; nA < X; nA++) if (_[T + nA] != k.charCodeAt(nA)) return !0;
      return !1;
    }(O, W, "RIFF", 4)) {
      for (p(O, W += 4), W += 8; W < O.length; ) {
        var oA = h(O, W), iA = p(O, W += 4);
        W += 4;
        var uA = iA + (1 & iA);
        switch (oA) {
          case "VP8 ":
          case "VP8L":
            cA.frames[I] === void 0 && (cA.frames[I] = {}), (hA = cA.frames[I]).src_off = H ? M : W - 8, hA.src_size = K + iA + 8, I++, H && (H = !1, K = 0, M = 0);
            break;
          case "VP8X":
            (hA = cA.header = {}).feature_flags = O[W];
            var eA = W + 4;
            hA.canvas_width = 1 + g(O, eA), eA += 3, hA.canvas_height = 1 + g(O, eA), eA += 3;
            break;
          case "ALPH":
            H = !0, K = uA + 8, M = W - 8;
            break;
          case "ANIM":
            (hA = cA.header).bgcolor = p(O, W), eA = W + 4, hA.loop_count = (UA = O)[(U = eA) + 0] << 0 | UA[U + 1] << 8, eA += 2;
            break;
          case "ANMF":
            var lA, hA;
            (hA = cA.frames[I] = {}).offset_x = 2 * g(O, W), W += 3, hA.offset_y = 2 * g(O, W), W += 3, hA.width = 1 + g(O, W), W += 3, hA.height = 1 + g(O, W), W += 3, hA.duration = g(O, W), W += 3, lA = O[W++], hA.dispose = 1 & lA, hA.blend = lA >> 1 & 1;
        }
        oA != "ANMF" && (W += uA);
      }
      var UA, U;
      return cA;
    }
  }(N, 0);
  F.response = N, F.rgbaoutput = !0, F.dataurl = !1;
  var x = F.header ? F.header : null, R = F.frames ? F.frames : null;
  if (x) {
    x.loop_counter = x.loop_count, w = [x.canvas_height], B = [x.canvas_width];
    for (var Y = 0; Y < R.length && R[Y].blend != 0; Y++) ;
  }
  var Z = R[0], $ = y.WebPDecodeRGBA(N, Z.src_off, Z.src_size, B, w);
  Z.rgba = $, Z.imgwidth = B[0], Z.imgheight = w[0];
  for (var J = 0; J < B[0] * w[0] * 4; J++) L[J] = $[J];
  return this.width = B, this.height = w, this.data = L, this;
}
(function(t) {
  var A = function() {
    return typeof Lc == "function";
  }, e = function(w, B, L, y) {
    var N = 4, F = s;
    switch (y) {
      case t.image_compression.FAST:
        N = 1, F = i;
        break;
      case t.image_compression.MEDIUM:
        N = 6, F = u;
        break;
      case t.image_compression.SLOW:
        N = 9, F = c;
    }
    w = r(w, B, L, F);
    var x = Lc(w, { level: N });
    return t.__addimage__.arrayBufferToBinaryString(x);
  }, r = function(w, B, L, y) {
    for (var N, F, x, R = w.length / B, Y = new Uint8Array(w.length + R), Z = g(), $ = 0; $ < R; $ += 1) {
      if (x = $ * B, N = w.subarray(x, x + B), y) Y.set(y(N, L, F), x + $);
      else {
        for (var J, O = Z.length, W = []; J < O; J += 1) W[J] = Z[J](N, L, F);
        var cA = p(W.concat());
        Y.set(W[cA], x + $);
      }
      F = N;
    }
    return Y;
  }, n = function(w) {
    var B = Array.apply([], w);
    return B.unshift(0), B;
  }, i = function(w, B) {
    var L, y = [], N = w.length;
    y[0] = 1;
    for (var F = 0; F < N; F += 1) L = w[F - B] || 0, y[F + 1] = w[F] - L + 256 & 255;
    return y;
  }, s = function(w, B, L) {
    var y, N = [], F = w.length;
    N[0] = 2;
    for (var x = 0; x < F; x += 1) y = L && L[x] || 0, N[x + 1] = w[x] - y + 256 & 255;
    return N;
  }, u = function(w, B, L) {
    var y, N, F = [], x = w.length;
    F[0] = 3;
    for (var R = 0; R < x; R += 1) y = w[R - B] || 0, N = L && L[R] || 0, F[R + 1] = w[R] + 256 - (y + N >>> 1) & 255;
    return F;
  }, c = function(w, B, L) {
    var y, N, F, x, R = [], Y = w.length;
    R[0] = 4;
    for (var Z = 0; Z < Y; Z += 1) y = w[Z - B] || 0, N = L && L[Z] || 0, F = L && L[Z - B] || 0, x = h(y, N, F), R[Z + 1] = w[Z] - x + 256 & 255;
    return R;
  }, h = function(w, B, L) {
    if (w === B && B === L) return w;
    var y = Math.abs(B - L), N = Math.abs(w - L), F = Math.abs(w + B - L - L);
    return y <= N && y <= F ? w : N <= F ? B : L;
  }, g = function() {
    return [n, i, s, u, c];
  }, p = function(w) {
    var B = w.map(function(L) {
      return L.reduce(function(y, N) {
        return y + Math.abs(N);
      }, 0);
    });
    return B.indexOf(Math.min.apply(null, B));
  };
  t.processPNG = function(w, B, L, y) {
    var N, F, x, R, Y, Z, $, J, O, W, cA, I, H, K, M, oA = this.decode.FLATE_DECODE, iA = "";
    if (this.__addimage__.isArrayBuffer(w) && (w = new Uint8Array(w)), this.__addimage__.isArrayBufferView(w)) {
      if (w = (x = new zp(w)).imgData, F = x.bits, N = x.colorSpace, Y = x.colors, [4, 6].indexOf(x.colorType) !== -1) {
        if (x.bits === 8) {
          O = (J = x.pixelBitlength == 32 ? new Uint32Array(x.decodePixels().buffer) : x.pixelBitlength == 16 ? new Uint16Array(x.decodePixels().buffer) : new Uint8Array(x.decodePixels().buffer)).length, cA = new Uint8Array(O * x.colors), W = new Uint8Array(O);
          var uA, eA = x.pixelBitlength - x.bits;
          for (K = 0, M = 0; K < O; K++) {
            for (H = J[K], uA = 0; uA < eA; ) cA[M++] = H >>> uA & 255, uA += x.bits;
            W[K] = H >>> uA & 255;
          }
        }
        if (x.bits === 16) {
          O = (J = new Uint32Array(x.decodePixels().buffer)).length, cA = new Uint8Array(O * (32 / x.pixelBitlength) * x.colors), W = new Uint8Array(O * (32 / x.pixelBitlength)), I = x.colors > 1, K = 0, M = 0;
          for (var lA = 0; K < O; ) H = J[K++], cA[M++] = H >>> 0 & 255, I && (cA[M++] = H >>> 16 & 255, H = J[K++], cA[M++] = H >>> 0 & 255), W[lA++] = H >>> 16 & 255;
          F = 8;
        }
        y !== t.image_compression.NONE && A() ? (w = e(cA, x.width * x.colors, x.colors, y), $ = e(W, x.width, 1, y)) : (w = cA, $ = W, oA = void 0);
      }
      if (x.colorType === 3 && (N = this.color_spaces.INDEXED, Z = x.palette, x.transparency.indexed)) {
        var hA = x.transparency.indexed, UA = 0;
        for (K = 0, O = hA.length; K < O; ++K) UA += hA[K];
        if ((UA /= 255) === O - 1 && hA.indexOf(0) !== -1) R = [hA.indexOf(0)];
        else if (UA !== O) {
          for (J = x.decodePixels(), W = new Uint8Array(J.length), K = 0, O = J.length; K < O; K++) W[K] = hA[J[K]];
          $ = e(W, x.width, 1);
        }
      }
      var U = function(_) {
        var T;
        switch (_) {
          case t.image_compression.FAST:
            T = 11;
            break;
          case t.image_compression.MEDIUM:
            T = 13;
            break;
          case t.image_compression.SLOW:
            T = 14;
            break;
          default:
            T = 12;
        }
        return T;
      }(y);
      return oA === this.decode.FLATE_DECODE && (iA = "/Predictor " + U + " "), iA += "/Colors " + Y + " /BitsPerComponent " + F + " /Columns " + x.width, (this.__addimage__.isArrayBuffer(w) || this.__addimage__.isArrayBufferView(w)) && (w = this.__addimage__.arrayBufferToBinaryString(w)), ($ && this.__addimage__.isArrayBuffer($) || this.__addimage__.isArrayBufferView($)) && ($ = this.__addimage__.arrayBufferToBinaryString($)), { alias: L, data: w, index: B, filter: oA, decodeParameters: iA, transparency: R, palette: Z, sMask: $, predictor: U, width: x.width, height: x.height, bitsPerComponent: F, colorSpace: N };
    }
  };
})(GA.API), function(t) {
  t.processGIF89A = function(A, e, r, n) {
    var i = new Yp(A), s = i.width, u = i.height, c = [];
    i.decodeAndBlitFrameRGBA(0, c);
    var h = { data: c, width: s, height: u }, g = new $u(100).encode(h, 100);
    return t.processJPEG.call(this, g, e, r, n);
  }, t.processGIF87A = t.processGIF89A;
}(GA.API), ar.prototype.parseHeader = function() {
  if (this.fileSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.reserved = this.datav.getUint32(this.pos, !0), this.pos += 4, this.offset = this.datav.getUint32(this.pos, !0), this.pos += 4, this.headerSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.width = this.datav.getUint32(this.pos, !0), this.pos += 4, this.height = this.datav.getInt32(this.pos, !0), this.pos += 4, this.planes = this.datav.getUint16(this.pos, !0), this.pos += 2, this.bitPP = this.datav.getUint16(this.pos, !0), this.pos += 2, this.compress = this.datav.getUint32(this.pos, !0), this.pos += 4, this.rawSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.hr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.vr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.colors = this.datav.getUint32(this.pos, !0), this.pos += 4, this.importantColors = this.datav.getUint32(this.pos, !0), this.pos += 4, this.bitPP === 16 && this.is_with_alpha && (this.bitPP = 15), this.bitPP < 15) {
    var t = this.colors === 0 ? 1 << this.bitPP : this.colors;
    this.palette = new Array(t);
    for (var A = 0; A < t; A++) {
      var e = this.datav.getUint8(this.pos++, !0), r = this.datav.getUint8(this.pos++, !0), n = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0);
      this.palette[A] = { red: n, green: r, blue: e, quad: i };
    }
  }
  this.height < 0 && (this.height *= -1, this.bottom_up = !1);
}, ar.prototype.parseBGR = function() {
  this.pos = this.offset;
  try {
    var t = "bit" + this.bitPP, A = this.width * this.height * 4;
    this.data = new Uint8Array(A), this[t]();
  } catch (e) {
    Qe.log("bit decode error:" + e);
  }
}, ar.prototype.bit1 = function() {
  var t, A = Math.ceil(this.width / 8), e = A % 4;
  for (t = this.height - 1; t >= 0; t--) {
    for (var r = this.bottom_up ? t : this.height - 1 - t, n = 0; n < A; n++) for (var i = this.datav.getUint8(this.pos++, !0), s = r * this.width * 4 + 8 * n * 4, u = 0; u < 8 && 8 * n + u < this.width; u++) {
      var c = this.palette[i >> 7 - u & 1];
      this.data[s + 4 * u] = c.blue, this.data[s + 4 * u + 1] = c.green, this.data[s + 4 * u + 2] = c.red, this.data[s + 4 * u + 3] = 255;
    }
    e !== 0 && (this.pos += 4 - e);
  }
}, ar.prototype.bit4 = function() {
  for (var t = Math.ceil(this.width / 2), A = t % 4, e = this.height - 1; e >= 0; e--) {
    for (var r = this.bottom_up ? e : this.height - 1 - e, n = 0; n < t; n++) {
      var i = this.datav.getUint8(this.pos++, !0), s = r * this.width * 4 + 2 * n * 4, u = i >> 4, c = 15 & i, h = this.palette[u];
      if (this.data[s] = h.blue, this.data[s + 1] = h.green, this.data[s + 2] = h.red, this.data[s + 3] = 255, 2 * n + 1 >= this.width) break;
      h = this.palette[c], this.data[s + 4] = h.blue, this.data[s + 4 + 1] = h.green, this.data[s + 4 + 2] = h.red, this.data[s + 4 + 3] = 255;
    }
    A !== 0 && (this.pos += 4 - A);
  }
}, ar.prototype.bit8 = function() {
  for (var t = this.width % 4, A = this.height - 1; A >= 0; A--) {
    for (var e = this.bottom_up ? A : this.height - 1 - A, r = 0; r < this.width; r++) {
      var n = this.datav.getUint8(this.pos++, !0), i = e * this.width * 4 + 4 * r;
      if (n < this.palette.length) {
        var s = this.palette[n];
        this.data[i] = s.red, this.data[i + 1] = s.green, this.data[i + 2] = s.blue, this.data[i + 3] = 255;
      } else this.data[i] = 255, this.data[i + 1] = 255, this.data[i + 2] = 255, this.data[i + 3] = 255;
    }
    t !== 0 && (this.pos += 4 - t);
  }
}, ar.prototype.bit15 = function() {
  for (var t = this.width % 3, A = parseInt("11111", 2), e = this.height - 1; e >= 0; e--) {
    for (var r = this.bottom_up ? e : this.height - 1 - e, n = 0; n < this.width; n++) {
      var i = this.datav.getUint16(this.pos, !0);
      this.pos += 2;
      var s = (i & A) / A * 255 | 0, u = (i >> 5 & A) / A * 255 | 0, c = (i >> 10 & A) / A * 255 | 0, h = i >> 15 ? 255 : 0, g = r * this.width * 4 + 4 * n;
      this.data[g] = c, this.data[g + 1] = u, this.data[g + 2] = s, this.data[g + 3] = h;
    }
    this.pos += t;
  }
}, ar.prototype.bit16 = function() {
  for (var t = this.width % 3, A = parseInt("11111", 2), e = parseInt("111111", 2), r = this.height - 1; r >= 0; r--) {
    for (var n = this.bottom_up ? r : this.height - 1 - r, i = 0; i < this.width; i++) {
      var s = this.datav.getUint16(this.pos, !0);
      this.pos += 2;
      var u = (s & A) / A * 255 | 0, c = (s >> 5 & e) / e * 255 | 0, h = (s >> 11) / A * 255 | 0, g = n * this.width * 4 + 4 * i;
      this.data[g] = h, this.data[g + 1] = c, this.data[g + 2] = u, this.data[g + 3] = 255;
    }
    this.pos += t;
  }
}, ar.prototype.bit24 = function() {
  for (var t = this.height - 1; t >= 0; t--) {
    for (var A = this.bottom_up ? t : this.height - 1 - t, e = 0; e < this.width; e++) {
      var r = this.datav.getUint8(this.pos++, !0), n = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), s = A * this.width * 4 + 4 * e;
      this.data[s] = i, this.data[s + 1] = n, this.data[s + 2] = r, this.data[s + 3] = 255;
    }
    this.pos += this.width % 4;
  }
}, ar.prototype.bit32 = function() {
  for (var t = this.height - 1; t >= 0; t--) for (var A = this.bottom_up ? t : this.height - 1 - t, e = 0; e < this.width; e++) {
    var r = this.datav.getUint8(this.pos++, !0), n = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), s = this.datav.getUint8(this.pos++, !0), u = A * this.width * 4 + 4 * e;
    this.data[u] = i, this.data[u + 1] = n, this.data[u + 2] = r, this.data[u + 3] = s;
  }
}, ar.prototype.getData = function() {
  return this.data;
}, /**
 * @license
 * Copyright (c) 2018 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t) {
  t.processBMP = function(A, e, r, n) {
    var i = new ar(A, !1), s = i.width, u = i.height, c = { data: i.getData(), width: s, height: u }, h = new $u(100).encode(c, 100);
    return t.processJPEG.call(this, h, e, r, n);
  };
}(GA.API), Df.prototype.getData = function() {
  return this.data;
}, /**
 * @license
 * Copyright (c) 2019 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t) {
  t.processWEBP = function(A, e, r, n) {
    var i = new Df(A), s = i.width, u = i.height, c = { data: i.getData(), width: s, height: u }, h = new $u(100).encode(c, 100);
    return t.processJPEG.call(this, h, e, r, n);
  };
}(GA.API), GA.API.processRGBA = function(t, A, e) {
  for (var r = t.data, n = r.length, i = new Uint8Array(n / 4 * 3), s = new Uint8Array(n / 4), u = 0, c = 0, h = 0; h < n; h += 4) {
    var g = r[h], p = r[h + 1], w = r[h + 2], B = r[h + 3];
    i[u++] = g, i[u++] = p, i[u++] = w, s[c++] = B;
  }
  var L = this.__addimage__.arrayBufferToBinaryString(i);
  return { alpha: this.__addimage__.arrayBufferToBinaryString(s), data: L, index: A, alias: e, colorSpace: "DeviceRGB", bitsPerComponent: 8, width: t.width, height: t.height };
}, GA.API.setLanguage = function(t) {
  return this.internal.languageSettings === void 0 && (this.internal.languageSettings = {}, this.internal.languageSettings.isSubscribed = !1), { af: "Afrikaans", sq: "Albanian", ar: "Arabic (Standard)", "ar-DZ": "Arabic (Algeria)", "ar-BH": "Arabic (Bahrain)", "ar-EG": "Arabic (Egypt)", "ar-IQ": "Arabic (Iraq)", "ar-JO": "Arabic (Jordan)", "ar-KW": "Arabic (Kuwait)", "ar-LB": "Arabic (Lebanon)", "ar-LY": "Arabic (Libya)", "ar-MA": "Arabic (Morocco)", "ar-OM": "Arabic (Oman)", "ar-QA": "Arabic (Qatar)", "ar-SA": "Arabic (Saudi Arabia)", "ar-SY": "Arabic (Syria)", "ar-TN": "Arabic (Tunisia)", "ar-AE": "Arabic (U.A.E.)", "ar-YE": "Arabic (Yemen)", an: "Aragonese", hy: "Armenian", as: "Assamese", ast: "Asturian", az: "Azerbaijani", eu: "Basque", be: "Belarusian", bn: "Bengali", bs: "Bosnian", br: "Breton", bg: "Bulgarian", my: "Burmese", ca: "Catalan", ch: "Chamorro", ce: "Chechen", zh: "Chinese", "zh-HK": "Chinese (Hong Kong)", "zh-CN": "Chinese (PRC)", "zh-SG": "Chinese (Singapore)", "zh-TW": "Chinese (Taiwan)", cv: "Chuvash", co: "Corsican", cr: "Cree", hr: "Croatian", cs: "Czech", da: "Danish", nl: "Dutch (Standard)", "nl-BE": "Dutch (Belgian)", en: "English", "en-AU": "English (Australia)", "en-BZ": "English (Belize)", "en-CA": "English (Canada)", "en-IE": "English (Ireland)", "en-JM": "English (Jamaica)", "en-NZ": "English (New Zealand)", "en-PH": "English (Philippines)", "en-ZA": "English (South Africa)", "en-TT": "English (Trinidad & Tobago)", "en-GB": "English (United Kingdom)", "en-US": "English (United States)", "en-ZW": "English (Zimbabwe)", eo: "Esperanto", et: "Estonian", fo: "Faeroese", fj: "Fijian", fi: "Finnish", fr: "French (Standard)", "fr-BE": "French (Belgium)", "fr-CA": "French (Canada)", "fr-FR": "French (France)", "fr-LU": "French (Luxembourg)", "fr-MC": "French (Monaco)", "fr-CH": "French (Switzerland)", fy: "Frisian", fur: "Friulian", gd: "Gaelic (Scots)", "gd-IE": "Gaelic (Irish)", gl: "Galacian", ka: "Georgian", de: "German (Standard)", "de-AT": "German (Austria)", "de-DE": "German (Germany)", "de-LI": "German (Liechtenstein)", "de-LU": "German (Luxembourg)", "de-CH": "German (Switzerland)", el: "Greek", gu: "Gujurati", ht: "Haitian", he: "Hebrew", hi: "Hindi", hu: "Hungarian", is: "Icelandic", id: "Indonesian", iu: "Inuktitut", ga: "Irish", it: "Italian (Standard)", "it-CH": "Italian (Switzerland)", ja: "Japanese", kn: "Kannada", ks: "Kashmiri", kk: "Kazakh", km: "Khmer", ky: "Kirghiz", tlh: "Klingon", ko: "Korean", "ko-KP": "Korean (North Korea)", "ko-KR": "Korean (South Korea)", la: "Latin", lv: "Latvian", lt: "Lithuanian", lb: "Luxembourgish", mk: "North Macedonia", ms: "Malay", ml: "Malayalam", mt: "Maltese", mi: "Maori", mr: "Marathi", mo: "Moldavian", nv: "Navajo", ng: "Ndonga", ne: "Nepali", no: "Norwegian", nb: "Norwegian (Bokmal)", nn: "Norwegian (Nynorsk)", oc: "Occitan", or: "Oriya", om: "Oromo", fa: "Persian", "fa-IR": "Persian/Iran", pl: "Polish", pt: "Portuguese", "pt-BR": "Portuguese (Brazil)", pa: "Punjabi", "pa-IN": "Punjabi (India)", "pa-PK": "Punjabi (Pakistan)", qu: "Quechua", rm: "Rhaeto-Romanic", ro: "Romanian", "ro-MO": "Romanian (Moldavia)", ru: "Russian", "ru-MO": "Russian (Moldavia)", sz: "Sami (Lappish)", sg: "Sango", sa: "Sanskrit", sc: "Sardinian", sd: "Sindhi", si: "Singhalese", sr: "Serbian", sk: "Slovak", sl: "Slovenian", so: "Somani", sb: "Sorbian", es: "Spanish", "es-AR": "Spanish (Argentina)", "es-BO": "Spanish (Bolivia)", "es-CL": "Spanish (Chile)", "es-CO": "Spanish (Colombia)", "es-CR": "Spanish (Costa Rica)", "es-DO": "Spanish (Dominican Republic)", "es-EC": "Spanish (Ecuador)", "es-SV": "Spanish (El Salvador)", "es-GT": "Spanish (Guatemala)", "es-HN": "Spanish (Honduras)", "es-MX": "Spanish (Mexico)", "es-NI": "Spanish (Nicaragua)", "es-PA": "Spanish (Panama)", "es-PY": "Spanish (Paraguay)", "es-PE": "Spanish (Peru)", "es-PR": "Spanish (Puerto Rico)", "es-ES": "Spanish (Spain)", "es-UY": "Spanish (Uruguay)", "es-VE": "Spanish (Venezuela)", sx: "Sutu", sw: "Swahili", sv: "Swedish", "sv-FI": "Swedish (Finland)", "sv-SV": "Swedish (Sweden)", ta: "Tamil", tt: "Tatar", te: "Teluga", th: "Thai", tig: "Tigre", ts: "Tsonga", tn: "Tswana", tr: "Turkish", tk: "Turkmen", uk: "Ukrainian", hsb: "Upper Sorbian", ur: "Urdu", ve: "Venda", vi: "Vietnamese", vo: "Volapuk", wa: "Walloon", cy: "Welsh", xh: "Xhosa", ji: "Yiddish", zu: "Zulu" }[t] !== void 0 && (this.internal.languageSettings.languageCode = t, this.internal.languageSettings.isSubscribed === !1 && (this.internal.events.subscribe("putCatalog", function() {
    this.internal.write("/Lang (" + this.internal.languageSettings.languageCode + ")");
  }), this.internal.languageSettings.isSubscribed = !0)), this;
}, Ui = GA.API, eo = Ui.getCharWidthsArray = function(t, A) {
  var e, r, n = (A = A || {}).font || this.internal.getFont(), i = A.fontSize || this.internal.getFontSize(), s = A.charSpace || this.internal.getCharSpace(), u = A.widths ? A.widths : n.metadata.Unicode.widths, c = u.fof ? u.fof : 1, h = A.kerning ? A.kerning : n.metadata.Unicode.kerning, g = h.fof ? h.fof : 1, p = A.doKerning !== !1, w = 0, B = t.length, L = 0, y = u[0] || c, N = [];
  for (e = 0; e < B; e++) r = t.charCodeAt(e), typeof n.metadata.widthOfString == "function" ? N.push((n.metadata.widthOfGlyph(n.metadata.characterToGlyph(r)) + s * (1e3 / i) || 0) / 1e3) : (w = p && de(h[r]) === "object" && !isNaN(parseInt(h[r][L], 10)) ? h[r][L] / g : 0, N.push((u[r] || y) / c + w)), L = r;
  return N;
}, Hf = Ui.getStringUnitWidth = function(t, A) {
  var e = (A = A || {}).fontSize || this.internal.getFontSize(), r = A.font || this.internal.getFont(), n = A.charSpace || this.internal.getCharSpace();
  return Ui.processArabic && (t = Ui.processArabic(t)), typeof r.metadata.widthOfString == "function" ? r.metadata.widthOfString(t, e, n) / e : eo.apply(this, arguments).reduce(function(i, s) {
    return i + s;
  }, 0);
}, Sf = function(t, A, e, r) {
  for (var n = [], i = 0, s = t.length, u = 0; i !== s && u + A[i] < e; ) u += A[i], i++;
  n.push(t.slice(0, i));
  var c = i;
  for (u = 0; i !== s; ) u + A[i] > r && (n.push(t.slice(c, i)), u = 0, c = i), u += A[i], i++;
  return c !== i && n.push(t.slice(c, i)), n;
}, Nf = function(t, A, e) {
  e || (e = {});
  var r, n, i, s, u, c, h, g = [], p = [g], w = e.textIndent || 0, B = 0, L = 0, y = t.split(" "), N = eo.apply(this, [" ", e])[0];
  if (c = e.lineIndent === -1 ? y[0].length + 2 : e.lineIndent || 0) {
    var F = Array(c).join(" "), x = [];
    y.map(function(Y) {
      (Y = Y.split(/\s*\n/)).length > 1 ? x = x.concat(Y.map(function(Z, $) {
        return ($ && Z.length ? `
` : "") + Z;
      })) : x.push(Y[0]);
    }), y = x, c = Hf.apply(this, [F, e]);
  }
  for (i = 0, s = y.length; i < s; i++) {
    var R = 0;
    if (r = y[i], c && r[0] == `
` && (r = r.substr(1), R = 1), w + B + (L = (n = eo.apply(this, [r, e])).reduce(function(Y, Z) {
      return Y + Z;
    }, 0)) > A || R) {
      if (L > A) {
        for (u = Sf.apply(this, [r, n, A - (w + B), A]), g.push(u.shift()), g = [u.pop()]; u.length; ) p.push([u.shift()]);
        L = n.slice(r.length - (g[0] ? g[0].length : 0)).reduce(function(Y, Z) {
          return Y + Z;
        }, 0);
      } else g = [r];
      p.push(g), w = L + c, B = N;
    } else g.push(r), w += B + L, B = N;
  }
  return h = c ? function(Y, Z) {
    return (Z ? F : "") + Y.join(" ");
  } : function(Y) {
    return Y.join(" ");
  }, p.map(h);
}, Ui.splitTextToSize = function(t, A, e) {
  var r, n = (e = e || {}).fontSize || this.internal.getFontSize(), i = (function(g) {
    if (g.widths && g.kerning) return { widths: g.widths, kerning: g.kerning };
    var p = this.internal.getFont(g.fontName, g.fontStyle);
    return p.metadata.Unicode ? { widths: p.metadata.Unicode.widths || { 0: 1 }, kerning: p.metadata.Unicode.kerning || {} } : { font: p.metadata, fontSize: this.internal.getFontSize(), charSpace: this.internal.getCharSpace() };
  }).call(this, e);
  r = Array.isArray(t) ? t : String(t).split(/\r?\n/);
  var s = 1 * this.internal.scaleFactor * A / n;
  i.textIndent = e.textIndent ? 1 * e.textIndent * this.internal.scaleFactor / n : 0, i.lineIndent = e.lineIndent;
  var u, c, h = [];
  for (u = 0, c = r.length; u < c; u++) h = h.concat(Nf.apply(this, [r[u], s, i]));
  return h;
}, function(t) {
  t.__fontmetrics__ = t.__fontmetrics__ || {};
  for (var A = "klmnopqrstuvwxyz", e = {}, r = {}, n = 0; n < A.length; n++) e[A[n]] = "0123456789abcdef"[n], r["0123456789abcdef"[n]] = A[n];
  var i = function(p) {
    return "0x" + parseInt(p, 10).toString(16);
  }, s = t.__fontmetrics__.compress = function(p) {
    var w, B, L, y, N = ["{"];
    for (var F in p) {
      if (w = p[F], isNaN(parseInt(F, 10)) ? B = "'" + F + "'" : (F = parseInt(F, 10), B = (B = i(F).slice(2)).slice(0, -1) + r[B.slice(-1)]), typeof w == "number") w < 0 ? (L = i(w).slice(3), y = "-") : (L = i(w).slice(2), y = ""), L = y + L.slice(0, -1) + r[L.slice(-1)];
      else {
        if (de(w) !== "object") throw new Error("Don't know what to do with value type " + de(w) + ".");
        L = s(w);
      }
      N.push(B + L);
    }
    return N.push("}"), N.join("");
  }, u = t.__fontmetrics__.uncompress = function(p) {
    if (typeof p != "string") throw new Error("Invalid argument passed to uncompress.");
    for (var w, B, L, y, N = {}, F = 1, x = N, R = [], Y = "", Z = "", $ = p.length - 1, J = 1; J < $; J += 1) (y = p[J]) == "'" ? w ? (L = w.join(""), w = void 0) : w = [] : w ? w.push(y) : y == "{" ? (R.push([x, L]), x = {}, L = void 0) : y == "}" ? ((B = R.pop())[0][B[1]] = x, L = void 0, x = B[0]) : y == "-" ? F = -1 : L === void 0 ? e.hasOwnProperty(y) ? (Y += e[y], L = parseInt(Y, 16) * F, F = 1, Y = "") : Y += y : e.hasOwnProperty(y) ? (Z += e[y], x[L] = parseInt(Z, 16) * F, F = 1, L = void 0, Z = "") : Z += y;
    return N;
  }, c = { codePages: ["WinAnsiEncoding"], WinAnsiEncoding: u("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}") }, h = { Unicode: { Courier: c, "Courier-Bold": c, "Courier-BoldOblique": c, "Courier-Oblique": c, Helvetica: c, "Helvetica-Bold": c, "Helvetica-BoldOblique": c, "Helvetica-Oblique": c, "Times-Roman": c, "Times-Bold": c, "Times-BoldItalic": c, "Times-Italic": c } }, g = { Unicode: { "Courier-Oblique": u("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"), "Times-BoldItalic": u("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"), "Helvetica-Bold": u("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"), Courier: u("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"), "Courier-BoldOblique": u("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"), "Times-Bold": u("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"), Symbol: u("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"), Helvetica: u("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"), "Helvetica-BoldOblique": u("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"), ZapfDingbats: u("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"), "Courier-Bold": u("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"), "Times-Italic": u("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"), "Times-Roman": u("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"), "Helvetica-Oblique": u("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}") } };
  t.events.push(["addFont", function(p) {
    var w = p.font, B = g.Unicode[w.postScriptName];
    B && (w.metadata.Unicode = {}, w.metadata.Unicode.widths = B.widths, w.metadata.Unicode.kerning = B.kerning);
    var L = h.Unicode[w.postScriptName];
    L && (w.metadata.Unicode.encoding = L, w.encoding = L.codePages[0]);
  }]);
}(GA.API), /**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t) {
  var A = function(e) {
    for (var r = e.length, n = new Uint8Array(r), i = 0; i < r; i++) n[i] = e.charCodeAt(i);
    return n;
  };
  t.API.events.push(["addFont", function(e) {
    var r = void 0, n = e.font, i = e.instance;
    if (!n.isStandardFont) {
      if (i === void 0) throw new Error("Font does not exist in vFS, import fonts or remove declaration doc.addFont('" + n.postScriptName + "').");
      if (typeof (r = i.existsFileInVFS(n.postScriptName) === !1 ? i.loadFile(n.postScriptName) : i.getFileFromVFS(n.postScriptName)) != "string") throw new Error("Font is not stored as string-data in vFS, import fonts or remove declaration doc.addFont('" + n.postScriptName + "').");
      (function(s, u) {
        u = /^\x00\x01\x00\x00/.test(u) ? A(u) : A(Sa(u)), s.metadata = t.API.TTFFont.open(u), s.metadata.Unicode = s.metadata.Unicode || { encoding: {}, kerning: {}, widths: [] }, s.metadata.glyIdsUsed = [0];
      })(n, r);
    }
  }]);
}(GA), /** @license
 * Copyright (c) 2012 Willow Systems Corporation, https://github.com/willowsystems
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */
function(t) {
  function A() {
    return (VA.canvg ? Promise.resolve(VA.canvg) : import("./index.es-BxWlBGnB.js")).catch(function(e) {
      return Promise.reject(new Error("Could not load canvg: " + e));
    }).then(function(e) {
      return e.default ? e.default : e;
    });
  }
  GA.API.addSvgAsImage = function(e, r, n, i, s, u, c, h) {
    if (isNaN(r) || isNaN(n)) throw Qe.error("jsPDF.addSvgAsImage: Invalid coordinates", arguments), new Error("Invalid coordinates passed to jsPDF.addSvgAsImage");
    if (isNaN(i) || isNaN(s)) throw Qe.error("jsPDF.addSvgAsImage: Invalid measurements", arguments), new Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");
    var g = document.createElement("canvas");
    g.width = i, g.height = s;
    var p = g.getContext("2d");
    p.fillStyle = "#fff", p.fillRect(0, 0, g.width, g.height);
    var w = { ignoreMouse: !0, ignoreAnimation: !0, ignoreDimensions: !0 }, B = this;
    return A().then(function(L) {
      return L.fromString(p, e, w);
    }, function() {
      return Promise.reject(new Error("Could not load canvg."));
    }).then(function(L) {
      return L.render(w);
    }).then(function() {
      B.addImage(g.toDataURL("image/jpeg", 1), r, n, i, s, c, h);
    });
  };
}(), GA.API.putTotalPages = function(t) {
  var A, e = 0;
  parseInt(this.internal.getFont().id.substr(1), 10) < 15 ? (A = new RegExp(t, "g"), e = this.internal.getNumberOfPages()) : (A = new RegExp(this.pdfEscape16(t, this.internal.getFont()), "g"), e = this.pdfEscape16(this.internal.getNumberOfPages() + "", this.internal.getFont()));
  for (var r = 1; r <= this.internal.getNumberOfPages(); r++) for (var n = 0; n < this.internal.pages[r].length; n++) this.internal.pages[r][n] = this.internal.pages[r][n].replace(A, e);
  return this;
}, GA.API.viewerPreferences = function(t, A) {
  var e;
  t = t || {}, A = A || !1;
  var r, n, i, s = { HideToolbar: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.3 }, HideMenubar: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.3 }, HideWindowUI: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.3 }, FitWindow: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.3 }, CenterWindow: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.3 }, DisplayDocTitle: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.4 }, NonFullScreenPageMode: { defaultValue: "UseNone", value: "UseNone", type: "name", explicitSet: !1, valueSet: ["UseNone", "UseOutlines", "UseThumbs", "UseOC"], pdfVersion: 1.3 }, Direction: { defaultValue: "L2R", value: "L2R", type: "name", explicitSet: !1, valueSet: ["L2R", "R2L"], pdfVersion: 1.3 }, ViewArea: { defaultValue: "CropBox", value: "CropBox", type: "name", explicitSet: !1, valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"], pdfVersion: 1.4 }, ViewClip: { defaultValue: "CropBox", value: "CropBox", type: "name", explicitSet: !1, valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"], pdfVersion: 1.4 }, PrintArea: { defaultValue: "CropBox", value: "CropBox", type: "name", explicitSet: !1, valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"], pdfVersion: 1.4 }, PrintClip: { defaultValue: "CropBox", value: "CropBox", type: "name", explicitSet: !1, valueSet: ["MediaBox", "CropBox", "TrimBox", "BleedBox", "ArtBox"], pdfVersion: 1.4 }, PrintScaling: { defaultValue: "AppDefault", value: "AppDefault", type: "name", explicitSet: !1, valueSet: ["AppDefault", "None"], pdfVersion: 1.6 }, Duplex: { defaultValue: "", value: "none", type: "name", explicitSet: !1, valueSet: ["Simplex", "DuplexFlipShortEdge", "DuplexFlipLongEdge", "none"], pdfVersion: 1.7 }, PickTrayByPDFSize: { defaultValue: !1, value: !1, type: "boolean", explicitSet: !1, valueSet: [!0, !1], pdfVersion: 1.7 }, PrintPageRange: { defaultValue: "", value: "", type: "array", explicitSet: !1, valueSet: null, pdfVersion: 1.7 }, NumCopies: { defaultValue: 1, value: 1, type: "integer", explicitSet: !1, valueSet: null, pdfVersion: 1.7 } }, u = Object.keys(s), c = [], h = 0, g = 0, p = 0;
  function w(L, y) {
    var N, F = !1;
    for (N = 0; N < L.length; N += 1) L[N] === y && (F = !0);
    return F;
  }
  if (this.internal.viewerpreferences === void 0 && (this.internal.viewerpreferences = {}, this.internal.viewerpreferences.configuration = JSON.parse(JSON.stringify(s)), this.internal.viewerpreferences.isSubscribed = !1), e = this.internal.viewerpreferences.configuration, t === "reset" || A === !0) {
    var B = u.length;
    for (p = 0; p < B; p += 1) e[u[p]].value = e[u[p]].defaultValue, e[u[p]].explicitSet = !1;
  }
  if (de(t) === "object") {
    for (n in t) if (i = t[n], w(u, n) && i !== void 0) {
      if (e[n].type === "boolean" && typeof i == "boolean") e[n].value = i;
      else if (e[n].type === "name" && w(e[n].valueSet, i)) e[n].value = i;
      else if (e[n].type === "integer" && Number.isInteger(i)) e[n].value = i;
      else if (e[n].type === "array") {
        for (h = 0; h < i.length; h += 1) if (r = !0, i[h].length === 1 && typeof i[h][0] == "number") c.push(String(i[h] - 1));
        else if (i[h].length > 1) {
          for (g = 0; g < i[h].length; g += 1) typeof i[h][g] != "number" && (r = !1);
          r === !0 && c.push([i[h][0] - 1, i[h][1] - 1].join(" "));
        }
        e[n].value = "[" + c.join(" ") + "]";
      } else e[n].value = e[n].defaultValue;
      e[n].explicitSet = !0;
    }
  }
  return this.internal.viewerpreferences.isSubscribed === !1 && (this.internal.events.subscribe("putCatalog", function() {
    var L, y = [];
    for (L in e) e[L].explicitSet === !0 && (e[L].type === "name" ? y.push("/" + L + " /" + e[L].value) : y.push("/" + L + " " + e[L].value));
    y.length !== 0 && this.internal.write(`/ViewerPreferences
<<
` + y.join(`
`) + `
>>`);
  }), this.internal.viewerpreferences.isSubscribed = !0), this.internal.viewerpreferences.configuration = e, this;
}, /** ====================================================================
 * @license
 * jsPDF XMP metadata plugin
 * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */
function(t) {
  var A = function() {
    var r = '<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="' + this.internal.__metadata__.namespaceuri + '"><jspdf:metadata>', n = unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')), i = unescape(encodeURIComponent(r)), s = unescape(encodeURIComponent(this.internal.__metadata__.metadata)), u = unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")), c = unescape(encodeURIComponent("</x:xmpmeta>")), h = i.length + s.length + u.length + n.length + c.length;
    this.internal.__metadata__.metadata_object_number = this.internal.newObject(), this.internal.write("<< /Type /Metadata /Subtype /XML /Length " + h + " >>"), this.internal.write("stream"), this.internal.write(n + i + s + u + c), this.internal.write("endstream"), this.internal.write("endobj");
  }, e = function() {
    this.internal.__metadata__.metadata_object_number && this.internal.write("/Metadata " + this.internal.__metadata__.metadata_object_number + " 0 R");
  };
  t.addMetadata = function(r, n) {
    return this.internal.__metadata__ === void 0 && (this.internal.__metadata__ = { metadata: r, namespaceuri: n || "http://jspdf.default.namespaceuri/" }, this.internal.events.subscribe("putCatalog", e), this.internal.events.subscribe("postPutResources", A)), this;
  };
}(GA.API), function(t) {
  var A = t.API, e = A.pdfEscape16 = function(i, s) {
    for (var u, c = s.metadata.Unicode.widths, h = ["", "0", "00", "000", "0000"], g = [""], p = 0, w = i.length; p < w; ++p) {
      if (u = s.metadata.characterToGlyph(i.charCodeAt(p)), s.metadata.glyIdsUsed.push(u), s.metadata.toUnicode[u] = i.charCodeAt(p), c.indexOf(u) == -1 && (c.push(u), c.push([parseInt(s.metadata.widthOfGlyph(u), 10)])), u == "0") return g.join("");
      u = u.toString(16), g.push(h[4 - u.length], u);
    }
    return g.join("");
  }, r = function(i) {
    var s, u, c, h, g, p, w;
    for (g = `/CIDInit /ProcSet findresource begin
12 dict begin
begincmap
/CIDSystemInfo <<
  /Registry (Adobe)
  /Ordering (UCS)
  /Supplement 0
>> def
/CMapName /Adobe-Identity-UCS def
/CMapType 2 def
1 begincodespacerange
<0000><ffff>
endcodespacerange`, c = [], p = 0, w = (u = Object.keys(i).sort(function(B, L) {
      return B - L;
    })).length; p < w; p++) s = u[p], c.length >= 100 && (g += `
` + c.length + ` beginbfchar
` + c.join(`
`) + `
endbfchar`, c = []), i[s] !== void 0 && i[s] !== null && typeof i[s].toString == "function" && (h = ("0000" + i[s].toString(16)).slice(-4), s = ("0000" + (+s).toString(16)).slice(-4), c.push("<" + s + "><" + h + ">"));
    return c.length && (g += `
` + c.length + ` beginbfchar
` + c.join(`
`) + `
endbfchar
`), g += `endcmap
CMapName currentdict /CMap defineresource pop
end
end`;
  };
  A.events.push(["putFont", function(i) {
    (function(s) {
      var u = s.font, c = s.out, h = s.newObject, g = s.putStream;
      if (u.metadata instanceof t.API.TTFFont && u.encoding === "Identity-H") {
        for (var p = u.metadata.Unicode.widths, w = u.metadata.subset.encode(u.metadata.glyIdsUsed, 1), B = "", L = 0; L < w.length; L++) B += String.fromCharCode(w[L]);
        var y = h();
        g({ data: B, addLength1: !0, objectId: y }), c("endobj");
        var N = h();
        g({ data: r(u.metadata.toUnicode), addLength1: !0, objectId: N }), c("endobj");
        var F = h();
        c("<<"), c("/Type /FontDescriptor"), c("/FontName /" + Ei(u.fontName)), c("/FontFile2 " + y + " 0 R"), c("/FontBBox " + t.API.PDFObject.convert(u.metadata.bbox)), c("/Flags " + u.metadata.flags), c("/StemV " + u.metadata.stemV), c("/ItalicAngle " + u.metadata.italicAngle), c("/Ascent " + u.metadata.ascender), c("/Descent " + u.metadata.decender), c("/CapHeight " + u.metadata.capHeight), c(">>"), c("endobj");
        var x = h();
        c("<<"), c("/Type /Font"), c("/BaseFont /" + Ei(u.fontName)), c("/FontDescriptor " + F + " 0 R"), c("/W " + t.API.PDFObject.convert(p)), c("/CIDToGIDMap /Identity"), c("/DW 1000"), c("/Subtype /CIDFontType2"), c("/CIDSystemInfo"), c("<<"), c("/Supplement 0"), c("/Registry (Adobe)"), c("/Ordering (" + u.encoding + ")"), c(">>"), c(">>"), c("endobj"), u.objectNumber = h(), c("<<"), c("/Type /Font"), c("/Subtype /Type0"), c("/ToUnicode " + N + " 0 R"), c("/BaseFont /" + Ei(u.fontName)), c("/Encoding /" + u.encoding), c("/DescendantFonts [" + x + " 0 R]"), c(">>"), c("endobj"), u.isAlreadyPutted = !0;
      }
    })(i);
  }]), A.events.push(["putFont", function(i) {
    (function(s) {
      var u = s.font, c = s.out, h = s.newObject, g = s.putStream;
      if (u.metadata instanceof t.API.TTFFont && u.encoding === "WinAnsiEncoding") {
        for (var p = u.metadata.rawData, w = "", B = 0; B < p.length; B++) w += String.fromCharCode(p[B]);
        var L = h();
        g({ data: w, addLength1: !0, objectId: L }), c("endobj");
        var y = h();
        g({ data: r(u.metadata.toUnicode), addLength1: !0, objectId: y }), c("endobj");
        var N = h();
        c("<<"), c("/Descent " + u.metadata.decender), c("/CapHeight " + u.metadata.capHeight), c("/StemV " + u.metadata.stemV), c("/Type /FontDescriptor"), c("/FontFile2 " + L + " 0 R"), c("/Flags 96"), c("/FontBBox " + t.API.PDFObject.convert(u.metadata.bbox)), c("/FontName /" + Ei(u.fontName)), c("/ItalicAngle " + u.metadata.italicAngle), c("/Ascent " + u.metadata.ascender), c(">>"), c("endobj"), u.objectNumber = h();
        for (var F = 0; F < u.metadata.hmtx.widths.length; F++) u.metadata.hmtx.widths[F] = parseInt(u.metadata.hmtx.widths[F] * (1e3 / u.metadata.head.unitsPerEm));
        c("<</Subtype/TrueType/Type/Font/ToUnicode " + y + " 0 R/BaseFont/" + Ei(u.fontName) + "/FontDescriptor " + N + " 0 R/Encoding/" + u.encoding + " /FirstChar 29 /LastChar 255 /Widths " + t.API.PDFObject.convert(u.metadata.hmtx.widths) + ">>"), c("endobj"), u.isAlreadyPutted = !0;
      }
    })(i);
  }]);
  var n = function(i) {
    var s, u = i.text || "", c = i.x, h = i.y, g = i.options || {}, p = i.mutex || {}, w = p.pdfEscape, B = p.activeFontKey, L = p.fonts, y = B, N = "", F = 0, x = "", R = L[y].encoding;
    if (L[y].encoding !== "Identity-H") return { text: u, x: c, y: h, options: g, mutex: p };
    for (x = u, y = B, Array.isArray(u) && (x = u[0]), F = 0; F < x.length; F += 1) L[y].metadata.hasOwnProperty("cmap") && (s = L[y].metadata.cmap.unicode.codeMap[x[F].charCodeAt(0)]), s || x[F].charCodeAt(0) < 256 && L[y].metadata.hasOwnProperty("Unicode") ? N += x[F] : N += "";
    var Y = "";
    return parseInt(y.slice(1)) < 14 || R === "WinAnsiEncoding" ? Y = w(N, y).split("").map(function(Z) {
      return Z.charCodeAt(0).toString(16);
    }).join("") : R === "Identity-H" && (Y = e(N, L[y])), p.isHex = !0, { text: Y, x: c, y: h, options: g, mutex: p };
  };
  A.events.push(["postProcessText", function(i) {
    var s = i.text || "", u = [], c = { text: s, x: i.x, y: i.y, options: i.options, mutex: i.mutex };
    if (Array.isArray(s)) {
      var h = 0;
      for (h = 0; h < s.length; h += 1) Array.isArray(s[h]) && s[h].length === 3 ? u.push([n(Object.assign({}, c, { text: s[h][0] })).text, s[h][1], s[h][2]]) : u.push(n(Object.assign({}, c, { text: s[h] })).text);
      i.text = u;
    } else i.text = n(Object.assign({}, c, { text: s })).text;
  }]);
}(GA), /**
 * @license
 * jsPDF virtual FileSystem functionality
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t) {
  var A = function() {
    return this.internal.vFS === void 0 && (this.internal.vFS = {}), !0;
  };
  t.existsFileInVFS = function(e) {
    return A.call(this), this.internal.vFS[e] !== void 0;
  }, t.addFileToVFS = function(e, r) {
    return A.call(this), this.internal.vFS[e] = r, this;
  }, t.getFileFromVFS = function(e) {
    return A.call(this), this.internal.vFS[e] !== void 0 ? this.internal.vFS[e] : null;
  };
}(GA.API), /**
 * @license
 * Unicode Bidi Engine based on the work of Alex Shensis (@asthensis)
 * MIT License
 */
function(t) {
  t.__bidiEngine__ = t.prototype.__bidiEngine__ = function(r) {
    var n, i, s, u, c, h, g, p = A, w = [[0, 3, 0, 1, 0, 0, 0], [0, 3, 0, 1, 2, 2, 0], [0, 3, 0, 17, 2, 0, 1], [0, 3, 5, 5, 4, 1, 0], [0, 3, 21, 21, 4, 0, 1], [0, 3, 5, 5, 4, 2, 0]], B = [[2, 0, 1, 1, 0, 1, 0], [2, 0, 1, 1, 0, 2, 0], [2, 0, 2, 1, 3, 2, 0], [2, 0, 2, 33, 3, 1, 1]], L = { L: 0, R: 1, EN: 2, AN: 3, N: 4, B: 5, S: 6 }, y = { 0: 0, 5: 1, 6: 2, 7: 3, 32: 4, 251: 5, 254: 6, 255: 7 }, N = ["(", ")", "(", "<", ">", "<", "[", "]", "[", "{", "}", "{", "«", "»", "«", "‹", "›", "‹", "⁅", "⁆", "⁅", "⁽", "⁾", "⁽", "₍", "₎", "₍", "≤", "≥", "≤", "〈", "〉", "〈", "﹙", "﹚", "﹙", "﹛", "﹜", "﹛", "﹝", "﹞", "﹝", "﹤", "﹥", "﹤"], F = new RegExp(/^([1-4|9]|1[0-9]|2[0-9]|3[0168]|4[04589]|5[012]|7[78]|159|16[0-9]|17[0-2]|21[569]|22[03489]|250)$/), x = !1, R = 0;
    this.__bidiEngine__ = {};
    var Y = function(I) {
      var H = I.charCodeAt(), K = H >> 8, M = y[K];
      return M !== void 0 ? p[256 * M + (255 & H)] : K === 252 || K === 253 ? "AL" : F.test(K) ? "L" : K === 8 ? "R" : "N";
    }, Z = function(I) {
      for (var H, K = 0; K < I.length; K++) {
        if ((H = Y(I.charAt(K))) === "L") return !1;
        if (H === "R") return !0;
      }
      return !1;
    }, $ = function(I, H, K, M) {
      var oA, iA, uA, eA, lA = H[M];
      switch (lA) {
        case "L":
        case "R":
          x = !1;
          break;
        case "N":
        case "AN":
          break;
        case "EN":
          x && (lA = "AN");
          break;
        case "AL":
          x = !0, lA = "R";
          break;
        case "WS":
          lA = "N";
          break;
        case "CS":
          M < 1 || M + 1 >= H.length || (oA = K[M - 1]) !== "EN" && oA !== "AN" || (iA = H[M + 1]) !== "EN" && iA !== "AN" ? lA = "N" : x && (iA = "AN"), lA = iA === oA ? iA : "N";
          break;
        case "ES":
          lA = (oA = M > 0 ? K[M - 1] : "B") === "EN" && M + 1 < H.length && H[M + 1] === "EN" ? "EN" : "N";
          break;
        case "ET":
          if (M > 0 && K[M - 1] === "EN") {
            lA = "EN";
            break;
          }
          if (x) {
            lA = "N";
            break;
          }
          for (uA = M + 1, eA = H.length; uA < eA && H[uA] === "ET"; ) uA++;
          lA = uA < eA && H[uA] === "EN" ? "EN" : "N";
          break;
        case "NSM":
          if (s && !u) {
            for (eA = H.length, uA = M + 1; uA < eA && H[uA] === "NSM"; ) uA++;
            if (uA < eA) {
              var hA = I[M], UA = hA >= 1425 && hA <= 2303 || hA === 64286;
              if (oA = H[uA], UA && (oA === "R" || oA === "AL")) {
                lA = "R";
                break;
              }
            }
          }
          lA = M < 1 || (oA = H[M - 1]) === "B" ? "N" : K[M - 1];
          break;
        case "B":
          x = !1, n = !0, lA = R;
          break;
        case "S":
          i = !0, lA = "N";
          break;
        case "LRE":
        case "RLE":
        case "LRO":
        case "RLO":
        case "PDF":
          x = !1;
          break;
        case "BN":
          lA = "N";
      }
      return lA;
    }, J = function(I, H, K) {
      var M = I.split("");
      return K && O(M, K, { hiLevel: R }), M.reverse(), H && H.reverse(), M.join("");
    }, O = function(I, H, K) {
      var M, oA, iA, uA, eA, lA = -1, hA = I.length, UA = 0, U = [], _ = R ? B : w, T = [];
      for (x = !1, n = !1, i = !1, oA = 0; oA < hA; oA++) T[oA] = Y(I[oA]);
      for (iA = 0; iA < hA; iA++) {
        if (eA = UA, U[iA] = $(I, T, U, iA), M = 240 & (UA = _[eA][L[U[iA]]]), UA &= 15, H[iA] = uA = _[UA][5], M > 0) if (M === 16) {
          for (oA = lA; oA < iA; oA++) H[oA] = 1;
          lA = -1;
        } else lA = -1;
        if (_[UA][6]) lA === -1 && (lA = iA);
        else if (lA > -1) {
          for (oA = lA; oA < iA; oA++) H[oA] = uA;
          lA = -1;
        }
        T[iA] === "B" && (H[iA] = 0), K.hiLevel |= uA;
      }
      i && function(k, X, nA) {
        for (var aA = 0; aA < nA; aA++) if (k[aA] === "S") {
          X[aA] = R;
          for (var sA = aA - 1; sA >= 0 && k[sA] === "WS"; sA--) X[sA] = R;
        }
      }(T, H, hA);
    }, W = function(I, H, K, M, oA) {
      if (!(oA.hiLevel < I)) {
        if (I === 1 && R === 1 && !n) return H.reverse(), void (K && K.reverse());
        for (var iA, uA, eA, lA, hA = H.length, UA = 0; UA < hA; ) {
          if (M[UA] >= I) {
            for (eA = UA + 1; eA < hA && M[eA] >= I; ) eA++;
            for (lA = UA, uA = eA - 1; lA < uA; lA++, uA--) iA = H[lA], H[lA] = H[uA], H[uA] = iA, K && (iA = K[lA], K[lA] = K[uA], K[uA] = iA);
            UA = eA;
          }
          UA++;
        }
      }
    }, cA = function(I, H, K) {
      var M = I.split(""), oA = { hiLevel: R };
      return K || (K = []), O(M, K, oA), function(iA, uA, eA) {
        if (eA.hiLevel !== 0 && g) for (var lA, hA = 0; hA < iA.length; hA++) uA[hA] === 1 && (lA = N.indexOf(iA[hA])) >= 0 && (iA[hA] = N[lA + 1]);
      }(M, K, oA), W(2, M, H, K, oA), W(1, M, H, K, oA), M.join("");
    };
    return this.__bidiEngine__.doBidiReorder = function(I, H, K) {
      if (function(oA, iA) {
        if (iA) for (var uA = 0; uA < oA.length; uA++) iA[uA] = uA;
        u === void 0 && (u = Z(oA)), h === void 0 && (h = Z(oA));
      }(I, H), s || !c || h) if (s && c && u ^ h) R = u ? 1 : 0, I = J(I, H, K);
      else if (!s && c && h) R = u ? 1 : 0, I = cA(I, H, K), I = J(I, H);
      else if (!s || u || c || h) {
        if (s && !c && u ^ h) I = J(I, H), u ? (R = 0, I = cA(I, H, K)) : (R = 1, I = cA(I, H, K), I = J(I, H));
        else if (s && u && !c && h) R = 1, I = cA(I, H, K), I = J(I, H);
        else if (!s && !c && u ^ h) {
          var M = g;
          u ? (R = 1, I = cA(I, H, K), R = 0, g = !1, I = cA(I, H, K), g = M) : (R = 0, I = cA(I, H, K), I = J(I, H), R = 1, g = !1, I = cA(I, H, K), g = M, I = J(I, H));
        }
      } else R = 0, I = cA(I, H, K);
      else R = u ? 1 : 0, I = cA(I, H, K);
      return I;
    }, this.__bidiEngine__.setOptions = function(I) {
      I && (s = I.isInputVisual, c = I.isOutputVisual, u = I.isInputRtl, h = I.isOutputRtl, g = I.isSymmetricSwapping);
    }, this.__bidiEngine__.setOptions(r), this.__bidiEngine__;
  };
  var A = ["BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "S", "B", "S", "WS", "B", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "B", "B", "B", "S", "WS", "N", "N", "ET", "ET", "ET", "N", "N", "N", "N", "N", "ES", "CS", "ES", "CS", "CS", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "CS", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "BN", "BN", "BN", "BN", "BN", "BN", "B", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "CS", "N", "ET", "ET", "ET", "ET", "N", "N", "N", "N", "L", "N", "N", "BN", "N", "N", "ET", "ET", "EN", "EN", "N", "L", "N", "N", "N", "EN", "L", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "L", "L", "L", "L", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "L", "N", "N", "N", "N", "N", "ET", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "R", "NSM", "R", "NSM", "NSM", "R", "NSM", "NSM", "R", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "N", "N", "N", "N", "N", "R", "R", "R", "R", "R", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "AN", "AN", "AN", "AN", "AN", "AN", "N", "N", "AL", "ET", "ET", "AL", "CS", "AL", "N", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "ET", "AN", "AN", "AL", "AL", "AL", "NSM", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AN", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "NSM", "NSM", "N", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "N", "AL", "AL", "NSM", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "R", "R", "N", "N", "N", "N", "R", "N", "N", "N", "N", "N", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "WS", "BN", "BN", "BN", "L", "R", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "WS", "B", "LRE", "RLE", "PDF", "LRO", "RLO", "CS", "ET", "ET", "ET", "ET", "ET", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "CS", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "WS", "BN", "BN", "BN", "BN", "BN", "N", "LRI", "RLI", "FSI", "PDI", "BN", "BN", "BN", "BN", "BN", "BN", "EN", "L", "N", "N", "EN", "EN", "EN", "EN", "EN", "EN", "ES", "ES", "N", "N", "N", "L", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "ES", "ES", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "ET", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "R", "NSM", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "ES", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "N", "R", "R", "R", "R", "R", "N", "R", "N", "R", "R", "N", "R", "R", "N", "R", "R", "R", "R", "R", "R", "R", "R", "R", "R", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "CS", "N", "CS", "N", "N", "CS", "N", "N", "N", "N", "N", "N", "N", "N", "N", "ET", "N", "N", "ES", "ES", "N", "N", "N", "N", "N", "ET", "ET", "N", "N", "N", "N", "N", "AL", "AL", "AL", "AL", "AL", "N", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "N", "N", "BN", "N", "N", "N", "ET", "ET", "ET", "N", "N", "N", "N", "N", "ES", "CS", "ES", "CS", "CS", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "CS", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "N", "N", "N", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "L", "L", "L", "N", "N", "L", "L", "L", "N", "N", "N", "ET", "ET", "N", "N", "N", "ET", "ET", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N", "N"], e = new t.__bidiEngine__({ isInputVisual: !0 });
  t.API.events.push(["postProcessText", function(r) {
    var n = r.text;
    r.x, r.y;
    var i = r.options || {};
    r.mutex, i.lang;
    var s = [];
    if (i.isInputVisual = typeof i.isInputVisual != "boolean" || i.isInputVisual, e.setOptions(i), Object.prototype.toString.call(n) === "[object Array]") {
      var u = 0;
      for (s = [], u = 0; u < n.length; u += 1) Object.prototype.toString.call(n[u]) === "[object Array]" ? s.push([e.doBidiReorder(n[u][0]), n[u][1], n[u][2]]) : s.push([e.doBidiReorder(n[u])]);
      r.text = s;
    } else r.text = e.doBidiReorder(n);
    e.setOptions({ isInputVisual: !0 });
  }]);
}(GA), GA.API.TTFFont = function() {
  function t(A) {
    var e;
    if (this.rawData = A, e = this.contents = new vn(A), this.contents.pos = 4, e.readString(4) === "ttcf") throw new Error("TTCF not supported.");
    e.pos = 0, this.parse(), this.subset = new f5(this), this.registerTTF();
  }
  return t.open = function(A) {
    return new t(A);
  }, t.prototype.parse = function() {
    return this.directory = new Zp(this.contents), this.head = new A5(this), this.name = new i5(this), this.cmap = new aB(this), this.toUnicode = {}, this.hhea = new e5(this), this.maxp = new a5(this), this.hmtx = new s5(this), this.post = new r5(this), this.os2 = new t5(this), this.loca = new l5(this), this.glyf = new o5(this), this.ascender = this.os2.exists && this.os2.ascender || this.hhea.ascender, this.decender = this.os2.exists && this.os2.decender || this.hhea.decender, this.lineGap = this.os2.exists && this.os2.lineGap || this.hhea.lineGap, this.bbox = [this.head.xMin, this.head.yMin, this.head.xMax, this.head.yMax];
  }, t.prototype.registerTTF = function() {
    var A, e, r, n, i;
    if (this.scaleFactor = 1e3 / this.head.unitsPerEm, this.bbox = (function() {
      var s, u, c, h;
      for (h = [], s = 0, u = (c = this.bbox).length; s < u; s++) A = c[s], h.push(Math.round(A * this.scaleFactor));
      return h;
    }).call(this), this.stemV = 0, this.post.exists ? (r = 255 & (n = this.post.italic_angle), (32768 & (e = n >> 16)) != 0 && (e = -(1 + (65535 ^ e))), this.italicAngle = +(e + "." + r)) : this.italicAngle = 0, this.ascender = Math.round(this.ascender * this.scaleFactor), this.decender = Math.round(this.decender * this.scaleFactor), this.lineGap = Math.round(this.lineGap * this.scaleFactor), this.capHeight = this.os2.exists && this.os2.capHeight || this.ascender, this.xHeight = this.os2.exists && this.os2.xHeight || 0, this.familyClass = (this.os2.exists && this.os2.familyClass || 0) >> 8, this.isSerif = (i = this.familyClass) === 1 || i === 2 || i === 3 || i === 4 || i === 5 || i === 7, this.isScript = this.familyClass === 10, this.flags = 0, this.post.isFixedPitch && (this.flags |= 1), this.isSerif && (this.flags |= 2), this.isScript && (this.flags |= 8), this.italicAngle !== 0 && (this.flags |= 64), this.flags |= 32, !this.cmap.unicode) throw new Error("No unicode cmap for font");
  }, t.prototype.characterToGlyph = function(A) {
    var e;
    return ((e = this.cmap.unicode) != null ? e.codeMap[A] : void 0) || 0;
  }, t.prototype.widthOfGlyph = function(A) {
    var e;
    return e = 1e3 / this.head.unitsPerEm, this.hmtx.forGlyph(A).advance * e;
  }, t.prototype.widthOfString = function(A, e, r) {
    var n, i, s, u;
    for (s = 0, i = 0, u = (A = "" + A).length; 0 <= u ? i < u : i > u; i = 0 <= u ? ++i : --i) n = A.charCodeAt(i), s += this.widthOfGlyph(this.characterToGlyph(n)) + r * (1e3 / e) || 0;
    return s * (e / 1e3);
  }, t.prototype.lineHeight = function(A, e) {
    var r;
    return e == null && (e = !1), r = e ? this.lineGap : 0, (this.ascender + r - this.decender) / 1e3 * A;
  }, t;
}();
var lr, vn = function() {
  function t(A) {
    this.data = A ?? [], this.pos = 0, this.length = this.data.length;
  }
  return t.prototype.readByte = function() {
    return this.data[this.pos++];
  }, t.prototype.writeByte = function(A) {
    return this.data[this.pos++] = A;
  }, t.prototype.readUInt32 = function() {
    return 16777216 * this.readByte() + (this.readByte() << 16) + (this.readByte() << 8) + this.readByte();
  }, t.prototype.writeUInt32 = function(A) {
    return this.writeByte(A >>> 24 & 255), this.writeByte(A >> 16 & 255), this.writeByte(A >> 8 & 255), this.writeByte(255 & A);
  }, t.prototype.readInt32 = function() {
    var A;
    return (A = this.readUInt32()) >= 2147483648 ? A - 4294967296 : A;
  }, t.prototype.writeInt32 = function(A) {
    return A < 0 && (A += 4294967296), this.writeUInt32(A);
  }, t.prototype.readUInt16 = function() {
    return this.readByte() << 8 | this.readByte();
  }, t.prototype.writeUInt16 = function(A) {
    return this.writeByte(A >> 8 & 255), this.writeByte(255 & A);
  }, t.prototype.readInt16 = function() {
    var A;
    return (A = this.readUInt16()) >= 32768 ? A - 65536 : A;
  }, t.prototype.writeInt16 = function(A) {
    return A < 0 && (A += 65536), this.writeUInt16(A);
  }, t.prototype.readString = function(A) {
    var e, r;
    for (r = [], e = 0; 0 <= A ? e < A : e > A; e = 0 <= A ? ++e : --e) r[e] = String.fromCharCode(this.readByte());
    return r.join("");
  }, t.prototype.writeString = function(A) {
    var e, r, n;
    for (n = [], e = 0, r = A.length; 0 <= r ? e < r : e > r; e = 0 <= r ? ++e : --e) n.push(this.writeByte(A.charCodeAt(e)));
    return n;
  }, t.prototype.readShort = function() {
    return this.readInt16();
  }, t.prototype.writeShort = function(A) {
    return this.writeInt16(A);
  }, t.prototype.readLongLong = function() {
    var A, e, r, n, i, s, u, c;
    return A = this.readByte(), e = this.readByte(), r = this.readByte(), n = this.readByte(), i = this.readByte(), s = this.readByte(), u = this.readByte(), c = this.readByte(), 128 & A ? -1 * (72057594037927940 * (255 ^ A) + 281474976710656 * (255 ^ e) + 1099511627776 * (255 ^ r) + 4294967296 * (255 ^ n) + 16777216 * (255 ^ i) + 65536 * (255 ^ s) + 256 * (255 ^ u) + (255 ^ c) + 1) : 72057594037927940 * A + 281474976710656 * e + 1099511627776 * r + 4294967296 * n + 16777216 * i + 65536 * s + 256 * u + c;
  }, t.prototype.writeLongLong = function(A) {
    var e, r;
    return e = Math.floor(A / 4294967296), r = 4294967295 & A, this.writeByte(e >> 24 & 255), this.writeByte(e >> 16 & 255), this.writeByte(e >> 8 & 255), this.writeByte(255 & e), this.writeByte(r >> 24 & 255), this.writeByte(r >> 16 & 255), this.writeByte(r >> 8 & 255), this.writeByte(255 & r);
  }, t.prototype.readInt = function() {
    return this.readInt32();
  }, t.prototype.writeInt = function(A) {
    return this.writeInt32(A);
  }, t.prototype.read = function(A) {
    var e, r;
    for (e = [], r = 0; 0 <= A ? r < A : r > A; r = 0 <= A ? ++r : --r) e.push(this.readByte());
    return e;
  }, t.prototype.write = function(A) {
    var e, r, n, i;
    for (i = [], r = 0, n = A.length; r < n; r++) e = A[r], i.push(this.writeByte(e));
    return i;
  }, t;
}(), Zp = function() {
  var t;
  function A(e) {
    var r, n, i;
    for (this.scalarType = e.readInt(), this.tableCount = e.readShort(), this.searchRange = e.readShort(), this.entrySelector = e.readShort(), this.rangeShift = e.readShort(), this.tables = {}, n = 0, i = this.tableCount; 0 <= i ? n < i : n > i; n = 0 <= i ? ++n : --n) r = { tag: e.readString(4), checksum: e.readInt(), offset: e.readInt(), length: e.readInt() }, this.tables[r.tag] = r;
  }
  return A.prototype.encode = function(e) {
    var r, n, i, s, u, c, h, g, p, w, B, L, y;
    for (y in B = Object.keys(e).length, c = Math.log(2), p = 16 * Math.floor(Math.log(B) / c), s = Math.floor(p / c), g = 16 * B - p, (n = new vn()).writeInt(this.scalarType), n.writeShort(B), n.writeShort(p), n.writeShort(s), n.writeShort(g), i = 16 * B, h = n.pos + i, u = null, L = [], e) for (w = e[y], n.writeString(y), n.writeInt(t(w)), n.writeInt(h), n.writeInt(w.length), L = L.concat(w), y === "head" && (u = h), h += w.length; h % 4; ) L.push(0), h++;
    return n.write(L), r = 2981146554 - t(n.data), n.pos = u + 8, n.writeUInt32(r), n.data;
  }, t = function(e) {
    var r, n, i, s;
    for (e = sB.call(e); e.length % 4; ) e.push(0);
    for (i = new vn(e), n = 0, r = 0, s = e.length; r < s; r = r += 4) n += i.readUInt32();
    return 4294967295 & n;
  }, A;
}(), $p = {}.hasOwnProperty, Er = function(t, A) {
  for (var e in A) $p.call(A, e) && (t[e] = A[e]);
  function r() {
    this.constructor = t;
  }
  return r.prototype = A.prototype, t.prototype = new r(), t.__super__ = A.prototype, t;
};
lr = function() {
  function t(A) {
    var e;
    this.file = A, e = this.file.directory.tables[this.tag], this.exists = !!e, e && (this.offset = e.offset, this.length = e.length, this.parse(this.file.contents));
  }
  return t.prototype.parse = function() {
  }, t.prototype.encode = function() {
  }, t.prototype.raw = function() {
    return this.exists ? (this.file.contents.pos = this.offset, this.file.contents.read(this.length)) : null;
  }, t;
}();
var A5 = function(t) {
  function A() {
    return A.__super__.constructor.apply(this, arguments);
  }
  return Er(A, lr), A.prototype.tag = "head", A.prototype.parse = function(e) {
    return e.pos = this.offset, this.version = e.readInt(), this.revision = e.readInt(), this.checkSumAdjustment = e.readInt(), this.magicNumber = e.readInt(), this.flags = e.readShort(), this.unitsPerEm = e.readShort(), this.created = e.readLongLong(), this.modified = e.readLongLong(), this.xMin = e.readShort(), this.yMin = e.readShort(), this.xMax = e.readShort(), this.yMax = e.readShort(), this.macStyle = e.readShort(), this.lowestRecPPEM = e.readShort(), this.fontDirectionHint = e.readShort(), this.indexToLocFormat = e.readShort(), this.glyphDataFormat = e.readShort();
  }, A.prototype.encode = function(e) {
    var r;
    return (r = new vn()).writeInt(this.version), r.writeInt(this.revision), r.writeInt(this.checkSumAdjustment), r.writeInt(this.magicNumber), r.writeShort(this.flags), r.writeShort(this.unitsPerEm), r.writeLongLong(this.created), r.writeLongLong(this.modified), r.writeShort(this.xMin), r.writeShort(this.yMin), r.writeShort(this.xMax), r.writeShort(this.yMax), r.writeShort(this.macStyle), r.writeShort(this.lowestRecPPEM), r.writeShort(this.fontDirectionHint), r.writeShort(e), r.writeShort(this.glyphDataFormat), r.data;
  }, A;
}(), Tf = function() {
  function t(A, e) {
    var r, n, i, s, u, c, h, g, p, w, B, L, y, N, F, x, R;
    switch (this.platformID = A.readUInt16(), this.encodingID = A.readShort(), this.offset = e + A.readInt(), p = A.pos, A.pos = this.offset, this.format = A.readUInt16(), this.length = A.readUInt16(), this.language = A.readUInt16(), this.isUnicode = this.platformID === 3 && this.encodingID === 1 && this.format === 4 || this.platformID === 0 && this.format === 4, this.codeMap = {}, this.format) {
      case 0:
        for (c = 0; c < 256; ++c) this.codeMap[c] = A.readByte();
        break;
      case 4:
        for (B = A.readUInt16(), w = B / 2, A.pos += 6, i = function() {
          var Y, Z;
          for (Z = [], c = Y = 0; 0 <= w ? Y < w : Y > w; c = 0 <= w ? ++Y : --Y) Z.push(A.readUInt16());
          return Z;
        }(), A.pos += 2, y = function() {
          var Y, Z;
          for (Z = [], c = Y = 0; 0 <= w ? Y < w : Y > w; c = 0 <= w ? ++Y : --Y) Z.push(A.readUInt16());
          return Z;
        }(), h = function() {
          var Y, Z;
          for (Z = [], c = Y = 0; 0 <= w ? Y < w : Y > w; c = 0 <= w ? ++Y : --Y) Z.push(A.readUInt16());
          return Z;
        }(), g = function() {
          var Y, Z;
          for (Z = [], c = Y = 0; 0 <= w ? Y < w : Y > w; c = 0 <= w ? ++Y : --Y) Z.push(A.readUInt16());
          return Z;
        }(), n = (this.length - A.pos + this.offset) / 2, u = function() {
          var Y, Z;
          for (Z = [], c = Y = 0; 0 <= n ? Y < n : Y > n; c = 0 <= n ? ++Y : --Y) Z.push(A.readUInt16());
          return Z;
        }(), c = F = 0, R = i.length; F < R; c = ++F) for (N = i[c], r = x = L = y[c]; L <= N ? x <= N : x >= N; r = L <= N ? ++x : --x) g[c] === 0 ? s = r + h[c] : (s = u[g[c] / 2 + (r - L) - (w - c)] || 0) !== 0 && (s += h[c]), this.codeMap[r] = 65535 & s;
    }
    A.pos = p;
  }
  return t.encode = function(A, e) {
    var r, n, i, s, u, c, h, g, p, w, B, L, y, N, F, x, R, Y, Z, $, J, O, W, cA, I, H, K, M, oA, iA, uA, eA, lA, hA, UA, U, _, T, k, X, nA, aA, sA, FA, QA, xA;
    switch (M = new vn(), s = Object.keys(A).sort(function(LA, jA) {
      return LA - jA;
    }), e) {
      case "macroman":
        for (y = 0, N = function() {
          var LA = [];
          for (L = 0; L < 256; ++L) LA.push(0);
          return LA;
        }(), x = { 0: 0 }, i = {}, oA = 0, lA = s.length; oA < lA; oA++) x[sA = A[n = s[oA]]] == null && (x[sA] = ++y), i[n] = { old: A[n], new: x[A[n]] }, N[n] = x[A[n]];
        return M.writeUInt16(1), M.writeUInt16(0), M.writeUInt32(12), M.writeUInt16(0), M.writeUInt16(262), M.writeUInt16(0), M.write(N), { charMap: i, subtable: M.data, maxGlyphID: y + 1 };
      case "unicode":
        for (H = [], p = [], R = 0, x = {}, r = {}, F = h = null, iA = 0, hA = s.length; iA < hA; iA++) x[Z = A[n = s[iA]]] == null && (x[Z] = ++R), r[n] = { old: Z, new: x[Z] }, u = x[Z] - n, F != null && u === h || (F && p.push(F), H.push(n), h = u), F = n;
        for (F && p.push(F), p.push(65535), H.push(65535), cA = 2 * (W = H.length), O = 2 * Math.pow(Math.log(W) / Math.LN2, 2), w = Math.log(O / 2) / Math.LN2, J = 2 * W - O, c = [], $ = [], B = [], L = uA = 0, UA = H.length; uA < UA; L = ++uA) {
          if (I = H[L], g = p[L], I === 65535) {
            c.push(0), $.push(0);
            break;
          }
          if (I - (K = r[I].new) >= 32768) for (c.push(0), $.push(2 * (B.length + W - L)), n = eA = I; I <= g ? eA <= g : eA >= g; n = I <= g ? ++eA : --eA) B.push(r[n].new);
          else c.push(K - I), $.push(0);
        }
        for (M.writeUInt16(3), M.writeUInt16(1), M.writeUInt32(12), M.writeUInt16(4), M.writeUInt16(16 + 8 * W + 2 * B.length), M.writeUInt16(0), M.writeUInt16(cA), M.writeUInt16(O), M.writeUInt16(w), M.writeUInt16(J), nA = 0, U = p.length; nA < U; nA++) n = p[nA], M.writeUInt16(n);
        for (M.writeUInt16(0), aA = 0, _ = H.length; aA < _; aA++) n = H[aA], M.writeUInt16(n);
        for (FA = 0, T = c.length; FA < T; FA++) u = c[FA], M.writeUInt16(u);
        for (QA = 0, k = $.length; QA < k; QA++) Y = $[QA], M.writeUInt16(Y);
        for (xA = 0, X = B.length; xA < X; xA++) y = B[xA], M.writeUInt16(y);
        return { charMap: r, subtable: M.data, maxGlyphID: R + 1 };
    }
  }, t;
}(), aB = function(t) {
  function A() {
    return A.__super__.constructor.apply(this, arguments);
  }
  return Er(A, lr), A.prototype.tag = "cmap", A.prototype.parse = function(e) {
    var r, n, i;
    for (e.pos = this.offset, this.version = e.readUInt16(), i = e.readUInt16(), this.tables = [], this.unicode = null, n = 0; 0 <= i ? n < i : n > i; n = 0 <= i ? ++n : --n) r = new Tf(e, this.offset), this.tables.push(r), r.isUnicode && this.unicode == null && (this.unicode = r);
    return !0;
  }, A.encode = function(e, r) {
    var n, i;
    return r == null && (r = "macroman"), n = Tf.encode(e, r), (i = new vn()).writeUInt16(0), i.writeUInt16(1), n.table = i.data.concat(n.subtable), n;
  }, A;
}(), e5 = function(t) {
  function A() {
    return A.__super__.constructor.apply(this, arguments);
  }
  return Er(A, lr), A.prototype.tag = "hhea", A.prototype.parse = function(e) {
    return e.pos = this.offset, this.version = e.readInt(), this.ascender = e.readShort(), this.decender = e.readShort(), this.lineGap = e.readShort(), this.advanceWidthMax = e.readShort(), this.minLeftSideBearing = e.readShort(), this.minRightSideBearing = e.readShort(), this.xMaxExtent = e.readShort(), this.caretSlopeRise = e.readShort(), this.caretSlopeRun = e.readShort(), this.caretOffset = e.readShort(), e.pos += 8, this.metricDataFormat = e.readShort(), this.numberOfMetrics = e.readUInt16();
  }, A;
}(), t5 = function(t) {
  function A() {
    return A.__super__.constructor.apply(this, arguments);
  }
  return Er(A, lr), A.prototype.tag = "OS/2", A.prototype.parse = function(e) {
    if (e.pos = this.offset, this.version = e.readUInt16(), this.averageCharWidth = e.readShort(), this.weightClass = e.readUInt16(), this.widthClass = e.readUInt16(), this.type = e.readShort(), this.ySubscriptXSize = e.readShort(), this.ySubscriptYSize = e.readShort(), this.ySubscriptXOffset = e.readShort(), this.ySubscriptYOffset = e.readShort(), this.ySuperscriptXSize = e.readShort(), this.ySuperscriptYSize = e.readShort(), this.ySuperscriptXOffset = e.readShort(), this.ySuperscriptYOffset = e.readShort(), this.yStrikeoutSize = e.readShort(), this.yStrikeoutPosition = e.readShort(), this.familyClass = e.readShort(), this.panose = function() {
      var r, n;
      for (n = [], r = 0; r < 10; ++r) n.push(e.readByte());
      return n;
    }(), this.charRange = function() {
      var r, n;
      for (n = [], r = 0; r < 4; ++r) n.push(e.readInt());
      return n;
    }(), this.vendorID = e.readString(4), this.selection = e.readShort(), this.firstCharIndex = e.readShort(), this.lastCharIndex = e.readShort(), this.version > 0 && (this.ascent = e.readShort(), this.descent = e.readShort(), this.lineGap = e.readShort(), this.winAscent = e.readShort(), this.winDescent = e.readShort(), this.codePageRange = function() {
      var r, n;
      for (n = [], r = 0; r < 2; r = ++r) n.push(e.readInt());
      return n;
    }(), this.version > 1)) return this.xHeight = e.readShort(), this.capHeight = e.readShort(), this.defaultChar = e.readShort(), this.breakChar = e.readShort(), this.maxContext = e.readShort();
  }, A;
}(), r5 = function(t) {
  function A() {
    return A.__super__.constructor.apply(this, arguments);
  }
  return Er(A, lr), A.prototype.tag = "post", A.prototype.parse = function(e) {
    var r, n, i;
    switch (e.pos = this.offset, this.format = e.readInt(), this.italicAngle = e.readInt(), this.underlinePosition = e.readShort(), this.underlineThickness = e.readShort(), this.isFixedPitch = e.readInt(), this.minMemType42 = e.readInt(), this.maxMemType42 = e.readInt(), this.minMemType1 = e.readInt(), this.maxMemType1 = e.readInt(), this.format) {
      case 65536:
        break;
      case 131072:
        var s;
        for (n = e.readUInt16(), this.glyphNameIndex = [], s = 0; 0 <= n ? s < n : s > n; s = 0 <= n ? ++s : --s) this.glyphNameIndex.push(e.readUInt16());
        for (this.names = [], i = []; e.pos < this.offset + this.length; ) r = e.readByte(), i.push(this.names.push(e.readString(r)));
        return i;
      case 151552:
        return n = e.readUInt16(), this.offsets = e.read(n);
      case 196608:
        break;
      case 262144:
        return this.map = (function() {
          var u, c, h;
          for (h = [], s = u = 0, c = this.file.maxp.numGlyphs; 0 <= c ? u < c : u > c; s = 0 <= c ? ++u : --u) h.push(e.readUInt32());
          return h;
        }).call(this);
    }
  }, A;
}(), n5 = function(t, A) {
  this.raw = t, this.length = t.length, this.platformID = A.platformID, this.encodingID = A.encodingID, this.languageID = A.languageID;
}, i5 = function(t) {
  function A() {
    return A.__super__.constructor.apply(this, arguments);
  }
  return Er(A, lr), A.prototype.tag = "name", A.prototype.parse = function(e) {
    var r, n, i, s, u, c, h, g, p, w, B;
    for (e.pos = this.offset, e.readShort(), r = e.readShort(), c = e.readShort(), n = [], s = 0; 0 <= r ? s < r : s > r; s = 0 <= r ? ++s : --s) n.push({ platformID: e.readShort(), encodingID: e.readShort(), languageID: e.readShort(), nameID: e.readShort(), length: e.readShort(), offset: this.offset + c + e.readShort() });
    for (h = {}, s = p = 0, w = n.length; p < w; s = ++p) i = n[s], e.pos = i.offset, g = e.readString(i.length), u = new n5(g, i), h[B = i.nameID] == null && (h[B] = []), h[i.nameID].push(u);
    this.strings = h, this.copyright = h[0], this.fontFamily = h[1], this.fontSubfamily = h[2], this.uniqueSubfamily = h[3], this.fontName = h[4], this.version = h[5];
    try {
      this.postscriptName = h[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
    } catch {
      this.postscriptName = h[4][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
    }
    return this.trademark = h[7], this.manufacturer = h[8], this.designer = h[9], this.description = h[10], this.vendorUrl = h[11], this.designerUrl = h[12], this.license = h[13], this.licenseUrl = h[14], this.preferredFamily = h[15], this.preferredSubfamily = h[17], this.compatibleFull = h[18], this.sampleText = h[19];
  }, A;
}(), a5 = function(t) {
  function A() {
    return A.__super__.constructor.apply(this, arguments);
  }
  return Er(A, lr), A.prototype.tag = "maxp", A.prototype.parse = function(e) {
    return e.pos = this.offset, this.version = e.readInt(), this.numGlyphs = e.readUInt16(), this.maxPoints = e.readUInt16(), this.maxContours = e.readUInt16(), this.maxCompositePoints = e.readUInt16(), this.maxComponentContours = e.readUInt16(), this.maxZones = e.readUInt16(), this.maxTwilightPoints = e.readUInt16(), this.maxStorage = e.readUInt16(), this.maxFunctionDefs = e.readUInt16(), this.maxInstructionDefs = e.readUInt16(), this.maxStackElements = e.readUInt16(), this.maxSizeOfInstructions = e.readUInt16(), this.maxComponentElements = e.readUInt16(), this.maxComponentDepth = e.readUInt16();
  }, A;
}(), s5 = function(t) {
  function A() {
    return A.__super__.constructor.apply(this, arguments);
  }
  return Er(A, lr), A.prototype.tag = "hmtx", A.prototype.parse = function(e) {
    var r, n, i, s, u, c, h;
    for (e.pos = this.offset, this.metrics = [], r = 0, c = this.file.hhea.numberOfMetrics; 0 <= c ? r < c : r > c; r = 0 <= c ? ++r : --r) this.metrics.push({ advance: e.readUInt16(), lsb: e.readInt16() });
    for (i = this.file.maxp.numGlyphs - this.file.hhea.numberOfMetrics, this.leftSideBearings = function() {
      var g, p;
      for (p = [], r = g = 0; 0 <= i ? g < i : g > i; r = 0 <= i ? ++g : --g) p.push(e.readInt16());
      return p;
    }(), this.widths = (function() {
      var g, p, w, B;
      for (B = [], g = 0, p = (w = this.metrics).length; g < p; g++) s = w[g], B.push(s.advance);
      return B;
    }).call(this), n = this.widths[this.widths.length - 1], h = [], r = u = 0; 0 <= i ? u < i : u > i; r = 0 <= i ? ++u : --u) h.push(this.widths.push(n));
    return h;
  }, A.prototype.forGlyph = function(e) {
    return e in this.metrics ? this.metrics[e] : { advance: this.metrics[this.metrics.length - 1].advance, lsb: this.leftSideBearings[e - this.metrics.length] };
  }, A;
}(), sB = [].slice, o5 = function(t) {
  function A() {
    return A.__super__.constructor.apply(this, arguments);
  }
  return Er(A, lr), A.prototype.tag = "glyf", A.prototype.parse = function() {
    return this.cache = {};
  }, A.prototype.glyphFor = function(e) {
    var r, n, i, s, u, c, h, g, p, w;
    return e in this.cache ? this.cache[e] : (s = this.file.loca, r = this.file.contents, n = s.indexOf(e), (i = s.lengthOf(e)) === 0 ? this.cache[e] = null : (r.pos = this.offset + n, u = (c = new vn(r.read(i))).readShort(), g = c.readShort(), w = c.readShort(), h = c.readShort(), p = c.readShort(), this.cache[e] = u === -1 ? new c5(c, g, w, h, p) : new u5(c, u, g, w, h, p), this.cache[e]));
  }, A.prototype.encode = function(e, r, n) {
    var i, s, u, c, h;
    for (u = [], s = [], c = 0, h = r.length; c < h; c++) i = e[r[c]], s.push(u.length), i && (u = u.concat(i.encode(n)));
    return s.push(u.length), { table: u, offsets: s };
  }, A;
}(), u5 = function() {
  function t(A, e, r, n, i, s) {
    this.raw = A, this.numberOfContours = e, this.xMin = r, this.yMin = n, this.xMax = i, this.yMax = s, this.compound = !1;
  }
  return t.prototype.encode = function() {
    return this.raw.data;
  }, t;
}(), c5 = function() {
  function t(A, e, r, n, i) {
    var s, u;
    for (this.raw = A, this.xMin = e, this.yMin = r, this.xMax = n, this.yMax = i, this.compound = !0, this.glyphIDs = [], this.glyphOffsets = [], s = this.raw; u = s.readShort(), this.glyphOffsets.push(s.pos), this.glyphIDs.push(s.readUInt16()), 32 & u; ) s.pos += 1 & u ? 4 : 2, 128 & u ? s.pos += 8 : 64 & u ? s.pos += 4 : 8 & u && (s.pos += 2);
  }
  return t.prototype.encode = function() {
    var A, e, r;
    for (e = new vn(sB.call(this.raw.data)), A = 0, r = this.glyphIDs.length; A < r; ++A) e.pos = this.glyphOffsets[A];
    return e.data;
  }, t;
}(), l5 = function(t) {
  function A() {
    return A.__super__.constructor.apply(this, arguments);
  }
  return Er(A, lr), A.prototype.tag = "loca", A.prototype.parse = function(e) {
    var r, n;
    return e.pos = this.offset, r = this.file.head.indexToLocFormat, this.offsets = r === 0 ? (function() {
      var i, s;
      for (s = [], n = 0, i = this.length; n < i; n += 2) s.push(2 * e.readUInt16());
      return s;
    }).call(this) : (function() {
      var i, s;
      for (s = [], n = 0, i = this.length; n < i; n += 4) s.push(e.readUInt32());
      return s;
    }).call(this);
  }, A.prototype.indexOf = function(e) {
    return this.offsets[e];
  }, A.prototype.lengthOf = function(e) {
    return this.offsets[e + 1] - this.offsets[e];
  }, A.prototype.encode = function(e, r) {
    for (var n = new Uint32Array(this.offsets.length), i = 0, s = 0, u = 0; u < n.length; ++u) if (n[u] = i, s < r.length && r[s] == u) {
      ++s, n[u] = i;
      var c = this.offsets[u], h = this.offsets[u + 1] - c;
      h > 0 && (i += h);
    }
    for (var g = new Array(4 * n.length), p = 0; p < n.length; ++p) g[4 * p + 3] = 255 & n[p], g[4 * p + 2] = (65280 & n[p]) >> 8, g[4 * p + 1] = (16711680 & n[p]) >> 16, g[4 * p] = (4278190080 & n[p]) >> 24;
    return g;
  }, A;
}(), f5 = function() {
  function t(A) {
    this.font = A, this.subset = {}, this.unicodes = {}, this.next = 33;
  }
  return t.prototype.generateCmap = function() {
    var A, e, r, n, i;
    for (e in n = this.font.cmap.tables[0].codeMap, A = {}, i = this.subset) r = i[e], A[e] = n[r];
    return A;
  }, t.prototype.glyphsFor = function(A) {
    var e, r, n, i, s, u, c;
    for (n = {}, s = 0, u = A.length; s < u; s++) n[i = A[s]] = this.font.glyf.glyphFor(i);
    for (i in e = [], n) (r = n[i]) != null && r.compound && e.push.apply(e, r.glyphIDs);
    if (e.length > 0) for (i in c = this.glyphsFor(e)) r = c[i], n[i] = r;
    return n;
  }, t.prototype.encode = function(A, e) {
    var r, n, i, s, u, c, h, g, p, w, B, L, y, N, F;
    for (n in r = aB.encode(this.generateCmap(), "unicode"), s = this.glyphsFor(A), B = { 0: 0 }, F = r.charMap) B[(c = F[n]).old] = c.new;
    for (L in w = r.maxGlyphID, s) L in B || (B[L] = w++);
    return g = function(x) {
      var R, Y;
      for (R in Y = {}, x) Y[x[R]] = R;
      return Y;
    }(B), p = Object.keys(g).sort(function(x, R) {
      return x - R;
    }), y = function() {
      var x, R, Y;
      for (Y = [], x = 0, R = p.length; x < R; x++) u = p[x], Y.push(g[u]);
      return Y;
    }(), i = this.font.glyf.encode(s, y, B), h = this.font.loca.encode(i.offsets, y), N = { cmap: this.font.cmap.raw(), glyf: i.table, loca: h, hmtx: this.font.hmtx.raw(), hhea: this.font.hhea.raw(), maxp: this.font.maxp.raw(), post: this.font.post.raw(), name: this.font.name.raw(), head: this.font.head.encode(e) }, this.font.os2.exists && (N["OS/2"] = this.font.os2.raw()), this.font.directory.encode(N);
  }, t;
}();
GA.API.PDFObject = function() {
  var t;
  function A() {
  }
  return t = function(e, r) {
    return (Array(r + 1).join("0") + e).slice(-r);
  }, A.convert = function(e) {
    var r, n, i, s;
    if (Array.isArray(e)) return "[" + function() {
      var u, c, h;
      for (h = [], u = 0, c = e.length; u < c; u++) r = e[u], h.push(A.convert(r));
      return h;
    }().join(" ") + "]";
    if (typeof e == "string") return "/" + e;
    if (e != null && e.isString) return "(" + e + ")";
    if (e instanceof Date) return "(D:" + t(e.getUTCFullYear(), 4) + t(e.getUTCMonth(), 2) + t(e.getUTCDate(), 2) + t(e.getUTCHours(), 2) + t(e.getUTCMinutes(), 2) + t(e.getUTCSeconds(), 2) + "Z)";
    if ({}.toString.call(e) === "[object Object]") {
      for (n in i = ["<<"], e) s = e[n], i.push("/" + n + " " + A.convert(s));
      return i.push(">>"), i.join(`
`);
    }
    return "" + e;
  }, A;
}();
const h5 = async (t, A) => {
  const e = await Kh(t, { scale: 2 }), r = e.toDataURL("image/png"), n = new GA({
    orientation: "portrait",
    unit: "px",
    format: [e.width, e.height]
  });
  n.addImage(r, "PNG", 0, 0, e.width, e.height), await n.save(`${A}.pdf`);
};
export {
  de as _,
  h5 as h
};
//# sourceMappingURL=files-CxGPn86v.js.map
